//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), s = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, c = (n, r, a) => (a = n == null ? {} : e(i(n)), s(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n)), l = /* @__PURE__ */ o(((e) => {
	function t(e, t) {
		var n = e.length;
		e.push(t);
		a: for (; 0 < n;) {
			var r = n - 1 >>> 1, a = e[r];
			if (0 < i(a, t)) e[r] = t, e[n] = a, n = r;
			else break a;
		}
	}
	function n(e) {
		return e.length === 0 ? null : e[0];
	}
	function r(e) {
		if (e.length === 0) return null;
		var t = e[0], n = e.pop();
		if (n !== t) {
			e[0] = n;
			a: for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
				var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
				if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s);
				else if (l < a && 0 > i(u, n)) e[r] = u, e[l] = n, r = l;
				else break a;
			}
		}
		return t;
	}
	function i(e, t) {
		var n = e.sortIndex - t.sortIndex;
		return n === 0 ? e.id - t.id : n;
	}
	if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
		var a = performance;
		e.unstable_now = function() {
			return a.now();
		};
	} else {
		var o = Date, s = o.now();
		e.unstable_now = function() {
			return o.now() - s;
		};
	}
	var c = [], l = [], u = 1, d = null, f = 3, p = !1, m = !1, h = !1, g = !1, _ = typeof setTimeout == "function" ? setTimeout : null, v = typeof clearTimeout == "function" ? clearTimeout : null, y = typeof setImmediate < "u" ? setImmediate : null;
	function b(e) {
		for (var i = n(l); i !== null;) {
			if (i.callback === null) r(l);
			else if (i.startTime <= e) r(l), i.sortIndex = i.expirationTime, t(c, i);
			else break;
			i = n(l);
		}
	}
	function x(e) {
		if (h = !1, b(e), !m) if (n(c) !== null) m = !0, S || (S = !0, O());
		else {
			var t = n(l);
			t !== null && j(x, t.startTime - e);
		}
	}
	var S = !1, C = -1, w = 5, T = -1;
	function E() {
		return g ? !0 : !(e.unstable_now() - T < w);
	}
	function D() {
		if (g = !1, S) {
			var t = e.unstable_now();
			T = t;
			var i = !0;
			try {
				a: {
					m = !1, h && (h = !1, v(C), C = -1), p = !0;
					var a = f;
					try {
						b: {
							for (b(t), d = n(c); d !== null && !(d.expirationTime > t && E());) {
								var o = d.callback;
								if (typeof o == "function") {
									d.callback = null, f = d.priorityLevel;
									var s = o(d.expirationTime <= t);
									if (t = e.unstable_now(), typeof s == "function") {
										d.callback = s, b(t), i = !0;
										break b;
									}
									d === n(c) && r(c), b(t);
								} else r(c);
								d = n(c);
							}
							if (d !== null) i = !0;
							else {
								var u = n(l);
								u !== null && j(x, u.startTime - t), i = !1;
							}
						}
						break a;
					} finally {
						d = null, f = a, p = !1;
					}
					i = void 0;
				}
			} finally {
				i ? O() : S = !1;
			}
		}
	}
	var O;
	if (typeof y == "function") O = function() {
		y(D);
	};
	else if (typeof MessageChannel < "u") {
		var k = new MessageChannel(), A = k.port2;
		k.port1.onmessage = D, O = function() {
			A.postMessage(null);
		};
	} else O = function() {
		_(D, 0);
	};
	function j(t, n) {
		C = _(function() {
			t(e.unstable_now());
		}, n);
	}
	e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(e) {
		e.callback = null;
	}, e.unstable_forceFrameRate = function(e) {
		0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : w = 0 < e ? Math.floor(1e3 / e) : 5;
	}, e.unstable_getCurrentPriorityLevel = function() {
		return f;
	}, e.unstable_next = function(e) {
		switch (f) {
			case 1:
			case 2:
			case 3:
				var t = 3;
				break;
			default: t = f;
		}
		var n = f;
		f = t;
		try {
			return e();
		} finally {
			f = n;
		}
	}, e.unstable_requestPaint = function() {
		g = !0;
	}, e.unstable_runWithPriority = function(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 3:
			case 4:
			case 5: break;
			default: e = 3;
		}
		var n = f;
		f = e;
		try {
			return t();
		} finally {
			f = n;
		}
	}, e.unstable_scheduleCallback = function(r, i, a) {
		var o = e.unstable_now();
		switch (typeof a == "object" && a ? (a = a.delay, a = typeof a == "number" && 0 < a ? o + a : o) : a = o, r) {
			case 1:
				var s = -1;
				break;
			case 2:
				s = 250;
				break;
			case 5:
				s = 1073741823;
				break;
			case 4:
				s = 1e4;
				break;
			default: s = 5e3;
		}
		return s = a + s, r = {
			id: u++,
			callback: i,
			priorityLevel: r,
			startTime: a,
			expirationTime: s,
			sortIndex: -1
		}, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (v(C), C = -1) : h = !0, j(x, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, S || (S = !0, O()))), r;
	}, e.unstable_shouldYield = E, e.unstable_wrapCallback = function(e) {
		var t = f;
		return function() {
			var n = f;
			f = t;
			try {
				return e.apply(this, arguments);
			} finally {
				f = n;
			}
		};
	};
})), u = /* @__PURE__ */ o(((e, t) => {
	t.exports = l();
})), d = /* @__PURE__ */ o(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.activity"), p = Symbol.iterator;
	function m(e) {
		return typeof e != "object" || !e ? null : (e = p && e[p] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var h = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	}, g = Object.assign, _ = {};
	function v(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	v.prototype.isReactComponent = {}, v.prototype.setState = function(e, t) {
		if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, e, t, "setState");
	}, v.prototype.forceUpdate = function(e) {
		this.updater.enqueueForceUpdate(this, e, "forceUpdate");
	};
	function y() {}
	y.prototype = v.prototype;
	function b(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	var x = b.prototype = new y();
	x.constructor = b, g(x, v.prototype), x.isPureReactComponent = !0;
	var S = Array.isArray;
	function C() {}
	var w = {
		H: null,
		A: null,
		T: null,
		S: null
	}, T = Object.prototype.hasOwnProperty;
	function E(e, n, r) {
		var i = r.ref;
		return {
			$$typeof: t,
			type: e,
			key: n,
			ref: i === void 0 ? null : i,
			props: r
		};
	}
	function D(e, t) {
		return E(e.type, t, e.props);
	}
	function O(e) {
		return typeof e == "object" && !!e && e.$$typeof === t;
	}
	function k(e) {
		var t = {
			"=": "=0",
			":": "=2"
		};
		return "$" + e.replace(/[=:]/g, function(e) {
			return t[e];
		});
	}
	var A = /\/+/g;
	function j(e, t) {
		return typeof e == "object" && e && e.key != null ? k("" + e.key) : t.toString(36);
	}
	function M(e) {
		switch (e.status) {
			case "fulfilled": return e.value;
			case "rejected": throw e.reason;
			default: switch (typeof e.status == "string" ? e.then(C, C) : (e.status = "pending", e.then(function(t) {
				e.status === "pending" && (e.status = "fulfilled", e.value = t);
			}, function(t) {
				e.status === "pending" && (e.status = "rejected", e.reason = t);
			})), e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
			}
		}
		throw e;
	}
	function N(e, r, i, a, o) {
		var s = typeof e;
		(s === "undefined" || s === "boolean") && (e = null);
		var c = !1;
		if (e === null) c = !0;
		else switch (s) {
			case "bigint":
			case "string":
			case "number":
				c = !0;
				break;
			case "object": switch (e.$$typeof) {
				case t:
				case n:
					c = !0;
					break;
				case d: return c = e._init, N(c(e._payload), r, i, a, o);
			}
		}
		if (c) return o = o(e), c = a === "" ? "." + j(e, 0) : a, S(o) ? (i = "", c != null && (i = c.replace(A, "$&/") + "/"), N(o, r, i, "", function(e) {
			return e;
		})) : o != null && (O(o) && (o = D(o, i + (o.key == null || e && e.key === o.key ? "" : ("" + o.key).replace(A, "$&/") + "/") + c)), r.push(o)), 1;
		c = 0;
		var l = a === "" ? "." : a + ":";
		if (S(e)) for (var u = 0; u < e.length; u++) a = e[u], s = l + j(a, u), c += N(a, r, i, s, o);
		else if (u = m(e), typeof u == "function") for (e = u.call(e), u = 0; !(a = e.next()).done;) a = a.value, s = l + j(a, u++), c += N(a, r, i, s, o);
		else if (s === "object") {
			if (typeof e.then == "function") return N(M(e), r, i, a, o);
			throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
		}
		return c;
	}
	function ee(e, t, n) {
		if (e == null) return e;
		var r = [], i = 0;
		return N(e, r, "", "", function(e) {
			return t.call(n, e, i++);
		}), r;
	}
	function te(e) {
		if (e._status === -1) {
			var t = e._result;
			t = t(), t.then(function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
			}, function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
			}), e._status === -1 && (e._status = 0, e._result = t);
		}
		if (e._status === 1) return e._result.default;
		throw e._result;
	}
	var P = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, F = {
		map: ee,
		forEach: function(e, t, n) {
			ee(e, function() {
				t.apply(this, arguments);
			}, n);
		},
		count: function(e) {
			var t = 0;
			return ee(e, function() {
				t++;
			}), t;
		},
		toArray: function(e) {
			return ee(e, function(e) {
				return e;
			}) || [];
		},
		only: function(e) {
			if (!O(e)) throw Error("React.Children.only expected to receive a single React element child.");
			return e;
		}
	};
	e.Activity = f, e.Children = F, e.Component = v, e.Fragment = r, e.Profiler = a, e.PureComponent = b, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = w, e.__COMPILER_RUNTIME = {
		__proto__: null,
		c: function(e) {
			return w.H.useMemoCache(e);
		}
	}, e.cache = function(e) {
		return function() {
			return e.apply(null, arguments);
		};
	}, e.cacheSignal = function() {
		return null;
	}, e.cloneElement = function(e, t, n) {
		if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
		var r = g({}, e.props), i = e.key;
		if (t != null) for (a in t.key !== void 0 && (i = "" + t.key), t) !T.call(t, a) || a === "key" || a === "__self" || a === "__source" || a === "ref" && t.ref === void 0 || (r[a] = t[a]);
		var a = arguments.length - 2;
		if (a === 1) r.children = n;
		else if (1 < a) {
			for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
			r.children = o;
		}
		return E(e.type, i, r);
	}, e.createContext = function(e) {
		return e = {
			$$typeof: s,
			_currentValue: e,
			_currentValue2: e,
			_threadCount: 0,
			Provider: null,
			Consumer: null
		}, e.Provider = e, e.Consumer = {
			$$typeof: o,
			_context: e
		}, e;
	}, e.createElement = function(e, t, n) {
		var r, i = {}, a = null;
		if (t != null) for (r in t.key !== void 0 && (a = "" + t.key), t) T.call(t, r) && r !== "key" && r !== "__self" && r !== "__source" && (i[r] = t[r]);
		var o = arguments.length - 2;
		if (o === 1) i.children = n;
		else if (1 < o) {
			for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
			i.children = s;
		}
		if (e && e.defaultProps) for (r in o = e.defaultProps, o) i[r] === void 0 && (i[r] = o[r]);
		return E(e, a, i);
	}, e.createRef = function() {
		return { current: null };
	}, e.forwardRef = function(e) {
		return {
			$$typeof: c,
			render: e
		};
	}, e.isValidElement = O, e.lazy = function(e) {
		return {
			$$typeof: d,
			_payload: {
				_status: -1,
				_result: e
			},
			_init: te
		};
	}, e.memo = function(e, t) {
		return {
			$$typeof: u,
			type: e,
			compare: t === void 0 ? null : t
		};
	}, e.startTransition = function(e) {
		var t = w.T, n = {};
		w.T = n;
		try {
			var r = e(), i = w.S;
			i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && r.then(C, P);
		} catch (e) {
			P(e);
		} finally {
			t !== null && n.types !== null && (t.types = n.types), w.T = t;
		}
	}, e.unstable_useCacheRefresh = function() {
		return w.H.useCacheRefresh();
	}, e.use = function(e) {
		return w.H.use(e);
	}, e.useActionState = function(e, t, n) {
		return w.H.useActionState(e, t, n);
	}, e.useCallback = function(e, t) {
		return w.H.useCallback(e, t);
	}, e.useContext = function(e) {
		return w.H.useContext(e);
	}, e.useDebugValue = function() {}, e.useDeferredValue = function(e, t) {
		return w.H.useDeferredValue(e, t);
	}, e.useEffect = function(e, t) {
		return w.H.useEffect(e, t);
	}, e.useEffectEvent = function(e) {
		return w.H.useEffectEvent(e);
	}, e.useId = function() {
		return w.H.useId();
	}, e.useImperativeHandle = function(e, t, n) {
		return w.H.useImperativeHandle(e, t, n);
	}, e.useInsertionEffect = function(e, t) {
		return w.H.useInsertionEffect(e, t);
	}, e.useLayoutEffect = function(e, t) {
		return w.H.useLayoutEffect(e, t);
	}, e.useMemo = function(e, t) {
		return w.H.useMemo(e, t);
	}, e.useOptimistic = function(e, t) {
		return w.H.useOptimistic(e, t);
	}, e.useReducer = function(e, t, n) {
		return w.H.useReducer(e, t, n);
	}, e.useRef = function(e) {
		return w.H.useRef(e);
	}, e.useState = function(e) {
		return w.H.useState(e);
	}, e.useSyncExternalStore = function(e, t, n) {
		return w.H.useSyncExternalStore(e, t, n);
	}, e.useTransition = function() {
		return w.H.useTransition();
	}, e.version = "19.2.6";
})), f = /* @__PURE__ */ o(((e, t) => {
	t.exports = d();
})), p = /* @__PURE__ */ o(((e) => {
	var t = f();
	function n(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function r() {}
	var i = {
		d: {
			f: r,
			r: function() {
				throw Error(n(522));
			},
			D: r,
			C: r,
			L: r,
			m: r,
			X: r,
			S: r,
			M: r
		},
		p: 0,
		findDOMNode: null
	}, a = Symbol.for("react.portal");
	function o(e, t, n) {
		var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
		return {
			$$typeof: a,
			key: r == null ? null : "" + r,
			children: e,
			containerInfo: t,
			implementation: n
		};
	}
	var s = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
	function c(e, t) {
		if (e === "font") return "";
		if (typeof t == "string") return t === "use-credentials" ? t : "";
	}
	e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i, e.createPortal = function(e, t) {
		var r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
		if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(n(299));
		return o(e, t, null, r);
	}, e.flushSync = function(e) {
		var t = s.T, n = i.p;
		try {
			if (s.T = null, i.p = 2, e) return e();
		} finally {
			s.T = t, i.p = n, i.d.f();
		}
	}, e.preconnect = function(e, t) {
		typeof e == "string" && (t ? (t = t.crossOrigin, t = typeof t == "string" ? t === "use-credentials" ? t : "" : void 0) : t = null, i.d.C(e, t));
	}, e.prefetchDNS = function(e) {
		typeof e == "string" && i.d.D(e);
	}, e.preinit = function(e, t) {
		if (typeof e == "string" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin), a = typeof t.integrity == "string" ? t.integrity : void 0, o = typeof t.fetchPriority == "string" ? t.fetchPriority : void 0;
			n === "style" ? i.d.S(e, typeof t.precedence == "string" ? t.precedence : void 0, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o
			}) : n === "script" && i.d.X(e, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0
			});
		}
	}, e.preinitModule = function(e, t) {
		if (typeof e == "string") if (typeof t == "object" && t) {
			if (t.as == null || t.as === "script") {
				var n = c(t.as, t.crossOrigin);
				i.d.M(e, {
					crossOrigin: n,
					integrity: typeof t.integrity == "string" ? t.integrity : void 0,
					nonce: typeof t.nonce == "string" ? t.nonce : void 0
				});
			}
		} else t ?? i.d.M(e);
	}, e.preload = function(e, t) {
		if (typeof e == "string" && typeof t == "object" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin);
			i.d.L(e, n, {
				crossOrigin: r,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0,
				type: typeof t.type == "string" ? t.type : void 0,
				fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0,
				referrerPolicy: typeof t.referrerPolicy == "string" ? t.referrerPolicy : void 0,
				imageSrcSet: typeof t.imageSrcSet == "string" ? t.imageSrcSet : void 0,
				imageSizes: typeof t.imageSizes == "string" ? t.imageSizes : void 0,
				media: typeof t.media == "string" ? t.media : void 0
			});
		}
	}, e.preloadModule = function(e, t) {
		if (typeof e == "string") if (t) {
			var n = c(t.as, t.crossOrigin);
			i.d.m(e, {
				as: typeof t.as == "string" && t.as !== "script" ? t.as : void 0,
				crossOrigin: n,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0
			});
		} else i.d.m(e);
	}, e.requestFormReset = function(e) {
		i.d.r(e);
	}, e.unstable_batchedUpdates = function(e, t) {
		return e(t);
	}, e.useFormState = function(e, t, n) {
		return s.H.useFormState(e, t, n);
	}, e.useFormStatus = function() {
		return s.H.useHostTransitionStatus();
	}, e.version = "19.2.6";
})), m = /* @__PURE__ */ o(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = p();
})), h = /* @__PURE__ */ o(((e) => {
	var t = u(), n = f(), r = m();
	function i(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function a(e) {
		return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
	}
	function o(e) {
		var t = e, n = e;
		if (e.alternate) for (; t.return;) t = t.return;
		else {
			e = t;
			do
				t = e, t.flags & 4098 && (n = t.return), e = t.return;
			while (e);
		}
		return t.tag === 3 ? n : null;
	}
	function s(e) {
		if (e.tag === 13) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function c(e) {
		if (e.tag === 31) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function l(e) {
		if (o(e) !== e) throw Error(i(188));
	}
	function d(e) {
		var t = e.alternate;
		if (!t) {
			if (t = o(e), t === null) throw Error(i(188));
			return t === e ? e : null;
		}
		for (var n = e, r = t;;) {
			var a = n.return;
			if (a === null) break;
			var s = a.alternate;
			if (s === null) {
				if (r = a.return, r !== null) {
					n = r;
					continue;
				}
				break;
			}
			if (a.child === s.child) {
				for (s = a.child; s;) {
					if (s === n) return l(a), e;
					if (s === r) return l(a), t;
					s = s.sibling;
				}
				throw Error(i(188));
			}
			if (n.return !== r.return) n = a, r = s;
			else {
				for (var c = !1, u = a.child; u;) {
					if (u === n) {
						c = !0, n = a, r = s;
						break;
					}
					if (u === r) {
						c = !0, r = a, n = s;
						break;
					}
					u = u.sibling;
				}
				if (!c) {
					for (u = s.child; u;) {
						if (u === n) {
							c = !0, n = s, r = a;
							break;
						}
						if (u === r) {
							c = !0, r = s, n = a;
							break;
						}
						u = u.sibling;
					}
					if (!c) throw Error(i(189));
				}
			}
			if (n.alternate !== r) throw Error(i(190));
		}
		if (n.tag !== 3) throw Error(i(188));
		return n.stateNode.current === n ? e : t;
	}
	function p(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e;
		for (e = e.child; e !== null;) {
			if (t = p(e), t !== null) return t;
			e = e.sibling;
		}
		return null;
	}
	var h = Object.assign, g = Symbol.for("react.element"), _ = Symbol.for("react.transitional.element"), v = Symbol.for("react.portal"), y = Symbol.for("react.fragment"), b = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), S = Symbol.for("react.consumer"), C = Symbol.for("react.context"), w = Symbol.for("react.forward_ref"), T = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), D = Symbol.for("react.memo"), O = Symbol.for("react.lazy"), k = Symbol.for("react.activity"), A = Symbol.for("react.memo_cache_sentinel"), j = Symbol.iterator;
	function M(e) {
		return typeof e != "object" || !e ? null : (e = j && e[j] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var N = Symbol.for("react.client.reference");
	function ee(e) {
		if (e == null) return null;
		if (typeof e == "function") return e.$$typeof === N ? null : e.displayName || e.name || null;
		if (typeof e == "string") return e;
		switch (e) {
			case y: return "Fragment";
			case x: return "Profiler";
			case b: return "StrictMode";
			case T: return "Suspense";
			case E: return "SuspenseList";
			case k: return "Activity";
		}
		if (typeof e == "object") switch (e.$$typeof) {
			case v: return "Portal";
			case C: return e.displayName || "Context";
			case S: return (e._context.displayName || "Context") + ".Consumer";
			case w:
				var t = e.render;
				return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
			case D: return t = e.displayName || null, t === null ? ee(e.type) || "Memo" : t;
			case O:
				t = e._payload, e = e._init;
				try {
					return ee(e(t));
				} catch {}
		}
		return null;
	}
	var te = Array.isArray, P = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, F = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ne = {
		pending: !1,
		data: null,
		method: null,
		action: null
	}, re = [], ie = -1;
	function I(e) {
		return { current: e };
	}
	function L(e) {
		0 > ie || (e.current = re[ie], re[ie] = null, ie--);
	}
	function R(e, t) {
		ie++, re[ie] = e.current, e.current = t;
	}
	var ae = I(null), z = I(null), oe = I(null), se = I(null);
	function ce(e, t) {
		switch (R(oe, t), R(z, e), R(ae, null), t.nodeType) {
			case 9:
			case 11:
				e = (e = t.documentElement) && (e = e.namespaceURI) ? Vd(e) : 0;
				break;
			default: if (e = t.tagName, t = t.namespaceURI) t = Vd(t), e = Hd(t, e);
			else switch (e) {
				case "svg":
					e = 1;
					break;
				case "math":
					e = 2;
					break;
				default: e = 0;
			}
		}
		L(ae), R(ae, e);
	}
	function le() {
		L(ae), L(z), L(oe);
	}
	function ue(e) {
		e.memoizedState !== null && R(se, e);
		var t = ae.current, n = Hd(t, e.type);
		t !== n && (R(z, e), R(ae, n));
	}
	function de(e) {
		z.current === e && (L(ae), L(z)), se.current === e && (L(se), Qf._currentValue = ne);
	}
	var fe, pe;
	function me(e) {
		if (fe === void 0) try {
			throw Error();
		} catch (e) {
			var t = e.stack.trim().match(/\n( *(at )?)/);
			fe = t && t[1] || "", pe = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
		}
		return "\n" + fe + e + pe;
	}
	var he = !1;
	function ge(e, t) {
		if (!e || he) return "";
		he = !0;
		var n = Error.prepareStackTrace;
		Error.prepareStackTrace = void 0;
		try {
			var r = { DetermineComponentFrameRoot: function() {
				try {
					if (t) {
						var n = function() {
							throw Error();
						};
						if (Object.defineProperty(n.prototype, "props", { set: function() {
							throw Error();
						} }), typeof Reflect == "object" && Reflect.construct) {
							try {
								Reflect.construct(n, []);
							} catch (e) {
								var r = e;
							}
							Reflect.construct(e, [], n);
						} else {
							try {
								n.call();
							} catch (e) {
								r = e;
							}
							e.call(n.prototype);
						}
					} else {
						try {
							throw Error();
						} catch (e) {
							r = e;
						}
						(n = e()) && typeof n.catch == "function" && n.catch(function() {});
					}
				} catch (e) {
					if (e && r && typeof e.stack == "string") return [e.stack, r.stack];
				}
				return [null, null];
			} };
			r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
			var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, "name");
			i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
			var a = r.DetermineComponentFrameRoot(), o = a[0], s = a[1];
			if (o && s) {
				var c = o.split("\n"), l = s.split("\n");
				for (i = r = 0; r < c.length && !c[r].includes("DetermineComponentFrameRoot");) r++;
				for (; i < l.length && !l[i].includes("DetermineComponentFrameRoot");) i++;
				if (r === c.length || i === l.length) for (r = c.length - 1, i = l.length - 1; 1 <= r && 0 <= i && c[r] !== l[i];) i--;
				for (; 1 <= r && 0 <= i; r--, i--) if (c[r] !== l[i]) {
					if (r !== 1 || i !== 1) do
						if (r--, i--, 0 > i || c[r] !== l[i]) {
							var u = "\n" + c[r].replace(" at new ", " at ");
							return e.displayName && u.includes("<anonymous>") && (u = u.replace("<anonymous>", e.displayName)), u;
						}
					while (1 <= r && 0 <= i);
					break;
				}
			}
		} finally {
			he = !1, Error.prepareStackTrace = n;
		}
		return (n = e ? e.displayName || e.name : "") ? me(n) : "";
	}
	function _e(e, t) {
		switch (e.tag) {
			case 26:
			case 27:
			case 5: return me(e.type);
			case 16: return me("Lazy");
			case 13: return e.child !== t && t !== null ? me("Suspense Fallback") : me("Suspense");
			case 19: return me("SuspenseList");
			case 0:
			case 15: return ge(e.type, !1);
			case 11: return ge(e.type.render, !1);
			case 1: return ge(e.type, !0);
			case 31: return me("Activity");
			default: return "";
		}
	}
	function ve(e) {
		try {
			var t = "", n = null;
			do
				t += _e(e, n), n = e, e = e.return;
			while (e);
			return t;
		} catch (e) {
			return "\nError generating stack: " + e.message + "\n" + e.stack;
		}
	}
	var ye = Object.prototype.hasOwnProperty, be = t.unstable_scheduleCallback, xe = t.unstable_cancelCallback, Se = t.unstable_shouldYield, Ce = t.unstable_requestPaint, we = t.unstable_now, Te = t.unstable_getCurrentPriorityLevel, Ee = t.unstable_ImmediatePriority, De = t.unstable_UserBlockingPriority, Oe = t.unstable_NormalPriority, ke = t.unstable_LowPriority, Ae = t.unstable_IdlePriority, je = t.log, Me = t.unstable_setDisableYieldValue, Ne = null, Pe = null;
	function Fe(e) {
		if (typeof je == "function" && Me(e), Pe && typeof Pe.setStrictMode == "function") try {
			Pe.setStrictMode(Ne, e);
		} catch {}
	}
	var Ie = Math.clz32 ? Math.clz32 : ze, Le = Math.log, Re = Math.LN2;
	function ze(e) {
		return e >>>= 0, e === 0 ? 32 : 31 - (Le(e) / Re | 0) | 0;
	}
	var Be = 256, Ve = 262144, He = 4194304;
	function Ue(e) {
		var t = e & 42;
		if (t !== 0) return t;
		switch (e & -e) {
			case 1: return 1;
			case 2: return 2;
			case 4: return 4;
			case 8: return 8;
			case 16: return 16;
			case 32: return 32;
			case 64: return 64;
			case 128: return 128;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072: return e & 261888;
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return e & 3932160;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return e & 62914560;
			case 67108864: return 67108864;
			case 134217728: return 134217728;
			case 268435456: return 268435456;
			case 536870912: return 536870912;
			case 1073741824: return 0;
			default: return e;
		}
	}
	function We(e, t, n) {
		var r = e.pendingLanes;
		if (r === 0) return 0;
		var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
		e = e.warmLanes;
		var s = r & 134217727;
		return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = Ue(n))) : i = Ue(o) : i = Ue(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = Ue(n))) : i = Ue(o)) : i = Ue(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i;
	}
	function Ge(e, t) {
		return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
	}
	function Ke(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 4:
			case 8:
			case 64: return t + 250;
			case 16:
			case 32:
			case 128:
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return t + 5e3;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return -1;
			case 67108864:
			case 134217728:
			case 268435456:
			case 536870912:
			case 1073741824: return -1;
			default: return -1;
		}
	}
	function qe() {
		var e = He;
		return He <<= 1, !(He & 62914560) && (He = 4194304), e;
	}
	function Je(e) {
		for (var t = [], n = 0; 31 > n; n++) t.push(e);
		return t;
	}
	function Ye(e, t) {
		e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
	}
	function Xe(e, t, n, r, i, a) {
		var o = e.pendingLanes;
		e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
		var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
		for (n = o & ~n; 0 < n;) {
			var u = 31 - Ie(n), d = 1 << u;
			s[u] = 0, c[u] = -1;
			var f = l[u];
			if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
				var p = f[u];
				p !== null && (p.lane &= -536870913);
			}
			n &= ~d;
		}
		r !== 0 && Ze(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t));
	}
	function Ze(e, t, n) {
		e.pendingLanes |= t, e.suspendedLanes &= ~t;
		var r = 31 - Ie(t);
		e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
	}
	function Qe(e, t) {
		var n = e.entangledLanes |= t;
		for (e = e.entanglements; n;) {
			var r = 31 - Ie(n), i = 1 << r;
			i & t | e[r] & t && (e[r] |= t), n &= ~i;
		}
	}
	function $e(e, t) {
		var n = t & -t;
		return n = n & 42 ? 1 : et(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0;
	}
	function et(e) {
		switch (e) {
			case 2:
				e = 1;
				break;
			case 8:
				e = 4;
				break;
			case 32:
				e = 16;
				break;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152:
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432:
				e = 128;
				break;
			case 268435456:
				e = 134217728;
				break;
			default: e = 0;
		}
		return e;
	}
	function tt(e) {
		return e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2;
	}
	function nt() {
		var e = F.p;
		return e === 0 ? (e = window.event, e === void 0 ? 32 : mp(e.type)) : e;
	}
	function rt(e, t) {
		var n = F.p;
		try {
			return F.p = e, t();
		} finally {
			F.p = n;
		}
	}
	var it = Math.random().toString(36).slice(2), at = "__reactFiber$" + it, ot = "__reactProps$" + it, st = "__reactContainer$" + it, ct = "__reactEvents$" + it, lt = "__reactListeners$" + it, ut = "__reactHandles$" + it, dt = "__reactResources$" + it, ft = "__reactMarker$" + it;
	function pt(e) {
		delete e[at], delete e[ot], delete e[ct], delete e[lt], delete e[ut];
	}
	function mt(e) {
		var t = e[at];
		if (t) return t;
		for (var n = e.parentNode; n;) {
			if (t = n[st] || n[at]) {
				if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = df(e); e !== null;) {
					if (n = e[at]) return n;
					e = df(e);
				}
				return t;
			}
			e = n, n = e.parentNode;
		}
		return null;
	}
	function ht(e) {
		if (e = e[at] || e[st]) {
			var t = e.tag;
			if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
		}
		return null;
	}
	function gt(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
		throw Error(i(33));
	}
	function _t(e) {
		var t = e[dt];
		return t ||= e[dt] = {
			hoistableStyles: /* @__PURE__ */ new Map(),
			hoistableScripts: /* @__PURE__ */ new Map()
		}, t;
	}
	function vt(e) {
		e[ft] = !0;
	}
	var yt = /* @__PURE__ */ new Set(), bt = {};
	function xt(e, t) {
		St(e, t), St(e + "Capture", t);
	}
	function St(e, t) {
		for (bt[e] = t, e = 0; e < t.length; e++) yt.add(t[e]);
	}
	var Ct = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), wt = {}, Tt = {};
	function Et(e) {
		return ye.call(Tt, e) ? !0 : ye.call(wt, e) ? !1 : Ct.test(e) ? Tt[e] = !0 : (wt[e] = !0, !1);
	}
	function Dt(e, t, n) {
		if (Et(t)) if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
					e.removeAttribute(t);
					return;
				case "boolean":
					var r = t.toLowerCase().slice(0, 5);
					if (r !== "data-" && r !== "aria-") {
						e.removeAttribute(t);
						return;
					}
			}
			e.setAttribute(t, "" + n);
		}
	}
	function Ot(e, t, n) {
		if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(t);
					return;
			}
			e.setAttribute(t, "" + n);
		}
	}
	function kt(e, t, n, r) {
		if (r === null) e.removeAttribute(n);
		else {
			switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(n);
					return;
			}
			e.setAttributeNS(t, n, "" + r);
		}
	}
	function B(e) {
		switch (typeof e) {
			case "bigint":
			case "boolean":
			case "number":
			case "string":
			case "undefined": return e;
			case "object": return e;
			default: return "";
		}
	}
	function At(e) {
		var t = e.type;
		return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
	}
	function jt(e, t, n) {
		var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
		if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == "function" && typeof r.set == "function") {
			var i = r.get, a = r.set;
			return Object.defineProperty(e, t, {
				configurable: !0,
				get: function() {
					return i.call(this);
				},
				set: function(e) {
					n = "" + e, a.call(this, e);
				}
			}), Object.defineProperty(e, t, { enumerable: r.enumerable }), {
				getValue: function() {
					return n;
				},
				setValue: function(e) {
					n = "" + e;
				},
				stopTracking: function() {
					e._valueTracker = null, delete e[t];
				}
			};
		}
	}
	function V(e) {
		if (!e._valueTracker) {
			var t = At(e) ? "checked" : "value";
			e._valueTracker = jt(e, t, "" + e[t]);
		}
	}
	function Mt(e) {
		if (!e) return !1;
		var t = e._valueTracker;
		if (!t) return !0;
		var n = t.getValue(), r = "";
		return e && (r = At(e) ? e.checked ? "true" : "false" : e.value), e = r, e === n ? !1 : (t.setValue(e), !0);
	}
	function Nt(e) {
		if (e ||= typeof document < "u" ? document : void 0, e === void 0) return null;
		try {
			return e.activeElement || e.body;
		} catch {
			return e.body;
		}
	}
	var Pt = /[\n"\\]/g;
	function H(e) {
		return e.replace(Pt, function(e) {
			return "\\" + e.charCodeAt(0).toString(16) + " ";
		});
	}
	function Ft(e, t, n, r, i, a, o, s) {
		e.name = "", o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" ? e.type = o : e.removeAttribute("type"), t == null ? o !== "submit" && o !== "reset" || e.removeAttribute("value") : o === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + B(t)) : e.value !== "" + B(t) && (e.value = "" + B(t)), t == null ? n == null ? r != null && e.removeAttribute("value") : Lt(e, o, B(n)) : Lt(e, o, B(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != "function" && typeof i != "symbol"), s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" ? e.name = "" + B(s) : e.removeAttribute("name");
	}
	function It(e, t, n, r, i, a, o, s) {
		if (a != null && typeof a != "function" && typeof a != "symbol" && typeof a != "boolean" && (e.type = a), t != null || n != null) {
			if (!(a !== "submit" && a !== "reset" || t != null)) {
				V(e);
				return;
			}
			n = n == null ? "" : "" + B(n), t = t == null ? n : "" + B(t), s || t === e.value || (e.value = t), e.defaultValue = t;
		}
		r ??= i, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" && (e.name = o), V(e);
	}
	function Lt(e, t, n) {
		t === "number" && Nt(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
	}
	function Rt(e, t, n, r) {
		if (e = e.options, t) {
			t = {};
			for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
			for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
		} else {
			for (n = "" + B(n), t = null, i = 0; i < e.length; i++) {
				if (e[i].value === n) {
					e[i].selected = !0, r && (e[i].defaultSelected = !0);
					return;
				}
				t !== null || e[i].disabled || (t = e[i]);
			}
			t !== null && (t.selected = !0);
		}
	}
	function zt(e, t, n) {
		if (t != null && (t = "" + B(t), t !== e.value && (e.value = t), n == null)) {
			e.defaultValue !== t && (e.defaultValue = t);
			return;
		}
		e.defaultValue = n == null ? "" : "" + B(n);
	}
	function Bt(e, t, n, r) {
		if (t == null) {
			if (r != null) {
				if (n != null) throw Error(i(92));
				if (te(r)) {
					if (1 < r.length) throw Error(i(93));
					r = r[0];
				}
				n = r;
			}
			n ??= "", t = n;
		}
		n = B(t), e.defaultValue = n, r = e.textContent, r === n && r !== "" && r !== null && (e.value = r), V(e);
	}
	function Vt(e, t) {
		if (t) {
			var n = e.firstChild;
			if (n && n === e.lastChild && n.nodeType === 3) {
				n.nodeValue = t;
				return;
			}
		}
		e.textContent = t;
	}
	var Ht = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
	function Ut(e, t, n) {
		var r = t.indexOf("--") === 0;
		n == null || typeof n == "boolean" || n === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, n) : typeof n != "number" || n === 0 || Ht.has(t) ? t === "float" ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
	}
	function Wt(e, t, n) {
		if (t != null && typeof t != "object") throw Error(i(62));
		if (e = e.style, n != null) {
			for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf("--") === 0 ? e.setProperty(r, "") : r === "float" ? e.cssFloat = "" : e[r] = "");
			for (var a in t) r = t[a], t.hasOwnProperty(a) && n[a] !== r && Ut(e, a, r);
		} else for (var o in t) t.hasOwnProperty(o) && Ut(e, o, t[o]);
	}
	function Gt(e) {
		if (e.indexOf("-") === -1) return !1;
		switch (e) {
			case "annotation-xml":
			case "color-profile":
			case "font-face":
			case "font-face-src":
			case "font-face-uri":
			case "font-face-format":
			case "font-face-name":
			case "missing-glyph": return !1;
			default: return !0;
		}
	}
	var Kt = new Map([
		["acceptCharset", "accept-charset"],
		["htmlFor", "for"],
		["httpEquiv", "http-equiv"],
		["crossOrigin", "crossorigin"],
		["accentHeight", "accent-height"],
		["alignmentBaseline", "alignment-baseline"],
		["arabicForm", "arabic-form"],
		["baselineShift", "baseline-shift"],
		["capHeight", "cap-height"],
		["clipPath", "clip-path"],
		["clipRule", "clip-rule"],
		["colorInterpolation", "color-interpolation"],
		["colorInterpolationFilters", "color-interpolation-filters"],
		["colorProfile", "color-profile"],
		["colorRendering", "color-rendering"],
		["dominantBaseline", "dominant-baseline"],
		["enableBackground", "enable-background"],
		["fillOpacity", "fill-opacity"],
		["fillRule", "fill-rule"],
		["floodColor", "flood-color"],
		["floodOpacity", "flood-opacity"],
		["fontFamily", "font-family"],
		["fontSize", "font-size"],
		["fontSizeAdjust", "font-size-adjust"],
		["fontStretch", "font-stretch"],
		["fontStyle", "font-style"],
		["fontVariant", "font-variant"],
		["fontWeight", "font-weight"],
		["glyphName", "glyph-name"],
		["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
		["glyphOrientationVertical", "glyph-orientation-vertical"],
		["horizAdvX", "horiz-adv-x"],
		["horizOriginX", "horiz-origin-x"],
		["imageRendering", "image-rendering"],
		["letterSpacing", "letter-spacing"],
		["lightingColor", "lighting-color"],
		["markerEnd", "marker-end"],
		["markerMid", "marker-mid"],
		["markerStart", "marker-start"],
		["overlinePosition", "overline-position"],
		["overlineThickness", "overline-thickness"],
		["paintOrder", "paint-order"],
		["panose-1", "panose-1"],
		["pointerEvents", "pointer-events"],
		["renderingIntent", "rendering-intent"],
		["shapeRendering", "shape-rendering"],
		["stopColor", "stop-color"],
		["stopOpacity", "stop-opacity"],
		["strikethroughPosition", "strikethrough-position"],
		["strikethroughThickness", "strikethrough-thickness"],
		["strokeDasharray", "stroke-dasharray"],
		["strokeDashoffset", "stroke-dashoffset"],
		["strokeLinecap", "stroke-linecap"],
		["strokeLinejoin", "stroke-linejoin"],
		["strokeMiterlimit", "stroke-miterlimit"],
		["strokeOpacity", "stroke-opacity"],
		["strokeWidth", "stroke-width"],
		["textAnchor", "text-anchor"],
		["textDecoration", "text-decoration"],
		["textRendering", "text-rendering"],
		["transformOrigin", "transform-origin"],
		["underlinePosition", "underline-position"],
		["underlineThickness", "underline-thickness"],
		["unicodeBidi", "unicode-bidi"],
		["unicodeRange", "unicode-range"],
		["unitsPerEm", "units-per-em"],
		["vAlphabetic", "v-alphabetic"],
		["vHanging", "v-hanging"],
		["vIdeographic", "v-ideographic"],
		["vMathematical", "v-mathematical"],
		["vectorEffect", "vector-effect"],
		["vertAdvY", "vert-adv-y"],
		["vertOriginX", "vert-origin-x"],
		["vertOriginY", "vert-origin-y"],
		["wordSpacing", "word-spacing"],
		["writingMode", "writing-mode"],
		["xmlnsXlink", "xmlns:xlink"],
		["xHeight", "x-height"]
	]), qt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
	function Jt(e) {
		return qt.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
	}
	function Yt() {}
	var Xt = null;
	function Zt(e) {
		return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
	}
	var Qt = null, $t = null;
	function en(e) {
		var t = ht(e);
		if (t && (e = t.stateNode)) {
			var n = e[ot] || null;
			a: switch (e = t.stateNode, t.type) {
				case "input":
					if (Ft(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === "radio" && t != null) {
						for (n = e; n.parentNode;) n = n.parentNode;
						for (n = n.querySelectorAll("input[name=\"" + H("" + t) + "\"][type=\"radio\"]"), t = 0; t < n.length; t++) {
							var r = n[t];
							if (r !== e && r.form === e.form) {
								var a = r[ot] || null;
								if (!a) throw Error(i(90));
								Ft(r, a.value, a.defaultValue, a.defaultValue, a.checked, a.defaultChecked, a.type, a.name);
							}
						}
						for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && Mt(r);
					}
					break a;
				case "textarea":
					zt(e, n.value, n.defaultValue);
					break a;
				case "select": t = n.value, t != null && Rt(e, !!n.multiple, t, !1);
			}
		}
	}
	var tn = !1;
	function nn(e, t, n) {
		if (tn) return e(t, n);
		tn = !0;
		try {
			return e(t);
		} finally {
			if (tn = !1, (Qt !== null || $t !== null) && (vu(), Qt && (t = Qt, e = $t, $t = Qt = null, en(t), e))) for (t = 0; t < e.length; t++) en(e[t]);
		}
	}
	function rn(e, t) {
		var n = e.stateNode;
		if (n === null) return null;
		var r = n[ot] || null;
		if (r === null) return null;
		n = r[t];
		a: switch (t) {
			case "onClick":
			case "onClickCapture":
			case "onDoubleClick":
			case "onDoubleClickCapture":
			case "onMouseDown":
			case "onMouseDownCapture":
			case "onMouseMove":
			case "onMouseMoveCapture":
			case "onMouseUp":
			case "onMouseUpCapture":
			case "onMouseEnter":
				(r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
				break a;
			default: e = !1;
		}
		if (e) return null;
		if (n && typeof n != "function") throw Error(i(231, t, typeof n));
		return n;
	}
	var an = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), on = !1;
	if (an) try {
		var sn = {};
		Object.defineProperty(sn, "passive", { get: function() {
			on = !0;
		} }), window.addEventListener("test", sn, sn), window.removeEventListener("test", sn, sn);
	} catch {
		on = !1;
	}
	var cn = null, ln = null, un = null;
	function dn() {
		if (un) return un;
		var e, t = ln, n = t.length, r, i = "value" in cn ? cn.value : cn.textContent, a = i.length;
		for (e = 0; e < n && t[e] === i[e]; e++);
		var o = n - e;
		for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
		return un = i.slice(e, 1 < r ? 1 - r : void 0);
	}
	function fn(e) {
		var t = e.keyCode;
		return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
	}
	function pn() {
		return !0;
	}
	function mn() {
		return !1;
	}
	function hn(e) {
		function t(t, n, r, i, a) {
			for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
			return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? pn : mn, this.isPropagationStopped = mn, this;
		}
		return h(t.prototype, {
			preventDefault: function() {
				this.defaultPrevented = !0;
				var e = this.nativeEvent;
				e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = pn);
			},
			stopPropagation: function() {
				var e = this.nativeEvent;
				e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = pn);
			},
			persist: function() {},
			isPersistent: pn
		}), t;
	}
	var gn = {
		eventPhase: 0,
		bubbles: 0,
		cancelable: 0,
		timeStamp: function(e) {
			return e.timeStamp || Date.now();
		},
		defaultPrevented: 0,
		isTrusted: 0
	}, _n = hn(gn), vn = h({}, gn, {
		view: 0,
		detail: 0
	}), yn = hn(vn), bn, xn, Sn, Cn = h({}, vn, {
		screenX: 0,
		screenY: 0,
		clientX: 0,
		clientY: 0,
		pageX: 0,
		pageY: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		getModifierState: Nn,
		button: 0,
		buttons: 0,
		relatedTarget: function(e) {
			return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
		},
		movementX: function(e) {
			return "movementX" in e ? e.movementX : (e !== Sn && (Sn && e.type === "mousemove" ? (bn = e.screenX - Sn.screenX, xn = e.screenY - Sn.screenY) : xn = bn = 0, Sn = e), bn);
		},
		movementY: function(e) {
			return "movementY" in e ? e.movementY : xn;
		}
	}), wn = hn(Cn), Tn = hn(h({}, Cn, { dataTransfer: 0 })), En = hn(h({}, vn, { relatedTarget: 0 })), Dn = hn(h({}, gn, {
		animationName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), On = hn(h({}, gn, { clipboardData: function(e) {
		return "clipboardData" in e ? e.clipboardData : window.clipboardData;
	} })), U = hn(h({}, gn, { data: 0 })), kn = {
		Esc: "Escape",
		Spacebar: " ",
		Left: "ArrowLeft",
		Up: "ArrowUp",
		Right: "ArrowRight",
		Down: "ArrowDown",
		Del: "Delete",
		Win: "OS",
		Menu: "ContextMenu",
		Apps: "ContextMenu",
		Scroll: "ScrollLock",
		MozPrintableKey: "Unidentified"
	}, An = {
		8: "Backspace",
		9: "Tab",
		12: "Clear",
		13: "Enter",
		16: "Shift",
		17: "Control",
		18: "Alt",
		19: "Pause",
		20: "CapsLock",
		27: "Escape",
		32: " ",
		33: "PageUp",
		34: "PageDown",
		35: "End",
		36: "Home",
		37: "ArrowLeft",
		38: "ArrowUp",
		39: "ArrowRight",
		40: "ArrowDown",
		45: "Insert",
		46: "Delete",
		112: "F1",
		113: "F2",
		114: "F3",
		115: "F4",
		116: "F5",
		117: "F6",
		118: "F7",
		119: "F8",
		120: "F9",
		121: "F10",
		122: "F11",
		123: "F12",
		144: "NumLock",
		145: "ScrollLock",
		224: "Meta"
	}, jn = {
		Alt: "altKey",
		Control: "ctrlKey",
		Meta: "metaKey",
		Shift: "shiftKey"
	};
	function Mn(e) {
		var t = this.nativeEvent;
		return t.getModifierState ? t.getModifierState(e) : (e = jn[e]) ? !!t[e] : !1;
	}
	function Nn() {
		return Mn;
	}
	var Pn = hn(h({}, vn, {
		key: function(e) {
			if (e.key) {
				var t = kn[e.key] || e.key;
				if (t !== "Unidentified") return t;
			}
			return e.type === "keypress" ? (e = fn(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? An[e.keyCode] || "Unidentified" : "";
		},
		code: 0,
		location: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		repeat: 0,
		locale: 0,
		getModifierState: Nn,
		charCode: function(e) {
			return e.type === "keypress" ? fn(e) : 0;
		},
		keyCode: function(e) {
			return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		},
		which: function(e) {
			return e.type === "keypress" ? fn(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		}
	})), Fn = hn(h({}, Cn, {
		pointerId: 0,
		width: 0,
		height: 0,
		pressure: 0,
		tangentialPressure: 0,
		tiltX: 0,
		tiltY: 0,
		twist: 0,
		pointerType: 0,
		isPrimary: 0
	})), In = hn(h({}, vn, {
		touches: 0,
		targetTouches: 0,
		changedTouches: 0,
		altKey: 0,
		metaKey: 0,
		ctrlKey: 0,
		shiftKey: 0,
		getModifierState: Nn
	})), Ln = hn(h({}, gn, {
		propertyName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), Rn = hn(h({}, Cn, {
		deltaX: function(e) {
			return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
		},
		deltaY: function(e) {
			return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
		},
		deltaZ: 0,
		deltaMode: 0
	})), zn = hn(h({}, gn, {
		newState: 0,
		oldState: 0
	})), Bn = [
		9,
		13,
		27,
		32
	], Vn = an && "CompositionEvent" in window, Hn = null;
	an && "documentMode" in document && (Hn = document.documentMode);
	var Un = an && "TextEvent" in window && !Hn, Wn = an && (!Vn || Hn && 8 < Hn && 11 >= Hn), Gn = " ", Kn = !1;
	function W(e, t) {
		switch (e) {
			case "keyup": return Bn.indexOf(t.keyCode) !== -1;
			case "keydown": return t.keyCode !== 229;
			case "keypress":
			case "mousedown":
			case "focusout": return !0;
			default: return !1;
		}
	}
	function qn(e) {
		return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
	}
	var Jn = !1;
	function Yn(e, t) {
		switch (e) {
			case "compositionend": return qn(t);
			case "keypress": return t.which === 32 ? (Kn = !0, Gn) : null;
			case "textInput": return e = t.data, e === Gn && Kn ? null : e;
			default: return null;
		}
	}
	function Xn(e, t) {
		if (Jn) return e === "compositionend" || !Vn && W(e, t) ? (e = dn(), un = ln = cn = null, Jn = !1, e) : null;
		switch (e) {
			case "paste": return null;
			case "keypress":
				if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
					if (t.char && 1 < t.char.length) return t.char;
					if (t.which) return String.fromCharCode(t.which);
				}
				return null;
			case "compositionend": return Wn && t.locale !== "ko" ? null : t.data;
			default: return null;
		}
	}
	var Zn = {
		color: !0,
		date: !0,
		datetime: !0,
		"datetime-local": !0,
		email: !0,
		month: !0,
		number: !0,
		password: !0,
		range: !0,
		search: !0,
		tel: !0,
		text: !0,
		time: !0,
		url: !0,
		week: !0
	};
	function Qn(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t === "input" ? !!Zn[e.type] : t === "textarea";
	}
	function $n(e, t, n, r) {
		Qt ? $t ? $t.push(r) : $t = [r] : Qt = r, t = Td(t, "onChange"), 0 < t.length && (n = new _n("onChange", "change", null, n, r), e.push({
			event: n,
			listeners: t
		}));
	}
	var er = null, tr = null;
	function nr(e) {
		vd(e, 0);
	}
	function rr(e) {
		if (Mt(gt(e))) return e;
	}
	function ir(e, t) {
		if (e === "change") return t;
	}
	var ar = !1;
	if (an) {
		var or;
		if (an) {
			var sr = "oninput" in document;
			if (!sr) {
				var cr = document.createElement("div");
				cr.setAttribute("oninput", "return;"), sr = typeof cr.oninput == "function";
			}
			or = sr;
		} else or = !1;
		ar = or && (!document.documentMode || 9 < document.documentMode);
	}
	function lr() {
		er && (er.detachEvent("onpropertychange", ur), tr = er = null);
	}
	function ur(e) {
		if (e.propertyName === "value" && rr(tr)) {
			var t = [];
			$n(t, tr, e, Zt(e)), nn(nr, t);
		}
	}
	function dr(e, t, n) {
		e === "focusin" ? (lr(), er = t, tr = n, er.attachEvent("onpropertychange", ur)) : e === "focusout" && lr();
	}
	function fr(e) {
		if (e === "selectionchange" || e === "keyup" || e === "keydown") return rr(tr);
	}
	function pr(e, t) {
		if (e === "click") return rr(t);
	}
	function mr(e, t) {
		if (e === "input" || e === "change") return rr(t);
	}
	function hr(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var gr = typeof Object.is == "function" ? Object.is : hr;
	function _r(e, t) {
		if (gr(e, t)) return !0;
		if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
		var n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (r = 0; r < n.length; r++) {
			var i = n[r];
			if (!ye.call(t, i) || !gr(e[i], t[i])) return !1;
		}
		return !0;
	}
	function vr(e) {
		for (; e && e.firstChild;) e = e.firstChild;
		return e;
	}
	function yr(e, t) {
		var n = vr(e);
		e = 0;
		for (var r; n;) {
			if (n.nodeType === 3) {
				if (r = e + n.textContent.length, e <= t && r >= t) return {
					node: n,
					offset: t - e
				};
				e = r;
			}
			a: {
				for (; n;) {
					if (n.nextSibling) {
						n = n.nextSibling;
						break a;
					}
					n = n.parentNode;
				}
				n = void 0;
			}
			n = vr(n);
		}
	}
	function br(e, t) {
		return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? br(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
	}
	function xr(e) {
		e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
		for (var t = Nt(e.document); t instanceof e.HTMLIFrameElement;) {
			try {
				var n = typeof t.contentWindow.location.href == "string";
			} catch {
				n = !1;
			}
			if (n) e = t.contentWindow;
			else break;
			t = Nt(e.document);
		}
		return t;
	}
	function Sr(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
	}
	var Cr = an && "documentMode" in document && 11 >= document.documentMode, wr = null, Tr = null, Er = null, Dr = !1;
	function Or(e, t, n) {
		var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
		Dr || wr == null || wr !== Nt(r) || (r = wr, "selectionStart" in r && Sr(r) ? r = {
			start: r.selectionStart,
			end: r.selectionEnd
		} : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
			anchorNode: r.anchorNode,
			anchorOffset: r.anchorOffset,
			focusNode: r.focusNode,
			focusOffset: r.focusOffset
		}), Er && _r(Er, r) || (Er = r, r = Td(Tr, "onSelect"), 0 < r.length && (t = new _n("onSelect", "select", null, t, n), e.push({
			event: t,
			listeners: r
		}), t.target = wr)));
	}
	function kr(e, t) {
		var n = {};
		return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
	}
	var Ar = {
		animationend: kr("Animation", "AnimationEnd"),
		animationiteration: kr("Animation", "AnimationIteration"),
		animationstart: kr("Animation", "AnimationStart"),
		transitionrun: kr("Transition", "TransitionRun"),
		transitionstart: kr("Transition", "TransitionStart"),
		transitioncancel: kr("Transition", "TransitionCancel"),
		transitionend: kr("Transition", "TransitionEnd")
	}, jr = {}, Mr = {};
	an && (Mr = document.createElement("div").style, "AnimationEvent" in window || (delete Ar.animationend.animation, delete Ar.animationiteration.animation, delete Ar.animationstart.animation), "TransitionEvent" in window || delete Ar.transitionend.transition);
	function Nr(e) {
		if (jr[e]) return jr[e];
		if (!Ar[e]) return e;
		var t = Ar[e], n;
		for (n in t) if (t.hasOwnProperty(n) && n in Mr) return jr[e] = t[n];
		return e;
	}
	var Pr = Nr("animationend"), Fr = Nr("animationiteration"), Ir = Nr("animationstart"), Lr = Nr("transitionrun"), Rr = Nr("transitionstart"), zr = Nr("transitioncancel"), Br = Nr("transitionend"), Vr = /* @__PURE__ */ new Map(), Hr = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	Hr.push("scrollEnd");
	function Ur(e, t) {
		Vr.set(e, t), xt(t, [e]);
	}
	var Wr = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, Gr = [], Kr = 0, qr = 0;
	function Jr() {
		for (var e = Kr, t = qr = Kr = 0; t < e;) {
			var n = Gr[t];
			Gr[t++] = null;
			var r = Gr[t];
			Gr[t++] = null;
			var i = Gr[t];
			Gr[t++] = null;
			var a = Gr[t];
			if (Gr[t++] = null, r !== null && i !== null) {
				var o = r.pending;
				o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
			}
			a !== 0 && Qr(n, i, a);
		}
	}
	function Yr(e, t, n, r) {
		Gr[Kr++] = e, Gr[Kr++] = t, Gr[Kr++] = n, Gr[Kr++] = r, qr |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
	}
	function Xr(e, t, n, r) {
		return Yr(e, t, n, r), $r(e);
	}
	function Zr(e, t) {
		return Yr(e, null, null, t), $r(e);
	}
	function Qr(e, t, n) {
		e.lanes |= n;
		var r = e.alternate;
		r !== null && (r.lanes |= n);
		for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return;
		return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - Ie(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
	}
	function $r(e) {
		if (50 < lu) throw lu = 0, uu = null, Error(i(185));
		for (var t = e.return; t !== null;) e = t, t = e.return;
		return e.tag === 3 ? e.stateNode : null;
	}
	var ei = {};
	function ti(e, t, n, r) {
		this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
	}
	function ni(e, t, n, r) {
		return new ti(e, t, n, r);
	}
	function ri(e) {
		return e = e.prototype, !(!e || !e.isReactComponent);
	}
	function ii(e, t) {
		var n = e.alternate;
		return n === null ? (n = ni(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
	}
	function ai(e, t) {
		e.flags &= 65011714;
		var n = e.alternate;
		return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}), e;
	}
	function oi(e, t, n, r, a, o) {
		var s = 0;
		if (r = e, typeof e == "function") ri(e) && (s = 1);
		else if (typeof e == "string") s = Uf(e, n, ae.current) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
		else a: switch (e) {
			case k: return e = ni(31, n, t, a), e.elementType = k, e.lanes = o, e;
			case y: return si(n.children, a, o, t);
			case b:
				s = 8, a |= 24;
				break;
			case x: return e = ni(12, n, t, a | 2), e.elementType = x, e.lanes = o, e;
			case T: return e = ni(13, n, t, a), e.elementType = T, e.lanes = o, e;
			case E: return e = ni(19, n, t, a), e.elementType = E, e.lanes = o, e;
			default:
				if (typeof e == "object" && e) switch (e.$$typeof) {
					case C:
						s = 10;
						break a;
					case S:
						s = 9;
						break a;
					case w:
						s = 11;
						break a;
					case D:
						s = 14;
						break a;
					case O:
						s = 16, r = null;
						break a;
				}
				s = 29, n = Error(i(130, e === null ? "null" : typeof e, "")), r = null;
		}
		return t = ni(s, n, t, a), t.elementType = e, t.type = r, t.lanes = o, t;
	}
	function si(e, t, n, r) {
		return e = ni(7, e, r, t), e.lanes = n, e;
	}
	function ci(e, t, n) {
		return e = ni(6, e, null, t), e.lanes = n, e;
	}
	function li(e) {
		var t = ni(18, null, null, 0);
		return t.stateNode = e, t;
	}
	function ui(e, t, n) {
		return t = ni(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
			containerInfo: e.containerInfo,
			pendingChildren: null,
			implementation: e.implementation
		}, t;
	}
	var di = /* @__PURE__ */ new WeakMap();
	function fi(e, t) {
		if (typeof e == "object" && e) {
			var n = di.get(e);
			return n === void 0 ? (t = {
				value: e,
				source: t,
				stack: ve(t)
			}, di.set(e, t), t) : n;
		}
		return {
			value: e,
			source: t,
			stack: ve(t)
		};
	}
	var pi = [], mi = 0, hi = null, gi = 0, _i = [], vi = 0, yi = null, bi = 1, xi = "";
	function Si(e, t) {
		pi[mi++] = gi, pi[mi++] = hi, hi = e, gi = t;
	}
	function Ci(e, t, n) {
		_i[vi++] = bi, _i[vi++] = xi, _i[vi++] = yi, yi = e;
		var r = bi;
		e = xi;
		var i = 32 - Ie(r) - 1;
		r &= ~(1 << i), n += 1;
		var a = 32 - Ie(t) + i;
		if (30 < a) {
			var o = i - i % 5;
			a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, bi = 1 << 32 - Ie(t) + i | n << i | r, xi = a + e;
		} else bi = 1 << a | n << i | r, xi = e;
	}
	function wi(e) {
		e.return !== null && (Si(e, 1), Ci(e, 1, 0));
	}
	function Ti(e) {
		for (; e === hi;) hi = pi[--mi], pi[mi] = null, gi = pi[--mi], pi[mi] = null;
		for (; e === yi;) yi = _i[--vi], _i[vi] = null, xi = _i[--vi], _i[vi] = null, bi = _i[--vi], _i[vi] = null;
	}
	function Ei(e, t) {
		_i[vi++] = bi, _i[vi++] = xi, _i[vi++] = yi, bi = t.id, xi = t.overflow, yi = e;
	}
	var Di = null, Oi = null, G = !1, ki = null, Ai = !1, ji = Error(i(519));
	function Mi(e) {
		throw Ri(fi(Error(i(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", "")), e)), ji;
	}
	function Ni(e) {
		var t = e.stateNode, n = e.type, r = e.memoizedProps;
		switch (t[at] = e, t[ot] = r, n) {
			case "dialog":
				$("cancel", t), $("close", t);
				break;
			case "iframe":
			case "object":
			case "embed":
				$("load", t);
				break;
			case "video":
			case "audio":
				for (n = 0; n < gd.length; n++) $(gd[n], t);
				break;
			case "source":
				$("error", t);
				break;
			case "img":
			case "image":
			case "link":
				$("error", t), $("load", t);
				break;
			case "details":
				$("toggle", t);
				break;
			case "input":
				$("invalid", t), It(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
				break;
			case "select":
				$("invalid", t);
				break;
			case "textarea": $("invalid", t), Bt(t, r.value, r.defaultValue, r.children);
		}
		n = r.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || !0 === r.suppressHydrationWarning || jd(t.textContent, n) ? (r.popover != null && ($("beforetoggle", t), $("toggle", t)), r.onScroll != null && $("scroll", t), r.onScrollEnd != null && $("scrollend", t), r.onClick != null && (t.onclick = Yt), t = !0) : t = !1, t || Mi(e, !0);
	}
	function Pi(e) {
		for (Di = e.return; Di;) switch (Di.tag) {
			case 5:
			case 31:
			case 13:
				Ai = !1;
				return;
			case 27:
			case 3:
				Ai = !0;
				return;
			default: Di = Di.return;
		}
	}
	function Fi(e) {
		if (e !== Di) return !1;
		if (!G) return Pi(e), G = !0, !1;
		var t = e.tag, n;
		if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = !(n !== "form" && n !== "button") || Ud(e.type, e.memoizedProps)), n = !n), n && Oi && Mi(e), Pi(e), t === 13) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			Oi = uf(e);
		} else if (t === 31) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			Oi = uf(e);
		} else t === 27 ? (t = Oi, Zd(e.type) ? (e = lf, lf = null, Oi = e) : Oi = t) : Oi = Di ? cf(e.stateNode.nextSibling) : null;
		return !0;
	}
	function Ii() {
		Oi = Di = null, G = !1;
	}
	function Li() {
		var e = ki;
		return e !== null && (Yl === null ? Yl = e : Yl.push.apply(Yl, e), ki = null), e;
	}
	function Ri(e) {
		ki === null ? ki = [e] : ki.push(e);
	}
	var zi = I(null), Bi = null, Vi = null;
	function Hi(e, t, n) {
		R(zi, t._currentValue), t._currentValue = n;
	}
	function Ui(e) {
		e._currentValue = zi.current, L(zi);
	}
	function Wi(e, t, n) {
		for (; e !== null;) {
			var r = e.alternate;
			if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
			e = e.return;
		}
	}
	function Gi(e, t, n, r) {
		var a = e.child;
		for (a !== null && (a.return = e); a !== null;) {
			var o = a.dependencies;
			if (o !== null) {
				var s = a.child;
				o = o.firstContext;
				a: for (; o !== null;) {
					var c = o;
					o = a;
					for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
						o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), Wi(o.return, n, e), r || (s = null);
						break a;
					}
					o = c.next;
				}
			} else if (a.tag === 18) {
				if (s = a.return, s === null) throw Error(i(341));
				s.lanes |= n, o = s.alternate, o !== null && (o.lanes |= n), Wi(s, n, e), s = null;
			} else s = a.child;
			if (s !== null) s.return = a;
			else for (s = a; s !== null;) {
				if (s === e) {
					s = null;
					break;
				}
				if (a = s.sibling, a !== null) {
					a.return = s.return, s = a;
					break;
				}
				s = s.return;
			}
			a = s;
		}
	}
	function Ki(e, t, n, r) {
		e = null;
		for (var a = t, o = !1; a !== null;) {
			if (!o) {
				if (a.flags & 524288) o = !0;
				else if (a.flags & 262144) break;
			}
			if (a.tag === 10) {
				var s = a.alternate;
				if (s === null) throw Error(i(387));
				if (s = s.memoizedProps, s !== null) {
					var c = a.type;
					gr(a.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c));
				}
			} else if (a === se.current) {
				if (s = a.alternate, s === null) throw Error(i(387));
				s.memoizedState.memoizedState !== a.memoizedState.memoizedState && (e === null ? e = [Qf] : e.push(Qf));
			}
			a = a.return;
		}
		e !== null && Gi(t, e, n, r), t.flags |= 262144;
	}
	function qi(e) {
		for (e = e.firstContext; e !== null;) {
			if (!gr(e.context._currentValue, e.memoizedValue)) return !0;
			e = e.next;
		}
		return !1;
	}
	function Ji(e) {
		Bi = e, Vi = null, e = e.dependencies, e !== null && (e.firstContext = null);
	}
	function Yi(e) {
		return Zi(Bi, e);
	}
	function Xi(e, t) {
		return Bi === null && Ji(e), Zi(e, t);
	}
	function Zi(e, t) {
		var n = t._currentValue;
		if (t = {
			context: t,
			memoizedValue: n,
			next: null
		}, Vi === null) {
			if (e === null) throw Error(i(308));
			Vi = t, e.dependencies = {
				lanes: 0,
				firstContext: t
			}, e.flags |= 524288;
		} else Vi = Vi.next = t;
		return n;
	}
	var Qi = typeof AbortController < "u" ? AbortController : function() {
		var e = [], t = this.signal = {
			aborted: !1,
			addEventListener: function(t, n) {
				e.push(n);
			}
		};
		this.abort = function() {
			t.aborted = !0, e.forEach(function(e) {
				return e();
			});
		};
	}, $i = t.unstable_scheduleCallback, ea = t.unstable_NormalPriority, ta = {
		$$typeof: C,
		Consumer: null,
		Provider: null,
		_currentValue: null,
		_currentValue2: null,
		_threadCount: 0
	};
	function na() {
		return {
			controller: new Qi(),
			data: /* @__PURE__ */ new Map(),
			refCount: 0
		};
	}
	function ra(e) {
		e.refCount--, e.refCount === 0 && $i(ea, function() {
			e.controller.abort();
		});
	}
	var ia = null, aa = 0, oa = 0, sa = null;
	function ca(e, t) {
		if (ia === null) {
			var n = ia = [];
			aa = 0, oa = ud(), sa = {
				status: "pending",
				value: void 0,
				then: function(e) {
					n.push(e);
				}
			};
		}
		return aa++, t.then(la, la), t;
	}
	function la() {
		if (--aa === 0 && ia !== null) {
			sa !== null && (sa.status = "fulfilled");
			var e = ia;
			ia = null, oa = 0, sa = null;
			for (var t = 0; t < e.length; t++) (0, e[t])();
		}
	}
	function ua(e, t) {
		var n = [], r = {
			status: "pending",
			value: null,
			reason: null,
			then: function(e) {
				n.push(e);
			}
		};
		return e.then(function() {
			r.status = "fulfilled", r.value = t;
			for (var e = 0; e < n.length; e++) (0, n[e])(t);
		}, function(e) {
			for (r.status = "rejected", r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0);
		}), r;
	}
	var da = P.S;
	P.S = function(e, t) {
		Ql = we(), typeof t == "object" && t && typeof t.then == "function" && ca(e, t), da !== null && da(e, t);
	};
	var fa = I(null);
	function pa() {
		var e = fa.current;
		return e === null ? Fl.pooledCache : e;
	}
	function ma(e, t) {
		t === null ? R(fa, fa.current) : R(fa, t.pool);
	}
	function ha() {
		var e = pa();
		return e === null ? null : {
			parent: ta._currentValue,
			pool: e
		};
	}
	var ga = Error(i(460)), _a = Error(i(474)), va = Error(i(542)), ya = { then: function() {} };
	function ba(e) {
		return e = e.status, e === "fulfilled" || e === "rejected";
	}
	function xa(e, t, n) {
		switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(Yt, Yt), t = n), t.status) {
			case "fulfilled": return t.value;
			case "rejected": throw e = t.reason, Ta(e), e;
			default:
				if (typeof t.status == "string") t.then(Yt, Yt);
				else {
					if (e = Fl, e !== null && 100 < e.shellSuspendCounter) throw Error(i(482));
					e = t, e.status = "pending", e.then(function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "fulfilled", n.value = e;
						}
					}, function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "rejected", n.reason = e;
						}
					});
				}
				switch (t.status) {
					case "fulfilled": return t.value;
					case "rejected": throw e = t.reason, Ta(e), e;
				}
				throw Ca = t, ga;
		}
	}
	function Sa(e) {
		try {
			var t = e._init;
			return t(e._payload);
		} catch (e) {
			throw typeof e == "object" && e && typeof e.then == "function" ? (Ca = e, ga) : e;
		}
	}
	var Ca = null;
	function wa() {
		if (Ca === null) throw Error(i(459));
		var e = Ca;
		return Ca = null, e;
	}
	function Ta(e) {
		if (e === ga || e === va) throw Error(i(483));
	}
	var Ea = null, Da = 0;
	function Oa(e) {
		var t = Da;
		return Da += 1, Ea === null && (Ea = []), xa(Ea, e, t);
	}
	function ka(e, t) {
		t = t.props.ref, e.ref = t === void 0 ? null : t;
	}
	function Aa(e, t) {
		throw t.$$typeof === g ? Error(i(525)) : (e = Object.prototype.toString.call(t), Error(i(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e)));
	}
	function ja(e) {
		function t(t, n) {
			if (e) {
				var r = t.deletions;
				r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
			}
		}
		function n(n, r) {
			if (!e) return null;
			for (; r !== null;) t(n, r), r = r.sibling;
			return null;
		}
		function r(e) {
			for (var t = /* @__PURE__ */ new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
			return t;
		}
		function a(e, t) {
			return e = ii(e, t), e.index = 0, e.sibling = null, e;
		}
		function o(t, n, r) {
			return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n);
		}
		function s(t) {
			return e && t.alternate === null && (t.flags |= 67108866), t;
		}
		function c(e, t, n, r) {
			return t === null || t.tag !== 6 ? (t = ci(n, e.mode, r), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function l(e, t, n, r) {
			var i = n.type;
			return i === y ? d(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === i || typeof i == "object" && i && i.$$typeof === O && Sa(i) === t.type) ? (t = a(t, n.props), ka(t, n), t.return = e, t) : (t = oi(n.type, n.key, n.props, null, e.mode, r), ka(t, n), t.return = e, t);
		}
		function u(e, t, n, r) {
			return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = ui(n, e.mode, r), t.return = e, t) : (t = a(t, n.children || []), t.return = e, t);
		}
		function d(e, t, n, r, i) {
			return t === null || t.tag !== 7 ? (t = si(n, e.mode, r, i), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function f(e, t, n) {
			if (typeof t == "string" && t !== "" || typeof t == "number" || typeof t == "bigint") return t = ci("" + t, e.mode, n), t.return = e, t;
			if (typeof t == "object" && t) {
				switch (t.$$typeof) {
					case _: return n = oi(t.type, t.key, t.props, null, e.mode, n), ka(n, t), n.return = e, n;
					case v: return t = ui(t, e.mode, n), t.return = e, t;
					case O: return t = Sa(t), f(e, t, n);
				}
				if (te(t) || M(t)) return t = si(t, e.mode, n, null), t.return = e, t;
				if (typeof t.then == "function") return f(e, Oa(t), n);
				if (t.$$typeof === C) return f(e, Xi(e, t), n);
				Aa(e, t);
			}
			return null;
		}
		function p(e, t, n, r) {
			var i = t === null ? null : t.key;
			if (typeof n == "string" && n !== "" || typeof n == "number" || typeof n == "bigint") return i === null ? c(e, t, "" + n, r) : null;
			if (typeof n == "object" && n) {
				switch (n.$$typeof) {
					case _: return n.key === i ? l(e, t, n, r) : null;
					case v: return n.key === i ? u(e, t, n, r) : null;
					case O: return n = Sa(n), p(e, t, n, r);
				}
				if (te(n) || M(n)) return i === null ? d(e, t, n, r, null) : null;
				if (typeof n.then == "function") return p(e, t, Oa(n), r);
				if (n.$$typeof === C) return p(e, t, Xi(e, n), r);
				Aa(e, n);
			}
			return null;
		}
		function m(e, t, n, r, i) {
			if (typeof r == "string" && r !== "" || typeof r == "number" || typeof r == "bigint") return e = e.get(n) || null, c(t, e, "" + r, i);
			if (typeof r == "object" && r) {
				switch (r.$$typeof) {
					case _: return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
					case v: return e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i);
					case O: return r = Sa(r), m(e, t, n, r, i);
				}
				if (te(r) || M(r)) return e = e.get(n) || null, d(t, e, r, i, null);
				if (typeof r.then == "function") return m(e, t, n, Oa(r), i);
				if (r.$$typeof === C) return m(e, t, n, Xi(t, r), i);
				Aa(t, r);
			}
			return null;
		}
		function h(i, a, s, c) {
			for (var l = null, u = null, d = a, h = a = 0, g = null; d !== null && h < s.length; h++) {
				d.index > h ? (g = d, d = null) : g = d.sibling;
				var _ = p(i, d, s[h], c);
				if (_ === null) {
					d === null && (d = g);
					break;
				}
				e && d && _.alternate === null && t(i, d), a = o(_, a, h), u === null ? l = _ : u.sibling = _, u = _, d = g;
			}
			if (h === s.length) return n(i, d), G && Si(i, h), l;
			if (d === null) {
				for (; h < s.length; h++) d = f(i, s[h], c), d !== null && (a = o(d, a, h), u === null ? l = d : u.sibling = d, u = d);
				return G && Si(i, h), l;
			}
			for (d = r(d); h < s.length; h++) g = m(d, i, h, s[h], c), g !== null && (e && g.alternate !== null && d.delete(g.key === null ? h : g.key), a = o(g, a, h), u === null ? l = g : u.sibling = g, u = g);
			return e && d.forEach(function(e) {
				return t(i, e);
			}), G && Si(i, h), l;
		}
		function g(a, s, c, l) {
			if (c == null) throw Error(i(151));
			for (var u = null, d = null, h = s, g = s = 0, _ = null, v = c.next(); h !== null && !v.done; g++, v = c.next()) {
				h.index > g ? (_ = h, h = null) : _ = h.sibling;
				var y = p(a, h, v.value, l);
				if (y === null) {
					h === null && (h = _);
					break;
				}
				e && h && y.alternate === null && t(a, h), s = o(y, s, g), d === null ? u = y : d.sibling = y, d = y, h = _;
			}
			if (v.done) return n(a, h), G && Si(a, g), u;
			if (h === null) {
				for (; !v.done; g++, v = c.next()) v = f(a, v.value, l), v !== null && (s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
				return G && Si(a, g), u;
			}
			for (h = r(h); !v.done; g++, v = c.next()) v = m(h, a, g, v.value, l), v !== null && (e && v.alternate !== null && h.delete(v.key === null ? g : v.key), s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
			return e && h.forEach(function(e) {
				return t(a, e);
			}), G && Si(a, g), u;
		}
		function b(e, r, o, c) {
			if (typeof o == "object" && o && o.type === y && o.key === null && (o = o.props.children), typeof o == "object" && o) {
				switch (o.$$typeof) {
					case _:
						a: {
							for (var l = o.key; r !== null;) {
								if (r.key === l) {
									if (l = o.type, l === y) {
										if (r.tag === 7) {
											n(e, r.sibling), c = a(r, o.props.children), c.return = e, e = c;
											break a;
										}
									} else if (r.elementType === l || typeof l == "object" && l && l.$$typeof === O && Sa(l) === r.type) {
										n(e, r.sibling), c = a(r, o.props), ka(c, o), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								} else t(e, r);
								r = r.sibling;
							}
							o.type === y ? (c = si(o.props.children, e.mode, c, o.key), c.return = e, e = c) : (c = oi(o.type, o.key, o.props, null, e.mode, c), ka(c, o), c.return = e, e = c);
						}
						return s(e);
					case v:
						a: {
							for (l = o.key; r !== null;) {
								if (r.key === l) if (r.tag === 4 && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
									n(e, r.sibling), c = a(r, o.children || []), c.return = e, e = c;
									break a;
								} else {
									n(e, r);
									break;
								}
								else t(e, r);
								r = r.sibling;
							}
							c = ui(o, e.mode, c), c.return = e, e = c;
						}
						return s(e);
					case O: return o = Sa(o), b(e, r, o, c);
				}
				if (te(o)) return h(e, r, o, c);
				if (M(o)) {
					if (l = M(o), typeof l != "function") throw Error(i(150));
					return o = l.call(o), g(e, r, o, c);
				}
				if (typeof o.then == "function") return b(e, r, Oa(o), c);
				if (o.$$typeof === C) return b(e, r, Xi(e, o), c);
				Aa(e, o);
			}
			return typeof o == "string" && o !== "" || typeof o == "number" || typeof o == "bigint" ? (o = "" + o, r !== null && r.tag === 6 ? (n(e, r.sibling), c = a(r, o), c.return = e, e = c) : (n(e, r), c = ci(o, e.mode, c), c.return = e, e = c), s(e)) : n(e, r);
		}
		return function(e, t, n, r) {
			try {
				Da = 0;
				var i = b(e, t, n, r);
				return Ea = null, i;
			} catch (t) {
				if (t === ga || t === va) throw t;
				var a = ni(29, t, null, e.mode);
				return a.lanes = r, a.return = e, a;
			}
		};
	}
	var Ma = ja(!0), Na = ja(!1), Pa = !1;
	function Fa(e) {
		e.updateQueue = {
			baseState: e.memoizedState,
			firstBaseUpdate: null,
			lastBaseUpdate: null,
			shared: {
				pending: null,
				lanes: 0,
				hiddenCallbacks: null
			},
			callbacks: null
		};
	}
	function Ia(e, t) {
		e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
			baseState: e.baseState,
			firstBaseUpdate: e.firstBaseUpdate,
			lastBaseUpdate: e.lastBaseUpdate,
			shared: e.shared,
			callbacks: null
		});
	}
	function La(e) {
		return {
			lane: e,
			tag: 0,
			payload: null,
			callback: null,
			next: null
		};
	}
	function Ra(e, t, n) {
		var r = e.updateQueue;
		if (r === null) return null;
		if (r = r.shared, X & 2) {
			var i = r.pending;
			return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = $r(e), Qr(e, null, n), t;
		}
		return Yr(e, r, t, n), $r(e);
	}
	function za(e, t, n) {
		if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, Qe(e, n);
		}
	}
	function Ba(e, t) {
		var n = e.updateQueue, r = e.alternate;
		if (r !== null && (r = r.updateQueue, n === r)) {
			var i = null, a = null;
			if (n = n.firstBaseUpdate, n !== null) {
				do {
					var o = {
						lane: n.lane,
						tag: n.tag,
						payload: n.payload,
						callback: null,
						next: null
					};
					a === null ? i = a = o : a = a.next = o, n = n.next;
				} while (n !== null);
				a === null ? i = a = t : a = a.next = t;
			} else i = a = t;
			n = {
				baseState: r.baseState,
				firstBaseUpdate: i,
				lastBaseUpdate: a,
				shared: r.shared,
				callbacks: r.callbacks
			}, e.updateQueue = n;
			return;
		}
		e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
	}
	var Va = !1;
	function Ha() {
		if (Va) {
			var e = sa;
			if (e !== null) throw e;
		}
	}
	function Ua(e, t, n, r) {
		Va = !1;
		var i = e.updateQueue;
		Pa = !1;
		var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
		if (s !== null) {
			i.shared.pending = null;
			var c = s, l = c.next;
			c.next = null, o === null ? a = l : o.next = l, o = c;
			var u = e.alternate;
			u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
		}
		if (a !== null) {
			var d = i.baseState;
			o = 0, u = l = c = null, s = a;
			do {
				var f = s.lane & -536870913, p = f !== s.lane;
				if (p ? (Q & f) === f : (r & f) === f) {
					f !== 0 && f === oa && (Va = !0), u !== null && (u = u.next = {
						lane: 0,
						tag: s.tag,
						payload: s.payload,
						callback: null,
						next: null
					});
					a: {
						var m = e, g = s;
						f = t;
						var _ = n;
						switch (g.tag) {
							case 1:
								if (m = g.payload, typeof m == "function") {
									d = m.call(_, d, f);
									break a;
								}
								d = m;
								break a;
							case 3: m.flags = m.flags & -65537 | 128;
							case 0:
								if (m = g.payload, f = typeof m == "function" ? m.call(_, d, f) : m, f == null) break a;
								d = h({}, d, f);
								break a;
							case 2: Pa = !0;
						}
					}
					f = s.callback, f !== null && (e.flags |= 64, p && (e.flags |= 8192), p = i.callbacks, p === null ? i.callbacks = [f] : p.push(f));
				} else p = {
					lane: f,
					tag: s.tag,
					payload: s.payload,
					callback: s.callback,
					next: null
				}, u === null ? (l = u = p, c = d) : u = u.next = p, o |= f;
				if (s = s.next, s === null) {
					if (s = i.shared.pending, s === null) break;
					p = s, s = p.next, p.next = null, i.lastBaseUpdate = p, i.shared.pending = null;
				}
			} while (1);
			u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Ul |= o, e.lanes = o, e.memoizedState = d;
		}
	}
	function Wa(e, t) {
		if (typeof e != "function") throw Error(i(191, e));
		e.call(t);
	}
	function Ga(e, t) {
		var n = e.callbacks;
		if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) Wa(n[e], t);
	}
	var Ka = I(null), qa = I(0);
	function Ja(e, t) {
		e = Vl, R(qa, e), R(Ka, t), Vl = e | t.baseLanes;
	}
	function Ya() {
		R(qa, Vl), R(Ka, Ka.current);
	}
	function Xa() {
		Vl = qa.current, L(Ka), L(qa);
	}
	var Za = I(null), Qa = null;
	function $a(e) {
		var t = e.alternate;
		R(io, io.current & 1), R(Za, e), Qa === null && (t === null || Ka.current !== null || t.memoizedState !== null) && (Qa = e);
	}
	function eo(e) {
		R(io, io.current), R(Za, e), Qa === null && (Qa = e);
	}
	function to(e) {
		e.tag === 22 ? (R(io, io.current), R(Za, e), Qa === null && (Qa = e)) : no(e);
	}
	function no() {
		R(io, io.current), R(Za, Za.current);
	}
	function ro(e) {
		L(Za), Qa === e && (Qa = null), L(io);
	}
	var io = I(0);
	function ao(e) {
		for (var t = e; t !== null;) {
			if (t.tag === 13) {
				var n = t.memoizedState;
				if (n !== null && (n = n.dehydrated, n === null || af(n) || of(n))) return t;
			} else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
				if (t.flags & 128) return t;
			} else if (t.child !== null) {
				t.child.return = t, t = t.child;
				continue;
			}
			if (t === e) break;
			for (; t.sibling === null;) {
				if (t.return === null || t.return === e) return null;
				t = t.return;
			}
			t.sibling.return = t.return, t = t.sibling;
		}
		return null;
	}
	var oo = 0, K = null, so = null, co = null, lo = !1, uo = !1, fo = !1, po = 0, mo = 0, ho = null, go = 0;
	function _o() {
		throw Error(i(321));
	}
	function vo(e, t) {
		if (t === null) return !1;
		for (var n = 0; n < t.length && n < e.length; n++) if (!gr(e[n], t[n])) return !1;
		return !0;
	}
	function yo(e, t, n, r, i, a) {
		return oo = a, K = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, P.H = e === null || e.memoizedState === null ? Ns : Ps, fo = !1, a = n(r, i), fo = !1, uo && (a = xo(t, n, r, i)), bo(e), a;
	}
	function bo(e) {
		P.H = Ms;
		var t = so !== null && so.next !== null;
		if (oo = 0, co = so = K = null, lo = !1, mo = 0, ho = null, t) throw Error(i(300));
		e === null || Zs || (e = e.dependencies, e !== null && qi(e) && (Zs = !0));
	}
	function xo(e, t, n, r) {
		K = e;
		var a = 0;
		do {
			if (uo && (ho = null), mo = 0, uo = !1, 25 <= a) throw Error(i(301));
			if (a += 1, co = so = null, e.updateQueue != null) {
				var o = e.updateQueue;
				o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0);
			}
			P.H = Fs, o = t(n, r);
		} while (uo);
		return o;
	}
	function So() {
		var e = P.H, t = e.useState()[0];
		return t = typeof t.then == "function" ? Oo(t) : t, e = e.useState()[0], (so === null ? null : so.memoizedState) !== e && (K.flags |= 1024), t;
	}
	function Co() {
		var e = po !== 0;
		return po = 0, e;
	}
	function wo(e, t, n) {
		t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
	}
	function To(e) {
		if (lo) {
			for (e = e.memoizedState; e !== null;) {
				var t = e.queue;
				t !== null && (t.pending = null), e = e.next;
			}
			lo = !1;
		}
		oo = 0, co = so = K = null, uo = !1, mo = po = 0, ho = null;
	}
	function q() {
		var e = {
			memoizedState: null,
			baseState: null,
			baseQueue: null,
			queue: null,
			next: null
		};
		return co === null ? K.memoizedState = co = e : co = co.next = e, co;
	}
	function Eo() {
		if (so === null) {
			var e = K.alternate;
			e = e === null ? null : e.memoizedState;
		} else e = so.next;
		var t = co === null ? K.memoizedState : co.next;
		if (t !== null) co = t, so = e;
		else {
			if (e === null) throw K.alternate === null ? Error(i(467)) : Error(i(310));
			so = e, e = {
				memoizedState: so.memoizedState,
				baseState: so.baseState,
				baseQueue: so.baseQueue,
				queue: so.queue,
				next: null
			}, co === null ? K.memoizedState = co = e : co = co.next = e;
		}
		return co;
	}
	function Do() {
		return {
			lastEffect: null,
			events: null,
			stores: null,
			memoCache: null
		};
	}
	function Oo(e) {
		var t = mo;
		return mo += 1, ho === null && (ho = []), e = xa(ho, e, t), t = K, (co === null ? t.memoizedState : co.next) === null && (t = t.alternate, P.H = t === null || t.memoizedState === null ? Ns : Ps), e;
	}
	function ko(e) {
		if (typeof e == "object" && e) {
			if (typeof e.then == "function") return Oo(e);
			if (e.$$typeof === C) return Yi(e);
		}
		throw Error(i(438, String(e)));
	}
	function Ao(e) {
		var t = null, n = K.updateQueue;
		if (n !== null && (t = n.memoCache), t == null) {
			var r = K.alternate;
			r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
				data: r.data.map(function(e) {
					return e.slice();
				}),
				index: 0
			})));
		}
		if (t ??= {
			data: [],
			index: 0
		}, n === null && (n = Do(), K.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = A;
		return t.index++, n;
	}
	function jo(e, t) {
		return typeof t == "function" ? t(e) : t;
	}
	function Mo(e) {
		return No(Eo(), so, e);
	}
	function No(e, t, n) {
		var r = e.queue;
		if (r === null) throw Error(i(311));
		r.lastRenderedReducer = n;
		var a = e.baseQueue, o = r.pending;
		if (o !== null) {
			if (a !== null) {
				var s = a.next;
				a.next = o.next, o.next = s;
			}
			t.baseQueue = a = o, r.pending = null;
		}
		if (o = e.baseState, a === null) e.memoizedState = o;
		else {
			t = a.next;
			var c = s = null, l = null, u = t, d = !1;
			do {
				var f = u.lane & -536870913;
				if (f === u.lane ? (oo & f) === f : (Q & f) === f) {
					var p = u.revertLane;
					if (p === 0) l !== null && (l = l.next = {
						lane: 0,
						revertLane: 0,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}), f === oa && (d = !0);
					else if ((oo & p) === p) {
						u = u.next, p === oa && (d = !0);
						continue;
					} else f = {
						lane: 0,
						revertLane: u.revertLane,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}, l === null ? (c = l = f, s = o) : l = l.next = f, K.lanes |= p, Ul |= p;
					f = u.action, fo && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f);
				} else p = {
					lane: f,
					revertLane: u.revertLane,
					gesture: u.gesture,
					action: u.action,
					hasEagerState: u.hasEagerState,
					eagerState: u.eagerState,
					next: null
				}, l === null ? (c = l = p, s = o) : l = l.next = p, K.lanes |= f, Ul |= f;
				u = u.next;
			} while (u !== null && u !== t);
			if (l === null ? s = o : l.next = c, !gr(o, e.memoizedState) && (Zs = !0, d && (n = sa, n !== null))) throw n;
			e.memoizedState = o, e.baseState = s, e.baseQueue = l, r.lastRenderedState = o;
		}
		return a === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
	}
	function Po(e) {
		var t = Eo(), n = t.queue;
		if (n === null) throw Error(i(311));
		n.lastRenderedReducer = e;
		var r = n.dispatch, a = n.pending, o = t.memoizedState;
		if (a !== null) {
			n.pending = null;
			var s = a = a.next;
			do
				o = e(o, s.action), s = s.next;
			while (s !== a);
			gr(o, t.memoizedState) || (Zs = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
		}
		return [o, r];
	}
	function Fo(e, t, n) {
		var r = K, a = Eo(), o = G;
		if (o) {
			if (n === void 0) throw Error(i(407));
			n = n();
		} else n = t();
		var s = !gr((so || a).memoizedState, n);
		if (s && (a.memoizedState = n, Zs = !0), a = a.queue, is(Lo.bind(null, r, a, e), [e]), a.getSnapshot !== t || s || co !== null && co.memoizedState.tag & 1) {
			if (r.flags |= 2048, $o(9, { destroy: void 0 }, J.bind(null, r, a, n, t), null), Fl === null) throw Error(i(349));
			o || oo & 127 || Io(r, t, n);
		}
		return n;
	}
	function Io(e, t, n) {
		e.flags |= 16384, e = {
			getSnapshot: t,
			value: n
		}, t = K.updateQueue, t === null ? (t = Do(), K.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
	}
	function J(e, t, n, r) {
		t.value = n, t.getSnapshot = r, Ro(t) && zo(e);
	}
	function Lo(e, t, n) {
		return n(function() {
			Ro(t) && zo(e);
		});
	}
	function Ro(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !gr(e, n);
		} catch {
			return !0;
		}
	}
	function zo(e) {
		var t = Zr(e, 2);
		t !== null && pu(t, e, 2);
	}
	function Bo(e) {
		var t = q();
		if (typeof e == "function") {
			var n = e;
			if (e = n(), fo) {
				Fe(!0);
				try {
					n();
				} finally {
					Fe(!1);
				}
			}
		}
		return t.memoizedState = t.baseState = e, t.queue = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: jo,
			lastRenderedState: e
		}, t;
	}
	function Vo(e, t, n, r) {
		return e.baseState = n, No(e, so, typeof r == "function" ? r : jo);
	}
	function Ho(e, t, n, r, a) {
		if (ks(e)) throw Error(i(485));
		if (e = t.action, e !== null) {
			var o = {
				payload: a,
				action: e,
				next: null,
				isTransition: !0,
				status: "pending",
				value: null,
				reason: null,
				listeners: [],
				then: function(e) {
					o.listeners.push(e);
				}
			};
			P.T === null ? o.isTransition = !1 : n(!0), r(o), n = t.pending, n === null ? (o.next = t.pending = o, Uo(t, o)) : (o.next = n.next, t.pending = n.next = o);
		}
	}
	function Uo(e, t) {
		var n = t.action, r = t.payload, i = e.state;
		if (t.isTransition) {
			var a = P.T, o = {};
			P.T = o;
			try {
				var s = n(i, r), c = P.S;
				c !== null && c(o, s), Y(e, t, s);
			} catch (n) {
				Go(e, t, n);
			} finally {
				a !== null && o.types !== null && (a.types = o.types), P.T = a;
			}
		} else try {
			a = n(i, r), Y(e, t, a);
		} catch (n) {
			Go(e, t, n);
		}
	}
	function Y(e, t, n) {
		typeof n == "object" && n && typeof n.then == "function" ? n.then(function(n) {
			Wo(e, t, n);
		}, function(n) {
			return Go(e, t, n);
		}) : Wo(e, t, n);
	}
	function Wo(e, t, n) {
		t.status = "fulfilled", t.value = n, Ko(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, Uo(e, n)));
	}
	function Go(e, t, n) {
		var r = e.pending;
		if (e.pending = null, r !== null) {
			r = r.next;
			do
				t.status = "rejected", t.reason = n, Ko(t), t = t.next;
			while (t !== r);
		}
		e.action = null;
	}
	function Ko(e) {
		e = e.listeners;
		for (var t = 0; t < e.length; t++) (0, e[t])();
	}
	function qo(e, t) {
		return t;
	}
	function Jo(e, t) {
		if (G) {
			var n = Fl.formState;
			if (n !== null) {
				a: {
					var r = K;
					if (G) {
						if (Oi) {
							b: {
								for (var i = Oi, a = Ai; i.nodeType !== 8;) {
									if (!a) {
										i = null;
										break b;
									}
									if (i = cf(i.nextSibling), i === null) {
										i = null;
										break b;
									}
								}
								a = i.data, i = a === "F!" || a === "F" ? i : null;
							}
							if (i) {
								Oi = cf(i.nextSibling), r = i.data === "F!";
								break a;
							}
						}
						Mi(r);
					}
					r = !1;
				}
				r && (t = n[0]);
			}
		}
		return n = q(), n.memoizedState = n.baseState = t, r = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: qo,
			lastRenderedState: t
		}, n.queue = r, n = Es.bind(null, K, r), r.dispatch = n, r = Bo(!1), a = Os.bind(null, K, !1, r.queue), r = q(), i = {
			state: t,
			dispatch: null,
			action: e,
			pending: null
		}, r.queue = i, n = Ho.bind(null, K, i, a, n), i.dispatch = n, r.memoizedState = e, [
			t,
			n,
			!1
		];
	}
	function Yo(e) {
		return Xo(Eo(), so, e);
	}
	function Xo(e, t, n) {
		if (t = No(e, t, qo)[0], e = Mo(jo)[0], typeof t == "object" && t && typeof t.then == "function") try {
			var r = Oo(t);
		} catch (e) {
			throw e === ga ? va : e;
		}
		else r = t;
		t = Eo();
		var i = t.queue, a = i.dispatch;
		return n !== t.memoizedState && (K.flags |= 2048, $o(9, { destroy: void 0 }, Zo.bind(null, i, n), null)), [
			r,
			a,
			e
		];
	}
	function Zo(e, t) {
		e.action = t;
	}
	function Qo(e) {
		var t = Eo(), n = so;
		if (n !== null) return Xo(t, n, e);
		Eo(), t = t.memoizedState, n = Eo();
		var r = n.queue.dispatch;
		return n.memoizedState = e, [
			t,
			r,
			!1
		];
	}
	function $o(e, t, n, r) {
		return e = {
			tag: e,
			create: n,
			deps: r,
			inst: t,
			next: null
		}, t = K.updateQueue, t === null && (t = Do(), K.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
	}
	function es() {
		return Eo().memoizedState;
	}
	function ts(e, t, n, r) {
		var i = q();
		K.flags |= e, i.memoizedState = $o(1 | t, { destroy: void 0 }, n, r === void 0 ? null : r);
	}
	function ns(e, t, n, r) {
		var i = Eo();
		r = r === void 0 ? null : r;
		var a = i.memoizedState.inst;
		so !== null && r !== null && vo(r, so.memoizedState.deps) ? i.memoizedState = $o(t, a, n, r) : (K.flags |= e, i.memoizedState = $o(1 | t, a, n, r));
	}
	function rs(e, t) {
		ts(8390656, 8, e, t);
	}
	function is(e, t) {
		ns(2048, 8, e, t);
	}
	function as(e) {
		K.flags |= 4;
		var t = K.updateQueue;
		if (t === null) t = Do(), K.updateQueue = t, t.events = [e];
		else {
			var n = t.events;
			n === null ? t.events = [e] : n.push(e);
		}
	}
	function os(e) {
		var t = Eo().memoizedState;
		return as({
			ref: t,
			nextImpl: e
		}), function() {
			if (X & 2) throw Error(i(440));
			return t.impl.apply(void 0, arguments);
		};
	}
	function ss(e, t) {
		return ns(4, 2, e, t);
	}
	function cs(e, t) {
		return ns(4, 4, e, t);
	}
	function ls(e, t) {
		if (typeof t == "function") {
			e = e();
			var n = t(e);
			return function() {
				typeof n == "function" ? n() : t(null);
			};
		}
		if (t != null) return e = e(), t.current = e, function() {
			t.current = null;
		};
	}
	function us(e, t, n) {
		n = n == null ? null : n.concat([e]), ns(4, 4, ls.bind(null, t, e), n);
	}
	function ds() {}
	function fs(e, t) {
		var n = Eo();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		return t !== null && vo(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	}
	function ps(e, t) {
		var n = Eo();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		if (t !== null && vo(t, r[1])) return r[0];
		if (r = e(), fo) {
			Fe(!0);
			try {
				e();
			} finally {
				Fe(!1);
			}
		}
		return n.memoizedState = [r, t], r;
	}
	function ms(e, t, n) {
		return n === void 0 || oo & 1073741824 && !(Q & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = fu(), K.lanes |= e, Ul |= e, n);
	}
	function hs(e, t, n, r) {
		return gr(n, t) ? n : Ka.current === null ? !(oo & 42) || oo & 1073741824 && !(Q & 261930) ? (Zs = !0, e.memoizedState = n) : (e = fu(), K.lanes |= e, Ul |= e, t) : (e = ms(e, n, r), gr(e, t) || (Zs = !0), e);
	}
	function gs(e, t, n, r, i) {
		var a = F.p;
		F.p = a !== 0 && 8 > a ? a : 8;
		var o = P.T, s = {};
		P.T = s, Os(e, !1, t, n);
		try {
			var c = i(), l = P.S;
			l !== null && l(s, c), typeof c == "object" && c && typeof c.then == "function" ? Ds(e, t, ua(c, r), du(e)) : Ds(e, t, r, du(e));
		} catch (n) {
			Ds(e, t, {
				then: function() {},
				status: "rejected",
				reason: n
			}, du());
		} finally {
			F.p = a, o !== null && s.types !== null && (o.types = s.types), P.T = o;
		}
	}
	function _s() {}
	function vs(e, t, n, r) {
		if (e.tag !== 5) throw Error(i(476));
		var a = ys(e).queue;
		gs(e, a, t, ne, n === null ? _s : function() {
			return bs(e), n(r);
		});
	}
	function ys(e) {
		var t = e.memoizedState;
		if (t !== null) return t;
		t = {
			memoizedState: ne,
			baseState: ne,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: jo,
				lastRenderedState: ne
			},
			next: null
		};
		var n = {};
		return t.next = {
			memoizedState: n,
			baseState: n,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: jo,
				lastRenderedState: n
			},
			next: null
		}, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
	}
	function bs(e) {
		var t = ys(e);
		t.next === null && (t = e.alternate.memoizedState), Ds(e, t.next.queue, {}, du());
	}
	function xs() {
		return Yi(Qf);
	}
	function Ss() {
		return Eo().memoizedState;
	}
	function Cs() {
		return Eo().memoizedState;
	}
	function ws(e) {
		for (var t = e.return; t !== null;) {
			switch (t.tag) {
				case 24:
				case 3:
					var n = du();
					e = La(n);
					var r = Ra(t, e, n);
					r !== null && (pu(r, t, n), za(r, t, n)), t = { cache: na() }, e.payload = t;
					return;
			}
			t = t.return;
		}
	}
	function Ts(e, t, n) {
		var r = du();
		n = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, ks(e) ? As(t, n) : (n = Xr(e, t, n, r), n !== null && (pu(n, e, r), js(n, t, r)));
	}
	function Es(e, t, n) {
		Ds(e, t, n, du());
	}
	function Ds(e, t, n, r) {
		var i = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		};
		if (ks(e)) As(t, i);
		else {
			var a = e.alternate;
			if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
				var o = t.lastRenderedState, s = a(o, n);
				if (i.hasEagerState = !0, i.eagerState = s, gr(s, o)) return Yr(e, t, i, 0), Fl === null && Jr(), !1;
			} catch {}
			if (n = Xr(e, t, i, r), n !== null) return pu(n, e, r), js(n, t, r), !0;
		}
		return !1;
	}
	function Os(e, t, n, r) {
		if (r = {
			lane: 2,
			revertLane: ud(),
			gesture: null,
			action: r,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, ks(e)) {
			if (t) throw Error(i(479));
		} else t = Xr(e, n, r, 2), t !== null && pu(t, e, 2);
	}
	function ks(e) {
		var t = e.alternate;
		return e === K || t !== null && t === K;
	}
	function As(e, t) {
		uo = lo = !0;
		var n = e.pending;
		n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
	}
	function js(e, t, n) {
		if (n & 4194048) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, Qe(e, n);
		}
	}
	var Ms = {
		readContext: Yi,
		use: ko,
		useCallback: _o,
		useContext: _o,
		useEffect: _o,
		useImperativeHandle: _o,
		useLayoutEffect: _o,
		useInsertionEffect: _o,
		useMemo: _o,
		useReducer: _o,
		useRef: _o,
		useState: _o,
		useDebugValue: _o,
		useDeferredValue: _o,
		useTransition: _o,
		useSyncExternalStore: _o,
		useId: _o,
		useHostTransitionStatus: _o,
		useFormState: _o,
		useActionState: _o,
		useOptimistic: _o,
		useMemoCache: _o,
		useCacheRefresh: _o
	};
	Ms.useEffectEvent = _o;
	var Ns = {
		readContext: Yi,
		use: ko,
		useCallback: function(e, t) {
			return q().memoizedState = [e, t === void 0 ? null : t], e;
		},
		useContext: Yi,
		useEffect: rs,
		useImperativeHandle: function(e, t, n) {
			n = n == null ? null : n.concat([e]), ts(4194308, 4, ls.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return ts(4194308, 4, e, t);
		},
		useInsertionEffect: function(e, t) {
			ts(4, 2, e, t);
		},
		useMemo: function(e, t) {
			var n = q();
			t = t === void 0 ? null : t;
			var r = e();
			if (fo) {
				Fe(!0);
				try {
					e();
				} finally {
					Fe(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		},
		useReducer: function(e, t, n) {
			var r = q();
			if (n !== void 0) {
				var i = n(t);
				if (fo) {
					Fe(!0);
					try {
						n(t);
					} finally {
						Fe(!1);
					}
				}
			} else i = t;
			return r.memoizedState = r.baseState = i, e = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: i
			}, r.queue = e, e = e.dispatch = Ts.bind(null, K, e), [r.memoizedState, e];
		},
		useRef: function(e) {
			var t = q();
			return e = { current: e }, t.memoizedState = e;
		},
		useState: function(e) {
			e = Bo(e);
			var t = e.queue, n = Es.bind(null, K, t);
			return t.dispatch = n, [e.memoizedState, n];
		},
		useDebugValue: ds,
		useDeferredValue: function(e, t) {
			return ms(q(), e, t);
		},
		useTransition: function() {
			var e = Bo(!1);
			return e = gs.bind(null, K, e.queue, !0, !1), q().memoizedState = e, [!1, e];
		},
		useSyncExternalStore: function(e, t, n) {
			var r = K, a = q();
			if (G) {
				if (n === void 0) throw Error(i(407));
				n = n();
			} else {
				if (n = t(), Fl === null) throw Error(i(349));
				Q & 127 || Io(r, t, n);
			}
			a.memoizedState = n;
			var o = {
				value: n,
				getSnapshot: t
			};
			return a.queue = o, rs(Lo.bind(null, r, o, e), [e]), r.flags |= 2048, $o(9, { destroy: void 0 }, J.bind(null, r, o, n, t), null), n;
		},
		useId: function() {
			var e = q(), t = Fl.identifierPrefix;
			if (G) {
				var n = xi, r = bi;
				n = (r & ~(1 << 32 - Ie(r) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = po++, 0 < n && (t += "H" + n.toString(32)), t += "_";
			} else n = go++, t = "_" + t + "r_" + n.toString(32) + "_";
			return e.memoizedState = t;
		},
		useHostTransitionStatus: xs,
		useFormState: Jo,
		useActionState: Jo,
		useOptimistic: function(e) {
			var t = q();
			t.memoizedState = t.baseState = e;
			var n = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: null,
				lastRenderedState: null
			};
			return t.queue = n, t = Os.bind(null, K, !0, n), n.dispatch = t, [e, t];
		},
		useMemoCache: Ao,
		useCacheRefresh: function() {
			return q().memoizedState = ws.bind(null, K);
		},
		useEffectEvent: function(e) {
			var t = q(), n = { impl: e };
			return t.memoizedState = n, function() {
				if (X & 2) throw Error(i(440));
				return n.impl.apply(void 0, arguments);
			};
		}
	}, Ps = {
		readContext: Yi,
		use: ko,
		useCallback: fs,
		useContext: Yi,
		useEffect: is,
		useImperativeHandle: us,
		useInsertionEffect: ss,
		useLayoutEffect: cs,
		useMemo: ps,
		useReducer: Mo,
		useRef: es,
		useState: function() {
			return Mo(jo);
		},
		useDebugValue: ds,
		useDeferredValue: function(e, t) {
			return hs(Eo(), so.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Mo(jo)[0], t = Eo().memoizedState;
			return [typeof e == "boolean" ? e : Oo(e), t];
		},
		useSyncExternalStore: Fo,
		useId: Ss,
		useHostTransitionStatus: xs,
		useFormState: Yo,
		useActionState: Yo,
		useOptimistic: function(e, t) {
			return Vo(Eo(), so, e, t);
		},
		useMemoCache: Ao,
		useCacheRefresh: Cs
	};
	Ps.useEffectEvent = os;
	var Fs = {
		readContext: Yi,
		use: ko,
		useCallback: fs,
		useContext: Yi,
		useEffect: is,
		useImperativeHandle: us,
		useInsertionEffect: ss,
		useLayoutEffect: cs,
		useMemo: ps,
		useReducer: Po,
		useRef: es,
		useState: function() {
			return Po(jo);
		},
		useDebugValue: ds,
		useDeferredValue: function(e, t) {
			var n = Eo();
			return so === null ? ms(n, e, t) : hs(n, so.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Po(jo)[0], t = Eo().memoizedState;
			return [typeof e == "boolean" ? e : Oo(e), t];
		},
		useSyncExternalStore: Fo,
		useId: Ss,
		useHostTransitionStatus: xs,
		useFormState: Qo,
		useActionState: Qo,
		useOptimistic: function(e, t) {
			var n = Eo();
			return so === null ? (n.baseState = e, [e, n.queue.dispatch]) : Vo(n, so, e, t);
		},
		useMemoCache: Ao,
		useCacheRefresh: Cs
	};
	Fs.useEffectEvent = os;
	function Is(e, t, n, r) {
		t = e.memoizedState, n = n(r, t), n = n == null ? t : h({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
	}
	var Ls = {
		enqueueSetState: function(e, t, n) {
			e = e._reactInternals;
			var r = du(), i = La(r);
			i.payload = t, n != null && (i.callback = n), t = Ra(e, i, r), t !== null && (pu(t, e, r), za(t, e, r));
		},
		enqueueReplaceState: function(e, t, n) {
			e = e._reactInternals;
			var r = du(), i = La(r);
			i.tag = 1, i.payload = t, n != null && (i.callback = n), t = Ra(e, i, r), t !== null && (pu(t, e, r), za(t, e, r));
		},
		enqueueForceUpdate: function(e, t) {
			e = e._reactInternals;
			var n = du(), r = La(n);
			r.tag = 2, t != null && (r.callback = t), t = Ra(e, r, n), t !== null && (pu(t, e, n), za(t, e, n));
		}
	};
	function Rs(e, t, n, r, i, a, o) {
		return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !_r(n, r) || !_r(i, a) : !0;
	}
	function zs(e, t, n, r) {
		e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Ls.enqueueReplaceState(t, t.state, null);
	}
	function Bs(e, t) {
		var n = t;
		if ("ref" in t) for (var r in n = {}, t) r !== "ref" && (n[r] = t[r]);
		if (e = e.defaultProps) for (var i in n === t && (n = h({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
		return n;
	}
	function Vs(e) {
		Wr(e);
	}
	function Hs(e) {
		console.error(e);
	}
	function Us(e) {
		Wr(e);
	}
	function Ws(e, t) {
		try {
			var n = e.onUncaughtError;
			n(t.value, { componentStack: t.stack });
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Gs(e, t, n) {
		try {
			var r = e.onCaughtError;
			r(n.value, {
				componentStack: n.stack,
				errorBoundary: t.tag === 1 ? t.stateNode : null
			});
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Ks(e, t, n) {
		return n = La(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
			Ws(e, t);
		}, n;
	}
	function qs(e) {
		return e = La(e), e.tag = 3, e;
	}
	function Js(e, t, n, r) {
		var i = n.type.getDerivedStateFromError;
		if (typeof i == "function") {
			var a = r.value;
			e.payload = function() {
				return i(a);
			}, e.callback = function() {
				Gs(t, n, r);
			};
		}
		var o = n.stateNode;
		o !== null && typeof o.componentDidCatch == "function" && (e.callback = function() {
			Gs(t, n, r), typeof i != "function" && (tu === null ? tu = new Set([this]) : tu.add(this));
			var e = r.stack;
			this.componentDidCatch(r.value, { componentStack: e === null ? "" : e });
		});
	}
	function Ys(e, t, n, r, a) {
		if (n.flags |= 32768, typeof r == "object" && r && typeof r.then == "function") {
			if (t = n.alternate, t !== null && Ki(t, n, a, !0), n = Za.current, n !== null) {
				switch (n.tag) {
					case 31:
					case 13: return Qa === null ? Tu() : n.alternate === null && Hl === 0 && (Hl = 3), n.flags &= -257, n.flags |= 65536, n.lanes = a, r === ya ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = new Set([r]) : t.add(r), Wu(e, r, a)), !1;
					case 22: return n.flags |= 65536, r === ya ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
						transitions: null,
						markerInstances: null,
						retryQueue: new Set([r])
					}, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = new Set([r]) : n.add(r)), Wu(e, r, a)), !1;
				}
				throw Error(i(435, n.tag));
			}
			return Wu(e, r, a), Tu(), !1;
		}
		if (G) return t = Za.current, t === null ? (r !== ji && (t = Error(i(423), { cause: r }), Ri(fi(t, n))), e = e.current.alternate, e.flags |= 65536, a &= -a, e.lanes |= a, r = fi(r, n), a = Ks(e.stateNode, r, a), Ba(e, a), Hl !== 4 && (Hl = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = a, r !== ji && (e = Error(i(422), { cause: r }), Ri(fi(e, n)))), !1;
		var o = Error(i(520), { cause: r });
		if (o = fi(o, n), Jl === null ? Jl = [o] : Jl.push(o), Hl !== 4 && (Hl = 2), t === null) return !0;
		r = fi(r, n), n = t;
		do {
			switch (n.tag) {
				case 3: return n.flags |= 65536, e = a & -a, n.lanes |= e, e = Ks(n.stateNode, r, e), Ba(n, e), !1;
				case 1: if (t = n.type, o = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == "function" || o !== null && typeof o.componentDidCatch == "function" && (tu === null || !tu.has(o)))) return n.flags |= 65536, a &= -a, n.lanes |= a, a = qs(a), Js(a, e, n, r), Ba(n, a), !1;
			}
			n = n.return;
		} while (n !== null);
		return !1;
	}
	var Xs = Error(i(461)), Zs = !1;
	function Qs(e, t, n, r) {
		t.child = e === null ? Na(t, null, n, r) : Ma(t, e.child, n, r);
	}
	function $s(e, t, n, r, i) {
		n = n.render;
		var a = t.ref;
		if ("ref" in r) {
			var o = {};
			for (var s in r) s !== "ref" && (o[s] = r[s]);
		} else o = r;
		return Ji(t), r = yo(e, t, n, o, a, i), s = Co(), e !== null && !Zs ? (wo(e, t, i), Cc(e, t, i)) : (G && s && wi(t), t.flags |= 1, Qs(e, t, r, i), t.child);
	}
	function ec(e, t, n, r, i) {
		if (e === null) {
			var a = n.type;
			return typeof a == "function" && !ri(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, tc(e, t, a, r, i)) : (e = oi(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
		}
		if (a = e.child, !wc(e, i)) {
			var o = a.memoizedProps;
			if (n = n.compare, n = n === null ? _r : n, n(o, r) && e.ref === t.ref) return Cc(e, t, i);
		}
		return t.flags |= 1, e = ii(a, r), e.ref = t.ref, e.return = t, t.child = e;
	}
	function tc(e, t, n, r, i) {
		if (e !== null) {
			var a = e.memoizedProps;
			if (_r(a, r) && e.ref === t.ref) if (Zs = !1, t.pendingProps = r = a, wc(e, i)) e.flags & 131072 && (Zs = !0);
			else return t.lanes = e.lanes, Cc(e, t, i);
		}
		return lc(e, t, n, r, i);
	}
	function nc(e, t, n, r) {
		var i = r.children, a = e === null ? null : e.memoizedState;
		if (e === null && t.stateNode === null && (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), r.mode === "hidden") {
			if (t.flags & 128) {
				if (a = a === null ? n : a.baseLanes | n, e !== null) {
					for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
					r = i & ~a;
				} else r = 0, t.child = null;
				return ic(e, t, a, n, r);
			}
			if (n & 536870912) t.memoizedState = {
				baseLanes: 0,
				cachePool: null
			}, e !== null && ma(t, a === null ? null : a.cachePool), a === null ? Ya() : Ja(t, a), to(t);
			else return r = t.lanes = 536870912, ic(e, t, a === null ? n : a.baseLanes | n, n, r);
		} else a === null ? (e !== null && ma(t, null), Ya(), no(t)) : (ma(t, a.cachePool), Ja(t, a), no(t), t.memoizedState = null);
		return Qs(e, t, i, n), t.child;
	}
	function rc(e, t) {
		return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), t.sibling;
	}
	function ic(e, t, n, r, i) {
		var a = pa();
		return a = a === null ? null : {
			parent: ta._currentValue,
			pool: a
		}, t.memoizedState = {
			baseLanes: n,
			cachePool: a
		}, e !== null && ma(t, null), Ya(), to(t), e !== null && Ki(e, t, r, !0), t.childLanes = i, null;
	}
	function ac(e, t) {
		return t = vc({
			mode: t.mode,
			children: t.children
		}, e.mode), t.ref = e.ref, e.child = t, t.return = e, t;
	}
	function oc(e, t, n) {
		return Ma(t, e.child, null, n), e = ac(t, t.pendingProps), e.flags |= 2, ro(t), t.memoizedState = null, e;
	}
	function sc(e, t, n) {
		var r = t.pendingProps, a = (t.flags & 128) != 0;
		if (t.flags &= -129, e === null) {
			if (G) {
				if (r.mode === "hidden") return e = ac(t, r), t.lanes = 536870912, rc(null, e);
				if (eo(t), (e = Oi) ? (e = rf(e, Ai), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: yi === null ? null : {
						id: bi,
						overflow: xi
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = li(e), n.return = t, t.child = n, Di = t, Oi = null)) : e = null, e === null) throw Mi(t);
				return t.lanes = 536870912, null;
			}
			return ac(t, r);
		}
		var o = e.memoizedState;
		if (o !== null) {
			var s = o.dehydrated;
			if (eo(t), a) if (t.flags & 256) t.flags &= -257, t = oc(e, t, n);
			else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null;
			else throw Error(i(558));
			else if (Zs || Ki(e, t, n, !1), a = (n & e.childLanes) !== 0, Zs || a) {
				if (r = Fl, r !== null && (s = $e(r, n), s !== 0 && s !== o.retryLane)) throw o.retryLane = s, Zr(e, s), pu(r, e, s), Xs;
				Tu(), t = oc(e, t, n);
			} else e = o.treeContext, Oi = cf(s.nextSibling), Di = t, G = !0, ki = null, Ai = !1, e !== null && Ei(t, e), t = ac(t, r), t.flags |= 4096;
			return t;
		}
		return e = ii(e.child, {
			mode: r.mode,
			children: r.children
		}), e.ref = t.ref, t.child = e, e.return = t, e;
	}
	function cc(e, t) {
		var n = t.ref;
		if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816);
		else {
			if (typeof n != "function" && typeof n != "object") throw Error(i(284));
			(e === null || e.ref !== n) && (t.flags |= 4194816);
		}
	}
	function lc(e, t, n, r, i) {
		return Ji(t), n = yo(e, t, n, r, void 0, i), r = Co(), e !== null && !Zs ? (wo(e, t, i), Cc(e, t, i)) : (G && r && wi(t), t.flags |= 1, Qs(e, t, n, i), t.child);
	}
	function uc(e, t, n, r, i, a) {
		return Ji(t), t.updateQueue = null, n = xo(t, r, n, i), bo(e), r = Co(), e !== null && !Zs ? (wo(e, t, a), Cc(e, t, a)) : (G && r && wi(t), t.flags |= 1, Qs(e, t, n, a), t.child);
	}
	function dc(e, t, n, r, i) {
		if (Ji(t), t.stateNode === null) {
			var a = ei, o = n.contextType;
			typeof o == "object" && o && (a = Yi(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Ls, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, Fa(t), o = n.contextType, a.context = typeof o == "object" && o ? Yi(o) : ei, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == "function" && (Is(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (o = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), o !== a.state && Ls.enqueueReplaceState(a, a.state, null), Ua(t, r, a, i), Ha(), a.state = t.memoizedState), typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
		} else if (e === null) {
			a = t.stateNode;
			var s = t.memoizedProps, c = Bs(n, s);
			a.props = c;
			var l = a.context, u = n.contextType;
			o = ei, typeof u == "object" && u && (o = Yi(u));
			var d = n.getDerivedStateFromProps;
			u = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function", s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s || l !== o) && zs(t, a, r, o), Pa = !1;
			var f = t.memoizedState;
			a.state = f, Ua(t, r, a, i), Ha(), l = t.memoizedState, s || f !== l || Pa ? (typeof d == "function" && (Is(t, n, d, r), l = t.memoizedState), (c = Pa || Rs(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
		} else {
			a = t.stateNode, Ia(e, t), o = t.memoizedProps, u = Bs(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = ei, typeof l == "object" && l && (c = Yi(l)), s = n.getDerivedStateFromProps, (l = typeof s == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (o !== d || f !== c) && zs(t, a, r, c), Pa = !1, f = t.memoizedState, a.state = f, Ua(t, r, a, i), Ha();
			var p = t.memoizedState;
			o !== d || f !== p || Pa || e !== null && e.dependencies !== null && qi(e.dependencies) ? (typeof s == "function" && (Is(t, n, s, r), p = t.memoizedState), (u = Pa || Rs(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && qi(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
		}
		return a = r, cc(e, t), r = (t.flags & 128) != 0, a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != "function" ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = Ma(t, e.child, null, i), t.child = Ma(t, null, n, i)) : Qs(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = Cc(e, t, i), e;
	}
	function fc(e, t, n, r) {
		return Ii(), t.flags |= 256, Qs(e, t, n, r), t.child;
	}
	var pc = {
		dehydrated: null,
		treeContext: null,
		retryLane: 0,
		hydrationErrors: null
	};
	function mc(e) {
		return {
			baseLanes: e,
			cachePool: ha()
		};
	}
	function hc(e, t, n) {
		return e = e === null ? 0 : e.childLanes & ~n, t && (e |= Kl), e;
	}
	function gc(e, t, n) {
		var r = t.pendingProps, a = !1, o = (t.flags & 128) != 0, s;
		if ((s = o) || (s = e !== null && e.memoizedState === null ? !1 : (io.current & 2) != 0), s && (a = !0, t.flags &= -129), s = (t.flags & 32) != 0, t.flags &= -33, e === null) {
			if (G) {
				if (a ? $a(t) : no(t), (e = Oi) ? (e = rf(e, Ai), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: yi === null ? null : {
						id: bi,
						overflow: xi
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = li(e), n.return = t, t.child = n, Di = t, Oi = null)) : e = null, e === null) throw Mi(t);
				return of(e) ? t.lanes = 32 : t.lanes = 536870912, null;
			}
			var c = r.children;
			return r = r.fallback, a ? (no(t), a = t.mode, c = vc({
				mode: "hidden",
				children: c
			}, a), r = si(r, a, n, null), c.return = t, r.return = t, c.sibling = r, t.child = c, r = t.child, r.memoizedState = mc(n), r.childLanes = hc(e, s, n), t.memoizedState = pc, rc(null, r)) : ($a(t), _c(t, c));
		}
		var l = e.memoizedState;
		if (l !== null && (c = l.dehydrated, c !== null)) {
			if (o) t.flags & 256 ? ($a(t), t.flags &= -257, t = yc(e, t, n)) : t.memoizedState === null ? (no(t), c = r.fallback, a = t.mode, r = vc({
				mode: "visible",
				children: r.children
			}, a), c = si(c, a, n, null), c.flags |= 2, r.return = t, c.return = t, r.sibling = c, t.child = r, Ma(t, e.child, null, n), r = t.child, r.memoizedState = mc(n), r.childLanes = hc(e, s, n), t.memoizedState = pc, t = rc(null, r)) : (no(t), t.child = e.child, t.flags |= 128, t = null);
			else if ($a(t), of(c)) {
				if (s = c.nextSibling && c.nextSibling.dataset, s) var u = s.dgst;
				s = u, r = Error(i(419)), r.stack = "", r.digest = s, Ri({
					value: r,
					source: null,
					stack: null
				}), t = yc(e, t, n);
			} else if (Zs || Ki(e, t, n, !1), s = (n & e.childLanes) !== 0, Zs || s) {
				if (s = Fl, s !== null && (r = $e(s, n), r !== 0 && r !== l.retryLane)) throw l.retryLane = r, Zr(e, r), pu(s, e, r), Xs;
				af(c) || Tu(), t = yc(e, t, n);
			} else af(c) ? (t.flags |= 192, t.child = e.child, t = null) : (e = l.treeContext, Oi = cf(c.nextSibling), Di = t, G = !0, ki = null, Ai = !1, e !== null && Ei(t, e), t = _c(t, r.children), t.flags |= 4096);
			return t;
		}
		return a ? (no(t), c = r.fallback, a = t.mode, l = e.child, u = l.sibling, r = ii(l, {
			mode: "hidden",
			children: r.children
		}), r.subtreeFlags = l.subtreeFlags & 65011712, u === null ? (c = si(c, a, n, null), c.flags |= 2) : c = ii(u, c), c.return = t, r.return = t, r.sibling = c, t.child = r, rc(null, r), r = t.child, c = e.child.memoizedState, c === null ? c = mc(n) : (a = c.cachePool, a === null ? a = ha() : (l = ta._currentValue, a = a.parent === l ? a : {
			parent: l,
			pool: l
		}), c = {
			baseLanes: c.baseLanes | n,
			cachePool: a
		}), r.memoizedState = c, r.childLanes = hc(e, s, n), t.memoizedState = pc, rc(e.child, r)) : ($a(t), n = e.child, e = n.sibling, n = ii(n, {
			mode: "visible",
			children: r.children
		}), n.return = t, n.sibling = null, e !== null && (s = t.deletions, s === null ? (t.deletions = [e], t.flags |= 16) : s.push(e)), t.child = n, t.memoizedState = null, n);
	}
	function _c(e, t) {
		return t = vc({
			mode: "visible",
			children: t
		}, e.mode), t.return = e, e.child = t;
	}
	function vc(e, t) {
		return e = ni(22, e, null, t), e.lanes = 0, e;
	}
	function yc(e, t, n) {
		return Ma(t, e.child, null, n), e = _c(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
	}
	function bc(e, t, n) {
		e.lanes |= t;
		var r = e.alternate;
		r !== null && (r.lanes |= t), Wi(e.return, t, n);
	}
	function xc(e, t, n, r, i, a) {
		var o = e.memoizedState;
		o === null ? e.memoizedState = {
			isBackwards: t,
			rendering: null,
			renderingStartTime: 0,
			last: r,
			tail: n,
			tailMode: i,
			treeForkCount: a
		} : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
	}
	function Sc(e, t, n) {
		var r = t.pendingProps, i = r.revealOrder, a = r.tail;
		r = r.children;
		var o = io.current, s = (o & 2) != 0;
		if (s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, R(io, o), Qs(e, t, r, n), r = G ? gi : 0, !s && e !== null && e.flags & 128) a: for (e = t.child; e !== null;) {
			if (e.tag === 13) e.memoizedState !== null && bc(e, n, t);
			else if (e.tag === 19) bc(e, n, t);
			else if (e.child !== null) {
				e.child.return = e, e = e.child;
				continue;
			}
			if (e === t) break a;
			for (; e.sibling === null;) {
				if (e.return === null || e.return === t) break a;
				e = e.return;
			}
			e.sibling.return = e.return, e = e.sibling;
		}
		switch (i) {
			case "forwards":
				for (n = t.child, i = null; n !== null;) e = n.alternate, e !== null && ao(e) === null && (i = n), n = n.sibling;
				n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), xc(t, !1, i, n, a, r);
				break;
			case "backwards":
			case "unstable_legacy-backwards":
				for (n = null, i = t.child, t.child = null; i !== null;) {
					if (e = i.alternate, e !== null && ao(e) === null) {
						t.child = i;
						break;
					}
					e = i.sibling, i.sibling = n, n = i, i = e;
				}
				xc(t, !0, n, null, a, r);
				break;
			case "together":
				xc(t, !1, null, null, void 0, r);
				break;
			default: t.memoizedState = null;
		}
		return t.child;
	}
	function Cc(e, t, n) {
		if (e !== null && (t.dependencies = e.dependencies), Ul |= t.lanes, (n & t.childLanes) === 0) if (e !== null) {
			if (Ki(e, t, n, !1), (n & t.childLanes) === 0) return null;
		} else return null;
		if (e !== null && t.child !== e.child) throw Error(i(153));
		if (t.child !== null) {
			for (e = t.child, n = ii(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = ii(e, e.pendingProps), n.return = t;
			n.sibling = null;
		}
		return t.child;
	}
	function wc(e, t) {
		return (e.lanes & t) === 0 ? (e = e.dependencies, !!(e !== null && qi(e))) : !0;
	}
	function Tc(e, t, n) {
		switch (t.tag) {
			case 3:
				ce(t, t.stateNode.containerInfo), Hi(t, ta, e.memoizedState.cache), Ii();
				break;
			case 27:
			case 5:
				ue(t);
				break;
			case 4:
				ce(t, t.stateNode.containerInfo);
				break;
			case 10:
				Hi(t, t.type, t.memoizedProps.value);
				break;
			case 31:
				if (t.memoizedState !== null) return t.flags |= 128, eo(t), null;
				break;
			case 13:
				var r = t.memoizedState;
				if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? ($a(t), e = Cc(e, t, n), e === null ? null : e.sibling) : gc(e, t, n) : ($a(t), t.flags |= 128, null);
				$a(t);
				break;
			case 19:
				var i = (e.flags & 128) != 0;
				if (r = (n & t.childLanes) !== 0, r ||= (Ki(e, t, n, !1), (n & t.childLanes) !== 0), i) {
					if (r) return Sc(e, t, n);
					t.flags |= 128;
				}
				if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), R(io, io.current), r) break;
				return null;
			case 22: return t.lanes = 0, nc(e, t, n, t.pendingProps);
			case 24: Hi(t, ta, e.memoizedState.cache);
		}
		return Cc(e, t, n);
	}
	function Ec(e, t, n) {
		if (e !== null) if (e.memoizedProps !== t.pendingProps) Zs = !0;
		else {
			if (!wc(e, n) && !(t.flags & 128)) return Zs = !1, Tc(e, t, n);
			Zs = !!(e.flags & 131072);
		}
		else Zs = !1, G && t.flags & 1048576 && Ci(t, gi, t.index);
		switch (t.lanes = 0, t.tag) {
			case 16:
				a: {
					var r = t.pendingProps;
					if (e = Sa(t.elementType), t.type = e, typeof e == "function") ri(e) ? (r = Bs(e, r), t.tag = 1, t = dc(null, t, e, r, n)) : (t.tag = 0, t = lc(null, t, e, r, n));
					else {
						if (e != null) {
							var a = e.$$typeof;
							if (a === w) {
								t.tag = 11, t = $s(null, t, e, r, n);
								break a;
							} else if (a === D) {
								t.tag = 14, t = ec(null, t, e, r, n);
								break a;
							}
						}
						throw t = ee(e) || e, Error(i(306, t, ""));
					}
				}
				return t;
			case 0: return lc(e, t, t.type, t.pendingProps, n);
			case 1: return r = t.type, a = Bs(r, t.pendingProps), dc(e, t, r, a, n);
			case 3:
				a: {
					if (ce(t, t.stateNode.containerInfo), e === null) throw Error(i(387));
					r = t.pendingProps;
					var o = t.memoizedState;
					a = o.element, Ia(e, t), Ua(t, r, null, n);
					var s = t.memoizedState;
					if (r = s.cache, Hi(t, ta, r), r !== o.cache && Gi(t, [ta], n, !0), Ha(), r = s.element, o.isDehydrated) if (o = {
						element: r,
						isDehydrated: !1,
						cache: s.cache
					}, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
						t = fc(e, t, r, n);
						break a;
					} else if (r !== a) {
						a = fi(Error(i(424)), t), Ri(a), t = fc(e, t, r, n);
						break a;
					} else {
						switch (e = t.stateNode.containerInfo, e.nodeType) {
							case 9:
								e = e.body;
								break;
							default: e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
						}
						for (Oi = cf(e.firstChild), Di = t, G = !0, ki = null, Ai = !0, n = Na(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling;
					}
					else {
						if (Ii(), r === a) {
							t = Cc(e, t, n);
							break a;
						}
						Qs(e, t, r, n);
					}
					t = t.child;
				}
				return t;
			case 26: return cc(e, t), e === null ? (n = kf(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : G || (n = t.type, e = t.pendingProps, r = Bd(oe.current).createElement(n), r[at] = t, r[ot] = e, Pd(r, n, e), vt(r), t.stateNode = r) : t.memoizedState = kf(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
			case 27: return ue(t), e === null && G && (r = t.stateNode = ff(t.type, t.pendingProps, oe.current), Di = t, Ai = !0, a = Oi, Zd(t.type) ? (lf = a, Oi = cf(r.firstChild)) : Oi = a), Qs(e, t, t.pendingProps.children, n), cc(e, t), e === null && (t.flags |= 4194304), t.child;
			case 5: return e === null && G && ((a = r = Oi) && (r = tf(r, t.type, t.pendingProps, Ai), r === null ? a = !1 : (t.stateNode = r, Di = t, Oi = cf(r.firstChild), Ai = !1, a = !0)), a || Mi(t)), ue(t), a = t.type, o = t.pendingProps, s = e === null ? null : e.memoizedProps, r = o.children, Ud(a, o) ? r = null : s !== null && Ud(a, s) && (t.flags |= 32), t.memoizedState !== null && (a = yo(e, t, So, null, null, n), Qf._currentValue = a), cc(e, t), Qs(e, t, r, n), t.child;
			case 6: return e === null && G && ((e = n = Oi) && (n = nf(n, t.pendingProps, Ai), n === null ? e = !1 : (t.stateNode = n, Di = t, Oi = null, e = !0)), e || Mi(t)), null;
			case 13: return gc(e, t, n);
			case 4: return ce(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Ma(t, null, r, n) : Qs(e, t, r, n), t.child;
			case 11: return $s(e, t, t.type, t.pendingProps, n);
			case 7: return Qs(e, t, t.pendingProps, n), t.child;
			case 8: return Qs(e, t, t.pendingProps.children, n), t.child;
			case 12: return Qs(e, t, t.pendingProps.children, n), t.child;
			case 10: return r = t.pendingProps, Hi(t, t.type, r.value), Qs(e, t, r.children, n), t.child;
			case 9: return a = t.type._context, r = t.pendingProps.children, Ji(t), a = Yi(a), r = r(a), t.flags |= 1, Qs(e, t, r, n), t.child;
			case 14: return ec(e, t, t.type, t.pendingProps, n);
			case 15: return tc(e, t, t.type, t.pendingProps, n);
			case 19: return Sc(e, t, n);
			case 31: return sc(e, t, n);
			case 22: return nc(e, t, n, t.pendingProps);
			case 24: return Ji(t), r = Yi(ta), e === null ? (a = pa(), a === null && (a = Fl, o = na(), a.pooledCache = o, o.refCount++, o !== null && (a.pooledCacheLanes |= n), a = o), t.memoizedState = {
				parent: r,
				cache: a
			}, Fa(t), Hi(t, ta, a)) : ((e.lanes & n) !== 0 && (Ia(e, t), Ua(t, null, null, n), Ha()), a = e.memoizedState, o = t.memoizedState, a.parent === r ? (r = o.cache, Hi(t, ta, r), r !== a.cache && Gi(t, [ta], n, !0)) : (a = {
				parent: r,
				cache: r
			}, t.memoizedState = a, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = a), Hi(t, ta, r))), Qs(e, t, t.pendingProps.children, n), t.child;
			case 29: throw t.pendingProps;
		}
		throw Error(i(156, t.tag));
	}
	function Dc(e) {
		e.flags |= 4;
	}
	function Oc(e, t, n, r, i) {
		if ((t = (e.mode & 32) != 0) && (t = !1), t) {
			if (e.flags |= 16777216, (i & 335544128) === i) if (e.stateNode.complete) e.flags |= 8192;
			else if (Su()) e.flags |= 8192;
			else throw Ca = ya, _a;
		} else e.flags &= -16777217;
	}
	function kc(e, t) {
		if (t.type !== "stylesheet" || t.state.loading & 4) e.flags &= -16777217;
		else if (e.flags |= 16777216, !Wf(t)) if (Su()) e.flags |= 8192;
		else throw Ca = ya, _a;
	}
	function Ac(e, t) {
		t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : qe(), e.lanes |= t, ql |= t);
	}
	function jc(e, t) {
		if (!G) switch (e.tailMode) {
			case "hidden":
				t = e.tail;
				for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
				n === null ? e.tail = null : n.sibling = null;
				break;
			case "collapsed":
				n = e.tail;
				for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
				r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
		}
	}
	function Mc(e) {
		var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
		if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling;
		else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
		return e.subtreeFlags |= r, e.childLanes = n, t;
	}
	function Nc(e, t, n) {
		var r = t.pendingProps;
		switch (Ti(t), t.tag) {
			case 16:
			case 15:
			case 0:
			case 11:
			case 7:
			case 8:
			case 12:
			case 9:
			case 14: return Mc(t), null;
			case 1: return Mc(t), null;
			case 3: return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), Ui(ta), le(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Fi(t) ? Dc(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Li())), Mc(t), null;
			case 26:
				var a = t.type, o = t.memoizedState;
				return e === null ? (Dc(t), o === null ? (Mc(t), Oc(t, a, null, r, n)) : (Mc(t), kc(t, o))) : o ? o === e.memoizedState ? (Mc(t), t.flags &= -16777217) : (Dc(t), Mc(t), kc(t, o)) : (e = e.memoizedProps, e !== r && Dc(t), Mc(t), Oc(t, a, e, r, n)), null;
			case 27:
				if (de(t), n = oe.current, a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Dc(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return Mc(t), null;
					}
					e = ae.current, Fi(t) ? Ni(t, e) : (e = ff(a, r, n), t.stateNode = e, Dc(t));
				}
				return Mc(t), null;
			case 5:
				if (de(t), a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Dc(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return Mc(t), null;
					}
					if (o = ae.current, Fi(t)) Ni(t, o);
					else {
						var s = Bd(oe.current);
						switch (o) {
							case 1:
								o = s.createElementNS("http://www.w3.org/2000/svg", a);
								break;
							case 2:
								o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
								break;
							default: switch (a) {
								case "svg":
									o = s.createElementNS("http://www.w3.org/2000/svg", a);
									break;
								case "math":
									o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
									break;
								case "script":
									o = s.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild);
									break;
								case "select":
									o = typeof r.is == "string" ? s.createElement("select", { is: r.is }) : s.createElement("select"), r.multiple ? o.multiple = !0 : r.size && (o.size = r.size);
									break;
								default: o = typeof r.is == "string" ? s.createElement(a, { is: r.is }) : s.createElement(a);
							}
						}
						o[at] = t, o[ot] = r;
						a: for (s = t.child; s !== null;) {
							if (s.tag === 5 || s.tag === 6) o.appendChild(s.stateNode);
							else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
								s.child.return = s, s = s.child;
								continue;
							}
							if (s === t) break a;
							for (; s.sibling === null;) {
								if (s.return === null || s.return === t) break a;
								s = s.return;
							}
							s.sibling.return = s.return, s = s.sibling;
						}
						t.stateNode = o;
						a: switch (Pd(o, a, r), a) {
							case "button":
							case "input":
							case "select":
							case "textarea":
								r = !!r.autoFocus;
								break a;
							case "img":
								r = !0;
								break a;
							default: r = !1;
						}
						r && Dc(t);
					}
				}
				return Mc(t), Oc(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
			case 6:
				if (e && t.stateNode != null) e.memoizedProps !== r && Dc(t);
				else {
					if (typeof r != "string" && t.stateNode === null) throw Error(i(166));
					if (e = oe.current, Fi(t)) {
						if (e = t.stateNode, n = t.memoizedProps, r = null, a = Di, a !== null) switch (a.tag) {
							case 27:
							case 5: r = a.memoizedProps;
						}
						e[at] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || jd(e.nodeValue, n)), e || Mi(t, !0);
					} else e = Bd(e).createTextNode(r), e[at] = t, t.stateNode = e;
				}
				return Mc(t), null;
			case 31:
				if (n = t.memoizedState, e === null || e.memoizedState !== null) {
					if (r = Fi(t), n !== null) {
						if (e === null) {
							if (!r) throw Error(i(318));
							if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(557));
							e[at] = t;
						} else Ii(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						Mc(t), e = !1;
					} else n = Li(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
					if (!e) return t.flags & 256 ? (ro(t), t) : (ro(t), null);
					if (t.flags & 128) throw Error(i(558));
				}
				return Mc(t), null;
			case 13:
				if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
					if (a = Fi(t), r !== null && r.dehydrated !== null) {
						if (e === null) {
							if (!a) throw Error(i(318));
							if (a = t.memoizedState, a = a === null ? null : a.dehydrated, !a) throw Error(i(317));
							a[at] = t;
						} else Ii(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						Mc(t), a = !1;
					} else a = Li(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), a = !0;
					if (!a) return t.flags & 256 ? (ro(t), t) : (ro(t), null);
				}
				return ro(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, a = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (a = r.alternate.memoizedState.cachePool.pool), o = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (o = r.memoizedState.cachePool.pool), o !== a && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Ac(t, t.updateQueue), Mc(t), null);
			case 4: return le(), e === null && xd(t.stateNode.containerInfo), Mc(t), null;
			case 10: return Ui(t.type), Mc(t), null;
			case 19:
				if (L(io), r = t.memoizedState, r === null) return Mc(t), null;
				if (a = (t.flags & 128) != 0, o = r.rendering, o === null) if (a) jc(r, !1);
				else {
					if (Hl !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
						if (o = ao(e), o !== null) {
							for (t.flags |= 128, jc(r, !1), e = o.updateQueue, t.updateQueue = e, Ac(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) ai(n, e), n = n.sibling;
							return R(io, io.current & 1 | 2), G && Si(t, r.treeForkCount), t.child;
						}
						e = e.sibling;
					}
					r.tail !== null && we() > $l && (t.flags |= 128, a = !0, jc(r, !1), t.lanes = 4194304);
				}
				else {
					if (!a) if (e = ao(o), e !== null) {
						if (t.flags |= 128, a = !0, e = e.updateQueue, t.updateQueue = e, Ac(t, e), jc(r, !0), r.tail === null && r.tailMode === "hidden" && !o.alternate && !G) return Mc(t), null;
					} else 2 * we() - r.renderingStartTime > $l && n !== 536870912 && (t.flags |= 128, a = !0, jc(r, !1), t.lanes = 4194304);
					r.isBackwards ? (o.sibling = t.child, t.child = o) : (e = r.last, e === null ? t.child = o : e.sibling = o, r.last = o);
				}
				return r.tail === null ? (Mc(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = we(), e.sibling = null, n = io.current, R(io, a ? n & 1 | 2 : n & 1), G && Si(t, r.treeForkCount), e);
			case 22:
			case 23: return ro(t), Xa(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (Mc(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Mc(t), n = t.updateQueue, n !== null && Ac(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && L(fa), null;
			case 24: return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), Ui(ta), Mc(t), null;
			case 25: return null;
			case 30: return null;
		}
		throw Error(i(156, t.tag));
	}
	function Pc(e, t) {
		switch (Ti(t), t.tag) {
			case 1: return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 3: return Ui(ta), le(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
			case 26:
			case 27:
			case 5: return de(t), null;
			case 31:
				if (t.memoizedState !== null) {
					if (ro(t), t.alternate === null) throw Error(i(340));
					Ii();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 13:
				if (ro(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
					if (t.alternate === null) throw Error(i(340));
					Ii();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 19: return L(io), null;
			case 4: return le(), null;
			case 10: return Ui(t.type), null;
			case 22:
			case 23: return ro(t), Xa(), e !== null && L(fa), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 24: return Ui(ta), null;
			case 25: return null;
			default: return null;
		}
	}
	function Fc(e, t) {
		switch (Ti(t), t.tag) {
			case 3:
				Ui(ta), le();
				break;
			case 26:
			case 27:
			case 5:
				de(t);
				break;
			case 4:
				le();
				break;
			case 31:
				t.memoizedState !== null && ro(t);
				break;
			case 13:
				ro(t);
				break;
			case 19:
				L(io);
				break;
			case 10:
				Ui(t.type);
				break;
			case 22:
			case 23:
				ro(t), Xa(), e !== null && L(fa);
				break;
			case 24: Ui(ta);
		}
	}
	function Ic(e, t) {
		try {
			var n = t.updateQueue, r = n === null ? null : n.lastEffect;
			if (r !== null) {
				var i = r.next;
				n = i;
				do {
					if ((n.tag & e) === e) {
						r = void 0;
						var a = n.create, o = n.inst;
						r = a(), o.destroy = r;
					}
					n = n.next;
				} while (n !== i);
			}
		} catch (e) {
			Uu(t, t.return, e);
		}
	}
	function Lc(e, t, n) {
		try {
			var r = t.updateQueue, i = r === null ? null : r.lastEffect;
			if (i !== null) {
				var a = i.next;
				r = a;
				do {
					if ((r.tag & e) === e) {
						var o = r.inst, s = o.destroy;
						if (s !== void 0) {
							o.destroy = void 0, i = t;
							var c = n, l = s;
							try {
								l();
							} catch (e) {
								Uu(i, c, e);
							}
						}
					}
					r = r.next;
				} while (r !== a);
			}
		} catch (e) {
			Uu(t, t.return, e);
		}
	}
	function Rc(e) {
		var t = e.updateQueue;
		if (t !== null) {
			var n = e.stateNode;
			try {
				Ga(t, n);
			} catch (t) {
				Uu(e, e.return, t);
			}
		}
	}
	function zc(e, t, n) {
		n.props = Bs(e.type, e.memoizedProps), n.state = e.memoizedState;
		try {
			n.componentWillUnmount();
		} catch (n) {
			Uu(e, t, n);
		}
	}
	function Bc(e, t) {
		try {
			var n = e.ref;
			if (n !== null) {
				switch (e.tag) {
					case 26:
					case 27:
					case 5:
						var r = e.stateNode;
						break;
					case 30:
						r = e.stateNode;
						break;
					default: r = e.stateNode;
				}
				typeof n == "function" ? e.refCleanup = n(r) : n.current = r;
			}
		} catch (n) {
			Uu(e, t, n);
		}
	}
	function Vc(e, t) {
		var n = e.ref, r = e.refCleanup;
		if (n !== null) if (typeof r == "function") try {
			r();
		} catch (n) {
			Uu(e, t, n);
		} finally {
			e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
		}
		else if (typeof n == "function") try {
			n(null);
		} catch (n) {
			Uu(e, t, n);
		}
		else n.current = null;
	}
	function Hc(e) {
		var t = e.type, n = e.memoizedProps, r = e.stateNode;
		try {
			a: switch (t) {
				case "button":
				case "input":
				case "select":
				case "textarea":
					n.autoFocus && r.focus();
					break a;
				case "img": n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
			}
		} catch (t) {
			Uu(e, e.return, t);
		}
	}
	function Uc(e, t, n) {
		try {
			var r = e.stateNode;
			Fd(r, e.type, n, t), r[ot] = t;
		} catch (t) {
			Uu(e, e.return, t);
		}
	}
	function Wc(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Zd(e.type) || e.tag === 4;
	}
	function Gc(e) {
		a: for (;;) {
			for (; e.sibling === null;) {
				if (e.return === null || Wc(e.return)) return null;
				e = e.return;
			}
			for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
				if (e.tag === 27 && Zd(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
				e.child.return = e, e = e.child;
			}
			if (!(e.flags & 2)) return e.stateNode;
		}
	}
	function Kc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = Yt));
		else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for (Kc(e, t, n), e = e.sibling; e !== null;) Kc(e, t, n), e = e.sibling;
	}
	function qc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
		else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode), e = e.child, e !== null)) for (qc(e, t, n), e = e.sibling; e !== null;) qc(e, t, n), e = e.sibling;
	}
	function Jc(e) {
		var t = e.stateNode, n = e.memoizedProps;
		try {
			for (var r = e.type, i = t.attributes; i.length;) t.removeAttributeNode(i[0]);
			Pd(t, r, n), t[at] = e, t[ot] = n;
		} catch (t) {
			Uu(e, e.return, t);
		}
	}
	var Yc = !1, Xc = !1, Zc = !1, Qc = typeof WeakSet == "function" ? WeakSet : Set, $c = null;
	function el(e, t) {
		if (e = e.containerInfo, Rd = sp, e = xr(e), Sr(e)) {
			if ("selectionStart" in e) var n = {
				start: e.selectionStart,
				end: e.selectionEnd
			};
			else a: {
				n = (n = e.ownerDocument) && n.defaultView || window;
				var r = n.getSelection && n.getSelection();
				if (r && r.rangeCount !== 0) {
					n = r.anchorNode;
					var a = r.anchorOffset, o = r.focusNode;
					r = r.focusOffset;
					try {
						n.nodeType, o.nodeType;
					} catch {
						n = null;
						break a;
					}
					var s = 0, c = -1, l = -1, u = 0, d = 0, f = e, p = null;
					b: for (;;) {
						for (var m; f !== n || a !== 0 && f.nodeType !== 3 || (c = s + a), f !== o || r !== 0 && f.nodeType !== 3 || (l = s + r), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) p = f, f = m;
						for (;;) {
							if (f === e) break b;
							if (p === n && ++u === a && (c = s), p === o && ++d === r && (l = s), (m = f.nextSibling) !== null) break;
							f = p, p = f.parentNode;
						}
						f = m;
					}
					n = c === -1 || l === -1 ? null : {
						start: c,
						end: l
					};
				} else n = null;
			}
			n ||= {
				start: 0,
				end: 0
			};
		} else n = null;
		for (zd = {
			focusedElem: e,
			selectionRange: n
		}, sp = !1, $c = t; $c !== null;) if (t = $c, e = t.child, t.subtreeFlags & 1028 && e !== null) e.return = t, $c = e;
		else for (; $c !== null;) {
			switch (t = $c, o = t.alternate, e = t.flags, t.tag) {
				case 0:
					if (e & 4 && (e = t.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) a = e[n], a.ref.impl = a.nextImpl;
					break;
				case 11:
				case 15: break;
				case 1:
					if (e & 1024 && o !== null) {
						e = void 0, n = t, a = o.memoizedProps, o = o.memoizedState, r = n.stateNode;
						try {
							var h = Bs(n.type, a);
							e = r.getSnapshotBeforeUpdate(h, o), r.__reactInternalSnapshotBeforeUpdate = e;
						} catch (e) {
							Uu(n, n.return, e);
						}
					}
					break;
				case 3:
					if (e & 1024) {
						if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9) ef(e);
						else if (n === 1) switch (e.nodeName) {
							case "HEAD":
							case "HTML":
							case "BODY":
								ef(e);
								break;
							default: e.textContent = "";
						}
					}
					break;
				case 5:
				case 26:
				case 27:
				case 6:
				case 4:
				case 17: break;
				default: if (e & 1024) throw Error(i(163));
			}
			if (e = t.sibling, e !== null) {
				e.return = t.return, $c = e;
				break;
			}
			$c = t.return;
		}
	}
	function tl(e, t, n) {
		var r = n.flags;
		switch (n.tag) {
			case 0:
			case 11:
			case 15:
				gl(e, n), r & 4 && Ic(5, n);
				break;
			case 1:
				if (gl(e, n), r & 4) if (e = n.stateNode, t === null) try {
					e.componentDidMount();
				} catch (e) {
					Uu(n, n.return, e);
				}
				else {
					var i = Bs(n.type, t.memoizedProps);
					t = t.memoizedState;
					try {
						e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
					} catch (e) {
						Uu(n, n.return, e);
					}
				}
				r & 64 && Rc(n), r & 512 && Bc(n, n.return);
				break;
			case 3:
				if (gl(e, n), r & 64 && (e = n.updateQueue, e !== null)) {
					if (t = null, n.child !== null) switch (n.child.tag) {
						case 27:
						case 5:
							t = n.child.stateNode;
							break;
						case 1: t = n.child.stateNode;
					}
					try {
						Ga(e, t);
					} catch (e) {
						Uu(n, n.return, e);
					}
				}
				break;
			case 27: t === null && r & 4 && Jc(n);
			case 26:
			case 5:
				gl(e, n), t === null && r & 4 && Hc(n), r & 512 && Bc(n, n.return);
				break;
			case 12:
				gl(e, n);
				break;
			case 31:
				gl(e, n), r & 4 && sl(e, n);
				break;
			case 13:
				gl(e, n), r & 4 && cl(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = qu.bind(null, n), sf(e, n))));
				break;
			case 22:
				if (r = n.memoizedState !== null || Yc, !r) {
					t = t !== null && t.memoizedState !== null || Xc, i = Yc;
					var a = Xc;
					Yc = r, (Xc = t) && !a ? vl(e, n, (n.subtreeFlags & 8772) != 0) : gl(e, n), Yc = i, Xc = a;
				}
				break;
			case 30: break;
			default: gl(e, n);
		}
	}
	function nl(e) {
		var t = e.alternate;
		t !== null && (e.alternate = null, nl(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && pt(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
	}
	var rl = null, il = !1;
	function al(e, t, n) {
		for (n = n.child; n !== null;) ol(e, t, n), n = n.sibling;
	}
	function ol(e, t, n) {
		if (Pe && typeof Pe.onCommitFiberUnmount == "function") try {
			Pe.onCommitFiberUnmount(Ne, n);
		} catch {}
		switch (n.tag) {
			case 26:
				Xc || Vc(n, t), al(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
				break;
			case 27:
				Xc || Vc(n, t);
				var r = rl, i = il;
				Zd(n.type) && (rl = n.stateNode, il = !1), al(e, t, n), pf(n.stateNode), rl = r, il = i;
				break;
			case 5: Xc || Vc(n, t);
			case 6:
				if (r = rl, i = il, rl = null, al(e, t, n), rl = r, il = i, rl !== null) if (il) try {
					(rl.nodeType === 9 ? rl.body : rl.nodeName === "HTML" ? rl.ownerDocument.body : rl).removeChild(n.stateNode);
				} catch (e) {
					Uu(n, t, e);
				}
				else try {
					rl.removeChild(n.stateNode);
				} catch (e) {
					Uu(n, t, e);
				}
				break;
			case 18:
				rl !== null && (il ? (e = rl, Qd(e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, n.stateNode), Np(e)) : Qd(rl, n.stateNode));
				break;
			case 4:
				r = rl, i = il, rl = n.stateNode.containerInfo, il = !0, al(e, t, n), rl = r, il = i;
				break;
			case 0:
			case 11:
			case 14:
			case 15:
				Lc(2, n, t), Xc || Lc(4, n, t), al(e, t, n);
				break;
			case 1:
				Xc || (Vc(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function" && zc(n, t, r)), al(e, t, n);
				break;
			case 21:
				al(e, t, n);
				break;
			case 22:
				Xc = (r = Xc) || n.memoizedState !== null, al(e, t, n), Xc = r;
				break;
			default: al(e, t, n);
		}
	}
	function sl(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
			e = e.dehydrated;
			try {
				Np(e);
			} catch (e) {
				Uu(t, t.return, e);
			}
		}
	}
	function cl(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
			Np(e);
		} catch (e) {
			Uu(t, t.return, e);
		}
	}
	function ll(e) {
		switch (e.tag) {
			case 31:
			case 13:
			case 19:
				var t = e.stateNode;
				return t === null && (t = e.stateNode = new Qc()), t;
			case 22: return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new Qc()), t;
			default: throw Error(i(435, e.tag));
		}
	}
	function ul(e, t) {
		var n = ll(e);
		t.forEach(function(t) {
			if (!n.has(t)) {
				n.add(t);
				var r = Ju.bind(null, e, t);
				t.then(r, r);
			}
		});
	}
	function dl(e, t) {
		var n = t.deletions;
		if (n !== null) for (var r = 0; r < n.length; r++) {
			var a = n[r], o = e, s = t, c = s;
			a: for (; c !== null;) {
				switch (c.tag) {
					case 27:
						if (Zd(c.type)) {
							rl = c.stateNode, il = !1;
							break a;
						}
						break;
					case 5:
						rl = c.stateNode, il = !1;
						break a;
					case 3:
					case 4:
						rl = c.stateNode.containerInfo, il = !0;
						break a;
				}
				c = c.return;
			}
			if (rl === null) throw Error(i(160));
			ol(o, s, a), rl = null, il = !1, o = a.alternate, o !== null && (o.return = null), a.return = null;
		}
		if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) pl(t, e), t = t.sibling;
	}
	var fl = null;
	function pl(e, t) {
		var n = e.alternate, r = e.flags;
		switch (e.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				dl(t, e), ml(e), r & 4 && (Lc(3, e, e.return), Ic(3, e), Lc(5, e, e.return));
				break;
			case 1:
				dl(t, e), ml(e), r & 512 && (Xc || n === null || Vc(n, n.return)), r & 64 && Yc && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? r : n.concat(r))));
				break;
			case 26:
				var a = fl;
				if (dl(t, e), ml(e), r & 512 && (Xc || n === null || Vc(n, n.return)), r & 4) {
					var o = n === null ? null : n.memoizedState;
					if (r = e.memoizedState, n === null) if (r === null) if (e.stateNode === null) {
						a: {
							r = e.type, n = e.memoizedProps, a = a.ownerDocument || a;
							b: switch (r) {
								case "title":
									o = a.getElementsByTagName("title")[0], (!o || o[ft] || o[at] || o.namespaceURI === "http://www.w3.org/2000/svg" || o.hasAttribute("itemprop")) && (o = a.createElement(r), a.head.insertBefore(o, a.querySelector("head > title"))), Pd(o, r, n), o[at] = e, vt(o), r = o;
									break a;
								case "link":
									var s = Vf("link", "href", a).get(r + (n.href || ""));
									if (s) {
										for (var c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && o.getAttribute("rel") === (n.rel == null ? null : n.rel) && o.getAttribute("title") === (n.title == null ? null : n.title) && o.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
											s.splice(c, 1);
											break b;
										}
									}
									o = a.createElement(r), Pd(o, r, n), a.head.appendChild(o);
									break;
								case "meta":
									if (s = Vf("meta", "content", a).get(r + (n.content || ""))) {
										for (c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("content") === (n.content == null ? null : "" + n.content) && o.getAttribute("name") === (n.name == null ? null : n.name) && o.getAttribute("property") === (n.property == null ? null : n.property) && o.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && o.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
											s.splice(c, 1);
											break b;
										}
									}
									o = a.createElement(r), Pd(o, r, n), a.head.appendChild(o);
									break;
								default: throw Error(i(468, r));
							}
							o[at] = e, vt(o), r = o;
						}
						e.stateNode = r;
					} else Hf(a, e.type, e.stateNode);
					else e.stateNode = If(a, r, e.memoizedProps);
					else o === r ? r === null && e.stateNode !== null && Uc(e, e.memoizedProps, n.memoizedProps) : (o === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : o.count--, r === null ? Hf(a, e.type, e.stateNode) : If(a, r, e.memoizedProps));
				}
				break;
			case 27:
				dl(t, e), ml(e), r & 512 && (Xc || n === null || Vc(n, n.return)), n !== null && r & 4 && Uc(e, e.memoizedProps, n.memoizedProps);
				break;
			case 5:
				if (dl(t, e), ml(e), r & 512 && (Xc || n === null || Vc(n, n.return)), e.flags & 32) {
					a = e.stateNode;
					try {
						Vt(a, "");
					} catch (t) {
						Uu(e, e.return, t);
					}
				}
				r & 4 && e.stateNode != null && (a = e.memoizedProps, Uc(e, a, n === null ? a : n.memoizedProps)), r & 1024 && (Zc = !0);
				break;
			case 6:
				if (dl(t, e), ml(e), r & 4) {
					if (e.stateNode === null) throw Error(i(162));
					r = e.memoizedProps, n = e.stateNode;
					try {
						n.nodeValue = r;
					} catch (t) {
						Uu(e, e.return, t);
					}
				}
				break;
			case 3:
				if (Bf = null, a = fl, fl = gf(t.containerInfo), dl(t, e), fl = a, ml(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
					Np(t.containerInfo);
				} catch (t) {
					Uu(e, e.return, t);
				}
				Zc && (Zc = !1, hl(e));
				break;
			case 4:
				r = fl, fl = gf(e.stateNode.containerInfo), dl(t, e), ml(e), fl = r;
				break;
			case 12:
				dl(t, e), ml(e);
				break;
			case 31:
				dl(t, e), ml(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, ul(e, r)));
				break;
			case 13:
				dl(t, e), ml(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && (Zl = we()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, ul(e, r)));
				break;
			case 22:
				a = e.memoizedState !== null;
				var l = n !== null && n.memoizedState !== null, u = Yc, d = Xc;
				if (Yc = u || a, Xc = d || l, dl(t, e), Xc = d, Yc = u, ml(e), r & 8192) a: for (t = e.stateNode, t._visibility = a ? t._visibility & -2 : t._visibility | 1, a && (n === null || l || Yc || Xc || _l(e)), n = null, t = e;;) {
					if (t.tag === 5 || t.tag === 26) {
						if (n === null) {
							l = n = t;
							try {
								if (o = l.stateNode, a) s = o.style, typeof s.setProperty == "function" ? s.setProperty("display", "none", "important") : s.display = "none";
								else {
									c = l.stateNode;
									var f = l.memoizedProps.style, p = f != null && f.hasOwnProperty("display") ? f.display : null;
									c.style.display = p == null || typeof p == "boolean" ? "" : ("" + p).trim();
								}
							} catch (e) {
								Uu(l, l.return, e);
							}
						}
					} else if (t.tag === 6) {
						if (n === null) {
							l = t;
							try {
								l.stateNode.nodeValue = a ? "" : l.memoizedProps;
							} catch (e) {
								Uu(l, l.return, e);
							}
						}
					} else if (t.tag === 18) {
						if (n === null) {
							l = t;
							try {
								var m = l.stateNode;
								a ? $d(m, !0) : $d(l.stateNode, !1);
							} catch (e) {
								Uu(l, l.return, e);
							}
						}
					} else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
						t.child.return = t, t = t.child;
						continue;
					}
					if (t === e) break a;
					for (; t.sibling === null;) {
						if (t.return === null || t.return === e) break a;
						n === t && (n = null), t = t.return;
					}
					n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
				}
				r & 4 && (r = e.updateQueue, r !== null && (n = r.retryQueue, n !== null && (r.retryQueue = null, ul(e, n))));
				break;
			case 19:
				dl(t, e), ml(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, ul(e, r)));
				break;
			case 30: break;
			case 21: break;
			default: dl(t, e), ml(e);
		}
	}
	function ml(e) {
		var t = e.flags;
		if (t & 2) {
			try {
				for (var n, r = e.return; r !== null;) {
					if (Wc(r)) {
						n = r;
						break;
					}
					r = r.return;
				}
				if (n == null) throw Error(i(160));
				switch (n.tag) {
					case 27:
						var a = n.stateNode;
						qc(e, Gc(e), a);
						break;
					case 5:
						var o = n.stateNode;
						n.flags & 32 && (Vt(o, ""), n.flags &= -33), qc(e, Gc(e), o);
						break;
					case 3:
					case 4:
						var s = n.stateNode.containerInfo;
						Kc(e, Gc(e), s);
						break;
					default: throw Error(i(161));
				}
			} catch (t) {
				Uu(e, e.return, t);
			}
			e.flags &= -3;
		}
		t & 4096 && (e.flags &= -4097);
	}
	function hl(e) {
		if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
			var t = e;
			hl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
		}
	}
	function gl(e, t) {
		if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) tl(e, t.alternate, t), t = t.sibling;
	}
	function _l(e) {
		for (e = e.child; e !== null;) {
			var t = e;
			switch (t.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					Lc(4, t, t.return), _l(t);
					break;
				case 1:
					Vc(t, t.return);
					var n = t.stateNode;
					typeof n.componentWillUnmount == "function" && zc(t, t.return, n), _l(t);
					break;
				case 27: pf(t.stateNode);
				case 26:
				case 5:
					Vc(t, t.return), _l(t);
					break;
				case 22:
					t.memoizedState === null && _l(t);
					break;
				case 30:
					_l(t);
					break;
				default: _l(t);
			}
			e = e.sibling;
		}
	}
	function vl(e, t, n) {
		for (n &&= (t.subtreeFlags & 8772) != 0, t = t.child; t !== null;) {
			var r = t.alternate, i = e, a = t, o = a.flags;
			switch (a.tag) {
				case 0:
				case 11:
				case 15:
					vl(i, a, n), Ic(4, a);
					break;
				case 1:
					if (vl(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == "function") try {
						i.componentDidMount();
					} catch (e) {
						Uu(r, r.return, e);
					}
					if (r = a, i = r.updateQueue, i !== null) {
						var s = r.stateNode;
						try {
							var c = i.shared.hiddenCallbacks;
							if (c !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < c.length; i++) Wa(c[i], s);
						} catch (e) {
							Uu(r, r.return, e);
						}
					}
					n && o & 64 && Rc(a), Bc(a, a.return);
					break;
				case 27: Jc(a);
				case 26:
				case 5:
					vl(i, a, n), n && r === null && o & 4 && Hc(a), Bc(a, a.return);
					break;
				case 12:
					vl(i, a, n);
					break;
				case 31:
					vl(i, a, n), n && o & 4 && sl(i, a);
					break;
				case 13:
					vl(i, a, n), n && o & 4 && cl(i, a);
					break;
				case 22:
					a.memoizedState === null && vl(i, a, n), Bc(a, a.return);
					break;
				case 30: break;
				default: vl(i, a, n);
			}
			t = t.sibling;
		}
	}
	function yl(e, t) {
		var n = null;
		e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && ra(n));
	}
	function bl(e, t) {
		e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ra(e));
	}
	function xl(e, t, n, r) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) Sl(e, t, n, r), t = t.sibling;
	}
	function Sl(e, t, n, r) {
		var i = t.flags;
		switch (t.tag) {
			case 0:
			case 11:
			case 15:
				xl(e, t, n, r), i & 2048 && Ic(9, t);
				break;
			case 1:
				xl(e, t, n, r);
				break;
			case 3:
				xl(e, t, n, r), i & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ra(e)));
				break;
			case 12:
				if (i & 2048) {
					xl(e, t, n, r), e = t.stateNode;
					try {
						var a = t.memoizedProps, o = a.id, s = a.onPostCommit;
						typeof s == "function" && s(o, t.alternate === null ? "mount" : "update", e.passiveEffectDuration, -0);
					} catch (e) {
						Uu(t, t.return, e);
					}
				} else xl(e, t, n, r);
				break;
			case 31:
				xl(e, t, n, r);
				break;
			case 13:
				xl(e, t, n, r);
				break;
			case 23: break;
			case 22:
				a = t.stateNode, o = t.alternate, t.memoizedState === null ? a._visibility & 2 ? xl(e, t, n, r) : (a._visibility |= 2, Cl(e, t, n, r, (t.subtreeFlags & 10256) != 0 || !1)) : a._visibility & 2 ? xl(e, t, n, r) : wl(e, t), i & 2048 && yl(o, t);
				break;
			case 24:
				xl(e, t, n, r), i & 2048 && bl(t.alternate, t);
				break;
			default: xl(e, t, n, r);
		}
	}
	function Cl(e, t, n, r, i) {
		for (i &&= (t.subtreeFlags & 10256) != 0 || !1, t = t.child; t !== null;) {
			var a = e, o = t, s = n, c = r, l = o.flags;
			switch (o.tag) {
				case 0:
				case 11:
				case 15:
					Cl(a, o, s, c, i), Ic(8, o);
					break;
				case 23: break;
				case 22:
					var u = o.stateNode;
					o.memoizedState === null ? (u._visibility |= 2, Cl(a, o, s, c, i)) : u._visibility & 2 ? Cl(a, o, s, c, i) : wl(a, o), i && l & 2048 && yl(o.alternate, o);
					break;
				case 24:
					Cl(a, o, s, c, i), i && l & 2048 && bl(o.alternate, o);
					break;
				default: Cl(a, o, s, c, i);
			}
			t = t.sibling;
		}
	}
	function wl(e, t) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) {
			var n = e, r = t, i = r.flags;
			switch (r.tag) {
				case 22:
					wl(n, r), i & 2048 && yl(r.alternate, r);
					break;
				case 24:
					wl(n, r), i & 2048 && bl(r.alternate, r);
					break;
				default: wl(n, r);
			}
			t = t.sibling;
		}
	}
	var Tl = 8192;
	function El(e, t, n) {
		if (e.subtreeFlags & Tl) for (e = e.child; e !== null;) Dl(e, t, n), e = e.sibling;
	}
	function Dl(e, t, n) {
		switch (e.tag) {
			case 26:
				El(e, t, n), e.flags & Tl && e.memoizedState !== null && Gf(n, fl, e.memoizedState, e.memoizedProps);
				break;
			case 5:
				El(e, t, n);
				break;
			case 3:
			case 4:
				var r = fl;
				fl = gf(e.stateNode.containerInfo), El(e, t, n), fl = r;
				break;
			case 22:
				e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Tl, Tl = 16777216, El(e, t, n), Tl = r) : El(e, t, n));
				break;
			default: El(e, t, n);
		}
	}
	function Ol(e) {
		var t = e.alternate;
		if (t !== null && (e = t.child, e !== null)) {
			t.child = null;
			do
				t = e.sibling, e.sibling = null, e = t;
			while (e !== null);
		}
	}
	function kl(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				$c = r, Ml(r, e);
			}
			Ol(e);
		}
		if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Al(e), e = e.sibling;
	}
	function Al(e) {
		switch (e.tag) {
			case 0:
			case 11:
			case 15:
				kl(e), e.flags & 2048 && Lc(9, e, e.return);
				break;
			case 3:
				kl(e);
				break;
			case 12:
				kl(e);
				break;
			case 22:
				var t = e.stateNode;
				e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, jl(e)) : kl(e);
				break;
			default: kl(e);
		}
	}
	function jl(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				$c = r, Ml(r, e);
			}
			Ol(e);
		}
		for (e = e.child; e !== null;) {
			switch (t = e, t.tag) {
				case 0:
				case 11:
				case 15:
					Lc(8, t, t.return), jl(t);
					break;
				case 22:
					n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, jl(t));
					break;
				default: jl(t);
			}
			e = e.sibling;
		}
	}
	function Ml(e, t) {
		for (; $c !== null;) {
			var n = $c;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					Lc(8, n, t);
					break;
				case 23:
				case 22:
					if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
						var r = n.memoizedState.cachePool.pool;
						r != null && r.refCount++;
					}
					break;
				case 24: ra(n.memoizedState.cache);
			}
			if (r = n.child, r !== null) r.return = n, $c = r;
			else a: for (n = e; $c !== null;) {
				r = $c;
				var i = r.sibling, a = r.return;
				if (nl(r), r === n) {
					$c = null;
					break a;
				}
				if (i !== null) {
					i.return = a, $c = i;
					break a;
				}
				$c = a;
			}
		}
	}
	var Nl = {
		getCacheForType: function(e) {
			var t = Yi(ta), n = t.data.get(e);
			return n === void 0 && (n = e(), t.data.set(e, n)), n;
		},
		cacheSignal: function() {
			return Yi(ta).controller.signal;
		}
	}, Pl = typeof WeakMap == "function" ? WeakMap : Map, X = 0, Fl = null, Z = null, Q = 0, Il = 0, Ll = null, Rl = !1, zl = !1, Bl = !1, Vl = 0, Hl = 0, Ul = 0, Wl = 0, Gl = 0, Kl = 0, ql = 0, Jl = null, Yl = null, Xl = !1, Zl = 0, Ql = 0, $l = Infinity, eu = null, tu = null, nu = 0, ru = null, iu = null, au = 0, ou = 0, su = null, cu = null, lu = 0, uu = null;
	function du() {
		return X & 2 && Q !== 0 ? Q & -Q : P.T === null ? nt() : ud();
	}
	function fu() {
		if (Kl === 0) if (!(Q & 536870912) || G) {
			var e = Ve;
			Ve <<= 1, !(Ve & 3932160) && (Ve = 262144), Kl = e;
		} else Kl = 536870912;
		return e = Za.current, e !== null && (e.flags |= 32), Kl;
	}
	function pu(e, t, n) {
		(e === Fl && (Il === 2 || Il === 9) || e.cancelPendingCommit !== null) && (bu(e, 0), _u(e, Q, Kl, !1)), Ye(e, n), (!(X & 2) || e !== Fl) && (e === Fl && (!(X & 2) && (Wl |= n), Hl === 4 && _u(e, Q, Kl, !1)), nd(e));
	}
	function mu(e, t, n) {
		if (X & 6) throw Error(i(327));
		var r = !n && (t & 127) == 0 && (t & e.expiredLanes) === 0 || Ge(e, t), a = r ? Ou(e, t) : Eu(e, t, !0), o = r;
		do {
			if (a === 0) {
				zl && !r && _u(e, t, 0, !1);
				break;
			} else {
				if (n = e.current.alternate, o && !gu(n)) {
					a = Eu(e, t, !1), o = !1;
					continue;
				}
				if (a === 2) {
					if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0;
					else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
					if (s !== 0) {
						t = s;
						a: {
							var c = e;
							a = Jl;
							var l = c.current.memoizedState.isDehydrated;
							if (l && (bu(c, s).flags |= 256), s = Eu(c, s, !1), s !== 2) {
								if (Bl && !l) {
									c.errorRecoveryDisabledLanes |= o, Wl |= o, a = 4;
									break a;
								}
								o = Yl, Yl = a, o !== null && (Yl === null ? Yl = o : Yl.push.apply(Yl, o));
							}
							a = s;
						}
						if (o = !1, a !== 2) continue;
					}
				}
				if (a === 1) {
					bu(e, 0), _u(e, t, 0, !0);
					break;
				}
				a: {
					switch (r = e, o = a, o) {
						case 0:
						case 1: throw Error(i(345));
						case 4: if ((t & 4194048) !== t) break;
						case 6:
							_u(r, t, Kl, !Rl);
							break a;
						case 2:
							Yl = null;
							break;
						case 3:
						case 5: break;
						default: throw Error(i(329));
					}
					if ((t & 62914560) === t && (a = Zl + 300 - we(), 10 < a)) {
						if (_u(r, t, Kl, !Rl), We(r, 0, !0) !== 0) break a;
						au = t, r.timeoutHandle = Kd(hu.bind(null, r, n, Yl, eu, Xl, t, Kl, Wl, ql, Rl, o, "Throttled", -0, 0), a);
						break a;
					}
					hu(r, n, Yl, eu, Xl, t, Kl, Wl, ql, Rl, o, null, -0, 0);
				}
			}
			break;
		} while (1);
		nd(e);
	}
	function hu(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
		if (e.timeoutHandle = -1, d = t.subtreeFlags, d & 8192 || (d & 16785408) == 16785408) {
			d = {
				stylesheets: null,
				count: 0,
				imgCount: 0,
				imgBytes: 0,
				suspenseyImages: [],
				waitingForImages: !0,
				waitingForViewTransition: !1,
				unsuspend: Yt
			}, Dl(t, a, d);
			var m = (a & 62914560) === a ? Zl - we() : (a & 4194048) === a ? Ql - we() : 0;
			if (m = qf(d, m), m !== null) {
				au = a, e.cancelPendingCommit = m(Fu.bind(null, e, t, a, n, r, i, o, s, c, u, d, null, f, p)), _u(e, a, o, !l);
				return;
			}
		}
		Fu(e, t, a, n, r, i, o, s, c);
	}
	function gu(e) {
		for (var t = e;;) {
			var n = t.tag;
			if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
				var i = n[r], a = i.getSnapshot;
				i = i.value;
				try {
					if (!gr(a(), i)) return !1;
				} catch {
					return !1;
				}
			}
			if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
			else {
				if (t === e) break;
				for (; t.sibling === null;) {
					if (t.return === null || t.return === e) return !0;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
		}
		return !0;
	}
	function _u(e, t, n, r) {
		t &= ~Gl, t &= ~Wl, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
		for (var i = t; 0 < i;) {
			var a = 31 - Ie(i), o = 1 << a;
			r[a] = -1, i &= ~o;
		}
		n !== 0 && Ze(e, n, t);
	}
	function vu() {
		return X & 6 ? !0 : (rd(0, !1), !1);
	}
	function yu() {
		if (Z !== null) {
			if (Il === 0) var e = Z.return;
			else e = Z, Vi = Bi = null, To(e), Ea = null, Da = 0, e = Z;
			for (; e !== null;) Fc(e.alternate, e), e = e.return;
			Z = null;
		}
	}
	function bu(e, t) {
		var n = e.timeoutHandle;
		n !== -1 && (e.timeoutHandle = -1, qd(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), au = 0, yu(), Fl = e, Z = n = ii(e.current, null), Q = t, Il = 0, Ll = null, Rl = !1, zl = Ge(e, t), Bl = !1, ql = Kl = Gl = Wl = Ul = Hl = 0, Yl = Jl = null, Xl = !1, t & 8 && (t |= t & 32);
		var r = e.entangledLanes;
		if (r !== 0) for (e = e.entanglements, r &= t; 0 < r;) {
			var i = 31 - Ie(r), a = 1 << i;
			t |= e[i], r &= ~a;
		}
		return Vl = t, Jr(), n;
	}
	function xu(e, t) {
		K = null, P.H = Ms, t === ga || t === va ? (t = wa(), Il = 3) : t === _a ? (t = wa(), Il = 4) : Il = t === Xs ? 8 : typeof t == "object" && t && typeof t.then == "function" ? 6 : 1, Ll = t, Z === null && (Hl = 1, Ws(e, fi(t, e.current)));
	}
	function Su() {
		var e = Za.current;
		return e === null ? !0 : (Q & 4194048) === Q ? Qa === null : (Q & 62914560) === Q || Q & 536870912 ? e === Qa : !1;
	}
	function Cu() {
		var e = P.H;
		return P.H = Ms, e === null ? Ms : e;
	}
	function wu() {
		var e = P.A;
		return P.A = Nl, e;
	}
	function Tu() {
		Hl = 4, Rl || (Q & 4194048) !== Q && Za.current !== null || (zl = !0), !(Ul & 134217727) && !(Wl & 134217727) || Fl === null || _u(Fl, Q, Kl, !1);
	}
	function Eu(e, t, n) {
		var r = X;
		X |= 2;
		var i = Cu(), a = wu();
		(Fl !== e || Q !== t) && (eu = null, bu(e, t)), t = !1;
		var o = Hl;
		a: do
			try {
				if (Il !== 0 && Z !== null) {
					var s = Z, c = Ll;
					switch (Il) {
						case 8:
							yu(), o = 6;
							break a;
						case 3:
						case 2:
						case 9:
						case 6:
							Za.current === null && (t = !0);
							var l = Il;
							if (Il = 0, Ll = null, Mu(e, s, c, l), n && zl) {
								o = 0;
								break a;
							}
							break;
						default: l = Il, Il = 0, Ll = null, Mu(e, s, c, l);
					}
				}
				Du(), o = Hl;
				break;
			} catch (t) {
				xu(e, t);
			}
		while (1);
		return t && e.shellSuspendCounter++, Vi = Bi = null, X = r, P.H = i, P.A = a, Z === null && (Fl = null, Q = 0, Jr()), o;
	}
	function Du() {
		for (; Z !== null;) Au(Z);
	}
	function Ou(e, t) {
		var n = X;
		X |= 2;
		var r = Cu(), a = wu();
		Fl !== e || Q !== t ? (eu = null, $l = we() + 500, bu(e, t)) : zl = Ge(e, t);
		a: do
			try {
				if (Il !== 0 && Z !== null) {
					t = Z;
					var o = Ll;
					b: switch (Il) {
						case 1:
							Il = 0, Ll = null, Mu(e, t, o, 1);
							break;
						case 2:
						case 9:
							if (ba(o)) {
								Il = 0, Ll = null, ju(t);
								break;
							}
							t = function() {
								Il !== 2 && Il !== 9 || Fl !== e || (Il = 7), nd(e);
							}, o.then(t, t);
							break a;
						case 3:
							Il = 7;
							break a;
						case 4:
							Il = 5;
							break a;
						case 7:
							ba(o) ? (Il = 0, Ll = null, ju(t)) : (Il = 0, Ll = null, Mu(e, t, o, 7));
							break;
						case 5:
							var s = null;
							switch (Z.tag) {
								case 26: s = Z.memoizedState;
								case 5:
								case 27:
									var c = Z;
									if (s ? Wf(s) : c.stateNode.complete) {
										Il = 0, Ll = null;
										var l = c.sibling;
										if (l !== null) Z = l;
										else {
											var u = c.return;
											u === null ? Z = null : (Z = u, Nu(u));
										}
										break b;
									}
							}
							Il = 0, Ll = null, Mu(e, t, o, 5);
							break;
						case 6:
							Il = 0, Ll = null, Mu(e, t, o, 6);
							break;
						case 8:
							yu(), Hl = 6;
							break a;
						default: throw Error(i(462));
					}
				}
				ku();
				break;
			} catch (t) {
				xu(e, t);
			}
		while (1);
		return Vi = Bi = null, P.H = r, P.A = a, X = n, Z === null ? (Fl = null, Q = 0, Jr(), Hl) : 0;
	}
	function ku() {
		for (; Z !== null && !Se();) Au(Z);
	}
	function Au(e) {
		var t = Ec(e.alternate, e, Vl);
		e.memoizedProps = e.pendingProps, t === null ? Nu(e) : Z = t;
	}
	function ju(e) {
		var t = e, n = t.alternate;
		switch (t.tag) {
			case 15:
			case 0:
				t = uc(n, t, t.pendingProps, t.type, void 0, Q);
				break;
			case 11:
				t = uc(n, t, t.pendingProps, t.type.render, t.ref, Q);
				break;
			case 5: To(t);
			default: Fc(n, t), t = Z = ai(t, Vl), t = Ec(n, t, Vl);
		}
		e.memoizedProps = e.pendingProps, t === null ? Nu(e) : Z = t;
	}
	function Mu(e, t, n, r) {
		Vi = Bi = null, To(t), Ea = null, Da = 0;
		var i = t.return;
		try {
			if (Ys(e, i, t, n, Q)) {
				Hl = 1, Ws(e, fi(n, e.current)), Z = null;
				return;
			}
		} catch (t) {
			if (i !== null) throw Z = i, t;
			Hl = 1, Ws(e, fi(n, e.current)), Z = null;
			return;
		}
		t.flags & 32768 ? (G || r === 1 ? e = !0 : zl || Q & 536870912 ? e = !1 : (Rl = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = Za.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Pu(t, e)) : Nu(t);
	}
	function Nu(e) {
		var t = e;
		do {
			if (t.flags & 32768) {
				Pu(t, Rl);
				return;
			}
			e = t.return;
			var n = Nc(t.alternate, t, Vl);
			if (n !== null) {
				Z = n;
				return;
			}
			if (t = t.sibling, t !== null) {
				Z = t;
				return;
			}
			Z = t = e;
		} while (t !== null);
		Hl === 0 && (Hl = 5);
	}
	function Pu(e, t) {
		do {
			var n = Pc(e.alternate, e);
			if (n !== null) {
				n.flags &= 32767, Z = n;
				return;
			}
			if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
				Z = e;
				return;
			}
			Z = e = n;
		} while (e !== null);
		Hl = 6, Z = null;
	}
	function Fu(e, t, n, r, a, o, s, c, l) {
		e.cancelPendingCommit = null;
		do
			Bu();
		while (nu !== 0);
		if (X & 6) throw Error(i(327));
		if (t !== null) {
			if (t === e.current) throw Error(i(177));
			if (o = t.lanes | t.childLanes, o |= qr, Xe(e, n, o, s, c, l), e === Fl && (Z = Fl = null, Q = 0), iu = t, ru = e, au = n, ou = o, su = a, cu = r, t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, Yu(Oe, function() {
				return Vu(), null;
			})) : (e.callbackNode = null, e.callbackPriority = 0), r = (t.flags & 13878) != 0, t.subtreeFlags & 13878 || r) {
				r = P.T, P.T = null, a = F.p, F.p = 2, s = X, X |= 4;
				try {
					el(e, t, n);
				} finally {
					X = s, F.p = a, P.T = r;
				}
			}
			nu = 1, Iu(), Lu(), Ru();
		}
	}
	function Iu() {
		if (nu === 1) {
			nu = 0;
			var e = ru, t = iu, n = (t.flags & 13878) != 0;
			if (t.subtreeFlags & 13878 || n) {
				n = P.T, P.T = null;
				var r = F.p;
				F.p = 2;
				var i = X;
				X |= 4;
				try {
					pl(t, e);
					var a = zd, o = xr(e.containerInfo), s = a.focusedElem, c = a.selectionRange;
					if (o !== s && s && s.ownerDocument && br(s.ownerDocument.documentElement, s)) {
						if (c !== null && Sr(s)) {
							var l = c.start, u = c.end;
							if (u === void 0 && (u = l), "selectionStart" in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length);
							else {
								var d = s.ownerDocument || document, f = d && d.defaultView || window;
								if (f.getSelection) {
									var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m), g = c.end === void 0 ? h : Math.min(c.end, m);
									!p.extend && h > g && (o = g, g = h, h = o);
									var _ = yr(s, h), v = yr(s, g);
									if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
										var y = d.createRange();
										y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y));
									}
								}
							}
						}
						for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
							element: p,
							left: p.scrollLeft,
							top: p.scrollTop
						});
						for (typeof s.focus == "function" && s.focus(), s = 0; s < d.length; s++) {
							var b = d[s];
							b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
						}
					}
					sp = !!Rd, zd = Rd = null;
				} finally {
					X = i, F.p = r, P.T = n;
				}
			}
			e.current = t, nu = 2;
		}
	}
	function Lu() {
		if (nu === 2) {
			nu = 0;
			var e = ru, t = iu, n = (t.flags & 8772) != 0;
			if (t.subtreeFlags & 8772 || n) {
				n = P.T, P.T = null;
				var r = F.p;
				F.p = 2;
				var i = X;
				X |= 4;
				try {
					tl(e, t.alternate, t);
				} finally {
					X = i, F.p = r, P.T = n;
				}
			}
			nu = 3;
		}
	}
	function Ru() {
		if (nu === 4 || nu === 3) {
			nu = 0, Ce();
			var e = ru, t = iu, n = au, r = cu;
			t.subtreeFlags & 10256 || t.flags & 10256 ? nu = 5 : (nu = 0, iu = ru = null, zu(e, e.pendingLanes));
			var i = e.pendingLanes;
			if (i === 0 && (tu = null), tt(n), t = t.stateNode, Pe && typeof Pe.onCommitFiberRoot == "function") try {
				Pe.onCommitFiberRoot(Ne, t, void 0, (t.current.flags & 128) == 128);
			} catch {}
			if (r !== null) {
				t = P.T, i = F.p, F.p = 2, P.T = null;
				try {
					for (var a = e.onRecoverableError, o = 0; o < r.length; o++) {
						var s = r[o];
						a(s.value, { componentStack: s.stack });
					}
				} finally {
					P.T = t, F.p = i;
				}
			}
			au & 3 && Bu(), nd(e), i = e.pendingLanes, n & 261930 && i & 42 ? e === uu ? lu++ : (lu = 0, uu = e) : lu = 0, rd(0, !1);
		}
	}
	function zu(e, t) {
		(e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, ra(t)));
	}
	function Bu() {
		return Iu(), Lu(), Ru(), Vu();
	}
	function Vu() {
		if (nu !== 5) return !1;
		var e = ru, t = ou;
		ou = 0;
		var n = tt(au), r = P.T, a = F.p;
		try {
			F.p = 32 > n ? 32 : n, P.T = null, n = su, su = null;
			var o = ru, s = au;
			if (nu = 0, iu = ru = null, au = 0, X & 6) throw Error(i(331));
			var c = X;
			if (X |= 4, Al(o.current), Sl(o, o.current, s, n), X = c, rd(0, !1), Pe && typeof Pe.onPostCommitFiberRoot == "function") try {
				Pe.onPostCommitFiberRoot(Ne, o);
			} catch {}
			return !0;
		} finally {
			F.p = a, P.T = r, zu(e, t);
		}
	}
	function Hu(e, t, n) {
		t = fi(n, t), t = Ks(e.stateNode, t, 2), e = Ra(e, t, 2), e !== null && (Ye(e, 2), nd(e));
	}
	function Uu(e, t, n) {
		if (e.tag === 3) Hu(e, e, n);
		else for (; t !== null;) {
			if (t.tag === 3) {
				Hu(t, e, n);
				break;
			} else if (t.tag === 1) {
				var r = t.stateNode;
				if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (tu === null || !tu.has(r))) {
					e = fi(n, e), n = qs(2), r = Ra(t, n, 2), r !== null && (Js(n, r, t, e), Ye(r, 2), nd(r));
					break;
				}
			}
			t = t.return;
		}
	}
	function Wu(e, t, n) {
		var r = e.pingCache;
		if (r === null) {
			r = e.pingCache = new Pl();
			var i = /* @__PURE__ */ new Set();
			r.set(t, i);
		} else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
		i.has(n) || (Bl = !0, i.add(n), e = Gu.bind(null, e, t, n), t.then(e, e));
	}
	function Gu(e, t, n) {
		var r = e.pingCache;
		r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, Fl === e && (Q & n) === n && (Hl === 4 || Hl === 3 && (Q & 62914560) === Q && 300 > we() - Zl ? !(X & 2) && bu(e, 0) : Gl |= n, ql === Q && (ql = 0)), nd(e);
	}
	function Ku(e, t) {
		t === 0 && (t = qe()), e = Zr(e, t), e !== null && (Ye(e, t), nd(e));
	}
	function qu(e) {
		var t = e.memoizedState, n = 0;
		t !== null && (n = t.retryLane), Ku(e, n);
	}
	function Ju(e, t) {
		var n = 0;
		switch (e.tag) {
			case 31:
			case 13:
				var r = e.stateNode, a = e.memoizedState;
				a !== null && (n = a.retryLane);
				break;
			case 19:
				r = e.stateNode;
				break;
			case 22:
				r = e.stateNode._retryCache;
				break;
			default: throw Error(i(314));
		}
		r !== null && r.delete(t), Ku(e, n);
	}
	function Yu(e, t) {
		return be(e, t);
	}
	var Xu = null, Zu = null, Qu = !1, $u = !1, ed = !1, td = 0;
	function nd(e) {
		e !== Zu && e.next === null && (Zu === null ? Xu = Zu = e : Zu = Zu.next = e), $u = !0, Qu || (Qu = !0, ld());
	}
	function rd(e, t) {
		if (!ed && $u) {
			ed = !0;
			do
				for (var n = !1, r = Xu; r !== null;) {
					if (!t) if (e !== 0) {
						var i = r.pendingLanes;
						if (i === 0) var a = 0;
						else {
							var o = r.suspendedLanes, s = r.pingedLanes;
							a = (1 << 31 - Ie(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
						}
						a !== 0 && (n = !0, cd(r, a));
					} else a = Q, a = We(r, r === Fl ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || Ge(r, a) || (n = !0, cd(r, a));
					r = r.next;
				}
			while (n);
			ed = !1;
		}
	}
	function id() {
		ad();
	}
	function ad() {
		$u = Qu = !1;
		var e = 0;
		td !== 0 && Gd() && (e = td);
		for (var t = we(), n = null, r = Xu; r !== null;) {
			var i = r.next, a = od(r, t);
			a === 0 ? (r.next = null, n === null ? Xu = i : n.next = i, i === null && (Zu = n)) : (n = r, (e !== 0 || a & 3) && ($u = !0)), r = i;
		}
		nu !== 0 && nu !== 5 || rd(e, !1), td !== 0 && (td = 0);
	}
	function od(e, t) {
		for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
			var o = 31 - Ie(a), s = 1 << o, c = i[o];
			c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = Ke(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
		}
		if (t = Fl, n = Q, n = We(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (Il === 2 || Il === 9) || e.cancelPendingCommit !== null) return r !== null && r !== null && xe(r), e.callbackNode = null, e.callbackPriority = 0;
		if (!(n & 3) || Ge(e, n)) {
			if (t = n & -n, t === e.callbackPriority) return t;
			switch (r !== null && xe(r), tt(n)) {
				case 2:
				case 8:
					n = De;
					break;
				case 32:
					n = Oe;
					break;
				case 268435456:
					n = Ae;
					break;
				default: n = Oe;
			}
			return r = sd.bind(null, e), n = be(n, r), e.callbackPriority = t, e.callbackNode = n, t;
		}
		return r !== null && r !== null && xe(r), e.callbackPriority = 2, e.callbackNode = null, 2;
	}
	function sd(e, t) {
		if (nu !== 0 && nu !== 5) return e.callbackNode = null, e.callbackPriority = 0, null;
		var n = e.callbackNode;
		if (Bu() && e.callbackNode !== n) return null;
		var r = Q;
		return r = We(e, e === Fl ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (mu(e, r, t), od(e, we()), e.callbackNode != null && e.callbackNode === n ? sd.bind(null, e) : null);
	}
	function cd(e, t) {
		if (Bu()) return null;
		mu(e, t, !0);
	}
	function ld() {
		Yd(function() {
			X & 6 ? be(Ee, id) : ad();
		});
	}
	function ud() {
		if (td === 0) {
			var e = oa;
			e === 0 && (e = Be, Be <<= 1, !(Be & 261888) && (Be = 256)), td = e;
		}
		return td;
	}
	function dd(e) {
		return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : Jt("" + e);
	}
	function fd(e, t) {
		var n = t.ownerDocument.createElement("input");
		return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
	}
	function pd(e, t, n, r, i) {
		if (t === "submit" && n && n.stateNode === i) {
			var a = dd((i[ot] || null).action), o = r.submitter;
			o && (t = (t = o[ot] || null) ? dd(t.formAction) : o.getAttribute("formAction"), t !== null && (a = t, o = null));
			var s = new _n("action", "action", null, r, i);
			e.push({
				event: s,
				listeners: [{
					instance: null,
					listener: function() {
						if (r.defaultPrevented) {
							if (td !== 0) {
								var e = o ? fd(i, o) : new FormData(i);
								vs(n, {
									pending: !0,
									data: e,
									method: i.method,
									action: a
								}, null, e);
							}
						} else typeof a == "function" && (s.preventDefault(), e = o ? fd(i, o) : new FormData(i), vs(n, {
							pending: !0,
							data: e,
							method: i.method,
							action: a
						}, a, e));
					},
					currentTarget: i
				}]
			});
		}
	}
	for (var md = 0; md < Hr.length; md++) {
		var hd = Hr[md];
		Ur(hd.toLowerCase(), "on" + (hd[0].toUpperCase() + hd.slice(1)));
	}
	Ur(Pr, "onAnimationEnd"), Ur(Fr, "onAnimationIteration"), Ur(Ir, "onAnimationStart"), Ur("dblclick", "onDoubleClick"), Ur("focusin", "onFocus"), Ur("focusout", "onBlur"), Ur(Lr, "onTransitionRun"), Ur(Rr, "onTransitionStart"), Ur(zr, "onTransitionCancel"), Ur(Br, "onTransitionEnd"), St("onMouseEnter", ["mouseout", "mouseover"]), St("onMouseLeave", ["mouseout", "mouseover"]), St("onPointerEnter", ["pointerout", "pointerover"]), St("onPointerLeave", ["pointerout", "pointerover"]), xt("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), xt("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), xt("onBeforeInput", [
		"compositionend",
		"keypress",
		"textInput",
		"paste"
	]), xt("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), xt("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), xt("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
	var gd = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), _d = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(gd));
	function vd(e, t) {
		t = (t & 4) != 0;
		for (var n = 0; n < e.length; n++) {
			var r = e[n], i = r.event;
			r = r.listeners;
			a: {
				var a = void 0;
				if (t) for (var o = r.length - 1; 0 <= o; o--) {
					var s = r[o], c = s.instance, l = s.currentTarget;
					if (s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						Wr(e);
					}
					i.currentTarget = null, a = c;
				}
				else for (o = 0; o < r.length; o++) {
					if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						Wr(e);
					}
					i.currentTarget = null, a = c;
				}
			}
		}
	}
	function $(e, t) {
		var n = t[ct];
		n === void 0 && (n = t[ct] = /* @__PURE__ */ new Set());
		var r = e + "__bubble";
		n.has(r) || (Sd(t, e, 2, !1), n.add(r));
	}
	function yd(e, t, n) {
		var r = 0;
		t && (r |= 4), Sd(n, e, r, t);
	}
	var bd = "_reactListening" + Math.random().toString(36).slice(2);
	function xd(e) {
		if (!e[bd]) {
			e[bd] = !0, yt.forEach(function(t) {
				t !== "selectionchange" && (_d.has(t) || yd(t, !1, e), yd(t, !0, e));
			});
			var t = e.nodeType === 9 ? e : e.ownerDocument;
			t === null || t[bd] || (t[bd] = !0, yd("selectionchange", !1, t));
		}
	}
	function Sd(e, t, n, r) {
		switch (mp(t)) {
			case 2:
				var i = cp;
				break;
			case 8:
				i = lp;
				break;
			default: i = up;
		}
		n = i.bind(null, t, n, e), i = void 0, !on || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
			capture: !0,
			passive: i
		}) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, { passive: i });
	}
	function Cd(e, t, n, r, i) {
		var a = r;
		if (!(t & 1) && !(t & 2) && r !== null) a: for (;;) {
			if (r === null) return;
			var s = r.tag;
			if (s === 3 || s === 4) {
				var c = r.stateNode.containerInfo;
				if (c === i) break;
				if (s === 4) for (s = r.return; s !== null;) {
					var l = s.tag;
					if ((l === 3 || l === 4) && s.stateNode.containerInfo === i) return;
					s = s.return;
				}
				for (; c !== null;) {
					if (s = mt(c), s === null) return;
					if (l = s.tag, l === 5 || l === 6 || l === 26 || l === 27) {
						r = a = s;
						continue a;
					}
					c = c.parentNode;
				}
			}
			r = r.return;
		}
		nn(function() {
			var r = a, i = Zt(n), s = [];
			a: {
				var c = Vr.get(e);
				if (c !== void 0) {
					var l = _n, u = e;
					switch (e) {
						case "keypress": if (fn(n) === 0) break a;
						case "keydown":
						case "keyup":
							l = Pn;
							break;
						case "focusin":
							u = "focus", l = En;
							break;
						case "focusout":
							u = "blur", l = En;
							break;
						case "beforeblur":
						case "afterblur":
							l = En;
							break;
						case "click": if (n.button === 2) break a;
						case "auxclick":
						case "dblclick":
						case "mousedown":
						case "mousemove":
						case "mouseup":
						case "mouseout":
						case "mouseover":
						case "contextmenu":
							l = wn;
							break;
						case "drag":
						case "dragend":
						case "dragenter":
						case "dragexit":
						case "dragleave":
						case "dragover":
						case "dragstart":
						case "drop":
							l = Tn;
							break;
						case "touchcancel":
						case "touchend":
						case "touchmove":
						case "touchstart":
							l = In;
							break;
						case Pr:
						case Fr:
						case Ir:
							l = Dn;
							break;
						case Br:
							l = Ln;
							break;
						case "scroll":
						case "scrollend":
							l = yn;
							break;
						case "wheel":
							l = Rn;
							break;
						case "copy":
						case "cut":
						case "paste":
							l = On;
							break;
						case "gotpointercapture":
						case "lostpointercapture":
						case "pointercancel":
						case "pointerdown":
						case "pointermove":
						case "pointerout":
						case "pointerover":
						case "pointerup":
							l = Fn;
							break;
						case "toggle":
						case "beforetoggle": l = zn;
					}
					var d = (t & 4) != 0, f = !d && (e === "scroll" || e === "scrollend"), p = d ? c === null ? null : c + "Capture" : c;
					d = [];
					for (var m = r, h; m !== null;) {
						var g = m;
						if (h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = rn(m, p), g != null && d.push(wd(m, g, h))), f) break;
						m = m.return;
					}
					0 < d.length && (c = new l(c, u, null, n, i), s.push({
						event: c,
						listeners: d
					}));
				}
			}
			if (!(t & 7)) {
				a: {
					if (c = e === "mouseover" || e === "pointerover", l = e === "mouseout" || e === "pointerout", c && n !== Xt && (u = n.relatedTarget || n.fromElement) && (mt(u) || u[st])) break a;
					if ((l || c) && (c = i.window === i ? i : (c = i.ownerDocument) ? c.defaultView || c.parentWindow : window, l ? (u = n.relatedTarget || n.toElement, l = r, u = u ? mt(u) : null, u !== null && (f = o(u), d = u.tag, u !== f || d !== 5 && d !== 27 && d !== 6) && (u = null)) : (l = null, u = r), l !== u)) {
						if (d = wn, g = "onMouseLeave", p = "onMouseEnter", m = "mouse", (e === "pointerout" || e === "pointerover") && (d = Fn, g = "onPointerLeave", p = "onPointerEnter", m = "pointer"), f = l == null ? c : gt(l), h = u == null ? c : gt(u), c = new d(g, m + "leave", l, n, i), c.target = f, c.relatedTarget = h, g = null, mt(i) === r && (d = new d(p, m + "enter", u, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, l && u) b: {
							for (d = Ed, p = l, m = u, h = 0, g = p; g; g = d(g)) h++;
							g = 0;
							for (var _ = m; _; _ = d(_)) g++;
							for (; 0 < h - g;) p = d(p), h--;
							for (; 0 < g - h;) m = d(m), g--;
							for (; h--;) {
								if (p === m || m !== null && p === m.alternate) {
									d = p;
									break b;
								}
								p = d(p), m = d(m);
							}
							d = null;
						}
						else d = null;
						l !== null && Dd(s, c, l, d, !1), u !== null && f !== null && Dd(s, f, u, d, !0);
					}
				}
				a: {
					if (c = r ? gt(r) : window, l = c.nodeName && c.nodeName.toLowerCase(), l === "select" || l === "input" && c.type === "file") var v = ir;
					else if (Qn(c)) if (ar) v = mr;
					else {
						v = fr;
						var y = dr;
					}
					else l = c.nodeName, !l || l.toLowerCase() !== "input" || c.type !== "checkbox" && c.type !== "radio" ? r && Gt(r.elementType) && (v = ir) : v = pr;
					if (v &&= v(e, r)) {
						$n(s, v, n, i);
						break a;
					}
					y && y(e, c, r), e === "focusout" && r && c.type === "number" && r.memoizedProps.value != null && Lt(c, "number", c.value);
				}
				switch (y = r ? gt(r) : window, e) {
					case "focusin":
						(Qn(y) || y.contentEditable === "true") && (wr = y, Tr = r, Er = null);
						break;
					case "focusout":
						Er = Tr = wr = null;
						break;
					case "mousedown":
						Dr = !0;
						break;
					case "contextmenu":
					case "mouseup":
					case "dragend":
						Dr = !1, Or(s, n, i);
						break;
					case "selectionchange": if (Cr) break;
					case "keydown":
					case "keyup": Or(s, n, i);
				}
				var b;
				if (Vn) b: {
					switch (e) {
						case "compositionstart":
							var x = "onCompositionStart";
							break b;
						case "compositionend":
							x = "onCompositionEnd";
							break b;
						case "compositionupdate":
							x = "onCompositionUpdate";
							break b;
					}
					x = void 0;
				}
				else Jn ? W(e, n) && (x = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (x = "onCompositionStart");
				x && (Wn && n.locale !== "ko" && (Jn || x !== "onCompositionStart" ? x === "onCompositionEnd" && Jn && (b = dn()) : (cn = i, ln = "value" in cn ? cn.value : cn.textContent, Jn = !0)), y = Td(r, x), 0 < y.length && (x = new U(x, e, null, n, i), s.push({
					event: x,
					listeners: y
				}), b ? x.data = b : (b = qn(n), b !== null && (x.data = b)))), (b = Un ? Yn(e, n) : Xn(e, n)) && (x = Td(r, "onBeforeInput"), 0 < x.length && (y = new U("onBeforeInput", "beforeinput", null, n, i), s.push({
					event: y,
					listeners: x
				}), y.data = b)), pd(s, e, r, n, i);
			}
			vd(s, t);
		});
	}
	function wd(e, t, n) {
		return {
			instance: e,
			listener: t,
			currentTarget: n
		};
	}
	function Td(e, t) {
		for (var n = t + "Capture", r = []; e !== null;) {
			var i = e, a = i.stateNode;
			if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = rn(e, n), i != null && r.unshift(wd(e, i, a)), i = rn(e, t), i != null && r.push(wd(e, i, a))), e.tag === 3) return r;
			e = e.return;
		}
		return [];
	}
	function Ed(e) {
		if (e === null) return null;
		do
			e = e.return;
		while (e && e.tag !== 5 && e.tag !== 27);
		return e || null;
	}
	function Dd(e, t, n, r, i) {
		for (var a = t._reactName, o = []; n !== null && n !== r;) {
			var s = n, c = s.alternate, l = s.stateNode;
			if (s = s.tag, c !== null && c === r) break;
			s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = rn(n, a), l != null && o.unshift(wd(n, l, c))) : i || (l = rn(n, a), l != null && o.push(wd(n, l, c)))), n = n.return;
		}
		o.length !== 0 && e.push({
			event: t,
			listeners: o
		});
	}
	var Od = /\r\n?/g, kd = /\u0000|\uFFFD/g;
	function Ad(e) {
		return (typeof e == "string" ? e : "" + e).replace(Od, "\n").replace(kd, "");
	}
	function jd(e, t) {
		return t = Ad(t), Ad(e) === t;
	}
	function Md(e, t, n, r, a, o) {
		switch (n) {
			case "children":
				typeof r == "string" ? t === "body" || t === "textarea" && r === "" || Vt(e, r) : (typeof r == "number" || typeof r == "bigint") && t !== "body" && Vt(e, "" + r);
				break;
			case "className":
				Ot(e, "class", r);
				break;
			case "tabIndex":
				Ot(e, "tabindex", r);
				break;
			case "dir":
			case "role":
			case "viewBox":
			case "width":
			case "height":
				Ot(e, n, r);
				break;
			case "style":
				Wt(e, r, o);
				break;
			case "data": if (t !== "object") {
				Ot(e, "data", r);
				break;
			}
			case "src":
			case "href":
				if (r === "" && (t !== "a" || n !== "href")) {
					e.removeAttribute(n);
					break;
				}
				if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = Jt("" + r), e.setAttribute(n, r);
				break;
			case "action":
			case "formAction":
				if (typeof r == "function") {
					e.setAttribute(n, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
					break;
				} else typeof o == "function" && (n === "formAction" ? (t !== "input" && Md(e, t, "name", a.name, a, null), Md(e, t, "formEncType", a.formEncType, a, null), Md(e, t, "formMethod", a.formMethod, a, null), Md(e, t, "formTarget", a.formTarget, a, null)) : (Md(e, t, "encType", a.encType, a, null), Md(e, t, "method", a.method, a, null), Md(e, t, "target", a.target, a, null)));
				if (r == null || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = Jt("" + r), e.setAttribute(n, r);
				break;
			case "onClick":
				r != null && (e.onclick = Yt);
				break;
			case "onScroll":
				r != null && $("scroll", e);
				break;
			case "onScrollEnd":
				r != null && $("scrollend", e);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "multiple":
				e.multiple = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "muted":
				e.muted = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "defaultValue":
			case "defaultChecked":
			case "innerHTML":
			case "ref": break;
			case "autoFocus": break;
			case "xlinkHref":
				if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
					e.removeAttribute("xlink:href");
					break;
				}
				n = Jt("" + r), e.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n);
				break;
			case "contentEditable":
			case "spellCheck":
			case "draggable":
			case "value":
			case "autoReverse":
			case "externalResourcesRequired":
			case "focusable":
			case "preserveAlpha":
				r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "" + r) : e.removeAttribute(n);
				break;
			case "inert":
			case "allowFullScreen":
			case "async":
			case "autoPlay":
			case "controls":
			case "default":
			case "defer":
			case "disabled":
			case "disablePictureInPicture":
			case "disableRemotePlayback":
			case "formNoValidate":
			case "hidden":
			case "loop":
			case "noModule":
			case "noValidate":
			case "open":
			case "playsInline":
			case "readOnly":
			case "required":
			case "reversed":
			case "scoped":
			case "seamless":
			case "itemScope":
				r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
				break;
			case "capture":
			case "download":
				!0 === r ? e.setAttribute(n, "") : !1 !== r && r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "cols":
			case "rows":
			case "size":
			case "span":
				r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "rowSpan":
			case "start":
				r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
				break;
			case "popover":
				$("beforetoggle", e), $("toggle", e), Dt(e, "popover", r);
				break;
			case "xlinkActuate":
				kt(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
				break;
			case "xlinkArcrole":
				kt(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
				break;
			case "xlinkRole":
				kt(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
				break;
			case "xlinkShow":
				kt(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
				break;
			case "xlinkTitle":
				kt(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
				break;
			case "xlinkType":
				kt(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
				break;
			case "xmlBase":
				kt(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
				break;
			case "xmlLang":
				kt(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
				break;
			case "xmlSpace":
				kt(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
				break;
			case "is":
				Dt(e, "is", r);
				break;
			case "innerText":
			case "textContent": break;
			default: (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = Kt.get(n) || n, Dt(e, n, r));
		}
	}
	function Nd(e, t, n, r, a, o) {
		switch (n) {
			case "style":
				Wt(e, r, o);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "children":
				typeof r == "string" ? Vt(e, r) : (typeof r == "number" || typeof r == "bigint") && Vt(e, "" + r);
				break;
			case "onScroll":
				r != null && $("scroll", e);
				break;
			case "onScrollEnd":
				r != null && $("scrollend", e);
				break;
			case "onClick":
				r != null && (e.onclick = Yt);
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "innerHTML":
			case "ref": break;
			case "innerText":
			case "textContent": break;
			default: if (!bt.hasOwnProperty(n)) a: {
				if (n[0] === "o" && n[1] === "n" && (a = n.endsWith("Capture"), t = n.slice(2, a ? n.length - 7 : void 0), o = e[ot] || null, o = o == null ? null : o[n], typeof o == "function" && e.removeEventListener(t, o, a), typeof r == "function")) {
					typeof o != "function" && o !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, a);
					break a;
				}
				n in e ? e[n] = r : !0 === r ? e.setAttribute(n, "") : Dt(e, n, r);
			}
		}
	}
	function Pd(e, t, n) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "img":
				$("error", e), $("load", e);
				var r = !1, a = !1, o;
				for (o in n) if (n.hasOwnProperty(o)) {
					var s = n[o];
					if (s != null) switch (o) {
						case "src":
							r = !0;
							break;
						case "srcSet":
							a = !0;
							break;
						case "children":
						case "dangerouslySetInnerHTML": throw Error(i(137, t));
						default: Md(e, t, o, s, n, null);
					}
				}
				a && Md(e, t, "srcSet", n.srcSet, n, null), r && Md(e, t, "src", n.src, n, null);
				return;
			case "input":
				$("invalid", e);
				var c = o = s = a = null, l = null, u = null;
				for (r in n) if (n.hasOwnProperty(r)) {
					var d = n[r];
					if (d != null) switch (r) {
						case "name":
							a = d;
							break;
						case "type":
							s = d;
							break;
						case "checked":
							l = d;
							break;
						case "defaultChecked":
							u = d;
							break;
						case "value":
							o = d;
							break;
						case "defaultValue":
							c = d;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (d != null) throw Error(i(137, t));
							break;
						default: Md(e, t, r, d, n, null);
					}
				}
				It(e, o, c, l, u, s, a, !1);
				return;
			case "select":
				for (a in $("invalid", e), r = s = o = null, n) if (n.hasOwnProperty(a) && (c = n[a], c != null)) switch (a) {
					case "value":
						o = c;
						break;
					case "defaultValue":
						s = c;
						break;
					case "multiple": r = c;
					default: Md(e, t, a, c, n, null);
				}
				t = o, n = s, e.multiple = !!r, t == null ? n != null && Rt(e, !!r, n, !0) : Rt(e, !!r, t, !1);
				return;
			case "textarea":
				for (s in $("invalid", e), o = a = r = null, n) if (n.hasOwnProperty(s) && (c = n[s], c != null)) switch (s) {
					case "value":
						r = c;
						break;
					case "defaultValue":
						a = c;
						break;
					case "children":
						o = c;
						break;
					case "dangerouslySetInnerHTML":
						if (c != null) throw Error(i(91));
						break;
					default: Md(e, t, s, c, n, null);
				}
				Bt(e, r, a, o);
				return;
			case "option":
				for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
					case "selected":
						e.selected = r && typeof r != "function" && typeof r != "symbol";
						break;
					default: Md(e, t, l, r, n, null);
				}
				return;
			case "dialog":
				$("beforetoggle", e), $("toggle", e), $("cancel", e), $("close", e);
				break;
			case "iframe":
			case "object":
				$("load", e);
				break;
			case "video":
			case "audio":
				for (r = 0; r < gd.length; r++) $(gd[r], e);
				break;
			case "image":
				$("error", e), $("load", e);
				break;
			case "details":
				$("toggle", e);
				break;
			case "embed":
			case "source":
			case "link": $("error", e), $("load", e);
			case "area":
			case "base":
			case "br":
			case "col":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "track":
			case "wbr":
			case "menuitem":
				for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML": throw Error(i(137, t));
					default: Md(e, t, u, r, n, null);
				}
				return;
			default: if (Gt(t)) {
				for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && Nd(e, t, d, r, n, void 0));
				return;
			}
		}
		for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && Md(e, t, c, r, n, null));
	}
	function Fd(e, t, n, r) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "input":
				var a = null, o = null, s = null, c = null, l = null, u = null, d = null;
				for (m in n) {
					var f = n[m];
					if (n.hasOwnProperty(m) && f != null) switch (m) {
						case "checked": break;
						case "value": break;
						case "defaultValue": l = f;
						default: r.hasOwnProperty(m) || Md(e, t, m, null, r, f);
					}
				}
				for (var p in r) {
					var m = r[p];
					if (f = n[p], r.hasOwnProperty(p) && (m != null || f != null)) switch (p) {
						case "type":
							o = m;
							break;
						case "name":
							a = m;
							break;
						case "checked":
							u = m;
							break;
						case "defaultChecked":
							d = m;
							break;
						case "value":
							s = m;
							break;
						case "defaultValue":
							c = m;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (m != null) throw Error(i(137, t));
							break;
						default: m !== f && Md(e, t, p, m, r, f);
					}
				}
				Ft(e, s, c, l, u, d, o, a);
				return;
			case "select":
				for (o in m = s = c = p = null, n) if (l = n[o], n.hasOwnProperty(o) && l != null) switch (o) {
					case "value": break;
					case "multiple": m = l;
					default: r.hasOwnProperty(o) || Md(e, t, o, null, r, l);
				}
				for (a in r) if (o = r[a], l = n[a], r.hasOwnProperty(a) && (o != null || l != null)) switch (a) {
					case "value":
						p = o;
						break;
					case "defaultValue":
						c = o;
						break;
					case "multiple": s = o;
					default: o !== l && Md(e, t, a, o, r, l);
				}
				t = c, n = s, r = m, p == null ? !!r != !!n && (t == null ? Rt(e, !!n, n ? [] : "", !1) : Rt(e, !!n, t, !0)) : Rt(e, !!n, p, !1);
				return;
			case "textarea":
				for (c in m = p = null, n) if (a = n[c], n.hasOwnProperty(c) && a != null && !r.hasOwnProperty(c)) switch (c) {
					case "value": break;
					case "children": break;
					default: Md(e, t, c, null, r, a);
				}
				for (s in r) if (a = r[s], o = n[s], r.hasOwnProperty(s) && (a != null || o != null)) switch (s) {
					case "value":
						p = a;
						break;
					case "defaultValue":
						m = a;
						break;
					case "children": break;
					case "dangerouslySetInnerHTML":
						if (a != null) throw Error(i(91));
						break;
					default: a !== o && Md(e, t, s, a, r, o);
				}
				zt(e, p, m);
				return;
			case "option":
				for (var h in n) if (p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) switch (h) {
					case "selected":
						e.selected = !1;
						break;
					default: Md(e, t, h, null, r, p);
				}
				for (l in r) if (p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null)) switch (l) {
					case "selected":
						e.selected = p && typeof p != "function" && typeof p != "symbol";
						break;
					default: Md(e, t, l, p, r, m);
				}
				return;
			case "img":
			case "link":
			case "area":
			case "base":
			case "br":
			case "col":
			case "embed":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "source":
			case "track":
			case "wbr":
			case "menuitem":
				for (var g in n) p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && Md(e, t, g, null, r, p);
				for (u in r) if (p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML":
						if (p != null) throw Error(i(137, t));
						break;
					default: Md(e, t, u, p, r, m);
				}
				return;
			default: if (Gt(t)) {
				for (var _ in n) p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && Nd(e, t, _, void 0, r, p);
				for (d in r) p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || Nd(e, t, d, p, r, m);
				return;
			}
		}
		for (var v in n) p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && Md(e, t, v, null, r, p);
		for (f in r) p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || Md(e, t, f, p, r, m);
	}
	function Id(e) {
		switch (e) {
			case "css":
			case "script":
			case "font":
			case "img":
			case "image":
			case "input":
			case "link": return !0;
			default: return !1;
		}
	}
	function Ld() {
		if (typeof performance.getEntriesByType == "function") {
			for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), r = 0; r < n.length; r++) {
				var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
				if (a && s && Id(o)) {
					for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
						var c = n[r], l = c.startTime;
						if (l > s) break;
						var u = c.transferSize, d = c.initiatorType;
						u && Id(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
					}
					if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break;
				}
			}
			if (0 < e) return t / e / 1e6;
		}
		return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
	}
	var Rd = null, zd = null;
	function Bd(e) {
		return e.nodeType === 9 ? e : e.ownerDocument;
	}
	function Vd(e) {
		switch (e) {
			case "http://www.w3.org/2000/svg": return 1;
			case "http://www.w3.org/1998/Math/MathML": return 2;
			default: return 0;
		}
	}
	function Hd(e, t) {
		if (e === 0) switch (t) {
			case "svg": return 1;
			case "math": return 2;
			default: return 0;
		}
		return e === 1 && t === "foreignObject" ? 0 : e;
	}
	function Ud(e, t) {
		return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
	}
	var Wd = null;
	function Gd() {
		var e = window.event;
		return e && e.type === "popstate" ? e === Wd ? !1 : (Wd = e, !0) : (Wd = null, !1);
	}
	var Kd = typeof setTimeout == "function" ? setTimeout : void 0, qd = typeof clearTimeout == "function" ? clearTimeout : void 0, Jd = typeof Promise == "function" ? Promise : void 0, Yd = typeof queueMicrotask == "function" ? queueMicrotask : Jd === void 0 ? Kd : function(e) {
		return Jd.resolve(null).then(e).catch(Xd);
	};
	function Xd(e) {
		setTimeout(function() {
			throw e;
		});
	}
	function Zd(e) {
		return e === "head";
	}
	function Qd(e, t) {
		var n = t, r = 0;
		do {
			var i = n.nextSibling;
			if (e.removeChild(n), i && i.nodeType === 8) if (n = i.data, n === "/$" || n === "/&") {
				if (r === 0) {
					e.removeChild(i), Np(t);
					return;
				}
				r--;
			} else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&") r++;
			else if (n === "html") pf(e.ownerDocument.documentElement);
			else if (n === "head") {
				n = e.ownerDocument.head, pf(n);
				for (var a = n.firstChild; a;) {
					var o = a.nextSibling, s = a.nodeName;
					a[ft] || s === "SCRIPT" || s === "STYLE" || s === "LINK" && a.rel.toLowerCase() === "stylesheet" || n.removeChild(a), a = o;
				}
			} else n === "body" && pf(e.ownerDocument.body);
			n = i;
		} while (n);
		Np(t);
	}
	function $d(e, t) {
		var n = e;
		e = 0;
		do {
			var r = n.nextSibling;
			if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), r && r.nodeType === 8) if (n = r.data, n === "/$") {
				if (e === 0) break;
				e--;
			} else n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || e++;
			n = r;
		} while (n);
	}
	function ef(e) {
		var t = e.firstChild;
		for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
			var n = t;
			switch (t = t.nextSibling, n.nodeName) {
				case "HTML":
				case "HEAD":
				case "BODY":
					ef(n), pt(n);
					continue;
				case "SCRIPT":
				case "STYLE": continue;
				case "LINK": if (n.rel.toLowerCase() === "stylesheet") continue;
			}
			e.removeChild(n);
		}
	}
	function tf(e, t, n, r) {
		for (; e.nodeType === 1;) {
			var i = n;
			if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
				if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden")) break;
			} else if (!r) if (t === "input" && e.type === "hidden") {
				var a = i.name == null ? null : "" + i.name;
				if (i.type === "hidden" && e.getAttribute("name") === a) return e;
			} else return e;
			else if (!e[ft]) switch (t) {
				case "meta":
					if (!e.hasAttribute("itemprop")) break;
					return e;
				case "link":
					if (a = e.getAttribute("rel"), a === "stylesheet" && e.hasAttribute("data-precedence") || a !== i.rel || e.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute("title") !== (i.title == null ? null : i.title)) break;
					return e;
				case "style":
					if (e.hasAttribute("data-precedence")) break;
					return e;
				case "script":
					if (a = e.getAttribute("src"), (a !== (i.src == null ? null : i.src) || e.getAttribute("type") !== (i.type == null ? null : i.type) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute("async") && !e.hasAttribute("itemprop")) break;
					return e;
				default: return e;
			}
			if (e = cf(e.nextSibling), e === null) break;
		}
		return null;
	}
	function nf(e, t, n) {
		if (t === "") return null;
		for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = cf(e.nextSibling), e === null)) return null;
		return e;
	}
	function rf(e, t) {
		for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = cf(e.nextSibling), e === null)) return null;
		return e;
	}
	function af(e) {
		return e.data === "$?" || e.data === "$~";
	}
	function of(e) {
		return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
	}
	function sf(e, t) {
		var n = e.ownerDocument;
		if (e.data === "$~") e._reactRetry = t;
		else if (e.data !== "$?" || n.readyState !== "loading") t();
		else {
			var r = function() {
				t(), n.removeEventListener("DOMContentLoaded", r);
			};
			n.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
		}
	}
	function cf(e) {
		for (; e != null; e = e.nextSibling) {
			var t = e.nodeType;
			if (t === 1 || t === 3) break;
			if (t === 8) {
				if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F") break;
				if (t === "/$" || t === "/&") return null;
			}
		}
		return e;
	}
	var lf = null;
	function uf(e) {
		e = e.nextSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "/$" || n === "/&") {
					if (t === 0) return cf(e.nextSibling);
					t--;
				} else n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || t++;
			}
			e = e.nextSibling;
		}
		return null;
	}
	function df(e) {
		e = e.previousSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
					if (t === 0) return e;
					t--;
				} else n !== "/$" && n !== "/&" || t++;
			}
			e = e.previousSibling;
		}
		return null;
	}
	function ff(e, t, n) {
		switch (t = Bd(n), e) {
			case "html":
				if (e = t.documentElement, !e) throw Error(i(452));
				return e;
			case "head":
				if (e = t.head, !e) throw Error(i(453));
				return e;
			case "body":
				if (e = t.body, !e) throw Error(i(454));
				return e;
			default: throw Error(i(451));
		}
	}
	function pf(e) {
		for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
		pt(e);
	}
	var mf = /* @__PURE__ */ new Map(), hf = /* @__PURE__ */ new Set();
	function gf(e) {
		return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
	}
	var _f = F.d;
	F.d = {
		f: vf,
		r: yf,
		D: Sf,
		C: Cf,
		L: wf,
		m: Tf,
		X: Df,
		S: Ef,
		M: Of
	};
	function vf() {
		var e = _f.f(), t = vu();
		return e || t;
	}
	function yf(e) {
		var t = ht(e);
		t !== null && t.tag === 5 && t.type === "form" ? bs(t) : _f.r(e);
	}
	var bf = typeof document > "u" ? null : document;
	function xf(e, t, n) {
		var r = bf;
		if (r && typeof t == "string" && t) {
			var i = H(t);
			i = "link[rel=\"" + e + "\"][href=\"" + i + "\"]", typeof n == "string" && (i += "[crossorigin=\"" + n + "\"]"), hf.has(i) || (hf.add(i), e = {
				rel: e,
				crossOrigin: n,
				href: t
			}, r.querySelector(i) === null && (t = r.createElement("link"), Pd(t, "link", e), vt(t), r.head.appendChild(t)));
		}
	}
	function Sf(e) {
		_f.D(e), xf("dns-prefetch", e, null);
	}
	function Cf(e, t) {
		_f.C(e, t), xf("preconnect", e, t);
	}
	function wf(e, t, n) {
		_f.L(e, t, n);
		var r = bf;
		if (r && e && t) {
			var i = "link[rel=\"preload\"][as=\"" + H(t) + "\"]";
			t === "image" && n && n.imageSrcSet ? (i += "[imagesrcset=\"" + H(n.imageSrcSet) + "\"]", typeof n.imageSizes == "string" && (i += "[imagesizes=\"" + H(n.imageSizes) + "\"]")) : i += "[href=\"" + H(e) + "\"]";
			var a = i;
			switch (t) {
				case "style":
					a = Af(e);
					break;
				case "script": a = Pf(e);
			}
			mf.has(a) || (e = h({
				rel: "preload",
				href: t === "image" && n && n.imageSrcSet ? void 0 : e,
				as: t
			}, n), mf.set(a, e), r.querySelector(i) !== null || t === "style" && r.querySelector(jf(a)) || t === "script" && r.querySelector(Ff(a)) || (t = r.createElement("link"), Pd(t, "link", e), vt(t), r.head.appendChild(t)));
		}
	}
	function Tf(e, t) {
		_f.m(e, t);
		var n = bf;
		if (n && e) {
			var r = t && typeof t.as == "string" ? t.as : "script", i = "link[rel=\"modulepreload\"][as=\"" + H(r) + "\"][href=\"" + H(e) + "\"]", a = i;
			switch (r) {
				case "audioworklet":
				case "paintworklet":
				case "serviceworker":
				case "sharedworker":
				case "worker":
				case "script": a = Pf(e);
			}
			if (!mf.has(a) && (e = h({
				rel: "modulepreload",
				href: e
			}, t), mf.set(a, e), n.querySelector(i) === null)) {
				switch (r) {
					case "audioworklet":
					case "paintworklet":
					case "serviceworker":
					case "sharedworker":
					case "worker":
					case "script": if (n.querySelector(Ff(a))) return;
				}
				r = n.createElement("link"), Pd(r, "link", e), vt(r), n.head.appendChild(r);
			}
		}
	}
	function Ef(e, t, n) {
		_f.S(e, t, n);
		var r = bf;
		if (r && e) {
			var i = _t(r).hoistableStyles, a = Af(e);
			t ||= "default";
			var o = i.get(a);
			if (!o) {
				var s = {
					loading: 0,
					preload: null
				};
				if (o = r.querySelector(jf(a))) s.loading = 5;
				else {
					e = h({
						rel: "stylesheet",
						href: e,
						"data-precedence": t
					}, n), (n = mf.get(a)) && Rf(e, n);
					var c = o = r.createElement("link");
					vt(c), Pd(c, "link", e), c._p = new Promise(function(e, t) {
						c.onload = e, c.onerror = t;
					}), c.addEventListener("load", function() {
						s.loading |= 1;
					}), c.addEventListener("error", function() {
						s.loading |= 2;
					}), s.loading |= 4, Lf(o, t, r);
				}
				o = {
					type: "stylesheet",
					instance: o,
					count: 1,
					state: s
				}, i.set(a, o);
			}
		}
	}
	function Df(e, t) {
		_f.X(e, t);
		var n = bf;
		if (n && e) {
			var r = _t(n).hoistableScripts, i = Pf(e), a = r.get(i);
			a || (a = n.querySelector(Ff(i)), a || (e = h({
				src: e,
				async: !0
			}, t), (t = mf.get(i)) && zf(e, t), a = n.createElement("script"), vt(a), Pd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function Of(e, t) {
		_f.M(e, t);
		var n = bf;
		if (n && e) {
			var r = _t(n).hoistableScripts, i = Pf(e), a = r.get(i);
			a || (a = n.querySelector(Ff(i)), a || (e = h({
				src: e,
				async: !0,
				type: "module"
			}, t), (t = mf.get(i)) && zf(e, t), a = n.createElement("script"), vt(a), Pd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function kf(e, t, n, r) {
		var a = (a = oe.current) ? gf(a) : null;
		if (!a) throw Error(i(446));
		switch (e) {
			case "meta":
			case "title": return null;
			case "style": return typeof n.precedence == "string" && typeof n.href == "string" ? (t = Af(n.href), n = _t(a).hoistableStyles, r = n.get(t), r || (r = {
				type: "style",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			case "link":
				if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
					e = Af(n.href);
					var o = _t(a).hoistableStyles, s = o.get(e);
					if (s || (a = a.ownerDocument || a, s = {
						type: "stylesheet",
						instance: null,
						count: 0,
						state: {
							loading: 0,
							preload: null
						}
					}, o.set(e, s), (o = a.querySelector(jf(e))) && !o._p && (s.instance = o, s.state.loading = 5), mf.has(e) || (n = {
						rel: "preload",
						as: "style",
						href: n.href,
						crossOrigin: n.crossOrigin,
						integrity: n.integrity,
						media: n.media,
						hrefLang: n.hrefLang,
						referrerPolicy: n.referrerPolicy
					}, mf.set(e, n), o || Nf(a, e, n, s.state))), t && r === null) throw Error(i(528, ""));
					return s;
				}
				if (t && r !== null) throw Error(i(529, ""));
				return null;
			case "script": return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Pf(n), n = _t(a).hoistableScripts, r = n.get(t), r || (r = {
				type: "script",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			default: throw Error(i(444, e));
		}
	}
	function Af(e) {
		return "href=\"" + H(e) + "\"";
	}
	function jf(e) {
		return "link[rel=\"stylesheet\"][" + e + "]";
	}
	function Mf(e) {
		return h({}, e, {
			"data-precedence": e.precedence,
			precedence: null
		});
	}
	function Nf(e, t, n, r) {
		e.querySelector("link[rel=\"preload\"][as=\"style\"][" + t + "]") ? r.loading = 1 : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
			return r.loading |= 1;
		}), t.addEventListener("error", function() {
			return r.loading |= 2;
		}), Pd(t, "link", n), vt(t), e.head.appendChild(t));
	}
	function Pf(e) {
		return "[src=\"" + H(e) + "\"]";
	}
	function Ff(e) {
		return "script[async]" + e;
	}
	function If(e, t, n) {
		if (t.count++, t.instance === null) switch (t.type) {
			case "style":
				var r = e.querySelector("style[data-href~=\"" + H(n.href) + "\"]");
				if (r) return t.instance = r, vt(r), r;
				var a = h({}, n, {
					"data-href": n.href,
					"data-precedence": n.precedence,
					href: null,
					precedence: null
				});
				return r = (e.ownerDocument || e).createElement("style"), vt(r), Pd(r, "style", a), Lf(r, n.precedence, e), t.instance = r;
			case "stylesheet":
				a = Af(n.href);
				var o = e.querySelector(jf(a));
				if (o) return t.state.loading |= 4, t.instance = o, vt(o), o;
				r = Mf(n), (a = mf.get(a)) && Rf(r, a), o = (e.ownerDocument || e).createElement("link"), vt(o);
				var s = o;
				return s._p = new Promise(function(e, t) {
					s.onload = e, s.onerror = t;
				}), Pd(o, "link", r), t.state.loading |= 4, Lf(o, n.precedence, e), t.instance = o;
			case "script": return o = Pf(n.src), (a = e.querySelector(Ff(o))) ? (t.instance = a, vt(a), a) : (r = n, (a = mf.get(o)) && (r = h({}, n), zf(r, a)), e = e.ownerDocument || e, a = e.createElement("script"), vt(a), Pd(a, "link", r), e.head.appendChild(a), t.instance = a);
			case "void": return null;
			default: throw Error(i(443, t.type));
		}
		else t.type === "stylesheet" && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Lf(r, n.precedence, e));
		return t.instance;
	}
	function Lf(e, t, n) {
		for (var r = n.querySelectorAll("link[rel=\"stylesheet\"][data-precedence],style[data-precedence]"), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
			var s = r[o];
			if (s.dataset.precedence === t) a = s;
			else if (a !== i) break;
		}
		a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
	}
	function Rf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title;
	}
	function zf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity;
	}
	var Bf = null;
	function Vf(e, t, n) {
		if (Bf === null) {
			var r = /* @__PURE__ */ new Map(), i = Bf = /* @__PURE__ */ new Map();
			i.set(n, r);
		} else i = Bf, r = i.get(n), r || (r = /* @__PURE__ */ new Map(), i.set(n, r));
		if (r.has(e)) return r;
		for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
			var a = n[i];
			if (!(a[ft] || a[at] || e === "link" && a.getAttribute("rel") === "stylesheet") && a.namespaceURI !== "http://www.w3.org/2000/svg") {
				var o = a.getAttribute(t) || "";
				o = e + o;
				var s = r.get(o);
				s ? s.push(a) : r.set(o, [a]);
			}
		}
		return r;
	}
	function Hf(e, t, n) {
		e = e.ownerDocument || e, e.head.insertBefore(n, t === "title" ? e.querySelector("head > title") : null);
	}
	function Uf(e, t, n) {
		if (n === 1 || t.itemProp != null) return !1;
		switch (e) {
			case "meta":
			case "title": return !0;
			case "style":
				if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") break;
				return !0;
			case "link":
				if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) break;
				switch (t.rel) {
					case "stylesheet": return e = t.disabled, typeof t.precedence == "string" && e == null;
					default: return !0;
				}
			case "script": if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string") return !0;
		}
		return !1;
	}
	function Wf(e) {
		return !(e.type === "stylesheet" && !(e.state.loading & 3));
	}
	function Gf(e, t, n, r) {
		if (n.type === "stylesheet" && (typeof r.media != "string" || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
			if (n.instance === null) {
				var i = Af(r.href), a = t.querySelector(jf(i));
				if (a) {
					t = a._p, typeof t == "object" && t && typeof t.then == "function" && (e.count++, e = Jf.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, vt(a);
					return;
				}
				a = t.ownerDocument || t, r = Mf(r), (i = mf.get(i)) && Rf(r, i), a = a.createElement("link"), vt(a);
				var o = a;
				o._p = new Promise(function(e, t) {
					o.onload = e, o.onerror = t;
				}), Pd(a, "link", r), n.instance = a;
			}
			e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = Jf.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
		}
	}
	var Kf = 0;
	function qf(e, t) {
		return e.stylesheets && e.count === 0 && Xf(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
			var r = setTimeout(function() {
				if (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, 6e4 + t);
			0 < e.imgBytes && Kf === 0 && (Kf = 62500 * Ld());
			var i = setTimeout(function() {
				if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend)) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, (e.imgBytes > Kf ? 50 : 800) + t);
			return e.unsuspend = n, function() {
				e.unsuspend = null, clearTimeout(r), clearTimeout(i);
			};
		} : null;
	}
	function Jf() {
		if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
			if (this.stylesheets) Xf(this, this.stylesheets);
			else if (this.unsuspend) {
				var e = this.unsuspend;
				this.unsuspend = null, e();
			}
		}
	}
	var Yf = null;
	function Xf(e, t) {
		e.stylesheets = null, e.unsuspend !== null && (e.count++, Yf = /* @__PURE__ */ new Map(), t.forEach(Zf, e), Yf = null, Jf.call(e));
	}
	function Zf(e, t) {
		if (!(t.state.loading & 4)) {
			var n = Yf.get(e);
			if (n) var r = n.get(null);
			else {
				n = /* @__PURE__ */ new Map(), Yf.set(e, n);
				for (var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), a = 0; a < i.length; a++) {
					var o = i[a];
					(o.nodeName === "LINK" || o.getAttribute("media") !== "not all") && (n.set(o.dataset.precedence, o), r = o);
				}
				r && n.set(null, r);
			}
			i = t.instance, o = i.getAttribute("data-precedence"), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = Jf.bind(this), i.addEventListener("load", r), i.addEventListener("error", r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4;
		}
	}
	var Qf = {
		$$typeof: C,
		Provider: null,
		Consumer: null,
		_currentValue: ne,
		_currentValue2: ne,
		_threadCount: 0
	};
	function $f(e, t, n, r, i, a, o, s, c) {
		this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Je(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Je(0), this.hiddenUpdates = Je(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = /* @__PURE__ */ new Map();
	}
	function ep(e, t, n, r, i, a, o, s, c, l, u, d) {
		return e = new $f(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = ni(3, null, null, t), e.current = a, a.stateNode = e, t = na(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
			element: r,
			isDehydrated: n,
			cache: t
		}, Fa(a), e;
	}
	function tp(e) {
		return e ? (e = ei, e) : ei;
	}
	function np(e, t, n, r, i, a) {
		i = tp(i), r.context === null ? r.context = i : r.pendingContext = i, r = La(t), r.payload = { element: n }, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = Ra(e, r, t), n !== null && (pu(n, e, t), za(n, e, t));
	}
	function rp(e, t) {
		if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
			var n = e.retryLane;
			e.retryLane = n !== 0 && n < t ? n : t;
		}
	}
	function ip(e, t) {
		rp(e, t), (e = e.alternate) && rp(e, t);
	}
	function ap(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = Zr(e, 67108864);
			t !== null && pu(t, e, 67108864), ip(e, 67108864);
		}
	}
	function op(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = du();
			t = et(t);
			var n = Zr(e, t);
			n !== null && pu(n, e, t), ip(e, t);
		}
	}
	var sp = !0;
	function cp(e, t, n, r) {
		var i = P.T;
		P.T = null;
		var a = F.p;
		try {
			F.p = 2, up(e, t, n, r);
		} finally {
			F.p = a, P.T = i;
		}
	}
	function lp(e, t, n, r) {
		var i = P.T;
		P.T = null;
		var a = F.p;
		try {
			F.p = 8, up(e, t, n, r);
		} finally {
			F.p = a, P.T = i;
		}
	}
	function up(e, t, n, r) {
		if (sp) {
			var i = dp(r);
			if (i === null) Cd(e, t, r, fp, n), Cp(e, r);
			else if (Tp(i, e, t, n, r)) r.stopPropagation();
			else if (Cp(e, r), t & 4 && -1 < Sp.indexOf(e)) {
				for (; i !== null;) {
					var a = ht(i);
					if (a !== null) switch (a.tag) {
						case 3:
							if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
								var o = Ue(a.pendingLanes);
								if (o !== 0) {
									var s = a;
									for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
										var c = 1 << 31 - Ie(o);
										s.entanglements[1] |= c, o &= ~c;
									}
									nd(a), !(X & 6) && ($l = we() + 500, rd(0, !1));
								}
							}
							break;
						case 31:
						case 13: s = Zr(a, 2), s !== null && pu(s, a, 2), vu(), ip(a, 2);
					}
					if (a = dp(r), a === null && Cd(e, t, r, fp, n), a === i) break;
					i = a;
				}
				i !== null && r.stopPropagation();
			} else Cd(e, t, r, null, n);
		}
	}
	function dp(e) {
		return e = Zt(e), pp(e);
	}
	var fp = null;
	function pp(e) {
		if (fp = null, e = mt(e), e !== null) {
			var t = o(e);
			if (t === null) e = null;
			else {
				var n = t.tag;
				if (n === 13) {
					if (e = s(t), e !== null) return e;
					e = null;
				} else if (n === 31) {
					if (e = c(t), e !== null) return e;
					e = null;
				} else if (n === 3) {
					if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
					e = null;
				} else t !== e && (e = null);
			}
		}
		return fp = e, null;
	}
	function mp(e) {
		switch (e) {
			case "beforetoggle":
			case "cancel":
			case "click":
			case "close":
			case "contextmenu":
			case "copy":
			case "cut":
			case "auxclick":
			case "dblclick":
			case "dragend":
			case "dragstart":
			case "drop":
			case "focusin":
			case "focusout":
			case "input":
			case "invalid":
			case "keydown":
			case "keypress":
			case "keyup":
			case "mousedown":
			case "mouseup":
			case "paste":
			case "pause":
			case "play":
			case "pointercancel":
			case "pointerdown":
			case "pointerup":
			case "ratechange":
			case "reset":
			case "resize":
			case "seeked":
			case "submit":
			case "toggle":
			case "touchcancel":
			case "touchend":
			case "touchstart":
			case "volumechange":
			case "change":
			case "selectionchange":
			case "textInput":
			case "compositionstart":
			case "compositionend":
			case "compositionupdate":
			case "beforeblur":
			case "afterblur":
			case "beforeinput":
			case "blur":
			case "fullscreenchange":
			case "focus":
			case "hashchange":
			case "popstate":
			case "select":
			case "selectstart": return 2;
			case "drag":
			case "dragenter":
			case "dragexit":
			case "dragleave":
			case "dragover":
			case "mousemove":
			case "mouseout":
			case "mouseover":
			case "pointermove":
			case "pointerout":
			case "pointerover":
			case "scroll":
			case "touchmove":
			case "wheel":
			case "mouseenter":
			case "mouseleave":
			case "pointerenter":
			case "pointerleave": return 8;
			case "message": switch (Te()) {
				case Ee: return 2;
				case De: return 8;
				case Oe:
				case ke: return 32;
				case Ae: return 268435456;
				default: return 32;
			}
			default: return 32;
		}
	}
	var hp = !1, gp = null, _p = null, vp = null, yp = /* @__PURE__ */ new Map(), bp = /* @__PURE__ */ new Map(), xp = [], Sp = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
	function Cp(e, t) {
		switch (e) {
			case "focusin":
			case "focusout":
				gp = null;
				break;
			case "dragenter":
			case "dragleave":
				_p = null;
				break;
			case "mouseover":
			case "mouseout":
				vp = null;
				break;
			case "pointerover":
			case "pointerout":
				yp.delete(t.pointerId);
				break;
			case "gotpointercapture":
			case "lostpointercapture": bp.delete(t.pointerId);
		}
	}
	function wp(e, t, n, r, i, a) {
		return e === null || e.nativeEvent !== a ? (e = {
			blockedOn: t,
			domEventName: n,
			eventSystemFlags: r,
			nativeEvent: a,
			targetContainers: [i]
		}, t !== null && (t = ht(t), t !== null && ap(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
	}
	function Tp(e, t, n, r, i) {
		switch (t) {
			case "focusin": return gp = wp(gp, e, t, n, r, i), !0;
			case "dragenter": return _p = wp(_p, e, t, n, r, i), !0;
			case "mouseover": return vp = wp(vp, e, t, n, r, i), !0;
			case "pointerover":
				var a = i.pointerId;
				return yp.set(a, wp(yp.get(a) || null, e, t, n, r, i)), !0;
			case "gotpointercapture": return a = i.pointerId, bp.set(a, wp(bp.get(a) || null, e, t, n, r, i)), !0;
		}
		return !1;
	}
	function Ep(e) {
		var t = mt(e.target);
		if (t !== null) {
			var n = o(t);
			if (n !== null) {
				if (t = n.tag, t === 13) {
					if (t = s(n), t !== null) {
						e.blockedOn = t, rt(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 31) {
					if (t = c(n), t !== null) {
						e.blockedOn = t, rt(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
					e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
					return;
				}
			}
		}
		e.blockedOn = null;
	}
	function Dp(e) {
		if (e.blockedOn !== null) return !1;
		for (var t = e.targetContainers; 0 < t.length;) {
			var n = dp(e.nativeEvent);
			if (n === null) {
				n = e.nativeEvent;
				var r = new n.constructor(n.type, n);
				Xt = r, n.target.dispatchEvent(r), Xt = null;
			} else return t = ht(n), t !== null && ap(t), e.blockedOn = n, !1;
			t.shift();
		}
		return !0;
	}
	function Op(e, t, n) {
		Dp(e) && n.delete(t);
	}
	function kp() {
		hp = !1, gp !== null && Dp(gp) && (gp = null), _p !== null && Dp(_p) && (_p = null), vp !== null && Dp(vp) && (vp = null), yp.forEach(Op), bp.forEach(Op);
	}
	function Ap(e, n) {
		e.blockedOn === n && (e.blockedOn = null, hp || (hp = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, kp)));
	}
	var jp = null;
	function Mp(e) {
		jp !== e && (jp = e, t.unstable_scheduleCallback(t.unstable_NormalPriority, function() {
			jp === e && (jp = null);
			for (var t = 0; t < e.length; t += 3) {
				var n = e[t], r = e[t + 1], i = e[t + 2];
				if (typeof r != "function") {
					if (pp(r || n) === null) continue;
					break;
				}
				var a = ht(n);
				a !== null && (e.splice(t, 3), t -= 3, vs(a, {
					pending: !0,
					data: i,
					method: n.method,
					action: r
				}, r, i));
			}
		}));
	}
	function Np(e) {
		function t(t) {
			return Ap(t, e);
		}
		gp !== null && Ap(gp, e), _p !== null && Ap(_p, e), vp !== null && Ap(vp, e), yp.forEach(t), bp.forEach(t);
		for (var n = 0; n < xp.length; n++) {
			var r = xp[n];
			r.blockedOn === e && (r.blockedOn = null);
		}
		for (; 0 < xp.length && (n = xp[0], n.blockedOn === null);) Ep(n), n.blockedOn === null && xp.shift();
		if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
			var i = n[r], a = n[r + 1], o = i[ot] || null;
			if (typeof a == "function") o || Mp(n);
			else if (o) {
				var s = null;
				if (a && a.hasAttribute("formAction")) {
					if (i = a, o = a[ot] || null) s = o.formAction;
					else if (pp(i) !== null) continue;
				} else s = o.action;
				typeof s == "function" ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Mp(n);
			}
		}
	}
	function Pp() {
		function e(e) {
			e.canIntercept && e.info === "react-transition" && e.intercept({
				handler: function() {
					return new Promise(function(e) {
						return i = e;
					});
				},
				focusReset: "manual",
				scroll: "manual"
			});
		}
		function t() {
			i !== null && (i(), i = null), r || setTimeout(n, 20);
		}
		function n() {
			if (!r && !navigation.transition) {
				var e = navigation.currentEntry;
				e && e.url != null && navigation.navigate(e.url, {
					state: e.getState(),
					info: "react-transition",
					history: "replace"
				});
			}
		}
		if (typeof navigation == "object") {
			var r = !1, i = null;
			return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
				r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), i !== null && (i(), i = null);
			};
		}
	}
	function Fp(e) {
		this._internalRoot = e;
	}
	Ip.prototype.render = Fp.prototype.render = function(e) {
		var t = this._internalRoot;
		if (t === null) throw Error(i(409));
		var n = t.current;
		np(n, du(), e, t, null, null);
	}, Ip.prototype.unmount = Fp.prototype.unmount = function() {
		var e = this._internalRoot;
		if (e !== null) {
			this._internalRoot = null;
			var t = e.containerInfo;
			np(e.current, 2, null, e, null, null), vu(), t[st] = null;
		}
	};
	function Ip(e) {
		this._internalRoot = e;
	}
	Ip.prototype.unstable_scheduleHydration = function(e) {
		if (e) {
			var t = nt();
			e = {
				blockedOn: null,
				target: e,
				priority: t
			};
			for (var n = 0; n < xp.length && t !== 0 && t < xp[n].priority; n++);
			xp.splice(n, 0, e), n === 0 && Ep(e);
		}
	};
	var Lp = n.version;
	if (Lp !== "19.2.6") throw Error(i(527, Lp, "19.2.6"));
	F.findDOMNode = function(e) {
		var t = e._reactInternals;
		if (t === void 0) throw typeof e.render == "function" ? Error(i(188)) : (e = Object.keys(e).join(","), Error(i(268, e)));
		return e = d(t), e = e === null ? null : p(e), e = e === null ? null : e.stateNode, e;
	};
	var Rp = {
		bundleType: 0,
		version: "19.2.6",
		rendererPackageName: "react-dom",
		currentDispatcherRef: P,
		reconcilerVersion: "19.2.6"
	};
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
		var zp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
		if (!zp.isDisabled && zp.supportsFiber) try {
			Ne = zp.inject(Rp), Pe = zp;
		} catch {}
	}
	e.hydrateRoot = function(e, t, n) {
		if (!a(e)) throw Error(i(299));
		var r = !1, o = "", s = Vs, c = Hs, l = Us, u = null;
		return n != null && (!0 === n.unstable_strictMode && (r = !0), n.identifierPrefix !== void 0 && (o = n.identifierPrefix), n.onUncaughtError !== void 0 && (s = n.onUncaughtError), n.onCaughtError !== void 0 && (c = n.onCaughtError), n.onRecoverableError !== void 0 && (l = n.onRecoverableError), n.formState !== void 0 && (u = n.formState)), t = ep(e, 1, !0, t, n ?? null, r, o, u, s, c, l, Pp), t.context = tp(null), n = t.current, r = du(), r = et(r), o = La(r), o.callback = null, Ra(n, o, r), n = r, t.current.lanes = n, Ye(t, n), nd(t), e[st] = t.current, xd(e), new Ip(t);
	};
})), g = /* @__PURE__ */ o(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = h();
})), _ = /* @__PURE__ */ c(f(), 1), v = g();
function y() {
	return typeof window > "u" ? globalThis.__JB_PATH__ || "/" : window.location.pathname;
}
function b() {
	throw Error("NOT_FOUND");
}
//#endregion
//#region node_modules/lucide-react/dist/esm/shared/src/utils/mergeClasses.mjs
var x = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), S = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), C = (e) => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()), w = (e) => {
	let t = C(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, T = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}, E = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, D = (0, _.createContext)({}), O = () => (0, _.useContext)(D), k = (0, _.forwardRef)(({ color: e, size: t, strokeWidth: n, absoluteStrokeWidth: r, className: i = "", children: a, iconNode: o, ...s }, c) => {
	let { size: l = 24, strokeWidth: u = 2, absoluteStrokeWidth: d = !1, color: f = "currentColor", className: p = "" } = O() ?? {}, m = r ?? d ? Number(n ?? u) * 24 / Number(t ?? l) : n ?? u;
	return (0, _.createElement)("svg", {
		ref: c,
		...T,
		width: t ?? l ?? T.width,
		height: t ?? l ?? T.height,
		stroke: e ?? f,
		strokeWidth: m,
		className: x("lucide", p, i),
		...!a && !E(s) && { "aria-hidden": "true" },
		...s
	}, [...o.map(([e, t]) => (0, _.createElement)(e, t)), ...Array.isArray(a) ? a : [a]]);
}), A = (e, t) => {
	let n = (0, _.forwardRef)(({ className: n, ...r }, i) => (0, _.createElement)(k, {
		ref: i,
		iconNode: t,
		className: x(`lucide-${S(w(e))}`, `lucide-${e}`, n),
		...r
	}));
	return n.displayName = w(e), n;
}, j = A("arrow-right", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}], ["path", {
	d: "m12 5 7 7-7 7",
	key: "xquz4c"
}]]), M = A("arrow-up-right", [["path", {
	d: "M7 7h10v10",
	key: "1tivn9"
}], ["path", {
	d: "M7 17 17 7",
	key: "1vkiza"
}]]), N = A("badge-check", [["path", {
	d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
	key: "3c2336"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), ee = A("book-open", [["path", {
	d: "M12 5v16",
	key: "1f6ucr"
}], ["path", {
	d: "M20.001 19A2 2 0 0022 17V5a2 2 0 00-1.999-2L16 3.002A5 5 0 0012 5a5 5 0 00-4-2H4a2 2 0 00-2 2v12a2 2 0 001.999 2H8a5 5 0 014 2 5 5 0 014-2z",
	key: "1fyvmf"
}]]), te = A("check", [["path", {
	d: "M20 6 9 17l-5-5",
	key: "1gmf2c"
}]]), P = A("chevron-down", [["path", {
	d: "m6 9 6 6 6-6",
	key: "qrunsl"
}]]), F = A("chevron-left", [["path", {
	d: "m15 18-6-6 6-6",
	key: "1wnfg3"
}]]), ne = A("chevron-right", [["path", {
	d: "m9 18 6-6-6-6",
	key: "mthhwq"
}]]), re = A("chevron-up", [["path", {
	d: "m18 15-6-6-6 6",
	key: "153udz"
}]]), ie = A("expand", [
	["path", {
		d: "m15 15 6 6",
		key: "1s409w"
	}],
	["path", {
		d: "m15 9 6-6",
		key: "ko1vev"
	}],
	["path", {
		d: "M21 16v5h-5",
		key: "1ck2sf"
	}],
	["path", {
		d: "M21 8V3h-5",
		key: "1qoq8a"
	}],
	["path", {
		d: "M3 16v5h5",
		key: "1t08am"
	}],
	["path", {
		d: "m3 21 6-6",
		key: "wwnumi"
	}],
	["path", {
		d: "M3 8V3h5",
		key: "1ln10m"
	}],
	["path", {
		d: "M9 9 3 3",
		key: "v551iv"
	}]
]), I = A("eye", [["path", {
	d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
	key: "1nclc0"
}], ["circle", {
	cx: "12",
	cy: "12",
	r: "3",
	key: "1v7zrd"
}]]), L = A("lock-keyhole", [
	["circle", {
		cx: "12",
		cy: "16",
		r: "1",
		key: "1au0dj"
	}],
	["rect", {
		x: "3",
		y: "10",
		width: "18",
		height: "12",
		rx: "2",
		key: "6s8ecr"
	}],
	["path", {
		d: "M7 10V7a5 5 0 0 1 10 0v3",
		key: "1pqi11"
	}]
]), R = A("mail", [["path", {
	d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
	key: "132q7q"
}], ["rect", {
	x: "2",
	y: "4",
	width: "20",
	height: "16",
	rx: "2",
	key: "izxlao"
}]]), ae = A("menu", [
	["path", {
		d: "M4 5h16",
		key: "1tepv9"
	}],
	["path", {
		d: "M4 12h16",
		key: "1lakjw"
	}],
	["path", {
		d: "M4 19h16",
		key: "1djgab"
	}]
]), z = A("minus", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}]]), oe = A("moon", [["path", {
	d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
	key: "kfwtm"
}]]), se = A("move-horizontal", [
	["path", {
		d: "m18 8 4 4-4 4",
		key: "1ak13k"
	}],
	["path", {
		d: "M2 12h20",
		key: "9i4pu4"
	}],
	["path", {
		d: "m6 8-4 4 4 4",
		key: "15zrgr"
	}]
]), ce = A("phone", [["path", {
	d: "M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384",
	key: "9njp5v"
}]]), le = A("plus", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}], ["path", {
	d: "M12 5v14",
	key: "s699le"
}]]), ue = A("search", [["path", {
	d: "m21 21-4.34-4.34",
	key: "14j7rj"
}], ["circle", {
	cx: "11",
	cy: "11",
	r: "8",
	key: "4ej97u"
}]]), de = A("shopping-bag", [
	["path", {
		d: "M16 10a4 4 0 0 1-8 0",
		key: "1ltviw"
	}],
	["path", {
		d: "M3.103 6.034h17.794",
		key: "awc11p"
	}],
	["path", {
		d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
		key: "o988cm"
	}]
]), fe = A("star", [["path", {
	d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
	key: "r04s7s"
}]]), pe = A("trash-2", [
	["path", {
		d: "M10 11v6",
		key: "nco0om"
	}],
	["path", {
		d: "M14 11v6",
		key: "outv1u"
	}],
	["path", {
		d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
		key: "miytrc"
	}],
	["path", {
		d: "M3 6h18",
		key: "d0wm0j"
	}],
	["path", {
		d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
		key: "e791ji"
	}]
]), me = A("wind", [
	["path", {
		d: "M12.8 19.6A2 2 0 1 0 14 16H2",
		key: "148xed"
	}],
	["path", {
		d: "M17.5 8a2.5 2.5 0 1 1 2 4H2",
		key: "1u4tom"
	}],
	["path", {
		d: "M9.8 4.4A2 2 0 1 1 11 8H2",
		key: "75valh"
	}]
]), he = A("x", [["path", {
	d: "M18 6 6 18",
	key: "1bl5f8"
}], ["path", {
	d: "m6 6 12 12",
	key: "d8bk6v"
}]]);
//#endregion
//#region node_modules/@base-ui/utils/formatErrorMessage.mjs
function ge(e, t) {
	return function(n, ...r) {
		let i = new URL(e);
		return i.searchParams.set("code", n.toString()), r.forEach((e) => i.searchParams.append("args[]", e)), `${t} error #${n}; visit ${i} for the full message.`;
	};
}
var _e = ge("https://base-ui.com/production-error", "Base UI"), ve = /* @__PURE__ */ _.createContext(void 0);
function ye(e) {
	let t = _.useContext(ve);
	if (!e && t === void 0) throw Error(_e(27));
	return t;
}
//#endregion
//#region node_modules/@base-ui/utils/useRefWithInit.mjs
var be = {};
function xe(e, t) {
	let n = _.useRef(be);
	return n.current === be && (n.current = e(t)), n;
}
//#endregion
//#region node_modules/@base-ui/utils/useMergedRefs.mjs
function Se(e, t, n, r) {
	let i = xe(we).current;
	return Te(i, e, t, n, r) && De(i, [
		e,
		t,
		n,
		r
	]), i.callback;
}
function Ce(e) {
	let t = xe(we).current;
	return Ee(t, e) && De(t, e), t.callback;
}
function we() {
	return {
		callback: null,
		cleanup: null,
		refs: []
	};
}
function Te(e, t, n, r, i) {
	return e.refs[0] !== t || e.refs[1] !== n || e.refs[2] !== r || e.refs[3] !== i;
}
function Ee(e, t) {
	return e.refs.length !== t.length || e.refs.some((e, n) => e !== t[n]);
}
function De(e, t) {
	if (e.refs = t, t.every((e) => e == null)) {
		e.callback = null;
		return;
	}
	e.callback = (n) => {
		if (e.cleanup &&= (e.cleanup(), null), n != null) {
			let r = Array(t.length).fill(null);
			for (let e = 0; e < t.length; e += 1) {
				let i = t[e];
				if (i != null) switch (typeof i) {
					case "function": {
						let t = i(n);
						typeof t == "function" && (r[e] = t);
						break;
					}
					case "object":
						i.current = n;
						break;
					default:
				}
			}
			e.cleanup = () => {
				for (let e = 0; e < t.length; e += 1) {
					let n = t[e];
					if (n != null) switch (typeof n) {
						case "function": {
							let t = r[e];
							typeof t == "function" ? t() : n(null);
							break;
						}
						case "object":
							n.current = null;
							break;
						default:
					}
				}
			};
		}
	};
}
//#endregion
//#region node_modules/@base-ui/utils/reactVersion.mjs
var Oe = 19;
function ke(e) {
	return Oe >= e;
}
//#endregion
//#region node_modules/@base-ui/utils/getReactElementRef.mjs
function Ae(e) {
	if (!/* @__PURE__ */ _.isValidElement(e)) return null;
	let t = e, n = t.props;
	return (ke(19) ? n?.ref : t.ref) ?? null;
}
//#endregion
//#region node_modules/@base-ui/utils/mergeObjects.mjs
function je(e, t) {
	if (e && !t) return e;
	if (!e && t) return t;
	if (e || t) return {
		...e,
		...t
	};
}
//#endregion
//#region node_modules/@base-ui/utils/empty.mjs
function Me() {}
var Ne = Object.freeze([]), Pe = Object.freeze({});
//#endregion
//#region node_modules/@base-ui/react/internals/getStateAttributesProps.mjs
function Fe(e, t) {
	let n = {};
	for (let r in e) {
		let i = e[r];
		if (t?.hasOwnProperty(r)) {
			let e = t[r](i);
			e != null && Object.assign(n, e);
			continue;
		}
		i === !0 ? n[`data-${r.toLowerCase()}`] = "" : i && (n[`data-${r.toLowerCase()}`] = i.toString());
	}
	return n;
}
//#endregion
//#region node_modules/@base-ui/react/utils/resolveClassName.mjs
function Ie(e, t) {
	return typeof e == "function" ? e(t) : e;
}
//#endregion
//#region node_modules/@base-ui/react/utils/resolveStyle.mjs
function Le(e, t) {
	return typeof e == "function" ? e(t) : e;
}
//#endregion
//#region node_modules/@base-ui/react/merge-props/mergeProps.mjs
var Re = {};
function ze(e, t, n, r, i) {
	if (!n && !r && !i && !e) return Ve(t);
	let a = Ve(e);
	return t && (a = He(a, t)), n && (a = He(a, n)), r && (a = He(a, r)), i && (a = He(a, i)), a;
}
function Be(e) {
	if (e.length === 0) return Re;
	if (e.length === 1) return Ve(e[0]);
	let t = Ve(e[0]);
	for (let n = 1; n < e.length; n += 1) t = He(t, e[n]);
	return t;
}
function Ve(e) {
	return Ke(e) ? { ...qe(e, Re) } : Ue(e);
}
function He(e, t) {
	return Ke(t) ? qe(t, e) : We(e, t);
}
function Ue(e) {
	let t = { ...e };
	for (let e in t) {
		let n = t[e];
		Ge(e, n) && (t[e] = Ye(n));
	}
	return t;
}
function We(e, t) {
	if (!t) return e;
	for (let n in t) {
		let r = t[n];
		switch (n) {
			case "style":
				e[n] = je(e.style, r);
				break;
			case "className":
				e[n] = Ze(e.className, r);
				break;
			default: Ge(n, r) ? e[n] = Je(e[n], r) : e[n] = r;
		}
	}
	return e;
}
function Ge(e, t) {
	let n = e.charCodeAt(0), r = e.charCodeAt(1), i = e.charCodeAt(2);
	return n === 111 && r === 110 && i >= 65 && i <= 90 && (typeof t == "function" || t === void 0);
}
function Ke(e) {
	return typeof e == "function";
}
function qe(e, t) {
	return Ke(e) ? e(t) : e ?? Re;
}
function Je(e, t) {
	return t ? e ? (...n) => {
		let r = n[0];
		if (Qe(r)) {
			let i = r;
			Xe(i);
			let a = t(...n);
			return i.baseUIHandlerPrevented || e?.(...n), a;
		}
		let i = t(...n);
		return e?.(...n), i;
	} : Ye(t) : e;
}
function Ye(e) {
	return e && ((...t) => {
		let n = t[0];
		return Qe(n) && Xe(n), e(...t);
	});
}
function Xe(e) {
	return e.preventBaseUIHandler = () => {
		e.baseUIHandlerPrevented = !0;
	}, e;
}
function Ze(e, t) {
	return t ? e ? t + " " + e : t : e;
}
function Qe(e) {
	return typeof e == "object" && !!e && "nativeEvent" in e;
}
//#endregion
//#region node_modules/@base-ui/react/internals/useRenderElement.mjs
function $e(e, t, n = {}) {
	let r = t.render, i = et(t, n);
	return n.enabled === !1 ? null : rt(e, r, i, n.state ?? Pe);
}
function et(e, t = {}) {
	let { className: n, style: r, render: i } = e, { state: a = Pe, ref: o, props: s, stateAttributesMapping: c, enabled: l = !0 } = t, u = l ? Ie(n, a) : void 0, d = l ? Le(r, a) : void 0, f = l ? Fe(a, c) : Pe, p = l && s ? tt(s) : void 0, m = l ? je(f, p) ?? {} : Pe;
	return typeof document < "u" && (l ? Array.isArray(o) ? m.ref = Ce([
		m.ref,
		Ae(i),
		...o
	]) : m.ref = Se(m.ref, Ae(i), o) : Se(null, null)), l ? (u !== void 0 && (m.className = Ze(m.className, u)), d !== void 0 && (m.style = je(m.style, d)), m) : Pe;
}
function tt(e) {
	return Array.isArray(e) ? Be(e) : ze(void 0, e);
}
var nt = Symbol.for("react.lazy");
function rt(e, t, n, r) {
	if (t) {
		if (typeof t == "function") return t(n, r);
		let e = ze(n, t.props);
		e.ref = n.ref;
		let i = t;
		return i?.$$typeof === nt && (i = _.Children.toArray(t)[0]), /* @__PURE__ */ _.cloneElement(i, e);
	}
	if (e && typeof e == "string") return it(e, n);
	throw Error(_e(8));
}
function it(e, t) {
	return e === "button" ? /* @__PURE__ */ (0, _.createElement)("button", {
		type: "button",
		...t,
		key: t.key
	}) : e === "img" ? /* @__PURE__ */ (0, _.createElement)("img", {
		alt: "",
		...t,
		key: t.key
	}) : /* @__PURE__ */ _.createElement(e, t);
}
//#endregion
//#region node_modules/@base-ui/react/internals/stateAttributesMapping.mjs
var at = /* @__PURE__ */ function(e) {
	return e.startingStyle = "data-starting-style", e.endingStyle = "data-ending-style", e;
}({}), ot = { "data-starting-style": "" }, st = { "data-ending-style": "" }, ct = { transitionStatus(e) {
	return e === "starting" ? ot : e === "ending" ? st : null;
} };
(function(e) {
	return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = at.startingStyle] = "startingStyle", e[e.endingStyle = at.endingStyle] = "endingStyle", e.anchorHidden = "data-anchor-hidden", e.side = "data-side", e.align = "data-align", e;
})({});
var lt = { "data-open": "" }, ut = { "data-closed": "" }, dt = { "data-anchor-hidden": "" }, ft = {
	open(e) {
		return e ? lt : ut;
	},
	anchorHidden(e) {
		return e ? dt : null;
	}
}, pt = {
	...ft,
	...ct
}, mt = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { render: n, className: r, style: i, forceRender: a = !1, ...o } = e, s = ye(), c = s.useState("open"), l = s.useState("nested"), u = s.useState("mounted");
	return $e("div", e, {
		state: {
			open: c,
			transitionStatus: s.useState("transitionStatus")
		},
		ref: [s.context.backdropRef, t],
		stateAttributesMapping: pt,
		props: [{
			role: "presentation",
			hidden: !u,
			style: {
				userSelect: "none",
				WebkitUserSelect: "none"
			}
		}, o],
		enabled: a || !l
	});
});
//#endregion
//#region node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function ht() {
	return typeof window < "u";
}
function gt(e) {
	return yt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function _t(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function vt(e) {
	return ((yt(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function yt(e) {
	return ht() ? e instanceof Node || e instanceof _t(e).Node : !1;
}
function bt(e) {
	return ht() ? e instanceof Element || e instanceof _t(e).Element : !1;
}
function xt(e) {
	return ht() ? e instanceof HTMLElement || e instanceof _t(e).HTMLElement : !1;
}
function St(e) {
	return !ht() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof _t(e).ShadowRoot;
}
function Ct(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = Tt(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && i !== "inline" && i !== "contents";
}
function wt(e) {
	return /^(html|body|#document)$/.test(gt(e));
}
function Tt(e) {
	return _t(e).getComputedStyle(e);
}
function Et(e) {
	if (gt(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || St(e) && e.host || vt(e);
	return St(t) ? t.host : t;
}
//#endregion
//#region node_modules/@base-ui/utils/safeReact.mjs
var Dt = { ..._ }, Ot = Dt.useInsertionEffect, kt = Ot && Ot !== Dt.useLayoutEffect ? Ot : (e) => e();
function B(e) {
	let t = xe(At).current;
	return t.next = e, kt(t.effect), t.trampoline;
}
function At() {
	let e = {
		next: void 0,
		callback: jt,
		trampoline: (...t) => e.callback?.(...t),
		effect: () => {
			e.callback = e.next;
		}
	};
	return e;
}
function jt() {}
var V = typeof document < "u" ? _.useLayoutEffect : () => {}, Mt = /* @__PURE__ */ _.createContext(void 0);
function Nt(e = !1) {
	let t = _.useContext(Mt);
	if (t === void 0 && !e) throw Error(_e(16));
	return t;
}
//#endregion
//#region node_modules/@base-ui/react/utils/useFocusableWhenDisabled.mjs
function Pt(e) {
	let { focusableWhenDisabled: t, disabled: n, composite: r = !1, tabIndex: i = 0, isNativeButton: a } = e, o = r && t !== !1, s = r && t === !1;
	return { props: _.useMemo(() => {
		let e = { onKeyDown(e) {
			n && t && e.key !== "Tab" && e.preventDefault();
		} };
		return r || (e.tabIndex = i, !a && n && (e.tabIndex = t ? i : -1)), (a && (t || o) || !a && n) && (e["aria-disabled"] = n), a && (!t || s) && (e.disabled = n), e;
	}, [
		r,
		n,
		t,
		o,
		s,
		a,
		i
	]) };
}
//#endregion
//#region node_modules/@base-ui/utils/owner.mjs
function H(e) {
	return e?.ownerDocument || document;
}
//#endregion
//#region node_modules/@base-ui/react/utils/dispatchClickWithModifiers.mjs
function Ft(e, t, { detail: n = 0 } = {}) {
	e.dispatchEvent(new (_t(e)).PointerEvent("click", {
		bubbles: !0,
		cancelable: !0,
		composed: !0,
		detail: n,
		shiftKey: t.shiftKey,
		ctrlKey: t.ctrlKey,
		altKey: t.altKey,
		metaKey: t.metaKey
	}));
}
//#endregion
//#region node_modules/@base-ui/react/internals/use-button/useButton.mjs
function It(e = {}) {
	let { disabled: t = !1, focusableWhenDisabled: n, tabIndex: r = 0, native: i = !0, composite: a } = e, o = _.useRef(null), s = Nt(!0), c = a ?? s !== void 0, { props: l } = Pt({
		focusableWhenDisabled: n,
		disabled: t,
		composite: c,
		tabIndex: r,
		isNativeButton: i
	}), u = _.useCallback(() => {
		let e = o.current;
		Lt(e) && c && t && l.disabled === void 0 && e.disabled && (e.disabled = !1);
	}, [
		t,
		l.disabled,
		c
	]);
	return V(u, [u]), {
		getButtonProps: _.useCallback((e = {}) => {
			let { onClick: n, onMouseDown: r, onKeyUp: a, onKeyDown: o, onPointerDown: s, ...u } = e;
			return ze({
				onClick(e) {
					if (t) {
						e.preventDefault();
						return;
					}
					n?.(e);
				},
				onMouseDown(e) {
					t || r?.(e);
				},
				onKeyDown(e) {
					if (t || (Xe(e), o?.(e), e.baseUIHandlerPrevented)) return;
					let n = e.target === e.currentTarget, r = e.currentTarget, a = Lt(r), s = !i && Rt(r), l = n && (i ? a : !s), u = e.key === "Enter", d = e.key === " ", f = r.getAttribute("role"), p = f?.startsWith("menuitem") || f === "option" || f === "gridcell";
					if (n && c && d) {
						if (e.defaultPrevented && p) return;
						e.preventDefault(), (!i || a) && (e.preventBaseUIHandler(), Ft(r, e));
						return;
					}
					if (!l || i || !d && !u) {
						n && s && d && e.preventDefault();
						return;
					}
					e.defaultPrevented || (e.preventDefault(), u && (e.preventBaseUIHandler(), Ft(r, e)));
				},
				onKeyUp(e) {
					if (!t) {
						if (Xe(e), a?.(e), e.target === e.currentTarget && i && c && Lt(e.currentTarget) && e.key === " ") {
							e.preventDefault();
							return;
						}
						e.baseUIHandlerPrevented || e.target === e.currentTarget && !i && !c && !e.defaultPrevented && e.key === " " && (e.preventBaseUIHandler(), Ft(e.currentTarget, e));
					}
				},
				onPointerDown(e) {
					if (t) {
						e.preventDefault();
						return;
					}
					s?.(e);
				}
			}, i ? { type: "button" } : { role: "button" }, l, u);
		}, [
			t,
			l,
			c,
			i
		]),
		buttonRef: B((e) => {
			o.current = e, u();
		})
	};
}
function Lt(e) {
	return xt(e) && e.tagName === "BUTTON";
}
function Rt(e) {
	return xt(e) && e.tagName === "A" && !!e.href;
}
//#endregion
//#region node_modules/@base-ui/react/internals/reason-parts.mjs
var zt = "none", Bt = "trigger-press", Vt = "outside-press", Ht = "close-press", Ut = "focus-out", Wt = "escape-key", Gt = "disabled", Kt = "missing", qt = "initial", Jt = "imperative-action";
//#endregion
//#region node_modules/@base-ui/react/internals/createBaseUIEventDetails.mjs
function Yt(e, t, n, r) {
	let i = !1, a = !1, o = r ?? Pe;
	return {
		reason: e,
		event: t ?? new Event("base-ui"),
		cancel() {
			i = !0;
		},
		allowPropagation() {
			a = !0;
		},
		get isCanceled() {
			return i;
		},
		get isPropagationAllowed() {
			return a;
		},
		trigger: n,
		...o
	};
}
//#endregion
//#region node_modules/@base-ui/react/dialog/close/DialogClose.mjs
var Xt = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { render: n, className: r, style: i, disabled: a = !1, nativeButton: o = !0, ...s } = e, c = ye(), l = c.useState("open"), { getButtonProps: u, buttonRef: d } = It({
		disabled: a,
		native: o
	}), f = { disabled: a };
	function p(e) {
		l && c.setOpen(!1, Yt(Ht, e.nativeEvent));
	}
	return $e("button", e, {
		state: f,
		ref: [t, d],
		props: [
			{ onClick: p },
			s,
			u
		]
	});
}), Zt = 0;
function Qt(e, t = "mui") {
	let [n, r] = _.useState(e), i = e || n;
	return _.useEffect(() => {
		n ?? (Zt += 1, r(`${t}-${Zt}`));
	}, [n, t]), i;
}
var $t = Dt.useId;
function en(e, t) {
	if ($t !== void 0) {
		let n = $t();
		return e ?? (t ? `${t}-${n}` : n);
	}
	return Qt(e, t);
}
//#endregion
//#region node_modules/@base-ui/react/internals/useBaseUiId.mjs
function tn(e) {
	return en(e, "base-ui");
}
//#endregion
//#region node_modules/@base-ui/react/dialog/description/DialogDescription.mjs
var nn = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { render: n, className: r, style: i, id: a, ...o } = e, s = ye(), c = tn(a);
	return s.useSyncedValueWithCleanup("descriptionElementId", c), $e("p", e, {
		ref: t,
		props: [{ id: c }, o]
	});
});
//#endregion
//#region node_modules/@base-ui/utils/useOnMount.mjs
function rn(e) {
	_.useEffect(e, Ne);
}
//#endregion
//#region node_modules/@base-ui/utils/useTimeout.mjs
var an = 0, on = class e {
	static create() {
		return new e();
	}
	currentId = an;
	start(e, t) {
		this.clear(), this.currentId = setTimeout(() => {
			this.currentId = an, t();
		}, e);
	}
	isStarted() {
		return this.currentId !== an;
	}
	clear = () => {
		this.currentId !== an && (clearTimeout(this.currentId), this.currentId = an);
	};
	disposeEffect = () => this.clear;
};
function sn() {
	let e = xe(on.create).current;
	return rn(e.disposeEffect), e;
}
//#endregion
//#region node_modules/@base-ui/utils/platform/shared.mjs
function cn() {
	return typeof navigator > "u" ? {
		userAgent: "",
		platform: "",
		maxTouchPoints: 0
	} : {
		userAgent: navigator.userAgent,
		platform: navigator.platform ?? "",
		maxTouchPoints: navigator.maxTouchPoints ?? 0
	};
}
var { userAgent: ln, platform: un, maxTouchPoints: dn } = cn(), fn = ln.toLowerCase(), pn = un.toLowerCase(), mn = /^i(os$|p)/.test(pn) || pn === "macintel" && dn > 1, hn = "android", gn = pn === hn || fn.includes(hn), _n = !mn && pn.startsWith("mac");
pn.startsWith("win"), !gn && /^(linux|chrome os)/.test(pn);
var vn = _n || mn, yn = typeof CSS < "u" && !!CSS.supports?.("-webkit-backdrop-filter:none");
!yn && fn.includes("firefox"), !yn && fn.includes("chrom");
//#endregion
//#region node_modules/@base-ui/utils/platform/screen-reader.mjs
var bn = vn, xn = /jsdom|happydom/.test(fn);
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/event.mjs
function Sn(e) {
	e.preventDefault(), e.stopPropagation();
}
function Cn(e) {
	return "nativeEvent" in e;
}
function wn(e) {
	return e.pointerType === "" && e.isTrusted ? !0 : gn && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function Tn(e) {
	return xn ? !1 : !gn && e.width === 0 && e.height === 0 || gn && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function En(e) {
	let t = e.type;
	return t === "click" || t === "mousedown" || t === "keydown" || t === "keyup";
}
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/constants.mjs
var Dn = "data-base-ui-focusable";
//#endregion
//#region node_modules/@base-ui/react/internals/shadowDom.mjs
function On(e) {
	let t = e.activeElement;
	for (; t?.shadowRoot?.activeElement != null;) t = t.shadowRoot.activeElement;
	return t;
}
function U(e, t) {
	if (!e || !t) return !1;
	let n = t.getRootNode?.();
	if (e.contains(t)) return !0;
	if (n && St(n)) {
		let n = t;
		for (; n;) {
			if (e === n) return !0;
			n = n.parentNode || n.host;
		}
	}
	return !1;
}
function kn(e) {
	return "composedPath" in e ? e.composedPath()[0] : e.target;
}
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/element.mjs
function An(e, t) {
	if (t == null) return !1;
	if ("composedPath" in e) return e.composedPath().includes(t);
	let n = e;
	return n.target != null && t.contains(n.target);
}
function jn(e) {
	return e.matches("html,body");
}
function Mn(e) {
	return xt(e) && e.matches("input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])");
}
function Nn(e) {
	return e ? e.getAttribute("role") === "combobox" && Mn(e) : !1;
}
function Pn(e) {
	return e ? e.hasAttribute("data-base-ui-focusable") ? e : e.querySelector("[data-base-ui-focusable]") || e : null;
}
//#endregion
//#region node_modules/react/cjs/react-jsx-runtime.production.js
var Fn = /* @__PURE__ */ o(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
	function r(e, n, r) {
		var i = null;
		if (r !== void 0 && (i = "" + r), n.key !== void 0 && (i = "" + n.key), "key" in n) for (var a in r = {}, n) a !== "key" && (r[a] = n[a]);
		else r = n;
		return n = r.ref, {
			$$typeof: t,
			type: e,
			key: i,
			ref: n === void 0 ? null : n,
			props: r
		};
	}
	e.Fragment = n, e.jsx = r, e.jsxs = r;
})), In = /* @__PURE__ */ o(((e, t) => {
	t.exports = Fn();
}));
//#endregion
//#region node_modules/@base-ui/utils/addEventListener.mjs
function Ln(e, t, n, r) {
	return e.addEventListener(t, n, r), () => {
		e.removeEventListener(t, n, r);
	};
}
//#endregion
//#region node_modules/@base-ui/utils/mergeCleanups.mjs
function Rn(...e) {
	return () => {
		for (let t = 0; t < e.length; t += 1) {
			let n = e[t];
			n && n();
		}
	};
}
//#endregion
//#region node_modules/@base-ui/utils/useValueAsRef.mjs
function zn(e) {
	let t = xe(Bn, e).current;
	return t.next = e, V(t.effect), t;
}
function Bn(e) {
	let t = {
		current: e,
		next: e,
		effect: () => {
			t.current = t.next;
		}
	};
	return t;
}
//#endregion
//#region node_modules/@base-ui/utils/useAnimationFrame.mjs
var Vn = null;
globalThis.requestAnimationFrame;
var Hn = new class {
	callbacks = [];
	callbacksCount = 0;
	nextId = 1;
	startId = 1;
	isScheduled = !1;
	tick = (e) => {
		this.isScheduled = !1;
		let t = this.callbacks, n = this.callbacksCount;
		if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, n > 0) for (let n = 0; n < t.length; n += 1) t[n]?.(e);
	};
	request(e) {
		let t = this.nextId;
		return this.nextId += 1, this.callbacks.push(e), this.callbacksCount += 1, this.isScheduled ||= (requestAnimationFrame(this.tick), !0), t;
	}
	cancel(e) {
		let t = e - this.startId;
		t < 0 || t >= this.callbacks.length || (this.callbacks[t] = null, --this.callbacksCount);
	}
}(), Un = class e {
	static create() {
		return new e();
	}
	static request(e) {
		return Hn.request(e);
	}
	static cancel(e) {
		return Hn.cancel(e);
	}
	currentId = Vn;
	request(e) {
		this.cancel(), this.currentId = Hn.request(() => {
			this.currentId = Vn, e();
		});
	}
	cancel = () => {
		this.currentId !== Vn && (Hn.cancel(this.currentId), this.currentId = Vn);
	};
	disposeEffect = () => this.cancel;
};
function Wn() {
	let e = xe(Un.create).current;
	return rn(e.disposeEffect), e;
}
//#endregion
//#region node_modules/@base-ui/utils/visuallyHidden.mjs
var Gn = {
	clipPath: "inset(50%)",
	overflow: "hidden",
	whiteSpace: "nowrap",
	border: 0,
	padding: 0,
	width: 1,
	height: 1,
	margin: -1
}, Kn = {
	...Gn,
	position: "fixed",
	top: 0,
	left: 0
};
({ ...Gn });
//#endregion
//#region node_modules/@base-ui/react/utils/FocusGuard.mjs
var W = In(), qn = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let [n, r] = _.useState();
	V(() => {
		bn && yn && r("button");
	}, []);
	let i = {
		tabIndex: 0,
		role: n
	};
	return /* @__PURE__ */ (0, W.jsx)("span", {
		...e,
		ref: t,
		style: Kn,
		"aria-hidden": n ? void 0 : !0,
		...i,
		"data-base-ui-focus-guard": ""
	});
});
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/composite.mjs
function Jn(e, t) {
	return t < 0 || t >= e.length;
}
function Yn(e, t) {
	return Zn(e.current, { disabledIndices: t });
}
function Xn(e, t) {
	return Zn(e.current, {
		decrement: !0,
		startingIndex: e.current.length,
		disabledIndices: t
	});
}
function Zn(e, { startingIndex: t = -1, decrement: n = !1, disabledIndices: r, amount: i = 1 } = {}) {
	let a = t;
	do
		a += n ? -i : i;
	while (a >= 0 && a <= e.length - 1 && Qn(e, a, r));
	return a;
}
function Qn(e, t, n) {
	if (typeof n == "function" ? n(t) : n?.includes(t) ?? !1) return !0;
	let r = e[t];
	return r ? !er(r) || r.matches(":disabled") ? !0 : !n && (r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true") : !1;
}
function $n(e) {
	return e.visibility === "hidden" || e.visibility === "collapse";
}
function er(e, t = e ? Tt(e) : null) {
	return !e || !e.isConnected || !t || $n(t) ? !1 : typeof e.checkVisibility == "function" ? e.checkVisibility() : t.display !== "none" && t.display !== "contents";
}
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/tabbable.mjs
var tr = "a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable=\"false\"]),audio[controls],video[controls]";
function nr(e) {
	let t = e.assignedSlot;
	if (t) return t;
	if (e.parentElement) return e.parentElement;
	let n = e.getRootNode();
	return St(n) ? n.host : null;
}
function rr(e) {
	for (let t of Array.from(e.children)) if (gt(t) === "summary") return t;
	return null;
}
function ir(e, t) {
	let n = rr(t);
	return !!n && (e === n || U(n, e));
}
function ar(e) {
	let t = e ? gt(e) : "";
	return e != null && e.matches(tr) && (t !== "summary" || e.parentElement != null && gt(e.parentElement) === "details" && rr(e.parentElement) === e) && (t !== "details" || rr(e) == null) && (t !== "input" || e.type !== "hidden");
}
function or(e) {
	if (!ar(e) || !e.isConnected || e.matches(":disabled")) return !1;
	for (let t = e; t; t = nr(t)) {
		let n = t !== e, r = gt(t) === "slot";
		if (t.hasAttribute("inert") || n && gt(t) === "details" && !t.open && !ir(e, t) || t.hasAttribute("hidden") || !r && !sr(t, n)) return !1;
	}
	return !0;
}
function sr(e, t) {
	let n = Tt(e);
	return t ? n.display !== "none" : er(e, n);
}
function cr(e) {
	let t = e.tabIndex;
	if (t < 0) {
		let t = gt(e);
		if (t === "details" || t === "audio" || t === "video" || xt(e) && e.isContentEditable) return 0;
	}
	return t;
}
function lr(e) {
	if (gt(e) !== "input") return null;
	let t = e;
	return t.type === "radio" && t.name !== "" ? t : null;
}
function ur(e, t) {
	let n = lr(e);
	if (!n) return !0;
	let r = t.find((e) => {
		let t = lr(e);
		return t?.name === n.name && t.form === n.form && t.checked;
	});
	return r ? r === n : t.find((e) => {
		let t = lr(e);
		return t?.name === n.name && t.form === n.form;
	}) === n;
}
function dr(e) {
	if (xt(e) && gt(e) === "slot") {
		let t = e.assignedElements({ flatten: !0 });
		if (t.length > 0) return t;
	}
	return xt(e) && e.shadowRoot ? Array.from(e.shadowRoot.children) : Array.from(e.children);
}
function fr(e, t) {
	dr(e).forEach((e) => {
		ar(e) && t.push(e), fr(e, t);
	});
}
function pr(e, t, n) {
	dr(e).forEach((e) => {
		xt(e) && e.matches(t) && n.push(e), pr(e, t, n);
	});
}
function mr(e) {
	return or(e) && cr(e) >= 0;
}
function hr(e) {
	let t = [];
	return fr(e, t), t.filter(or);
}
function gr(e) {
	let t = hr(e);
	return t.filter((e) => cr(e) >= 0 && ur(e, t));
}
function _r(e, t) {
	let n = gr(e), r = n.length;
	if (r === 0) return;
	let i = On(H(e)), a = n.indexOf(i);
	return n[a === -1 ? t === 1 ? 0 : r - 1 : a + t];
}
function vr(e) {
	return _r(H(e).body, 1) || e;
}
function yr(e) {
	return _r(H(e).body, -1) || e;
}
function br(e, t) {
	let n = t || e.currentTarget, r = e.relatedTarget;
	return !r || !U(n, r);
}
function xr(e) {
	gr(e).forEach((e) => {
		e.dataset.tabindex = e.getAttribute("tabindex") || "", e.setAttribute("tabindex", "-1");
	});
}
function Sr(e) {
	let t = [];
	pr(e, "[data-tabindex]", t), t.forEach((e) => {
		let t = e.dataset.tabindex;
		delete e.dataset.tabindex, t ? e.setAttribute("tabindex", t) : e.removeAttribute("tabindex");
	});
}
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/nodes.mjs
function Cr(e, t, n = !0) {
	return e.filter((e) => e.parentId === t).flatMap((t) => [...!n || t.context?.open ? [t] : [], ...Cr(e, t.id, n)]);
}
function wr(e, t) {
	let n = [], r = e.find((e) => e.id === t)?.parentId;
	for (; r;) {
		let t = e.find((e) => e.id === r);
		r = t?.parentId, t && (n = n.concat(t));
	}
	return n;
}
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/createAttribute.mjs
function Tr(e) {
	return `data-base-ui-${e}`;
}
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/enqueueFocus.mjs
var Er = 0;
function Dr(e, t = {}) {
	let { preventScroll: n = !1, sync: r = !1, shouldFocus: i } = t;
	cancelAnimationFrame(Er);
	function a() {
		i && !i() || e?.focus({ preventScroll: n });
	}
	if (r) return a(), Me;
	let o = requestAnimationFrame(a);
	return Er = o, () => {
		Er === o && (cancelAnimationFrame(o), Er = 0);
	};
}
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/markOthers.mjs
var Or = {
	inert: /* @__PURE__ */ new WeakMap(),
	"aria-hidden": /* @__PURE__ */ new WeakMap()
}, kr = "data-base-ui-inert", Ar = {
	inert: /* @__PURE__ */ new WeakSet(),
	"aria-hidden": /* @__PURE__ */ new WeakSet()
}, jr = /* @__PURE__ */ new WeakMap(), Mr = 0;
function Nr(e) {
	return Ar[e];
}
function Pr(e) {
	return e ? St(e) ? e.host : Pr(e.parentNode) : null;
}
var Fr = (e, t) => t.map((t) => {
	if (e.contains(t)) return t;
	let n = Pr(t);
	return e.contains(n) ? n : null;
}).filter((e) => e != null), Ir = (e) => {
	let t = /* @__PURE__ */ new Set();
	return e.forEach((e) => {
		let n = e;
		for (; n && !t.has(n);) t.add(n), n = n.parentNode;
	}), t;
}, Lr = (e, t, n) => {
	let r = [], i = (e) => {
		!e || n.has(e) || Array.from(e.children).forEach((e) => {
			gt(e) !== "script" && (t.has(e) ? i(e) : r.push(e));
		});
	};
	return i(e), r;
};
function Rr(e, t, n, r, { mark: i = !0 }) {
	let a = null;
	r ? a = "inert" : n && (a = "aria-hidden");
	let o = null, s = null, c = Fr(t, e), l = i ? Lr(t, Ir(c), new Set(c)) : [], u = [], d = [];
	if (a) {
		let e = Or[a], n = Nr(a);
		s = n, o = e;
		let r = Fr(t, Array.from(t.querySelectorAll("[aria-live]"))), i = c.concat(r);
		Lr(t, Ir(i), new Set(i)).forEach((t) => {
			let r = t.getAttribute(a), i = r !== null && r !== "false", o = (e.get(t) || 0) + 1;
			e.set(t, o), u.push(t), o === 1 && i && n.add(t), i || t.setAttribute(a, a === "inert" ? "" : "true");
		});
	}
	return i && l.forEach((e) => {
		let t = (jr.get(e) || 0) + 1;
		jr.set(e, t), d.push(e), t === 1 && e.setAttribute(kr, "");
	}), Mr += 1, () => {
		o && u.forEach((e) => {
			let t = (o.get(e) || 0) - 1;
			o.set(e, t), t || (!s?.has(e) && a && e.removeAttribute(a), s?.delete(e));
		}), i && d.forEach((e) => {
			let t = (jr.get(e) || 0) - 1;
			jr.set(e, t), t || e.removeAttribute(kr);
		}), --Mr, Mr || (Or.inert = /* @__PURE__ */ new WeakMap(), Or["aria-hidden"] = /* @__PURE__ */ new WeakMap(), Ar.inert = /* @__PURE__ */ new WeakSet(), Ar["aria-hidden"] = /* @__PURE__ */ new WeakSet(), jr = /* @__PURE__ */ new WeakMap());
	};
}
function zr(e, t = {}) {
	let { ariaHidden: n = !1, inert: r = !1, mark: i = !0 } = t, a = H(e[0]).body;
	return Rr(e, a, n, r, { mark: i });
}
var Br = {
	clipPath: "inset(50%)",
	position: "fixed",
	top: 0,
	left: 0
}, Vr = /* @__PURE__ */ c(m(), 1), Hr = /* @__PURE__ */ _.createContext(null), Ur = () => _.useContext(Hr), Wr = Tr("portal");
function Gr(e = {}) {
	let { ref: t, container: n, componentProps: r = Pe, elementProps: i } = e, a = en(), o = Ur()?.portalNode, [s, c] = _.useState(null), [l, u] = _.useState(null), d = B((e) => {
		e !== null && u(e);
	}), f = _.useRef(null);
	V(() => {
		if (n === null) {
			f.current && (f.current = null, u(null), c(null));
			return;
		}
		let e = (n && (yt(n) ? n : n.current)) ?? o ?? document.body;
		if (e == null) {
			f.current && (f.current = null, u(null), c(null));
			return;
		}
		f.current !== e && (f.current = e, u(null), c(e));
	}, [n, o]);
	let p = $e("div", r, {
		ref: [t, d],
		props: [{
			id: a,
			[Wr]: ""
		}, i]
	}), m = s && p ? /* @__PURE__ */ Vr.createPortal(p, s) : null;
	return {
		node: l,
		nodeId: /* @__PURE__ */ _.isValidElement(p) ? p.props.id : void 0,
		subtree: m
	};
}
var Kr = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { render: n, className: r, style: i, children: a, container: o, ...s } = e, { node: c, nodeId: l, subtree: u } = Gr({
		container: o,
		ref: t,
		componentProps: e,
		elementProps: s
	}), d = _.useRef(null), f = _.useRef(null), p = _.useRef(null), m = _.useRef(null), [h, g] = _.useState(null), v = _.useRef(!1), y = h?.modal, b = h?.open, x = !!h && !h.modal && h.open && !!c;
	_.useEffect(() => {
		if (!c || y) return;
		function e(e) {
			c && e.relatedTarget && br(e) && (e.type === "focusin" ? v.current &&= (Sr(c), !1) : (xr(c), v.current = !0));
		}
		return Rn(Ln(c, "focusin", e, !0), Ln(c, "focusout", e, !0));
	}, [c, y]), V(() => {
		!c || b !== !0 || !v.current || (Sr(c), v.current = !1);
	}, [b, c]);
	let S = _.useMemo(() => ({
		beforeOutsideRef: d,
		afterOutsideRef: f,
		beforeInsideRef: p,
		afterInsideRef: m,
		portalNode: c,
		setFocusManagerState: g
	}), [c]);
	return /* @__PURE__ */ (0, W.jsxs)(_.Fragment, { children: [u, /* @__PURE__ */ (0, W.jsxs)(Hr.Provider, {
		value: S,
		children: [
			x && c && /* @__PURE__ */ (0, W.jsx)(qn, {
				"data-type": "outside",
				ref: d,
				onFocus: (e) => {
					br(e, c) ? p.current?.focus() : yr(h ? h.domReference : null)?.focus();
				}
			}),
			x && c && /* @__PURE__ */ (0, W.jsx)("span", {
				"aria-owns": l,
				style: Br
			}),
			c && /* @__PURE__ */ Vr.createPortal(a, c),
			x && c && /* @__PURE__ */ (0, W.jsx)(qn, {
				"data-type": "outside",
				ref: f,
				onFocus: (e) => {
					br(e, c) ? m.current?.focus() : (vr(h ? h.domReference : null)?.focus(), h?.closeOnFocusOut && h?.onOpenChange(!1, Yt("focus-out", e.nativeEvent)));
				}
			})
		]
	})] });
});
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/createEventEmitter.mjs
function qr() {
	let e = /* @__PURE__ */ new Map();
	return {
		emit(t, n) {
			e.get(t)?.forEach((e) => e(n));
		},
		on(t, n) {
			e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
		},
		off(t, n) {
			e.get(t)?.delete(n);
		}
	};
}
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/components/FloatingTree.mjs
var Jr = /* @__PURE__ */ _.createContext(null), Yr = /* @__PURE__ */ _.createContext(null), Xr = () => _.useContext(Jr)?.id || null, Zr = (e) => {
	let t = _.useContext(Yr);
	return e ?? t;
};
//#endregion
//#region node_modules/@base-ui/react/utils/resolveRef.mjs
function Qr(e) {
	return e == null ? e : "current" in e ? e.current : e;
}
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/components/FloatingFocusManager.mjs
function $r(e, t) {
	let n = _t(kn(e));
	return e instanceof n.KeyboardEvent ? "keyboard" : e instanceof n.FocusEvent ? t || "keyboard" : "pointerType" in e ? e.pointerType || "keyboard" : "touches" in e ? "touch" : e instanceof n.MouseEvent ? t || (e.detail === 0 ? "keyboard" : "mouse") : "";
}
var ei = 20, ti = [];
function ni() {
	ti = ti.filter((e) => e.deref()?.isConnected);
}
function ri(e) {
	ni(), e && gt(e) !== "body" && (ti.push(new WeakRef(e)), ti.length > ei && (ti = ti.slice(-ei)));
}
function ii() {
	return ni(), ti[ti.length - 1]?.deref();
}
function ai(e) {
	return e ? mr(e) ? e : gr(e)[0] || e : null;
}
function oi(e) {
	if (e.hasAttribute("tabindex") && !e.hasAttribute("data-tabindex") || !e.getAttribute("role")?.includes("dialog")) return;
	let t = hr(e).filter((e) => {
		let t = e.getAttribute("data-tabindex") || "";
		return mr(e) || e.hasAttribute("data-tabindex") && !t.startsWith("-");
	}), n = e.getAttribute("tabindex");
	t.length === 0 ? n !== "0" && (e.setAttribute("tabindex", "0"), e.setAttribute("data-tabindex", "0")) : (n !== "-1" || e.hasAttribute("data-tabindex") && e.getAttribute("data-tabindex") !== "-1") && (e.setAttribute("tabindex", "-1"), e.setAttribute("data-tabindex", "-1"));
}
function si(e) {
	let { context: t, children: n, disabled: r = !1, initialFocus: i = !0, returnFocus: a = !0, restoreFocus: o = !1, modal: s = !0, closeOnFocusOut: c = !0, openInteractionType: l = "", nextFocusableElement: u, previousFocusableElement: d, beforeContentFocusGuardRef: f, externalTree: p, getInsideElements: m } = e, h = "rootStore" in t ? t.rootStore : t, g = h.useState("open"), v = h.useState("domReferenceElement"), y = h.useState("floatingElement"), { events: b, dataRef: x } = h.context, S = B(() => x.current.floatingContext?.nodeId), C = i === !1, w = Nn(v) && C, T = zn(i), E = zn(a), D = zn(l), O = zn(g), k = Zr(p), A = Ur(), j = _.useRef(!1), M = _.useRef(!1), N = _.useRef(!1), ee = _.useRef(null), te = _.useRef(""), P = _.useRef(""), F = _.useRef(null), ne = _.useRef(null), re = Se(F, f, A?.beforeInsideRef), ie = Se(ne, A?.afterInsideRef), I = sn(), L = sn(), R = Wn(), ae = A != null, z = Pn(y), oe = B((e = z) => e ? gr(e) : []), se = B(() => m?.().filter((e) => e != null) ?? []);
	_.useEffect(() => {
		if (r || !s) return;
		function e(e) {
			e.key === "Tab" && U(z, On(H(z))) && oe().length === 0 && !w && Sn(e);
		}
		return Ln(H(z), "keydown", e);
	}, [
		r,
		z,
		s,
		w,
		oe
	]), _.useEffect(() => {
		if (r || !g) return;
		let e = H(z);
		function t() {
			N.current = !1;
		}
		function n(e) {
			let t = kn(e), n = se();
			N.current = !(U(y, t) || U(v, t) || U(A?.portalNode, t) || n.some((e) => e === t || U(e, t))), P.current = e.pointerType || "keyboard", t?.closest("[data-base-ui-click-trigger]") && (M.current = !0, L.start(0, () => {
				M.current = !1;
			}));
		}
		function i() {
			P.current = "keyboard";
		}
		return Rn(Ln(e, "pointerdown", n, !0), Ln(e, "pointerup", t, !0), Ln(e, "pointercancel", t, !0), Ln(e, "keydown", i, !0), t);
	}, [
		r,
		y,
		v,
		z,
		g,
		A,
		L,
		se
	]), _.useEffect(() => {
		if (r || !c) return;
		let e = H(z);
		function t() {
			M.current = !0, L.start(0, () => {
				M.current = !1;
			});
		}
		function n(e) {
			let t = kn(e);
			mr(t) && (ee.current = t);
		}
		function i(t) {
			let n = t.relatedTarget, r = t.currentTarget, i = kn(t);
			s && n == null && i != null && U(y, i) && ri(i), queueMicrotask(() => {
				let a = S(), c = h.context.triggerElements, l = se(), f = n?.hasAttribute(Tr("focus-guard")) && [
					F.current,
					ne.current,
					A?.beforeInsideRef.current,
					A?.afterInsideRef.current,
					A?.beforeOutsideRef.current,
					A?.afterOutsideRef.current,
					Qr(d),
					Qr(u)
				].includes(n), p = !(U(v, n) || U(y, n) || U(n, y) || U(A?.portalNode, n) || l.some((e) => e === n || U(e, n)) || c.hasMatchingElement((e) => U(e, n)) || f || k && (Cr(k.nodesRef.current, a).find((e) => U(e.context?.elements.floating, n) || U(e.context?.elements.domReference, n)) || wr(k.nodesRef.current, a).find((e) => [e.context?.elements.floating, Pn(e.context?.elements.floating)].includes(n) || e.context?.elements.domReference === n)));
				if (r === v && z && oi(z), o && r !== v && !er(i) && On(e) === e.body) {
					if (xt(z) && (z.focus(), o === "popup")) {
						R.request(() => {
							z.focus();
						});
						return;
					}
					let e = oe(), t = ee.current, n = (t && e.includes(t) ? t : null) || e[e.length - 1] || z;
					xt(n) && n.focus();
				}
				if (x.current.insideReactTree) {
					x.current.insideReactTree = !1;
					return;
				}
				(w || !s) && n && p && !M.current && (w || n !== ii()) && (j.current = !0, h.setOpen(!1, Yt(Ut, t)));
			});
		}
		function a() {
			N.current || (x.current.insideReactTree = !0, I.start(0, () => {
				x.current.insideReactTree = !1;
			}));
		}
		let l = xt(v) ? v : null;
		if (!(!y && !l)) return Rn(l && Ln(l, "focusout", i), l && Ln(l, "pointerdown", t), y && Ln(y, "focusin", n), y && Ln(y, "focusout", i), y && A && Ln(y, "focusout", a, !0));
	}, [
		r,
		v,
		y,
		z,
		s,
		k,
		A,
		h,
		c,
		o,
		oe,
		w,
		S,
		x,
		I,
		L,
		R,
		u,
		d,
		se
	]), _.useEffect(() => {
		if (r || !y || !g) return;
		let e = Array.from(A?.portalNode?.querySelectorAll(`[${Tr("portal")}]`) || []), t = (k ? wr(k.nodesRef.current, S()) : []).find((e) => Nn(e.context?.elements.domReference || null))?.context?.elements.domReference, n = zr([
			y,
			...e,
			F.current,
			ne.current,
			A?.beforeOutsideRef.current,
			A?.afterOutsideRef.current,
			...se(),
			t,
			Qr(d),
			Qr(u),
			w ? v : null
		].filter((e) => e != null), {
			ariaHidden: s || w,
			mark: !1
		}), i = zr([y, ...e].filter((e) => e != null));
		return () => {
			i(), n();
		};
	}, [
		g,
		r,
		v,
		y,
		s,
		A,
		w,
		k,
		S,
		u,
		d,
		se
	]), V(() => {
		if (!g || r || !xt(z)) return;
		te.current = "", P.current = "";
		let e = H(z), t = On(e);
		queueMicrotask(() => {
			let n = T.current, r = typeof n == "function" ? n(D.current || "") : n;
			if (r === void 0 || r === !1 || U(z, t)) return;
			let i = null, a = () => (i ??= oe(z), i[0] || z), o;
			o = r === !0 || r === null ? a() : Qr(r), o ||= a();
			let s = U(z, On(e));
			Dr(o, {
				preventScroll: o === z,
				shouldFocus() {
					if (!O.current) return !1;
					if (s) return !0;
					let t = On(e);
					return !(t !== o && U(z, t));
				}
			});
		});
	}, [
		r,
		g,
		z,
		oe,
		T,
		D,
		O
	]), V(() => {
		if (r || !z) return;
		let e = H(z), t = On(e), n = D.current == null;
		ri(t);
		function i(e) {
			if (e.open || (te.current = $r(e.nativeEvent, P.current)), e.reason === "trigger-hover" && e.nativeEvent.type === "mouseleave" && (j.current = !0), e.reason === "outside-press") if (e.nested) j.current = !1;
			else if (wn(e.nativeEvent) || Tn(e.nativeEvent)) j.current = !1;
			else {
				let e = !1;
				H(z).createElement("div").focus({ get preventScroll() {
					return e = !0, !1;
				} }), e ? j.current = !1 : j.current = !0;
			}
		}
		b.on("openchange", i);
		function a(e) {
			let r = E.current, i = typeof r == "function" ? r(e) : r;
			if (i === void 0 || i === !1) return null;
			i === null && (i = !0);
			let a = v?.isConnected ? v : null, o = t?.isConnected && gt(t) !== "body" ? t : null, s = n ? o || a : a || o;
			return s ||= ii() || null, typeof i == "boolean" ? s : Qr(i) || s || null;
		}
		return () => {
			b.off("openchange", i);
			let t = On(e), n = se(), r = U(y, t) || n.some((e) => e === t || U(e, t)) || k && Cr(k.nodesRef.current, S(), !1).some((e) => U(e.context?.elements.floating, t)), o = E.current, s = te.current, c = a(s);
			queueMicrotask(() => {
				let n = ai(c), i = typeof o != "boolean";
				if (o && !j.current && xt(n) && (!(!i && n !== t && t !== e.body) || r)) {
					let e = { preventScroll: !0 };
					s === "keyboard" && (e.focusVisible = !0), n.focus(e);
				}
				j.current = !1;
			});
		};
	}, [
		r,
		y,
		z,
		E,
		D,
		b,
		k,
		v,
		S,
		se
	]), V(() => {
		if (!yn || g || !y) return;
		let e = On(H(y));
		!xt(e) || !Mn(e) || U(y, e) && e.blur();
	}, [g, y]), V(() => {
		if (!(r || !A)) return A.setFocusManagerState({
			modal: s,
			closeOnFocusOut: c,
			open: g,
			onOpenChange: h.setOpen,
			domReference: v
		}), () => {
			A.setFocusManagerState(null);
		};
	}, [
		r,
		A,
		s,
		g,
		h,
		c,
		v
	]), V(() => {
		if (!(r || !z)) return oi(z), () => {
			queueMicrotask(ni);
		};
	}, [r, z]);
	let ce = !r && (s ? !w : !0) && (ae || s);
	return /* @__PURE__ */ (0, W.jsxs)(_.Fragment, { children: [
		ce && /* @__PURE__ */ (0, W.jsx)(qn, {
			"data-type": "inside",
			ref: re,
			onFocus: (e) => {
				if (s) {
					let e = oe();
					Dr(e[e.length - 1]);
				} else A?.portalNode && (j.current = !1, br(e, A.portalNode) ? vr(v)?.focus() : Qr(d ?? A.beforeOutsideRef)?.focus());
			}
		}),
		n,
		ce && /* @__PURE__ */ (0, W.jsx)(qn, {
			"data-type": "inside",
			ref: ie,
			onFocus: (e) => {
				s ? Dr(oe()[0]) : A?.portalNode && (c && (j.current = !0), br(e, A.portalNode) ? yr(v)?.focus() : Qr(u ?? A.afterOutsideRef)?.focus());
			}
		})
	] });
}
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/hooks/useDismiss.mjs
function ci() {
	return !1;
}
function li(e) {
	return {
		escapeKey: typeof e == "boolean" ? e : e?.escapeKey ?? !1,
		outsidePress: typeof e == "boolean" ? e : e?.outsidePress ?? !0
	};
}
function ui(e, t = {}) {
	let { enabled: n = !0, escapeKey: r = !0, outsidePress: i = !0, outsidePressEvent: a = "sloppy", referencePress: o = ci, bubbles: s, externalTree: c } = t, l = "rootStore" in e ? e.rootStore : e, u = l.useState("open"), d = l.useState("floatingElement"), { dataRef: f } = l.context, p = Zr(c), m = B(typeof i == "function" ? i : () => !1), h = typeof i == "function" ? m : i, g = h !== !1, v = B(() => a), { escapeKey: y, outsidePress: b } = li(s), x = _.useRef(!1), S = _.useRef(!1), C = _.useRef(!1), w = _.useRef(!1), T = _.useRef(""), E = _.useRef(null), D = sn(), O = sn(), k = B(() => {
		O.clear(), f.current.insideReactTree = !1;
	}), A = B((e) => {
		let t = f.current.floatingContext?.nodeId;
		return (p ? Cr(p.nodesRef.current, t) : []).some((t) => t.context?.open && !t.context.dataRef.current[e]);
	}), j = B((e) => An(e, l.select("floatingElement")) || An(e, l.select("domReferenceElement"))), M = B((e) => {
		o() && l.setOpen(!1, Yt(Bt, e.nativeEvent));
	}), N = B((e) => {
		if (!u || !n || !r || e.key !== "Escape" || w.current || !y && A("__escapeKeyBubbles")) return;
		let t = Yt(Wt, Cn(e) ? e.nativeEvent : e);
		l.setOpen(!1, t), t.isCanceled || e.preventDefault(), !y && !t.isPropagationAllowed && e.stopPropagation();
	}), ee = B(() => {
		f.current.insideReactTree = !0, O.start(0, k);
	}), te = B((e) => {
		if (!u || !n || e.button !== 0) return;
		let t = kn(e.nativeEvent);
		U(l.select("floatingElement"), t) && (x.current || (x.current = !0, S.current = !1));
	}), P = B((e) => {
		!u || !n || (e.defaultPrevented || e.nativeEvent.defaultPrevented) && x.current && (S.current = !0);
	});
	_.useEffect(() => {
		if (!u || !n) return k;
		f.current.__escapeKeyBubbles = y, f.current.__outsidePressBubbles = b;
		let e = new on(), t = new on();
		function i() {
			e.clear(), w.current = !0;
		}
		function a() {
			e.start(yn ? 5 : 0, () => {
				w.current = !1;
			});
		}
		function o() {
			C.current = !0, t.start(0, () => {
				C.current = !1;
			});
		}
		function s() {
			x.current = !1, S.current = !1;
		}
		function c() {
			let e = T.current, t = e === "pen" || !e ? "mouse" : e, n = v(), r = typeof n == "function" ? n() : n;
			return typeof r == "string" ? r : r[t];
		}
		function m(e) {
			let t = c();
			return t === "intentional" && e.type !== "click" || t === "sloppy" && e.type === "click";
		}
		function _(e) {
			let t = f.current.floatingContext?.nodeId, n = p && Cr(p.nodesRef.current, t).some((t) => An(e, t.context?.elements.floating));
			return j(e) || n;
		}
		function O(e) {
			if (m(e)) {
				e.type !== "click" && !j(e) && (t.clear(), C.current = !1), k();
				return;
			}
			if (f.current.insideReactTree) {
				k();
				return;
			}
			let n = kn(e), r = `[${Tr("inert")}]`, i = bt(n) ? n.getRootNode() : null, a = Array.from((St(i) ? i : H(l.select("floatingElement"))).querySelectorAll(r)), o = l.context.triggerElements;
			if (n && (o.hasElement(n) || o.hasMatchingElement((e) => U(e, n)))) return;
			let s = bt(n) ? n : null;
			for (; s && !wt(s);) {
				let e = Et(s);
				if (wt(e) || !bt(e)) break;
				s = e;
			}
			if (!(a.length && bt(n) && !jn(n) && !U(n, l.select("floatingElement")) && a.every((e) => !U(s, e)))) {
				if (xt(n) && !("touches" in e)) {
					let t = wt(n), r = Tt(n), i = /auto|scroll/, a = t || i.test(r.overflowX), o = t || i.test(r.overflowY), s = a && n.clientWidth > 0 && n.scrollWidth > n.clientWidth, c = o && n.clientHeight > 0 && n.scrollHeight > n.clientHeight, l = r.direction === "rtl", u = c && (l ? e.offsetX <= n.offsetWidth - n.clientWidth : e.offsetX > n.clientWidth), d = s && e.offsetY > n.clientHeight;
					if (u || d) return;
				}
				if (!_(e)) {
					if (c() === "intentional" && C.current) {
						t.clear(), C.current = !1;
						return;
					}
					typeof h == "function" && !h(e) || A("__outsidePressBubbles") || (l.setOpen(!1, Yt(Vt, e)), k());
				}
			}
		}
		function M(e) {
			c() !== "sloppy" || e.pointerType === "touch" || !l.select("open") || !n || j(e) || O(e);
		}
		function ee(e) {
			if (c() !== "sloppy" || !l.select("open") || !n || j(e)) return;
			let t = e.touches[0];
			t && (E.current = {
				startTime: Date.now(),
				startX: t.clientX,
				startY: t.clientY,
				dismissOnTouchEnd: !1,
				dismissOnMouseDown: !0
			}, D.start(1e3, () => {
				E.current && (E.current.dismissOnTouchEnd = !1, E.current.dismissOnMouseDown = !1);
			}));
		}
		function te(e, t) {
			let n = kn(e);
			if (!n) return;
			let r = Ln(n, e.type, () => {
				t(e), r();
			});
		}
		function P(e) {
			T.current = "touch", te(e, ee);
		}
		function F(e) {
			D.clear(), e.type === "pointerdown" && (T.current = e.pointerType), !(e.type === "mousedown" && E.current && !E.current.dismissOnMouseDown) && te(e, (e) => {
				e.type === "pointerdown" ? M(e) : O(e);
			});
		}
		function ne(e) {
			if (!x.current) return;
			let n = S.current;
			if (s(), c() === "intentional") {
				if (e.type === "pointercancel") {
					n && o();
					return;
				}
				if (!_(e)) {
					if (n) {
						o();
						return;
					}
					typeof h == "function" && !h(e) || (t.clear(), C.current = !0, k());
				}
			}
		}
		function re(e) {
			if (c() !== "sloppy" || !E.current || j(e)) return;
			let t = e.touches[0];
			if (!t) return;
			let n = Math.abs(t.clientX - E.current.startX), r = Math.abs(t.clientY - E.current.startY), i = Math.sqrt(n * n + r * r);
			i > 5 && (E.current.dismissOnTouchEnd = !0), i > 10 && (O(e), D.clear(), E.current = null);
		}
		function ie(e) {
			te(e, re);
		}
		function I(e) {
			c() !== "sloppy" || !E.current || j(e) || (E.current.dismissOnTouchEnd && O(e), D.clear(), E.current = null);
		}
		function L(e) {
			te(e, I);
		}
		let R = H(d), ae = Rn(r && Rn(Ln(R, "keydown", N), Ln(R, "compositionstart", i), Ln(R, "compositionend", a)), g && Rn(Ln(R, "click", F, !0), Ln(R, "pointerdown", F, !0), Ln(R, "pointerup", ne, !0), Ln(R, "pointercancel", ne, !0), Ln(R, "mousedown", F, !0), Ln(R, "mouseup", ne, !0), Ln(R, "touchstart", P, !0), Ln(R, "touchmove", ie, !0), Ln(R, "touchend", L, !0)));
		return () => {
			ae(), e.clear(), t.clear(), s(), C.current = !1, k();
		};
	}, [
		f,
		d,
		r,
		g,
		h,
		u,
		n,
		y,
		b,
		N,
		k,
		v,
		A,
		j,
		p,
		l,
		D
	]);
	let F = _.useMemo(() => ({
		onKeyDown: N,
		onPointerDown: M,
		onClick: M
	}), [N, M]), ne = _.useMemo(() => ({
		onKeyDown: N,
		onPointerDown: P,
		onMouseDown: P,
		onClickCapture: ee,
		onMouseDownCapture(e) {
			ee(), te(e);
		},
		onPointerDownCapture(e) {
			ee(), te(e);
		},
		onMouseUpCapture: ee,
		onTouchEndCapture: ee,
		onTouchMoveCapture: ee
	}), [
		N,
		ee,
		te,
		P
	]);
	return _.useMemo(() => n ? {
		reference: F,
		floating: ne,
		trigger: F
	} : {}, [
		n,
		F,
		ne
	]);
}
//#endregion
//#region node_modules/use-sync-external-store/cjs/use-sync-external-store-shim.production.js
var di = /* @__PURE__ */ o(((e) => {
	var t = f();
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, o = t.useLayoutEffect, s = t.useDebugValue;
	function c(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), c = r[0].inst, u = r[1];
		return o(function() {
			c.value = n, c.getSnapshot = t, l(c) && u({ inst: c });
		}, [
			e,
			n,
			t
		]), a(function() {
			return l(c) && u({ inst: c }), e(function() {
				l(c) && u({ inst: c });
			});
		}, [e]), s(n), n;
	}
	function l(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function u(e, t) {
		return t();
	}
	var d = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? u : c;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? d : t.useSyncExternalStore;
})), fi = /* @__PURE__ */ o(((e, t) => {
	t.exports = di();
})), pi = /* @__PURE__ */ o(((e) => {
	var t = f(), n = fi();
	function r(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var i = typeof Object.is == "function" ? Object.is : r, a = n.useSyncExternalStore, o = t.useRef, s = t.useEffect, c = t.useMemo, l = t.useDebugValue;
	e.useSyncExternalStoreWithSelector = function(e, t, n, r, u) {
		var d = o(null);
		if (d.current === null) {
			var f = {
				hasValue: !1,
				value: null
			};
			d.current = f;
		} else f = d.current;
		d = c(function() {
			function e(e) {
				if (!a) {
					if (a = !0, o = e, e = r(e), u !== void 0 && f.hasValue) {
						var t = f.value;
						if (u(t, e)) return s = t;
					}
					return s = e;
				}
				if (t = s, i(o, e)) return t;
				var n = r(e);
				return u !== void 0 && u(t, n) ? (o = e, t) : (o = e, s = n);
			}
			var a = !1, o, s, c = n === void 0 ? null : n;
			return [function() {
				return e(t());
			}, c === null ? void 0 : function() {
				return e(c());
			}];
		}, [
			t,
			n,
			r,
			u
		]);
		var p = a(e, d[0], d[1]);
		return s(function() {
			f.hasValue = !0, f.value = p;
		}, [p]), l(p), p;
	};
})), mi = /* @__PURE__ */ o(((e, t) => {
	t.exports = pi();
})), hi = [], gi = void 0;
function _i() {
	return gi;
}
function vi(e) {
	hi.push(e);
}
//#endregion
//#region node_modules/@base-ui/utils/store/useStore.mjs
var yi = fi(), bi = mi(), xi = ke(19) ? wi : Ti;
function Si(e, t, n, r, i) {
	return xi(e, t, n, r, i);
}
function Ci(e, t, n, r, i) {
	let a = _.useCallback(() => t(e.getSnapshot(), n, r, i), [
		e,
		t,
		n,
		r,
		i
	]);
	return (0, yi.useSyncExternalStore)(e.subscribe, a, a);
}
vi({
	before(e) {
		e.syncIndex = 0, e.didInitialize || (e.syncTick = 1, e.syncHooks = [], e.didChangeStore = !0, e.getSnapshot = () => {
			let t = !1;
			for (let n = 0; n < e.syncHooks.length; n += 1) {
				let r = e.syncHooks[n], i = r.selector(r.store.state, r.a1, r.a2, r.a3);
				Object.is(r.value, i) || (t = !0, r.value = i);
			}
			return t && (e.syncTick += 1), e.syncTick;
		});
	},
	after(e) {
		e.syncHooks.length > 0 && (e.didChangeStore && (e.didChangeStore = !1, e.subscribe = (t) => {
			let n = /* @__PURE__ */ new Set();
			for (let t of e.syncHooks) n.add(t.store);
			let r = [];
			for (let e of n) r.push(e.subscribe(t));
			return () => {
				for (let e of r) e();
			};
		}), (0, yi.useSyncExternalStore)(e.subscribe, e.getSnapshot, e.getSnapshot));
	}
});
function wi(e, t, n, r, i) {
	let a = _i();
	if (!a) return Ci(e, t, n, r, i);
	let o = a.syncIndex;
	a.syncIndex += 1;
	let s;
	return a.didInitialize ? (s = a.syncHooks[o], (s.store !== e || s.selector !== t || !Object.is(s.a1, n) || !Object.is(s.a2, r) || !Object.is(s.a3, i)) && (s.store !== e && (a.didChangeStore = !0), s.store = e, s.selector = t, s.a1 = n, s.a2 = r, s.a3 = i, s.value = t(e.getSnapshot(), n, r, i))) : (s = {
		store: e,
		selector: t,
		a1: n,
		a2: r,
		a3: i,
		value: t(e.getSnapshot(), n, r, i)
	}, a.syncHooks.push(s)), s.value;
}
function Ti(e, t, n, r, i) {
	return (0, bi.useSyncExternalStoreWithSelector)(e.subscribe, e.getSnapshot, e.getSnapshot, (e) => t(e, n, r, i));
}
//#endregion
//#region node_modules/@base-ui/utils/store/Store.mjs
var Ei = class {
	constructor(e) {
		this.state = e, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
	}
	subscribe = (e) => (this.listeners.add(e), () => {
		this.listeners.delete(e);
	});
	getSnapshot = () => this.state;
	setState(e) {
		if (this.state === e) return;
		this.state = e, this.updateTick += 1;
		let t = this.updateTick;
		for (let n of this.listeners) {
			if (t !== this.updateTick) return;
			n(e);
		}
	}
	update(e) {
		for (let t in e) if (!Object.is(this.state[t], e[t])) {
			this.setState({
				...this.state,
				...e
			});
			return;
		}
	}
	set(e, t) {
		Object.is(this.state[e], t) || this.setState({
			...this.state,
			[e]: t
		});
	}
	notifyAll() {
		let e = { ...this.state };
		this.setState(e);
	}
	use(e, t, n, r) {
		return Si(this, e, t, n, r);
	}
}, Di = class extends Ei {
	constructor(e, t = {}, n) {
		super(e), this.context = t, this.selectors = n;
	}
	useSyncedValue(e, t) {
		_.useDebugValue(e);
		let n = this;
		V(() => {
			n.state[e] !== t && n.set(e, t);
		}, [
			n,
			e,
			t
		]);
	}
	useSyncedValueWithCleanup(e, t) {
		let n = this;
		V(() => (n.state[e] !== t && n.set(e, t), () => {
			n.set(e, void 0);
		}), [
			n,
			e,
			t
		]);
	}
	useSyncedValues(e) {
		let t = this;
		V(() => {
			t.update(e);
		}, [t, ...Object.values(e)]);
	}
	useControlledProp(e, t) {
		_.useDebugValue(e);
		let n = this, r = t !== void 0;
		V(() => {
			r && !Object.is(n.state[e], t) && n.setState({
				...n.state,
				[e]: t
			});
		}, [
			n,
			e,
			t,
			r
		]);
	}
	select(e, t, n, r) {
		let i = this.selectors[e];
		return i(this.state, t, n, r);
	}
	useState(e, t, n, r) {
		return _.useDebugValue(e), Si(this, this.selectors[e], t, n, r);
	}
	useContextCallback(e, t) {
		_.useDebugValue(e);
		let n = B(t ?? Me);
		this.context[e] = n;
	}
	useStateSetter(e) {
		let t = _.useRef(void 0);
		return t.current === void 0 && (t.current = (t) => {
			this.set(e, t);
		}), t.current;
	}
	observe(e, t) {
		let n;
		n = typeof e == "function" ? e : this.selectors[e];
		let r = n(this.state);
		return t(r, r, this), this.subscribe((e) => {
			let i = n(e);
			if (!Object.is(r, i)) {
				let e = r;
				r = i, t(i, e, this);
			}
		});
	}
}, Oi = {
	open: (e) => e.open,
	transitionStatus: (e) => e.transitionStatus,
	domReferenceElement: (e) => e.domReferenceElement,
	referenceElement: (e) => e.positionReference ?? e.referenceElement,
	floatingElement: (e) => e.floatingElement,
	floatingId: (e) => e.floatingId
}, G = class extends Di {
	constructor(e) {
		let { syncOnly: t, nested: n, onOpenChange: r, triggerElements: i, ...a } = e;
		super({
			...a,
			positionReference: a.referenceElement,
			domReferenceElement: a.referenceElement
		}, {
			onOpenChange: r,
			dataRef: { current: {} },
			events: qr(),
			nested: n,
			triggerElements: i
		}, Oi), this.syncOnly = t;
	}
	syncOpenEvent = (e, t) => {
		(!e || !this.state.open || t != null && En(t)) && (this.context.dataRef.current.openEvent = e ? t : void 0);
	};
	dispatchOpenChange = (e, t) => {
		this.syncOpenEvent(e, t.event);
		let n = {
			open: e,
			reason: t.reason,
			nativeEvent: t.event,
			nested: this.context.nested,
			triggerElement: t.trigger
		};
		this.context.events.emit("openchange", n);
	};
	setOpen = (e, t) => {
		if (this.syncOnly) {
			this.context.onOpenChange?.(e, t);
			return;
		}
		this.dispatchOpenChange(e, t), this.context.onOpenChange?.(e, t);
	};
};
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/hooks/useSyncedFloatingRootContext.mjs
function ki(e) {
	let { popupStore: t, treatPopupAsFloatingElement: n = !1, floatingRootContext: r, floatingId: i, nested: a, onOpenChange: o } = e, s = t.useState("open"), c = t.useState("activeTriggerElement"), l = t.useState(n ? "popupElement" : "positionerElement"), u = t.context.triggerElements, d = o, f = _.useRef(null);
	r === void 0 && f.current === null && (f.current = new G({
		open: s,
		transitionStatus: void 0,
		referenceElement: c,
		floatingElement: l,
		triggerElements: u,
		onOpenChange: d,
		floatingId: i,
		syncOnly: !0,
		nested: a
	}));
	let p = r ?? f.current;
	return t.useSyncedValue("floatingId", i), V(() => {
		let e = {
			open: s,
			floatingId: i,
			referenceElement: c,
			floatingElement: l
		};
		bt(c) && (e.domReferenceElement = c), p.state.positionReference === p.state.referenceElement && (e.positionReference = c), p.update(e);
	}, [
		s,
		i,
		c,
		l,
		p
	]), p.context.onOpenChange = d, p.context.nested = a, p;
}
//#endregion
//#region node_modules/@base-ui/react/internals/useTransitionStatus.mjs
function Ai(e, t = !1, n = !1) {
	let [r, i] = _.useState(e && t ? "idle" : void 0), [a, o] = _.useState(e);
	return e && !a && (o(!0), i("starting")), !e && a && r !== "ending" && !n && i("ending"), !e && !a && r === "ending" && i(void 0), V(() => {
		if (!e && a && r !== "ending" && n) {
			let e = Un.request(() => {
				i("ending");
			});
			return () => {
				Un.cancel(e);
			};
		}
	}, [
		e,
		a,
		r,
		n
	]), V(() => {
		if (!e || t) return;
		let n = Un.request(() => {
			i(void 0);
		});
		return () => {
			Un.cancel(n);
		};
	}, [t, e]), V(() => {
		if (!e || !t) return;
		e && a && r !== "idle" && i("starting");
		let n = Un.request(() => {
			i("idle");
		});
		return () => {
			Un.cancel(n);
		};
	}, [
		t,
		e,
		a,
		r
	]), {
		mounted: a,
		setMounted: o,
		transitionStatus: r
	};
}
//#endregion
//#region node_modules/@base-ui/react/internals/useAnimationsFinished.mjs
function ji(e, t = !1) {
	let n = Wn();
	return B((r, i = null) => {
		n.cancel();
		let a = Qr(e);
		if (a == null) return;
		let o = a, s = () => {
			Vr.flushSync(r);
		};
		if (typeof o.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
			r();
			return;
		}
		function c() {
			Promise.all(o.getAnimations().map((e) => e.finished)).then(() => {
				i?.aborted || s();
			}, () => {
				if (!i?.aborted) {
					if (o.getAnimations().some((e) => e.pending || e.playState !== "finished")) {
						c();
						return;
					}
					s();
				}
			});
		}
		if (t) {
			let e = "data-starting-style";
			if (!o.hasAttribute(e)) {
				n.request(c);
				return;
			}
			let t = new MutationObserver(() => {
				o.hasAttribute(e) || (t.disconnect(), c());
			});
			t.observe(o, {
				attributes: !0,
				attributeFilter: [e]
			}), i?.addEventListener("abort", () => t.disconnect(), { once: !0 });
			return;
		}
		n.request(c);
	});
}
//#endregion
//#region node_modules/@base-ui/react/internals/useOpenChangeComplete.mjs
function Mi(e) {
	let { enabled: t = !0, open: n, ref: r, onComplete: i } = e, a = B(i), o = ji(r, n);
	_.useEffect(() => {
		if (!t) return;
		let e = new AbortController();
		return o(a, e.signal), () => {
			e.abort();
		};
	}, [
		t,
		n,
		a,
		o
	]);
}
//#endregion
//#region node_modules/@base-ui/react/utils/popups/popupStoreUtils.mjs
var Ni = {
	tabIndex: -1,
	[Dn]: ""
};
function Pi(e) {
	return (t) => t === "touch" ? e.current : !0;
}
function Fi(e, t = !1) {
	let n = en(), r = Xr() != null, i = xe(() => e(n, r)).current;
	return ki({
		popupStore: i,
		treatPopupAsFloatingElement: t,
		floatingRootContext: i.state.floatingRootContext,
		floatingId: n,
		nested: r,
		onOpenChange: i.setOpen
	}), i;
}
function Ii({ handle: e, store: t }) {
	return V(() => e.attachStore(t), [e, t]), null;
}
function Li(e, t, n, r = !1) {
	t ? e.preventUnmountingOnClose = !1 : r && (e.preventUnmountingOnClose = !0);
	let i = n?.id ?? null;
	(i || t) && (e.activeTriggerId = i, e.activeTriggerElement = n ?? null);
}
function Ri(e, t = {}) {
	let { closeOnActiveTriggerUnmount: n = !1 } = t, r = _.useRef(null), i = e.useState("open");
	V(() => {
		if (!i) {
			r.current = null, e.state.triggerCount !== 0 && e.set("triggerCount", 0);
			return;
		}
		let t = e.context.triggerElements.size, a = {};
		e.state.triggerCount !== t && (a.triggerCount = t);
		let o = e.select("activeTriggerId"), s = null;
		if (o) {
			let t = e.context.triggerElements.getById(o);
			if (t) r.current = o, t !== e.state.activeTriggerElement && (a.activeTriggerElement = t);
			else {
				for (let [t, n] of e.context.triggerElements.entries()) if (n === e.state.activeTriggerElement) {
					a.activeTriggerId = t, a.activeTriggerElement = n, r.current = t;
					break;
				}
				a.activeTriggerId === void 0 && (r.current === o ? s = o : r.current = null);
			}
		} else r.current = null;
		if (!s && !o && t === 1) {
			let t = e.context.triggerElements.entries().next();
			if (!t.done) {
				let [e, n] = t.value;
				a.activeTriggerId = e, a.activeTriggerElement = n, r.current = e;
			}
		}
		(a.triggerCount !== void 0 || a.activeTriggerId !== void 0 || a.activeTriggerElement !== void 0) && e.update(a), s && n && queueMicrotask(() => {
			if (e.select("open") && e.select("activeTriggerId") === s && !e.context.triggerElements.getById(s)) {
				let t = Yt(zt);
				e.setOpen(!1, t), t.isCanceled || e.update({
					activeTriggerId: null,
					activeTriggerElement: null
				});
			}
		});
	}, [
		i,
		e,
		e.useState("triggerCount"),
		e.useState("activeTriggerId"),
		e.useState("activeTriggerElement"),
		n
	]);
}
function zi(e, t, n) {
	let { mounted: r, setMounted: i, transitionStatus: a } = Ai(e), o = t.useState("preventUnmountingOnClose"), s = e ? !1 : o;
	t.useSyncedValues({
		mounted: r,
		transitionStatus: a,
		preventUnmountingOnClose: s
	});
	let c = B(() => {
		i(!1), t.update({
			activeTriggerId: null,
			activeTriggerElement: null,
			mounted: !1,
			preventUnmountingOnClose: !1
		}), n?.(), t.context.onOpenChangeComplete?.(!1);
	});
	return Mi({
		enabled: r && !e && !s,
		open: e,
		ref: t.context.popupRef,
		onComplete() {
			e || c();
		}
	}), {
		forceUnmount: c,
		transitionStatus: a
	};
}
function Bi(e, t) {
	e.useSyncedValues(t), V(() => () => {
		e.update({
			activeTriggerProps: Pe,
			inactiveTriggerProps: Pe,
			popupProps: Pe
		});
	}, [e]);
}
function Vi(e, t) {
	V(() => {
		!t && e.state.openMethod !== null && e.set("openMethod", null);
	}, [t, e]), V(() => () => {
		e.state.openMethod !== null && e.set("openMethod", null);
	}, [e]);
}
//#endregion
//#region node_modules/@base-ui/react/utils/popups/popupTriggerMap.mjs
var Hi = class {
	constructor() {
		this.idMap = /* @__PURE__ */ new Map();
	}
	add(e, t) {
		this.idMap.set(e, t);
	}
	delete(e) {
		this.idMap.delete(e);
	}
	hasElement(e) {
		for (let t of this.idMap.values()) if (t === e) return !0;
		return !1;
	}
	hasMatchingElement(e) {
		for (let t of this.idMap.values()) if (e(t)) return !0;
		return !1;
	}
	getById(e) {
		return this.idMap.get(e);
	}
	entries() {
		return this.idMap.entries();
	}
	elements() {
		return this.idMap.values();
	}
	get size() {
		return this.idMap.size;
	}
};
//#endregion
//#region node_modules/@base-ui/react/floating-ui-react/utils/getEmptyRootContext.mjs
function Ui() {
	return new G({
		open: !1,
		transitionStatus: void 0,
		floatingElement: null,
		referenceElement: null,
		triggerElements: new Hi(),
		floatingId: void 0,
		syncOnly: !1,
		nested: !1,
		onOpenChange: void 0
	});
}
//#endregion
//#region node_modules/@base-ui/react/utils/popups/store.mjs
function Wi() {
	return {
		open: !1,
		openProp: void 0,
		mounted: !1,
		transitionStatus: void 0,
		floatingRootContext: Ui(),
		floatingId: void 0,
		triggerCount: 0,
		preventUnmountingOnClose: !1,
		payload: void 0,
		activeTriggerId: null,
		activeTriggerElement: null,
		triggerIdProp: void 0,
		popupElement: null,
		positionerElement: null,
		activeTriggerProps: Pe,
		inactiveTriggerProps: Pe,
		popupProps: Pe
	};
}
function Gi(e, t, n = !1) {
	return new G({
		open: !1,
		transitionStatus: void 0,
		floatingElement: null,
		referenceElement: null,
		triggerElements: e,
		floatingId: t,
		syncOnly: !0,
		nested: n,
		onOpenChange: void 0
	});
}
var Ki = (e) => e.triggerIdProp ?? e.activeTriggerId, qi = (e) => e.openProp ?? e.open, Ji = (e) => (e.popupElement?.id ?? e.floatingId) || void 0;
function Yi(e, t) {
	return t !== void 0 && qi(e) && Ki(e) === t;
}
function Xi(e, t) {
	return Yi(e, t) ? !0 : t !== void 0 && qi(e) && Ki(e) == null && e.triggerCount === 1;
}
var Zi = {
	open: qi,
	mounted: (e) => e.mounted,
	transitionStatus: (e) => e.transitionStatus,
	floatingRootContext: (e) => e.floatingRootContext,
	triggerCount: (e) => e.triggerCount,
	preventUnmountingOnClose: (e) => e.preventUnmountingOnClose,
	payload: (e) => e.payload,
	activeTriggerId: Ki,
	activeTriggerElement: (e) => e.mounted ? e.activeTriggerElement : null,
	popupId: Ji,
	isTriggerActive: (e, t) => t !== void 0 && Ki(e) === t,
	isOpenedByTrigger: (e, t) => Yi(e, t),
	isMountedByTrigger: (e, t) => t !== void 0 && Ki(e) === t && e.mounted,
	triggerProps: (e, t) => t ? e.activeTriggerProps : e.inactiveTriggerProps,
	triggerPopupId: (e, t) => Xi(e, t) ? Ji(e) : void 0,
	popupProps: (e) => e.popupProps,
	popupElement: (e) => e.popupElement,
	positionerElement: (e) => e.positionerElement
}, Qi = /* @__PURE__ */ _.createContext(void 0);
function $i() {
	let e = _.useContext(Qi);
	if (e === void 0) throw Error(_e(26));
	return e;
}
//#endregion
//#region node_modules/@base-ui/react/internals/composite/composite.mjs
var ea = "ArrowUp", ta = "ArrowDown", na = "ArrowLeft", ra = "ArrowRight", ia = new Set([
	ea,
	ta,
	na,
	ra,
	"Home",
	"End"
]), aa = [
	"Shift",
	"Control",
	"Alt",
	"Meta"
];
function oa(e) {
	return xt(e) && e.tagName === "INPUT";
}
function sa(e) {
	return !!(oa(e) && e.selectionStart != null || xt(e) && e.tagName === "TEXTAREA");
}
function ca(e, t, n, r) {
	if (!e || !t || !t.scrollTo) return;
	let i = e.scrollLeft, a = e.scrollTop, o = e.clientWidth < e.scrollWidth, s = e.clientHeight < e.scrollHeight;
	if (o && r !== "vertical") {
		let r = la(e, t, "left"), a = ua(e), o = ua(t);
		n === "ltr" && (r + t.offsetWidth + o.scrollMarginRight > e.scrollLeft + e.clientWidth - a.scrollPaddingRight ? i = r + t.offsetWidth + o.scrollMarginRight - e.clientWidth + a.scrollPaddingRight : r - o.scrollMarginLeft < e.scrollLeft + a.scrollPaddingLeft && (i = r - o.scrollMarginLeft - a.scrollPaddingLeft)), n === "rtl" && (r - o.scrollMarginLeft < e.scrollLeft + a.scrollPaddingLeft ? i = r - o.scrollMarginLeft - a.scrollPaddingLeft : r + t.offsetWidth + o.scrollMarginRight > e.scrollLeft + e.clientWidth - a.scrollPaddingRight && (i = r + t.offsetWidth + o.scrollMarginRight - e.clientWidth + a.scrollPaddingRight));
	}
	if (s && r !== "horizontal") {
		let n = la(e, t, "top"), r = ua(e), i = ua(t);
		n - i.scrollMarginTop < e.scrollTop + r.scrollPaddingTop ? a = n - i.scrollMarginTop - r.scrollPaddingTop : n + t.offsetHeight + i.scrollMarginBottom > e.scrollTop + e.clientHeight - r.scrollPaddingBottom && (a = n + t.offsetHeight + i.scrollMarginBottom - e.clientHeight + r.scrollPaddingBottom);
	}
	e.scrollTo({
		left: i,
		top: a,
		behavior: "auto"
	});
}
function la(e, t, n) {
	let r = n === "left" ? "offsetLeft" : "offsetTop", i = 0;
	for (; t.offsetParent && (i += t[r], t.offsetParent !== e);) t = t.offsetParent;
	return i;
}
function ua(e) {
	let t = getComputedStyle(e);
	return {
		scrollMarginTop: parseFloat(t.scrollMarginTop) || 0,
		scrollMarginRight: parseFloat(t.scrollMarginRight) || 0,
		scrollMarginBottom: parseFloat(t.scrollMarginBottom) || 0,
		scrollMarginLeft: parseFloat(t.scrollMarginLeft) || 0,
		scrollPaddingTop: parseFloat(t.scrollPaddingTop) || 0,
		scrollPaddingRight: parseFloat(t.scrollPaddingRight) || 0,
		scrollPaddingBottom: parseFloat(t.scrollPaddingBottom) || 0,
		scrollPaddingLeft: parseFloat(t.scrollPaddingLeft) || 0
	};
}
//#endregion
//#region node_modules/@base-ui/react/dialog/utils/stateAttributesMapping.mjs
var da = {
	...ft,
	...ct,
	nestedDialogOpen(e) {
		return e ? { "data-nested-dialog-open": "" } : null;
	}
}, fa = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { render: n, className: r, style: i, finalFocus: a, initialFocus: o, ...s } = e, c = ye(), l = c.useState("descriptionElementId"), u = c.useState("disablePointerDismissal"), d = c.useState("floatingRootContext"), f = c.useState("popupProps"), p = c.useState("modal"), m = c.useState("mounted"), h = c.useState("nested"), g = c.useState("nestedOpenDialogCount"), _ = c.useState("open"), v = c.useState("openMethod"), y = c.useState("titleElementId"), b = c.useState("transitionStatus"), x = c.useState("role"), S = d.useState("floatingId");
	$i(), Mi({
		open: _,
		ref: c.context.popupRef,
		onComplete() {
			_ && c.context.onOpenChangeComplete?.(!0);
		}
	});
	let C = o === void 0 ? Pi(c.context.popupRef) : o, w = g > 0, T = c.useStateSetter("popupElement"), E = $e("div", e, {
		state: {
			open: _,
			nested: h,
			transitionStatus: b,
			nestedDialogOpen: w
		},
		props: [
			f,
			{
				id: S,
				"aria-labelledby": y,
				"aria-describedby": l,
				role: x,
				...Ni,
				hidden: !m,
				onKeyDown(e) {
					ia.has(e.key) && e.stopPropagation();
				},
				style: { "--nested-dialogs": g }
			},
			s
		],
		ref: [
			t,
			c.context.popupRef,
			T
		],
		stateAttributesMapping: da
	});
	return /* @__PURE__ */ (0, W.jsx)(si, {
		context: d,
		openInteractionType: v,
		disabled: !m,
		closeOnFocusOut: !u,
		initialFocus: C,
		returnFocus: a,
		modal: p !== !1,
		restoreFocus: "popup",
		children: E
	});
});
//#endregion
//#region node_modules/@base-ui/utils/inertValue.mjs
function pa(e) {
	return ke(19) ? e : e ? "true" : void 0;
}
//#endregion
//#region node_modules/@base-ui/react/utils/InternalBackdrop.mjs
var ma = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { cutout: n, ...r } = e, i;
	if (n) {
		let e = n.getBoundingClientRect();
		i = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${e.left}px ${e.top}px,${e.left}px ${e.bottom}px,${e.right}px ${e.bottom}px,${e.right}px ${e.top}px,${e.left}px ${e.top}px)`;
	}
	return /* @__PURE__ */ (0, W.jsx)("div", {
		ref: t,
		role: "presentation",
		"data-base-ui-inert": "",
		...r,
		style: {
			position: "fixed",
			inset: 0,
			userSelect: "none",
			WebkitUserSelect: "none",
			clipPath: i
		}
	});
}), ha = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { keepMounted: n = !1, ...r } = e, i = ye(), a = i.useState("mounted"), o = i.useState("modal"), s = i.useState("open");
	return a || n ? /* @__PURE__ */ (0, W.jsx)(Qi.Provider, {
		value: n,
		children: /* @__PURE__ */ (0, W.jsxs)(Kr, {
			ref: t,
			...r,
			children: [a && o === !0 && /* @__PURE__ */ (0, W.jsx)(ma, {
				ref: i.context.internalBackdropRef,
				inert: pa(!s)
			}), e.children]
		})
	}) : null;
}), ga = {}, _a = {}, va = "";
function ya(e, t) {
	return Ct(e) ? e : t;
}
function ba(e, t, n) {
	return /hidden|clip/.test(e.getComputedStyle(ya(t, n)).overflowY);
}
function xa(e) {
	if (typeof document > "u") return !1;
	let t = H(e);
	return _t(t).innerWidth - t.documentElement.clientWidth > 0;
}
function Sa(e) {
	if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u") return !1;
	let t = H(e), n = t.documentElement, r = t.body, i = ya(n, r), a = i.style.overflowY, o = n.style.scrollbarGutter;
	n.style.scrollbarGutter = "stable", i.style.overflowY = "scroll";
	let s = i.offsetWidth;
	i.style.overflowY = "hidden";
	let c = i.offsetWidth;
	return i.style.overflowY = a, n.style.scrollbarGutter = o, s === c;
}
function Ca(e) {
	let t = H(e), n = t.documentElement, r = t.body, i = ya(n, r), a = {
		overflowY: i.style.overflowY,
		overflowX: i.style.overflowX
	};
	return Object.assign(i.style, {
		overflowY: "hidden",
		overflowX: "hidden"
	}), () => {
		Object.assign(i.style, a);
	};
}
function wa(e) {
	let t = H(e), n = t.documentElement, r = t.body, i = _t(n), a = 0, o = 0, s = !1, c = Un.create();
	if (yn && (i.visualViewport?.scale ?? 1) !== 1) return () => {};
	function l() {
		let t = i.getComputedStyle(n), c = i.getComputedStyle(r), l = (t.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
		a = n.scrollTop, o = n.scrollLeft, ga = {
			scrollbarGutter: n.style.scrollbarGutter,
			overflowY: n.style.overflowY,
			overflowX: n.style.overflowX
		}, va = n.style.scrollBehavior, _a = {
			position: r.style.position,
			height: r.style.height,
			width: r.style.width,
			boxSizing: r.style.boxSizing,
			overflowY: r.style.overflowY,
			overflowX: r.style.overflowX,
			scrollBehavior: r.style.scrollBehavior
		};
		let u = n.scrollHeight > n.clientHeight, d = n.scrollWidth > n.clientWidth, f = t.overflowY === "scroll" || c.overflowY === "scroll", p = t.overflowX === "scroll" || c.overflowX === "scroll", m = Math.max(0, i.innerWidth - r.clientWidth), h = Math.max(0, i.innerHeight - r.clientHeight), g = parseFloat(c.marginTop) + parseFloat(c.marginBottom), _ = parseFloat(c.marginLeft) + parseFloat(c.marginRight), v = ya(n, r);
		if (s = Sa(e), s) {
			n.style.scrollbarGutter = l, v.style.overflowY = "hidden", v.style.overflowX = "hidden";
			return;
		}
		Object.assign(n.style, {
			scrollbarGutter: l,
			overflowY: "hidden",
			overflowX: "hidden"
		}), (u || f) && (n.style.overflowY = "scroll"), (d || p) && (n.style.overflowX = "scroll"), Object.assign(r.style, {
			position: "relative",
			height: g || h ? `calc(100dvh - ${g + h}px)` : "100dvh",
			width: _ || m ? `calc(100vw - ${_ + m}px)` : "100vw",
			boxSizing: "border-box",
			overflowY: "hidden",
			overflowX: "hidden",
			scrollBehavior: "unset"
		}), r.scrollTop = a, r.scrollLeft = o, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
	}
	function u() {
		Object.assign(n.style, ga), Object.assign(r.style, _a), s || (n.scrollTop = a, n.scrollLeft = o, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = va);
	}
	function d() {
		u(), c.request(l);
	}
	l();
	let f = Ln(i, "resize", d);
	return () => {
		c.cancel(), u(), typeof i.removeEventListener == "function" && f();
	};
}
var Ta = new class {
	lockCount = 0;
	restore = null;
	timeoutLock = on.create();
	timeoutUnlock = on.create();
	acquire(e) {
		return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(e)), this.release;
	}
	release = () => {
		--this.lockCount, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
	};
	unlock = () => {
		this.lockCount === 0 && this.restore && (this.restore?.(), this.restore = null);
	};
	lock(e) {
		if (this.lockCount === 0 || this.restore !== null) return;
		let t = H(e), n = t.documentElement, r = t.body, i = _t(n);
		if (ba(i, n, r)) {
			let t = new i.MutationObserver(() => {
				ba(i, n, r) || (t.disconnect(), this.restore = null, this.lock(e));
			}), a = { attributes: !0 };
			t.observe(n, a), t.observe(r, a), this.restore = () => t.disconnect();
			return;
		}
		let a = mn || !xa(e);
		this.restore = a ? Ca(e) : wa(e);
	}
}();
function Ea(e = !0, t = null) {
	V(() => {
		if (e) return Ta.acquire(t);
	}, [e, t]);
}
//#endregion
//#region node_modules/@base-ui/react/dialog/root/useDialogRoot.mjs
function Da({ store: e, parentContext: t, isDrawer: n }) {
	let r = e.useState("open"), i = e.useState("disablePointerDismissal"), a = e.useState("modal"), o = e.useState("popupElement"), s = e.useState("floatingRootContext"), [c, l] = _.useState(0), [u, d] = _.useState(0), f = c === 0, p = ui(s, {
		outsidePressEvent() {
			return e.context.internalBackdropRef.current || e.context.backdropRef.current ? "intentional" : {
				mouse: a === "trap-focus" ? "sloppy" : "intentional",
				touch: "sloppy"
			};
		},
		outsidePress(t) {
			if (!e.context.outsidePressEnabledRef.current || "button" in t && t.button !== 0) return !1;
			if ("touches" in t) {
				if (t.type === "touchend") {
					if (t.changedTouches.length !== 1 || t.touches.length !== 0) return !1;
				} else if (t.touches.length !== 1) return !1;
			}
			let n = kn(t);
			if (f && !i) {
				if (a) {
					let t = e.context.internalBackdropRef.current, r = e.context.backdropRef.current;
					return t || r ? t === n || r === n || U(n, o) && !n?.hasAttribute("data-base-ui-portal") : !0;
				}
				return !0;
			}
			return !1;
		},
		escapeKey: f
	});
	return Ea(r && a === !0, o), e.useContextCallback("onNestedDialogOpen", (e, t) => {
		l(e), d(t);
	}), V(() => (t?.onNestedDialogOpen && (r ? t.onNestedDialogOpen(c + 1, u + +!!n) : t.onNestedDialogOpen(0, 0)), () => {
		t?.onNestedDialogOpen && r && t.onNestedDialogOpen(0, 0);
	}), [
		n,
		r,
		c,
		u,
		t
	]), Bi(e, {
		activeTriggerProps: p.reference,
		inactiveTriggerProps: p.trigger,
		popupProps: p.floating,
		nestedOpenDialogCount: c,
		nestedOpenDrawerCount: u
	}), null;
}
//#endregion
//#region node_modules/@base-ui/react/dialog/store/DialogStore.mjs
var Oa = {
	...Zi,
	modal: (e) => e.modal,
	nested: (e) => e.nested,
	nestedOpenDialogCount: (e) => e.nestedOpenDialogCount,
	nestedOpenDrawerCount: (e) => e.nestedOpenDrawerCount,
	disablePointerDismissal: (e) => e.disablePointerDismissal,
	openMethod: (e) => e.openMethod,
	descriptionElementId: (e) => e.descriptionElementId,
	titleElementId: (e) => e.titleElementId,
	viewportElement: (e) => e.viewportElement,
	role: (e) => e.role
}, ka = class extends Di {
	constructor(e, t, n) {
		let r = new Hi(), i = Aa(e, r, t, n);
		super(i, ja(r), Oa);
	}
	setOpen = (e, t) => {
		if (t.preventUnmountOnClose = () => {
			this.set("preventUnmountingOnClose", !0);
		}, !e && t.trigger == null && this.state.activeTriggerId != null && (t.trigger = this.state.activeTriggerElement ?? void 0), this.context.onOpenChange?.(e, t), t.isCanceled) return;
		this.state.floatingRootContext.dispatchOpenChange(e, t);
		let n = { open: e };
		Li(n, e, t.trigger), this.update(n);
	};
};
function Aa(e, t, n, r = !1) {
	let i = {
		...Wi(),
		modal: !0,
		disablePointerDismissal: !1,
		viewportElement: null,
		descriptionElementId: void 0,
		titleElementId: void 0,
		openMethod: null,
		nested: !1,
		nestedOpenDialogCount: 0,
		nestedOpenDrawerCount: 0,
		role: "dialog",
		...e
	};
	return i.floatingRootContext = Gi(t, n, r), i;
}
function ja(e) {
	return {
		popupRef: /* @__PURE__ */ _.createRef(),
		backdropRef: /* @__PURE__ */ _.createRef(),
		internalBackdropRef: /* @__PURE__ */ _.createRef(),
		outsidePressEnabledRef: { current: !0 },
		triggerElements: e,
		onOpenChange: void 0,
		onOpenChangeComplete: void 0
	};
}
//#endregion
//#region node_modules/@base-ui/react/dialog/root/useRenderDialogRoot.mjs
function Ma(e, t) {
	let { children: n, open: r, defaultOpen: i = !1, onOpenChange: a, onOpenChangeComplete: o, disablePointerDismissal: s = !1, modal: c = !0, actionsRef: l, handle: u, triggerId: d, defaultTriggerId: f = null } = t, p = e === "drawer", m = e === "alert-dialog", h = m ? !0 : c, g = m || s, v = m ? "alertdialog" : "dialog", y = ye(!0), b = {
		modal: h,
		disablePointerDismissal: g,
		nested: y != null,
		role: v
	}, x = Fi((e, t) => new ka({
		open: i,
		openProp: r,
		activeTriggerId: f,
		triggerIdProp: d,
		...b
	}, e, t), !0);
	x.useControlledProp("openProp", r), x.useControlledProp("triggerIdProp", d), x.useSyncedValues(b), x.useContextCallback("onOpenChange", a), x.useContextCallback("onOpenChangeComplete", o);
	let S = x.useState("open"), C = x.useState("mounted"), w = x.useState("payload");
	Vi(x, S), Ri(x);
	let { forceUnmount: T } = zi(S, x);
	_.useImperativeHandle(l, () => ({
		unmount: T,
		close: () => x.setOpen(!1, Yt(Jt))
	}), [T, x]);
	let E = S || C;
	return /* @__PURE__ */ (0, W.jsxs)(ve.Provider, {
		value: x,
		children: [
			u && /* @__PURE__ */ (0, W.jsx)(Ii, {
				handle: u,
				store: x
			}),
			E && /* @__PURE__ */ (0, W.jsx)(Da, {
				store: x,
				parentContext: y?.context,
				isDrawer: p
			}),
			typeof n == "function" ? n({ payload: w }) : n
		]
	});
}
//#endregion
//#region node_modules/@base-ui/react/dialog/root/DialogRoot.mjs
function Na(e) {
	return Ma("dialog", e);
}
//#endregion
//#region node_modules/@base-ui/react/dialog/title/DialogTitle.mjs
var Pa = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { render: n, className: r, style: i, id: a, ...o } = e, s = ye(), c = tn(a);
	return s.useSyncedValueWithCleanup("titleElementId", c), $e("h2", e, {
		ref: t,
		props: [{ id: c }, o]
	});
});
//#endregion
//#region node_modules/clsx/dist/clsx.mjs
function Fa(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = Fa(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function Ia() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Fa(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region node_modules/tailwind-merge/dist/bundle-mjs.mjs
var La = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, Ra = (e, t) => ({
	classGroupId: e,
	validator: t
}), za = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), Ba = "-", Va = [], Ha = "arbitrary..", Ua = (e) => {
	let t = Ka(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return Ga(e);
			let n = e.split(Ba);
			return Wa(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? La(i, t) : t : i || Va;
			}
			return n[e] || Va;
		}
	};
}, Wa = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = Wa(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(Ba) : e.slice(t).join(Ba), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, Ga = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? Ha + r : void 0;
})(), Ka = (e) => {
	let { theme: t, classGroups: n } = e;
	return qa(n, t);
}, qa = (e, t) => {
	let n = za();
	for (let r in e) {
		let i = e[r];
		Ja(i, n, r, t);
	}
	return n;
}, Ja = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		Ya(i, t, n, r);
	}
}, Ya = (e, t, n, r) => {
	if (typeof e == "string") {
		Xa(e, t, n);
		return;
	}
	if (typeof e == "function") {
		Za(e, t, n, r);
		return;
	}
	Qa(e, t, n, r);
}, Xa = (e, t, n) => {
	let r = e === "" ? t : $a(t, e);
	r.classGroupId = n;
}, Za = (e, t, n, r) => {
	if (eo(e)) {
		Ja(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(Ra(n, e));
}, Qa = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		Ja(o, $a(t, a), n, r);
	}
}, $a = (e, t) => {
	let n = e, r = t.split(Ba), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = za(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, eo = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, to = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, no = "!", ro = ":", io = [], ao = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), oo = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === ro) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(no) ? (c = s.slice(0, -1), l = !0) : s.startsWith(no) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return ao(t, l, c, u);
	};
	if (t) {
		let e = t + ro, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : ao(io, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, K = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, so = (e) => ({
	cache: to(e.cacheSize),
	parseClassName: oo(e),
	sortModifiers: K(e),
	postfixLookupClassGroupIds: co(e),
	...Ua(e)
}), co = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, lo = /\s+/, uo = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split(lo), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + no : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, fo = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = po(n)) && (i && (i += " "), i += r);
	return i;
}, po = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = po(e[r])) && (n && (n += " "), n += t);
	return n;
}, mo = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = so(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = uo(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(fo(...e));
}, ho = [], go = (e) => {
	let t = (t) => t[e] || ho;
	return t.isThemeGetter = !0, t;
}, _o = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, vo = /^\((?:(\w[\w-]*):)?(.+)\)$/i, yo = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, bo = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, xo = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, So = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Co = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, wo = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, To = (e) => yo.test(e), q = (e) => !!e && !Number.isNaN(Number(e)), Eo = (e) => !!e && Number.isInteger(Number(e)), Do = (e) => e.endsWith("%") && q(e.slice(0, -1)), Oo = (e) => bo.test(e), ko = () => !0, Ao = (e) => xo.test(e) && !So.test(e), jo = () => !1, Mo = (e) => Co.test(e), No = (e) => wo.test(e), Po = (e) => !J(e) && !Y(e), Fo = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), Io = (e) => Zo(e, ts, jo), J = (e) => _o.test(e), Lo = (e) => Zo(e, ns, Ao), Ro = (e) => Zo(e, rs, q), zo = (e) => Zo(e, as, ko), Bo = (e) => Zo(e, is, jo), Vo = (e) => Zo(e, $o, jo), Ho = (e) => Zo(e, es, No), Uo = (e) => Zo(e, os, Mo), Y = (e) => vo.test(e), Wo = (e) => Qo(e, ns), Go = (e) => Qo(e, is), Ko = (e) => Qo(e, $o), qo = (e) => Qo(e, ts), Jo = (e) => Qo(e, es), Yo = (e) => Qo(e, os, !0), Xo = (e) => Qo(e, as, !0), Zo = (e, t, n) => {
	let r = _o.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Qo = (e, t, n = !1) => {
	let r = vo.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, $o = (e) => e === "position" || e === "percentage", es = (e) => e === "image" || e === "url", ts = (e) => e === "length" || e === "size" || e === "bg-size", ns = (e) => e === "length", rs = (e) => e === "number", is = (e) => e === "family-name", as = (e) => e === "number" || e === "weight", os = (e) => e === "shadow", ss = /* @__PURE__ */ mo(() => {
	let e = go("color"), t = go("font"), n = go("text"), r = go("font-weight"), i = go("tracking"), a = go("leading"), o = go("breakpoint"), s = go("container"), c = go("spacing"), l = go("radius"), u = go("shadow"), d = go("inset-shadow"), f = go("text-shadow"), p = go("drop-shadow"), m = go("blur"), h = go("perspective"), g = go("aspect"), _ = go("ease"), v = go("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		Y,
		J
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		Y,
		J,
		c
	], T = () => [
		To,
		"full",
		"auto",
		...w()
	], E = () => [
		Eo,
		"none",
		"subgrid",
		Y,
		J
	], D = () => [
		"auto",
		{ span: [
			"full",
			Eo,
			Y,
			J
		] },
		Eo,
		Y,
		J
	], O = () => [
		Eo,
		"auto",
		Y,
		J
	], k = () => [
		"auto",
		"min",
		"max",
		"fr",
		Y,
		J
	], A = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], j = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], M = () => ["auto", ...w()], N = () => [
		To,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], ee = () => [
		To,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], te = () => [
		To,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], P = () => [
		e,
		Y,
		J
	], F = () => [
		...b(),
		Ko,
		Vo,
		{ position: [Y, J] }
	], ne = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], re = () => [
		"auto",
		"cover",
		"contain",
		qo,
		Io,
		{ size: [Y, J] }
	], ie = () => [
		Do,
		Wo,
		Lo
	], I = () => [
		"",
		"none",
		"full",
		l,
		Y,
		J
	], L = () => [
		"",
		q,
		Wo,
		Lo
	], R = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], ae = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], z = () => [
		q,
		Do,
		Ko,
		Vo
	], oe = () => [
		"",
		"none",
		m,
		Y,
		J
	], se = () => [
		"none",
		q,
		Y,
		J
	], ce = () => [
		"none",
		q,
		Y,
		J
	], le = () => [
		q,
		Y,
		J
	], ue = () => [
		To,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [Oo],
			breakpoint: [Oo],
			color: [ko],
			container: [Oo],
			"drop-shadow": [Oo],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [Po],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [Oo],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [Oo],
			shadow: [Oo],
			spacing: ["px", q],
			text: [Oo],
			"text-shadow": [Oo],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				To,
				J,
				Y,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				Y,
				J
			] }],
			"container-named": [Fo],
			columns: [{ columns: [
				q,
				J,
				Y,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				Eo,
				"auto",
				Y,
				J
			] }],
			basis: [{ basis: [
				To,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				q,
				To,
				"auto",
				"initial",
				"none",
				J
			] }],
			grow: [{ grow: [
				"",
				q,
				Y,
				J
			] }],
			shrink: [{ shrink: [
				"",
				q,
				Y,
				J
			] }],
			order: [{ order: [
				Eo,
				"first",
				"last",
				"none",
				Y,
				J
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: D() }],
			"col-start": [{ "col-start": O() }],
			"col-end": [{ "col-end": O() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: D() }],
			"row-start": [{ "row-start": O() }],
			"row-end": [{ "row-end": O() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": k() }],
			"auto-rows": [{ "auto-rows": k() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...A(), "normal"] }],
			"justify-items": [{ "justify-items": [...j(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...j()] }],
			"align-content": [{ content: ["normal", ...A()] }],
			"align-items": [{ items: [...j(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...j(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": A() }],
			"place-items": [{ "place-items": [...j(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...j()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: M() }],
			mx: [{ mx: M() }],
			my: [{ my: M() }],
			ms: [{ ms: M() }],
			me: [{ me: M() }],
			mbs: [{ mbs: M() }],
			mbe: [{ mbe: M() }],
			mt: [{ mt: M() }],
			mr: [{ mr: M() }],
			mb: [{ mb: M() }],
			ml: [{ ml: M() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: N() }],
			"inline-size": [{ inline: ["auto", ...ee()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...ee()] }],
			"max-inline-size": [{ "max-inline": ["none", ...ee()] }],
			"block-size": [{ block: ["auto", ...te()] }],
			"min-block-size": [{ "min-block": ["auto", ...te()] }],
			"max-block-size": [{ "max-block": ["none", ...te()] }],
			w: [{ w: [
				s,
				"screen",
				...N()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...N()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...N()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...N()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...N()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...N()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				Wo,
				Lo
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				Xo,
				zo
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				Do,
				J
			] }],
			"font-family": [{ font: [
				Go,
				Bo,
				t
			] }],
			"font-features": [{ "font-features": [J] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				Y,
				J
			] }],
			"line-clamp": [{ "line-clamp": [
				q,
				"none",
				Y,
				Ro
			] }],
			leading: [{ leading: [a, ...w()] }],
			"list-image": [{ "list-image": [
				"none",
				Y,
				J
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				Y,
				J
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: P() }],
			"text-color": [{ text: P() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...R(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				q,
				"from-font",
				"auto",
				Y,
				Lo
			] }],
			"text-decoration-color": [{ decoration: P() }],
			"underline-offset": [{ "underline-offset": [
				q,
				"auto",
				Y,
				J
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				Eo,
				Y,
				J
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				Y,
				J
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				Y,
				J
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: F() }],
			"bg-repeat": [{ bg: ne() }],
			"bg-size": [{ bg: re() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						Eo,
						Y,
						J
					],
					radial: [
						"",
						Y,
						J
					],
					conic: [
						Eo,
						Y,
						J
					]
				},
				Jo,
				Ho
			] }],
			"bg-color": [{ bg: P() }],
			"gradient-from-pos": [{ from: ie() }],
			"gradient-via-pos": [{ via: ie() }],
			"gradient-to-pos": [{ to: ie() }],
			"gradient-from": [{ from: P() }],
			"gradient-via": [{ via: P() }],
			"gradient-to": [{ to: P() }],
			rounded: [{ rounded: I() }],
			"rounded-s": [{ "rounded-s": I() }],
			"rounded-e": [{ "rounded-e": I() }],
			"rounded-t": [{ "rounded-t": I() }],
			"rounded-r": [{ "rounded-r": I() }],
			"rounded-b": [{ "rounded-b": I() }],
			"rounded-l": [{ "rounded-l": I() }],
			"rounded-ss": [{ "rounded-ss": I() }],
			"rounded-se": [{ "rounded-se": I() }],
			"rounded-ee": [{ "rounded-ee": I() }],
			"rounded-es": [{ "rounded-es": I() }],
			"rounded-tl": [{ "rounded-tl": I() }],
			"rounded-tr": [{ "rounded-tr": I() }],
			"rounded-br": [{ "rounded-br": I() }],
			"rounded-bl": [{ "rounded-bl": I() }],
			"border-w": [{ border: L() }],
			"border-w-x": [{ "border-x": L() }],
			"border-w-y": [{ "border-y": L() }],
			"border-w-s": [{ "border-s": L() }],
			"border-w-e": [{ "border-e": L() }],
			"border-w-bs": [{ "border-bs": L() }],
			"border-w-be": [{ "border-be": L() }],
			"border-w-t": [{ "border-t": L() }],
			"border-w-r": [{ "border-r": L() }],
			"border-w-b": [{ "border-b": L() }],
			"border-w-l": [{ "border-l": L() }],
			"divide-x": [{ "divide-x": L() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": L() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...R(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...R(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: P() }],
			"border-color-x": [{ "border-x": P() }],
			"border-color-y": [{ "border-y": P() }],
			"border-color-s": [{ "border-s": P() }],
			"border-color-e": [{ "border-e": P() }],
			"border-color-bs": [{ "border-bs": P() }],
			"border-color-be": [{ "border-be": P() }],
			"border-color-t": [{ "border-t": P() }],
			"border-color-r": [{ "border-r": P() }],
			"border-color-b": [{ "border-b": P() }],
			"border-color-l": [{ "border-l": P() }],
			"divide-color": [{ divide: P() }],
			"outline-style": [{ outline: [
				...R(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				q,
				Y,
				J
			] }],
			"outline-w": [{ outline: [
				"",
				q,
				Wo,
				Lo
			] }],
			"outline-color": [{ outline: P() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				Yo,
				Uo
			] }],
			"shadow-color": [{ shadow: P() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				Yo,
				Uo
			] }],
			"inset-shadow-color": [{ "inset-shadow": P() }],
			"ring-w": [{ ring: L() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: P() }],
			"ring-offset-w": [{ "ring-offset": [q, Lo] }],
			"ring-offset-color": [{ "ring-offset": P() }],
			"inset-ring-w": [{ "inset-ring": L() }],
			"inset-ring-color": [{ "inset-ring": P() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				Yo,
				Uo
			] }],
			"text-shadow-color": [{ "text-shadow": P() }],
			opacity: [{ opacity: [
				q,
				Y,
				J
			] }],
			"mix-blend": [{ "mix-blend": [
				...ae(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": ae() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [q] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": z() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": z() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": P() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": P() }],
			"mask-image-t-from-pos": [{ "mask-t-from": z() }],
			"mask-image-t-to-pos": [{ "mask-t-to": z() }],
			"mask-image-t-from-color": [{ "mask-t-from": P() }],
			"mask-image-t-to-color": [{ "mask-t-to": P() }],
			"mask-image-r-from-pos": [{ "mask-r-from": z() }],
			"mask-image-r-to-pos": [{ "mask-r-to": z() }],
			"mask-image-r-from-color": [{ "mask-r-from": P() }],
			"mask-image-r-to-color": [{ "mask-r-to": P() }],
			"mask-image-b-from-pos": [{ "mask-b-from": z() }],
			"mask-image-b-to-pos": [{ "mask-b-to": z() }],
			"mask-image-b-from-color": [{ "mask-b-from": P() }],
			"mask-image-b-to-color": [{ "mask-b-to": P() }],
			"mask-image-l-from-pos": [{ "mask-l-from": z() }],
			"mask-image-l-to-pos": [{ "mask-l-to": z() }],
			"mask-image-l-from-color": [{ "mask-l-from": P() }],
			"mask-image-l-to-color": [{ "mask-l-to": P() }],
			"mask-image-x-from-pos": [{ "mask-x-from": z() }],
			"mask-image-x-to-pos": [{ "mask-x-to": z() }],
			"mask-image-x-from-color": [{ "mask-x-from": P() }],
			"mask-image-x-to-color": [{ "mask-x-to": P() }],
			"mask-image-y-from-pos": [{ "mask-y-from": z() }],
			"mask-image-y-to-pos": [{ "mask-y-to": z() }],
			"mask-image-y-from-color": [{ "mask-y-from": P() }],
			"mask-image-y-to-color": [{ "mask-y-to": P() }],
			"mask-image-radial": [{ "mask-radial": [Y, J] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": z() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": z() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": P() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": P() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [q] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": z() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": z() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": P() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": P() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: F() }],
			"mask-repeat": [{ mask: ne() }],
			"mask-size": [{ mask: re() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				Y,
				J
			] }],
			filter: [{ filter: [
				"",
				"none",
				Y,
				J
			] }],
			blur: [{ blur: oe() }],
			brightness: [{ brightness: [
				q,
				Y,
				J
			] }],
			contrast: [{ contrast: [
				q,
				Y,
				J
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				Yo,
				Uo
			] }],
			"drop-shadow-color": [{ "drop-shadow": P() }],
			grayscale: [{ grayscale: [
				"",
				q,
				Y,
				J
			] }],
			"hue-rotate": [{ "hue-rotate": [
				q,
				Y,
				J
			] }],
			invert: [{ invert: [
				"",
				q,
				Y,
				J
			] }],
			saturate: [{ saturate: [
				q,
				Y,
				J
			] }],
			sepia: [{ sepia: [
				"",
				q,
				Y,
				J
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				Y,
				J
			] }],
			"backdrop-blur": [{ "backdrop-blur": oe() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				q,
				Y,
				J
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				q,
				Y,
				J
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				q,
				Y,
				J
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				q,
				Y,
				J
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				q,
				Y,
				J
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				q,
				Y,
				J
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				q,
				Y,
				J
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				q,
				Y,
				J
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				Y,
				J
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				q,
				"initial",
				Y,
				J
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				Y,
				J
			] }],
			delay: [{ delay: [
				q,
				Y,
				J
			] }],
			animate: [{ animate: [
				"none",
				v,
				Y,
				J
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				Y,
				J
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: se() }],
			"rotate-x": [{ "rotate-x": se() }],
			"rotate-y": [{ "rotate-y": se() }],
			"rotate-z": [{ "rotate-z": se() }],
			scale: [{ scale: ce() }],
			"scale-x": [{ "scale-x": ce() }],
			"scale-y": [{ "scale-y": ce() }],
			"scale-z": [{ "scale-z": ce() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: le() }],
			"skew-x": [{ "skew-x": le() }],
			"skew-y": [{ "skew-y": le() }],
			transform: [{ transform: [
				Y,
				J,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: ue() }],
			"translate-x": [{ "translate-x": ue() }],
			"translate-y": [{ "translate-y": ue() }],
			"translate-z": [{ "translate-z": ue() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				Eo,
				Y,
				J
			] }],
			accent: [{ accent: P() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: P() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				Y,
				J
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": P() }],
			"scrollbar-track-color": [{ "scrollbar-track": P() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				Y,
				J
			] }],
			fill: [{ fill: ["none", ...P()] }],
			"stroke-w": [{ stroke: [
				q,
				Wo,
				Lo,
				Ro
			] }],
			stroke: [{ stroke: ["none", ...P()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region lib/utils.ts
function cs(...e) {
	return ss(Ia(e));
}
//#endregion
//#region node_modules/@base-ui/react/button/Button.mjs
var ls = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { render: n, className: r, disabled: i = !1, focusableWhenDisabled: a = !1, nativeButton: o = !0, style: s, ...c } = e, { getButtonProps: l, buttonRef: u } = It({
		disabled: i,
		focusableWhenDisabled: a,
		native: o
	});
	return $e("button", e, {
		state: { disabled: i },
		ref: [t, u],
		props: [c, l]
	});
}), us = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, ds = Ia, fs = (e, t) => (n) => {
	if (t?.variants == null) return ds(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = us(t) || us(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return ds(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
}, ps = fs("group/button inline-flex shrink-0 items-center justify-center rounded-lg border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground hover:bg-primary/80",
			outline: "border-border bg-background hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
			secondary: "bg-secondary text-secondary-foreground hover:bg-[color-mix(in_oklch,var(--secondary),var(--foreground)_5%)] aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
			ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
			destructive: "bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-8 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
			xs: "h-6 gap-1 rounded-[min(var(--radius-md),10px)] px-2 text-xs in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3",
			sm: "h-7 gap-1 rounded-[min(var(--radius-md),12px)] px-2.5 text-[0.8rem] in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5",
			lg: "h-9 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
			icon: "size-8",
			"icon-xs": "size-6 rounded-[min(var(--radius-md),10px)] in-data-[slot=button-group]:rounded-lg [&_svg:not([class*='size-'])]:size-3",
			"icon-sm": "size-7 rounded-[min(var(--radius-md),12px)] in-data-[slot=button-group]:rounded-lg",
			"icon-lg": "size-9"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function ms({ className: e, variant: t = "default", size: n = "default", ...r }) {
	return /* @__PURE__ */ (0, W.jsx)(ls, {
		"data-slot": "button",
		className: cs(ps({
			variant: t,
			size: n,
			className: e
		})),
		...r
	});
}
//#endregion
//#region components/ui/sheet.tsx
function hs({ ...e }) {
	return /* @__PURE__ */ (0, W.jsx)(Na, {
		"data-slot": "sheet",
		...e
	});
}
function gs({ ...e }) {
	return /* @__PURE__ */ (0, W.jsx)(Xt, {
		"data-slot": "sheet-close",
		...e
	});
}
function _s({ ...e }) {
	return /* @__PURE__ */ (0, W.jsx)(ha, {
		"data-slot": "sheet-portal",
		...e
	});
}
function vs({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)(mt, {
		"data-slot": "sheet-overlay",
		className: cs("bg-black/10 supports-backdrop-filter:backdrop-blur-xs fixed inset-0 z-50 transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0", e),
		...t
	});
}
function ys({ className: e, children: t, side: n = "right", showCloseButton: r = !0, ...i }) {
	return /* @__PURE__ */ (0, W.jsxs)(_s, { children: [/* @__PURE__ */ (0, W.jsx)(vs, {}), /* @__PURE__ */ (0, W.jsxs)(fa, {
		"data-slot": "sheet-content",
		"data-side": n,
		className: cs("bg-popover text-popover-foreground fixed z-50 flex flex-col gap-4 bg-clip-padding text-sm shadow-lg transition duration-200 ease-in-out data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:border-t data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm data-ending-style:opacity-0 data-starting-style:opacity-0 data-[side=bottom]:data-ending-style:translate-y-[2.5rem] data-[side=bottom]:data-starting-style:translate-y-[2.5rem] data-[side=left]:data-ending-style:translate-x-[-2.5rem] data-[side=left]:data-starting-style:translate-x-[-2.5rem] data-[side=right]:data-ending-style:translate-x-[2.5rem] data-[side=right]:data-starting-style:translate-x-[2.5rem] data-[side=top]:data-ending-style:translate-y-[-2.5rem] data-[side=top]:data-starting-style:translate-y-[-2.5rem]", e),
		...i,
		children: [t, r && /* @__PURE__ */ (0, W.jsxs)(Xt, {
			"data-slot": "sheet-close",
			render: /* @__PURE__ */ (0, W.jsx)(ms, {
				variant: "ghost",
				className: "absolute top-3 right-3",
				size: "icon-sm"
			}),
			children: [/* @__PURE__ */ (0, W.jsx)(he, {}), /* @__PURE__ */ (0, W.jsx)("span", {
				className: "sr-only",
				children: "Close"
			})]
		})]
	})] });
}
function bs({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)(Pa, {
		"data-slot": "sheet-title",
		className: cs("text-foreground text-base font-medium cn-font-heading", e),
		...t
	});
}
function xs({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)(nn, {
		"data-slot": "sheet-description",
		className: cs("text-muted-foreground text-sm", e),
		...t
	});
}
//#endregion
//#region lib/catalog-snapshot.json
var Ss = [
	{
		id: 0x9c73c07814e,
		handle: "silentsleep",
		title: "SilentSleep öronproppar",
		variants: [{
			id: 54731287920974,
			title: "Default Title",
			price: 21900,
			available: !0
		}]
	},
	{
		id: 8897386807630,
		handle: "nightshift",
		title: "RÖD NightShift",
		variants: [{
			id: 48102057902414,
			title: "Röd lins",
			price: 43900,
			available: !1
		}, {
			id: 48102057935182,
			title: "Orange lins",
			price: 43900,
			available: !0
		}]
	},
	{
		id: 7821093568720,
		handle: "pannband-sovhorlurar-med-bluetooth",
		title: "Pannband- Sovhörlurar med bluetooth",
		variants: [{
			id: 43122170134736,
			title: "Default Title",
			price: 21900,
			available: !0
		}]
	},
	{
		id: 6635103813840,
		handle: "somnmask",
		title: "Jon Blund™ Sömnmask",
		variants: [{
			id: 39668730036432,
			title: "Default Title",
			price: 28900,
			available: !0
		}]
	}
], Cs = (e) => globalThis.__JB_ASSETS__?.[e] || "/images/" + e, ws = (e, t, n, r, i = 1800, a = 1200) => ({
	src: Cs(e),
	alt: t,
	label: n,
	caption: r,
	width: i,
	height: a
}), Ts = [
	{
		handle: "somnmask",
		title: "Jon Blund™ Sömnmask",
		kicker: "En av Sveriges mest köpta sovmasker",
		category: "Sömnmasker",
		summary: "Mörker för dig. Utrymme för ögonen.",
		description: "När sovrummet inte är mörkt nog. En mjuk, formad 3D-sömnmask som sluter om ögonen och ger dem plats att röra sig. Justera bandet, hitta din passform och låt resten av världen vara vaken.",
		images: [
			ws("somnmask-1.jpg", "Svart Jon Blund sömnmask, framsida", "Framsida", "Din kvällsrutin börjar med en mask.", 1800, 1168),
			ws("somnmask-9.jpg", "Sömnmaskens insida med två urgröpningar för ögonen", "3D-formen", "Utrymme för ögonen. Mjuk vaddering runtom.", 1800, 1200),
			ws("lifestyle-original.jpg", "Person som vilar i soffan med Jon Blunds mask", "På riktigt", "Så sitter masken på ansiktet.", 1440, 1080),
			ws("somnmask-4.jpg", "Närbild på sömnmaskens justerbara band", "Bandet", "Finjustera passformen med bandets spänne.", 1800, 1200),
			ws("somnmask-6.jpg", "Sömnmaskens baksida och elastiska band", "Baksida", "Enkel konstruktion. Redo för nästa kväll.", 1576, 1051)
		],
		benefits: [
			"Formad för att stänga ute ljus",
			"3D-utrymme för ögon och fransar",
			"Mjukt material som andas",
			"Justerbart band för din passform"
		],
		details: [
			["I förpackningen", "1 × svart Jon Blund™ Sömnmask med justerbart band."],
			["Passform", "Formad dyna runt ögonen och näsan. Bandets längd går att justera. Passform och komfort kan variera med ansiktsform och sovställning."],
			["Skötsel", "Masken är tvättbar. Följ skötselråden som följer med produkten."],
			["Att tänka på", "Den formade 3D-konstruktionen kan upplevas olika när ansiktet ligger mot kudden, särskilt för den som sover på mage."]
		]
	},
	{
		handle: "silentsleep",
		title: "SilentSleep öronproppar",
		kicker: "EN LUGNARE OMGIVNING",
		category: "Öronproppar",
		summary: "Stäng ute lite mer av omvärlden.",
		description: "Mjuka, återanvändbara öronproppar i silikon. Med fyra storlekar på propparna kan du hitta en passform som känns bekväm för dig. Förvaringsetuiet håller dem samlade mellan användningarna.",
		images: [ws("silentsleep-1.png", "SilentSleep öronproppar och tillbehör", "Produkten", "Öronproppar för din stund av lugn.", 2e3, 2e3), ws("silentsleep-2.jpg", "SilentSleep produktfoto", "Detaljer", "Se produkten på nära håll.", 1800, 1200)],
		benefits: [
			"Mjukt silikon",
			"Fyra storlekar",
			"Återanvändbara",
			"Förvaringsetui ingår"
		],
		details: [
			["I förpackningen", "SilentSleep öronproppar, proppar i fyra storlekar och ett förvaringsetui."],
			["Passform", "Välj den storlek som sluter bekvämt i örat. Hur mycket ljud som dämpas beror på passformen."],
			["Skötsel", "Återanvändbara och lätta att rengöra. Följ produktens skötselinstruktioner."]
		]
	},
	{
		handle: "pannband-sovhorlurar-med-bluetooth",
		title: "Pannband – Sovhörlurar med Bluetooth",
		kicker: "LYSSNA OCH VARVA NER",
		category: "Sovhörlurar",
		summary: "Din ljudbok. Din podcast. Din stund.",
		description: "Ett mjukt pannband med inbyggda stereohörlurar. Anslut trådlöst till mobilen och lyssna på det du tycker om när det är dags att varva ner.",
		images: [ws("pannband-sovhorlurar-med-bluetooth-1.jpg", "Pannband med inbyggda Bluetooth-hörlurar", "Pannbandet", "Trådlöst ljud i ett mjukt pannband.", 800, 800), ws("pannband-sovhorlurar-med-bluetooth-2.jpg", "Person med ett pannband med sovhörlurar", "På plats", "Pannbandet på huvudet.", 500, 500)],
		benefits: [
			"Trådlös Bluetooth-anslutning",
			"Upp till 10 timmars batteritid",
			"Mjukt pannband",
			"Laddningskabel ingår"
		],
		details: [
			["I förpackningen", "1 × pannband med sovhörlurar och Micro USB-laddningskabel."],
			["Kompatibilitet", "iPhone, iPad, Android och andra enheter med Bluetooth."],
			["Batteritid", "Upp till 10 timmar enligt produktinformationen. Faktisk tid beror på användningen."],
			["Kontroller", "Start och stopp, volym samt möjlighet att besvara telefonsamtal med inbyggd mikrofon."]
		]
	},
	{
		handle: "nightshift",
		title: "RÖD NightShift",
		kicker: "FÖR KVÄLLENS SKÄRMTID",
		category: "Glasögon",
		summary: "Ett annat ljus i slutet av dagen.",
		description: "NightShift från RÖD har färgade linser och en lätt, flexibel TR90-båge. Välj linsfärg och se tillgängligheten för just den varianten.",
		images: [ws("nightshift-1.webp", "RÖD NightShift glasögon med röd lins", "Röd lins", "NightShift med röd lins.", 3235, 3235), ws("nightshift-2.webp", "RÖD NightShift glasögon med orange lins", "Orange lins", "NightShift med orange lins.", 800, 800)],
		benefits: [
			"Lätt TR90-båge",
			"Flexibel konstruktion",
			"Röd eller orange lins",
			"Säljs av Jonblund"
		],
		details: [
			["Varumärke", "RÖD. Återförsäljare: Jonblund."],
			["Material", "TR90-båge."],
			["Varianter", "Röd lins och orange lins. Aktuell tillgänglighet visas när du väljer variant."],
			["I förpackningen", "1 × NightShift-glasögon i vald linsfärg."]
		]
	}
], Es = Ss, Ds = (e) => new Intl.NumberFormat("sv-SE", {
	style: "currency",
	currency: "SEK",
	minimumFractionDigits: e % 100 == 0 ? 0 : 2,
	maximumFractionDigits: 2
}).format(e / 100);
function Os(e) {
	return Ts.find((t) => t.handle === e);
}
function ks(e, t) {
	for (let n of e) {
		let e = n.variants.find((e) => e.id === t);
		if (e) return {
			product: n,
			variant: e
		};
	}
}
function As(e, t) {
	let n = e * t;
	return t >= 4 ? Math.round(n * .75) : Math.max(0, n - (t === 3 ? 17400 : t === 2 ? 8700 : 0));
}
//#endregion
//#region shopify-integration/provider.tsx
var js = (e) => globalThis.__JB_ASSETS__?.[e] || "/images/" + e, Ms = (0, _.createContext)(null);
function Ns() {
	let e = (0, _.useContext)(Ms);
	if (!e) throw Error("Store context missing");
	return e;
}
async function Ps(e, t) {
	let n = await fetch(e, {
		method: t ? "POST" : "GET",
		credentials: "same-origin",
		cache: "no-store",
		headers: {
			Accept: "application/json",
			...t ? { "Content-Type": "application/json" } : {}
		},
		...t ? { body: JSON.stringify(t) } : {},
		signal: AbortSignal.timeout(15e3)
	}), r = await n.json();
	if (!n.ok) throw Error(typeof r == "object" && r && "description" in r ? String(r.description) : "Kunde inte uppdatera varukorgen. Försök igen.");
	return r;
}
function Fs({ children: e }) {
	let [t, n] = (0, _.useState)(Es), [r, i] = (0, _.useState)("loading"), [a, o] = (0, _.useState)([]), [s, c] = (0, _.useState)(0), [l, u] = (0, _.useState)(0), [d, f] = (0, _.useState)(!1), [p, m] = (0, _.useState)(!1), [h, g] = (0, _.useState)(""), v = (0, _.useRef)(!1), y = (0, _.useCallback)((e) => {
		o(e.items.map((e) => ({
			id: e.variant_id,
			key: e.key,
			quantity: e.quantity,
			finalTotal: e.final_line_price,
			title: e.product_title,
			variantTitle: e.variant_title,
			image: e.image,
			url: e.url,
			signature: JSON.stringify(Object.entries(e.properties || {}).sort(([e], [t]) => e.localeCompare(t)))
		}))), c(e.total_price), u(e.total_discount);
	}, []), b = (0, _.useCallback)(async () => {
		try {
			let [e, t] = await Promise.all([Ps("/products.json?limit=250"), Ps("/cart.js")]), r = e.products.map((e) => ({
				id: e.id,
				handle: e.handle,
				title: e.title,
				variants: e.variants.map((e) => ({
					id: e.id,
					title: e.title,
					price: Math.round(Number(e.price) * 100),
					available: e.available
				}))
			}));
			return n(r), y(t), i("live"), r;
		} catch (e) {
			return i("error"), g(e instanceof Error ? e.message : "Kunde inte hämta butiken."), null;
		}
	}, [y]);
	(0, _.useEffect)(() => {
		b();
		let e = () => {
			v.current || b();
		};
		return window.addEventListener("focus", e), () => window.removeEventListener("focus", e);
	}, [b]);
	let x = async (e, t) => {
		if (v.current) return !1;
		v.current = !0, m(!0), g("");
		try {
			return await Ps(e, t), y(await Ps("/cart.js")), f(!0), !0;
		} catch (e) {
			return g(e instanceof Error ? e.message : "Försök igen."), f(!0), !1;
		} finally {
			v.current = !1, m(!1);
		}
	};
	return /* @__PURE__ */ (0, W.jsxs)(Ms.Provider, {
		value: {
			catalog: t,
			status: r,
			lines: a,
			total: s,
			count: a.reduce((e, t) => e + t.quantity, 0),
			discount: l,
			add: (e, n = 1) => v.current || r !== "live" || !ks(t, e)?.variant.available || !Number.isInteger(n) || n < 1 || n > 20 ? !1 : (x("/cart/add.js", { items: [{
				id: e,
				quantity: n
			}] }), !0),
			change: (e, t) => {
				if (v.current || !Number.isInteger(t) || t < 0 || t > 20) return;
				let n = a.find((t) => t.key === e);
				n && (v.current = !0, m(!0), g(""), (async () => {
					try {
						let r = await Ps("/cart.js"), i = r.items.find((t) => t.key === e) || r.items.find((e) => e.variant_id === n.id && JSON.stringify(Object.entries(e.properties || {}).sort(([e], [t]) => e.localeCompare(t))) === n.signature);
						if (!i) throw y(r), Error("Varukorgen har uppdaterats. Kontrollera innehållet och försök igen.");
						y(await Ps("/cart/change.js", {
							id: i.key,
							quantity: t
						})), setTimeout(() => {
							v.current || b();
						}, 1200);
					} catch (e) {
						g(e instanceof Error ? e.message : "Kunde inte ändra antal."), b();
					} finally {
						v.current = !1, m(!1);
					}
				})());
			},
			setOpen: (e) => {
				f(e), e && b();
			},
			refresh: b,
			checkout: async () => {
				if (!(v.current || !a.length)) {
					v.current = !0, m(!0);
					try {
						let e = await Ps("/cart.js");
						if (y(e), !e.items.length) throw Error("Varukorgen är tom.");
						if (e.total_price !== s) {
							g("Summan har uppdaterats. Kontrollera varukorgen och fortsätt igen.");
							return;
						}
						window.location.assign("/checkout");
					} catch (e) {
						g(e instanceof Error ? e.message : "Kassan kunde inte öppnas.");
					} finally {
						v.current = !1, m(!1);
					}
				}
			},
			checking: p,
			error: h,
			offers: !0
		},
		children: [e, /* @__PURE__ */ (0, W.jsx)(hs, {
			open: d,
			onOpenChange: f,
			children: /* @__PURE__ */ (0, W.jsxs)(ys, {
				className: "cart-sheet",
				showCloseButton: !1,
				children: [
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "drawer-heading",
						children: [/* @__PURE__ */ (0, W.jsxs)(bs, { children: [
							"Din varukorg",
							" ",
							/* @__PURE__ */ (0, W.jsxs)("span", { children: [
								"(",
								a.reduce((e, t) => e + t.quantity, 0),
								")"
							] })
						] }), /* @__PURE__ */ (0, W.jsx)(gs, {
							className: "icon-button",
							"aria-label": "Stäng varukorgen",
							children: /* @__PURE__ */ (0, W.jsx)(he, {})
						})]
					}),
					/* @__PURE__ */ (0, W.jsx)(xs, {
						className: "sr-only",
						children: "Priser och rabatter beräknas av Shopify."
					}),
					/* @__PURE__ */ (0, W.jsx)(Ls, {})
				]
			})
		})]
	});
}
function Is() {
	let e = Ns();
	if (e.status !== "live") return null;
	let t = e.catalog.find((e) => e.handle === "somnmask")?.variants[0], n = e.lines.find((e) => e.id === t?.id);
	if (!n) return null;
	let r = Ts.filter((e) => ["nightshift", "pannband-sovhorlurar-med-bluetooth"].includes(e.handle));
	return /* @__PURE__ */ (0, W.jsxs)("div", {
		className: "native-extras",
		children: [n.quantity === 1 && n.finalTotal === t?.price && /* @__PURE__ */ (0, W.jsxs)("button", {
			className: "native-upgrade",
			disabled: e.checking,
			onClick: () => e.change(n.key, 2),
			children: ["Välj 2 masker — spara 87 kr ", /* @__PURE__ */ (0, W.jsx)(j, { size: 17 })]
		}), r.map((t) => {
			let n = e.catalog.find((e) => e.handle === t.handle)?.variants.find((e) => e.available);
			return !n || e.lines.some((e) => e.id === n.id) ? null : /* @__PURE__ */ (0, W.jsxs)("div", {
				className: "cart-extra",
				children: [/* @__PURE__ */ (0, W.jsx)("p", {
					className: "eyebrow",
					children: "KOMPLETTERA DIN KVÄLL"
				}), /* @__PURE__ */ (0, W.jsxs)("div", { children: [
					/* @__PURE__ */ (0, W.jsx)("img", {
						src: t.images[+(t.handle === "nightshift" && n.title === "Orange lins")].src,
						alt: t.title,
						width: 70,
						height: 70
					}),
					/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("a", {
						href: "/products/" + t.handle + "?variant=" + n.id,
						children: t.title
					}), /* @__PURE__ */ (0, W.jsx)("span", { children: Ds(n.price) })] }),
					/* @__PURE__ */ (0, W.jsx)("button", {
						className: "icon-button",
						disabled: e.checking,
						"aria-label": "Lägg till " + t.title,
						onClick: () => e.add(n.id, 1),
						children: /* @__PURE__ */ (0, W.jsx)(le, { size: 18 })
					})
				] })]
			}, t.handle);
		})]
	});
}
function Ls() {
	let e = Ns();
	return /* @__PURE__ */ (0, W.jsx)(W.Fragment, { children: e.lines.length ? /* @__PURE__ */ (0, W.jsxs)(W.Fragment, { children: [/* @__PURE__ */ (0, W.jsxs)("div", {
		className: "cart-items",
		children: [
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "shipping-progress",
				children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: e.total >= 3e4 ? "Du har fri frakt inom Sverige." : "Lägg till för " + Ds(3e4 - e.total) + " för fri frakt inom Sverige." }), /* @__PURE__ */ (0, W.jsx)("progress", {
					"aria-label": "Till fri frakt",
					max: 3e4,
					value: Math.min(e.total, 3e4)
				})]
			}),
			e.lines.map((t) => {
				let n = ks(e.catalog, t.id), r = Ts.find((e) => e.handle === n?.product.handle), i = n?.variant, a = r?.title || t.title, o = i?.title || t.variantTitle, s = +(r?.handle === "nightshift" && i?.title === "Orange lins"), c = r?.images[s].src || t.image, l = t.url || "/collections/all";
				return /* @__PURE__ */ (0, W.jsxs)("div", {
					className: "cart-item",
					children: [
						c && /* @__PURE__ */ (0, W.jsx)("a", {
							href: l,
							onClick: () => e.setOpen(!1),
							children: /* @__PURE__ */ (0, W.jsx)("img", {
								src: c,
								alt: a,
								width: 100,
								height: 100
							})
						}),
						/* @__PURE__ */ (0, W.jsxs)("div", { children: [
							/* @__PURE__ */ (0, W.jsx)("a", {
								className: "cart-title",
								href: l,
								onClick: () => e.setOpen(!1),
								children: a
							}),
							o && o !== "Default Title" && /* @__PURE__ */ (0, W.jsx)("p", {
								className: "small-text",
								children: o
							}),
							/* @__PURE__ */ (0, W.jsx)("strong", { children: Ds(t.finalTotal) }),
							e.status === "live" && i?.available === !1 && /* @__PURE__ */ (0, W.jsx)("p", {
								className: "error-text",
								children: "Slutsåld – ta bort för att fortsätta"
							}),
							/* @__PURE__ */ (0, W.jsxs)("div", {
								className: "quantity",
								children: [
									/* @__PURE__ */ (0, W.jsx)("button", {
										disabled: e.checking,
										"aria-label": "Minska antal " + a,
										onClick: () => e.change(t.key, t.quantity - 1),
										children: /* @__PURE__ */ (0, W.jsx)(z, { size: 14 })
									}),
									/* @__PURE__ */ (0, W.jsx)("span", { children: t.quantity }),
									/* @__PURE__ */ (0, W.jsx)("button", {
										"aria-label": "Öka antal " + a,
										disabled: e.checking || t.quantity >= 20,
										onClick: () => e.change(t.key, t.quantity + 1),
										children: /* @__PURE__ */ (0, W.jsx)(le, { size: 14 })
									})
								]
							})
						] }),
						/* @__PURE__ */ (0, W.jsx)("button", {
							className: "icon-button remove-item",
							disabled: e.checking,
							"aria-label": "Ta bort " + a,
							onClick: () => e.change(t.key, 0),
							children: /* @__PURE__ */ (0, W.jsx)(pe, { size: 17 })
						})
					]
				}, t.key);
			}),
			/* @__PURE__ */ (0, W.jsx)(Rs, {}),
			/* @__PURE__ */ (0, W.jsx)(Is, {})
		]
	}), /* @__PURE__ */ (0, W.jsxs)("div", {
		className: "cart-bottom",
		children: [
			e.discount > 0 && /* @__PURE__ */ (0, W.jsxs)("div", {
				className: "cart-total",
				children: [/* @__PURE__ */ (0, W.jsx)("span", { children: "Du sparar" }), /* @__PURE__ */ (0, W.jsx)("strong", { children: Ds(e.discount) })]
			}),
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "cart-total",
				children: [/* @__PURE__ */ (0, W.jsx)("span", { children: e.discount > 0 ? "Totalt efter rabatt" : "Totalt" }), /* @__PURE__ */ (0, W.jsx)("strong", { children: Ds(e.total) })]
			}),
			/* @__PURE__ */ (0, W.jsxs)("p", {
				className: "small-text",
				children: [
					"Frakt beräknas i kassan. Se",
					" ",
					/* @__PURE__ */ (0, W.jsx)("a", {
						href: "/policies/shipping-policy",
						onClick: () => e.setOpen(!1),
						children: "leveransvillkor"
					}),
					"."
				]
			}),
			e.error && /* @__PURE__ */ (0, W.jsx)("p", {
				role: "alert",
				className: "error-text",
				children: e.error
			}),
			e.status === "error" && /* @__PURE__ */ (0, W.jsxs)("p", {
				className: "error-text",
				children: [
					"Pris och lager kunde inte kontrolleras.",
					" ",
					/* @__PURE__ */ (0, W.jsx)("button", {
						onClick: () => e.refresh(),
						children: "Försök igen"
					})
				]
			}),
			/* @__PURE__ */ (0, W.jsxs)("button", {
				className: "button peach checkout-button",
				disabled: e.checking || e.status !== "live" || e.lines.some((t) => e.status === "live" && ks(e.catalog, t.id)?.variant.available === !1),
				onClick: e.checkout,
				children: [e.checking ? "Förbereder kassan…" : "Till kassan", /* @__PURE__ */ (0, W.jsx)(j, { size: 20 })]
			}),
			/* @__PURE__ */ (0, W.jsxs)("p", {
				className: "secure",
				children: [/* @__PURE__ */ (0, W.jsx)(L, { size: 14 }), " Säker betalning hos Jonblund"]
			}),
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "payments",
				children: [
					/* @__PURE__ */ (0, W.jsx)("span", { children: "Klarna." }),
					/* @__PURE__ */ (0, W.jsx)("span", { children: "VISA" }),
					/* @__PURE__ */ (0, W.jsx)("span", { children: "Mastercard" }),
					/* @__PURE__ */ (0, W.jsx)("span", { children: "Apple Pay" })
				]
			})
		]
	})] }) : /* @__PURE__ */ (0, W.jsxs)("div", {
		className: "empty-cart",
		children: [
			/* @__PURE__ */ (0, W.jsx)(de, {
				size: 48,
				strokeWidth: 1
			}),
			/* @__PURE__ */ (0, W.jsx)("h2", { children: "Plats för lite lugn." }),
			/* @__PURE__ */ (0, W.jsx)("p", { children: "Din varukorg är tom." }),
			/* @__PURE__ */ (0, W.jsxs)("a", {
				className: "button",
				href: "/products/somnmask",
				onClick: () => e.setOpen(!1),
				children: ["Upptäck sömnmasken ", /* @__PURE__ */ (0, W.jsx)(j, { size: 18 })]
			})
		]
	}) });
}
function Rs() {
	let e = Ns(), t = e.catalog.find((e) => e.handle === "silentsleep")?.variants[0], n = e.catalog.find((e) => e.handle === "somnmask")?.variants[0];
	return !t || !n || e.status !== "live" || !t.available || !e.lines.some((e) => e.id === n.id) || e.lines.some((e) => e.id === t.id) ? null : /* @__PURE__ */ (0, W.jsxs)("aside", {
		className: "cart-extra",
		children: [/* @__PURE__ */ (0, W.jsx)("p", {
			className: "eyebrow",
			children: "LITE TYSTARE OCKSÅ?"
		}), /* @__PURE__ */ (0, W.jsxs)("div", { children: [
			/* @__PURE__ */ (0, W.jsx)("img", {
				src: js("silentsleep-1.png"),
				alt: "SilentSleep öronproppar",
				width: 70,
				height: 70
			}),
			/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("a", {
				href: "/products/silentsleep",
				onClick: () => e.setOpen(!1),
				children: "SilentSleep öronproppar"
			}), /* @__PURE__ */ (0, W.jsx)("span", { children: Ds(t.price) })] }),
			/* @__PURE__ */ (0, W.jsx)("button", {
				className: "icon-button",
				"aria-label": "Lägg till SilentSleep öronproppar",
				onClick: () => e.add(t.id, 1),
				children: /* @__PURE__ */ (0, W.jsx)(le, { size: 18 })
			})
		] })]
	});
}
//#endregion
//#region components/store/chrome.tsx
function zs() {
	let e = Ns(), [t, n] = (0, _.useState)(!1), r = y(), i = [
		["Sömnmasken", "/products/somnmask"],
		["Alla produkter", "/collections/all"],
		["Om Jonblund", "/pages/om-oss"],
		["Forskning", "/pages/forskning"],
		["Vanliga frågor", "/pages/vanliga-fragor"]
	];
	return /* @__PURE__ */ (0, W.jsxs)(W.Fragment, { children: [
		/* @__PURE__ */ (0, W.jsx)("a", {
			href: "#main",
			className: "skip-link",
			children: "Till innehållet"
		}),
		/* @__PURE__ */ (0, W.jsxs)("div", {
			className: "announcement",
			children: [
				/* @__PURE__ */ (0, W.jsx)(oe, { size: 13 }),
				" ",
				r === "/" ? "Ljusa svenska nätter. Dina egna sovtider." : "Ditt mörker. Var du än är."
			]
		}),
		/* @__PURE__ */ (0, W.jsxs)("header", {
			className: "site-header " + (r === "/" ? "home-header" : "light-header"),
			children: [
				/* @__PURE__ */ (0, W.jsx)("button", {
					className: "icon-button mobile-menu",
					onClick: () => n(!0),
					"aria-label": "Öppna menyn",
					children: /* @__PURE__ */ (0, W.jsx)(ae, { size: 23 })
				}),
				/* @__PURE__ */ (0, W.jsxs)("a", {
					className: "wordmark",
					href: "/",
					"aria-label": "Jonblund, startsida",
					children: ["jonblund", /* @__PURE__ */ (0, W.jsx)("span", { children: "®" })]
				}),
				/* @__PURE__ */ (0, W.jsx)("nav", {
					"aria-label": "Huvudmeny",
					children: i.map(([e, t]) => /* @__PURE__ */ (0, W.jsx)("a", {
						href: t,
						"aria-current": r === t ? "page" : void 0,
						children: e
					}, t))
				}),
				/* @__PURE__ */ (0, W.jsxs)("div", {
					className: "header-actions",
					children: [/* @__PURE__ */ (0, W.jsx)("a", {
						className: "icon-button search-link",
						href: "/search",
						"aria-label": "Sök produkter",
						children: /* @__PURE__ */ (0, W.jsx)(ue, { size: 20 })
					}), /* @__PURE__ */ (0, W.jsxs)("button", {
						className: "bag",
						onClick: () => e.setOpen(!0),
						"aria-label": `Öppna varukorgen, ${e.count} produkter`,
						children: [/* @__PURE__ */ (0, W.jsx)(de, { size: 21 }), /* @__PURE__ */ (0, W.jsx)("span", { children: e.count })]
					})]
				})
			]
		}),
		/* @__PURE__ */ (0, W.jsx)(hs, {
			open: t,
			onOpenChange: n,
			children: /* @__PURE__ */ (0, W.jsxs)(ys, {
				side: "left",
				className: "menu-sheet",
				showCloseButton: !1,
				children: [
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "drawer-heading",
						children: [/* @__PURE__ */ (0, W.jsx)(bs, {
							className: "wordmark",
							children: "jonblund"
						}), /* @__PURE__ */ (0, W.jsx)(gs, {
							className: "icon-button",
							"aria-label": "Stäng menyn",
							children: /* @__PURE__ */ (0, W.jsx)(he, {})
						})]
					}),
					/* @__PURE__ */ (0, W.jsx)(xs, {
						className: "sr-only",
						children: "Navigera i Jonblunds butik"
					}),
					/* @__PURE__ */ (0, W.jsxs)("nav", {
						className: "mobile-nav",
						children: [
							i.map(([e, t]) => /* @__PURE__ */ (0, W.jsxs)("a", {
								href: t,
								onClick: () => n(!1),
								children: [e, /* @__PURE__ */ (0, W.jsx)(M, { size: 24 })]
							}, t)),
							/* @__PURE__ */ (0, W.jsxs)("a", {
								href: "/pages/kontakta-oss",
								onClick: () => n(!1),
								children: ["Kontakta oss", /* @__PURE__ */ (0, W.jsx)(M, { size: 24 })]
							}),
							/* @__PURE__ */ (0, W.jsxs)("a", {
								href: "/search",
								onClick: () => n(!1),
								children: ["Sök", /* @__PURE__ */ (0, W.jsx)(ue, { size: 24 })]
							})
						]
					}),
					/* @__PURE__ */ (0, W.jsxs)("p", {
						className: "menu-signoff",
						children: [
							"God natt.",
							/* @__PURE__ */ (0, W.jsx)("br", {}),
							/* @__PURE__ */ (0, W.jsx)("em", { children: "På ditt sätt." })
						]
					})
				]
			})
		})
	] });
}
function Bs() {
	return /* @__PURE__ */ (0, W.jsxs)("footer", {
		className: "footer",
		children: [
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "footer-top",
				children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [
					/* @__PURE__ */ (0, W.jsx)("p", {
						className: "eyebrow",
						children: "VI SES PÅ DEN LUGNA SIDAN."
					}),
					/* @__PURE__ */ (0, W.jsxs)("h2", { children: [
						"God natt.",
						/* @__PURE__ */ (0, W.jsx)("br", {}),
						/* @__PURE__ */ (0, W.jsx)("em", { children: "På ditt sätt." })
					] }),
					/* @__PURE__ */ (0, W.jsxs)("a", {
						className: "footer-shop",
						href: "/products/somnmask",
						children: ["Hitta ditt mörker ", /* @__PURE__ */ (0, W.jsx)(M, { size: 21 })]
					})
				] }), /* @__PURE__ */ (0, W.jsxs)("div", {
					className: "footer-links",
					children: [
						/* @__PURE__ */ (0, W.jsxs)("div", { children: [
							/* @__PURE__ */ (0, W.jsx)("h3", { children: "Din kvällsrutin" }),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/products/somnmask",
								children: "Sömnmasken"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/products/silentsleep",
								children: "SilentSleep"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/products/pannband-sovhorlurar-med-bluetooth",
								children: "Sovhörlurar"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/products/nightshift",
								children: "NightShift"
							})
						] }),
						/* @__PURE__ */ (0, W.jsxs)("div", { children: [
							/* @__PURE__ */ (0, W.jsx)("h3", { children: "Vi hjälper dig" }),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/pages/vanliga-fragor",
								children: "Vanliga frågor"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/pages/kontakta-oss",
								children: "Kontakta oss"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/policies/shipping-policy",
								children: "Leverans"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/policies/refund-policy",
								children: "Retur & ångerrätt"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "https://jonblund.se/account",
								children: "Mitt konto"
							})
						] }),
						/* @__PURE__ */ (0, W.jsxs)("div", { children: [
							/* @__PURE__ */ (0, W.jsx)("h3", { children: "Jonblund" }),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/pages/om-oss",
								children: "Om oss"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/pages/forskning",
								children: "Forskning & sömn"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/blogs/sovbloggen",
								children: "Sovbloggen"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/policies/terms-of-service",
								children: "Köpvillkor"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/policies/privacy-policy",
								children: "Integritetspolicy"
							})
						] })
					]
				})]
			}),
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "footer-wordmark",
				"aria-hidden": "true",
				children: ["jonblund", /* @__PURE__ */ (0, W.jsx)("span", { children: "®" })]
			}),
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "footer-bottom",
				children: [
					/* @__PURE__ */ (0, W.jsxs)("span", { children: [
						"© ",
						(/* @__PURE__ */ new Date()).getFullYear(),
						" Jonblund"
					] }),
					/* @__PURE__ */ (0, W.jsxs)("div", { children: [
						/* @__PURE__ */ (0, W.jsx)("span", { children: "Sverige / SEK" }),
						/* @__PURE__ */ (0, W.jsx)("a", {
							href: "https://jonblund.se/da",
							children: "Dansk"
						}),
						/* @__PURE__ */ (0, W.jsx)("a", {
							href: "https://jonblund.se/fi",
							children: "Suomi"
						})
					] }),
					/* @__PURE__ */ (0, W.jsx)("span", { children: "Klarna · Visa · Mastercard" })
				]
			})
		]
	});
}
//#endregion
//#region components/ui/native-select.tsx
function Vs({ className: e, size: t = "default", ...n }) {
	return /* @__PURE__ */ (0, W.jsxs)("div", {
		className: cs("group/native-select relative w-fit has-[select:disabled]:opacity-50", e),
		"data-slot": "native-select-wrapper",
		"data-size": t,
		children: [/* @__PURE__ */ (0, W.jsx)("select", {
			"data-slot": "native-select",
			"data-size": t,
			className: "border-input placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 dark:hover:bg-input/50 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:aria-invalid:border-destructive/50 h-8 w-full min-w-0 appearance-none rounded-lg border bg-transparent py-1 pr-8 pl-2.5 text-sm transition-colors select-none focus-visible:ring-3 aria-invalid:ring-3 data-[size=sm]:h-7 data-[size=sm]:rounded-[min(var(--radius-md),10px)] data-[size=sm]:py-0.5 outline-none disabled:pointer-events-none disabled:cursor-not-allowed",
			...n
		}), /* @__PURE__ */ (0, W.jsx)(P, {
			className: "text-muted-foreground top-1/2 right-2.5 size-4 -translate-y-1/2 pointer-events-none absolute select-none",
			"aria-hidden": "true",
			"data-slot": "native-select-icon"
		})]
	});
}
function Hs({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)("option", {
		"data-slot": "native-select-option",
		className: cs("bg-[Canvas] text-[CanvasText]", e),
		...t
	});
}
var Us = {
	silentsleep: {
		productId: 0x9c73c07814e,
		sourceUrl: "https://jonblund.se/products/silentsleep",
		importedAt: "2026-09-18",
		count: 0,
		average: 0,
		distribution: {
			1: 0,
			2: 0,
			3: 0,
			4: 0,
			5: 0
		},
		reviews: []
	},
	nightshift: {
		productId: 8897386807630,
		sourceUrl: "https://jonblund.se/products/nightshift",
		importedAt: "2026-09-18",
		count: 2,
		average: 3.5,
		distribution: {
			1: 0,
			2: 1,
			3: 0,
			4: 0,
			5: 1
		},
		reviews: [{
			id: "bceeb7c4-ccb8-45b6-ae47-5be3476539a5",
			rating: 2,
			date: "2026-02-16T19:32:38Z",
			author: "Anneli",
			title: "Ser suddigare",
			body: "Plus: Det verkar som de hjälper nattsömnen litegrann om jag har dem på från 19-tiden. \n\nMinus: Jag ser suddigare med glasögonen och det kanske är så det blir mer färgade glas. Jag har mejlat och frågat om det är så samt påmint men inte fått något svar.",
			verified: !0,
			sourceLanguage: "",
			productUrl: "/products/nightshift",
			images: [],
			reply: ""
		}, {
			id: "bfa5c598-cd7c-42be-8284-eaac2394d5c0",
			rating: 5,
			date: "2025-02-06T09:21:39Z",
			author: "Alfred",
			title: "Snygga och lätta",
			body: "De funkar verkligen! De är lätta så dem märks knappt på huvudet. Plus att de är snygga!",
			verified: !0,
			sourceLanguage: "",
			productUrl: "/products/nightshift",
			images: [],
			reply: ""
		}]
	},
	"pannband-sovhorlurar-med-bluetooth": /* @__PURE__ */ JSON.parse("{\"productId\":7821093568720,\"sourceUrl\":\"https://jonblund.se/products/pannband-sovhorlurar-med-bluetooth\",\"importedAt\":\"2026-09-18\",\"count\":29,\"average\":4.586206896551724,\"distribution\":{\"1\":1,\"2\":0,\"3\":2,\"4\":4,\"5\":22},\"reviews\":[{\"id\":\"e74b44a2-cc7e-4716-bb26-891583f81939\",\"rating\":1,\"date\":\"2025-10-07T12:09:53Z\",\"author\":\"Carl-Henry Eriksson\",\"title\":\"Fungerar ej\",\"body\":\"Fungerar inte. Hur reklamerar jag?\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"59aafc0b-be48-4204-b9e8-e7ae5746721d\",\"rating\":5,\"date\":\"2024-03-18T08:56:55Z\",\"author\":\"susanne knutmark\",\"title\":\"\",\"body\":\"Pannband- Sovhörlurar med bluetooth\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"687b3b25-547b-4949-933f-acc32bd1f50b\",\"rating\":5,\"date\":\"2023-12-09T11:56:29Z\",\"author\":\"Lena Brederfält\",\"title\":\"Sovhörlurar\",\"body\":\"Jag är jättenöjd. Dom var lätta o få igång och dom fungerar toppen. Bandet är mjukt o skönt mot huden. Brett o bra.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"ba0e5eb3-1f38-4557-8b40-9a9b5630c0ee\",\"rating\":4,\"date\":\"2023-12-07T19:07:54Z\",\"author\":\"Jessica Söderberg\",\"title\":\"Bättre än förväntat\",\"body\":\"Äntligen kan man somna med hörlurar utan obehag. Själva hörlurarna ligger rätt när man har pannbandet över ögonen som en sovmask men har man den på pannan så hamnar ena hörluren inte över örat. Annars är den toppen. Bra batteritid!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"4189e626-29e7-4e83-8845-8cd7b0a207dc\",\"rating\":5,\"date\":\"2023-10-31T17:00:46Z\",\"author\":\"Tord Maritha Hemlin\",\"title\":\"Hörlurar\",\"body\":\"Super bra\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"09c651ab-0f3d-4b79-b491-d659bd6aa210\",\"rating\":5,\"date\":\"2023-10-25T14:42:14Z\",\"author\":\"Ulla Gustafsson\",\"title\":\"\",\"body\":\"Har inte börjat använda den ännu! Tråkigt att instruktionen inte är på svenska\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"4b775623-bc92-401a-a61c-3bd2e461bff6\",\"rating\":5,\"date\":\"2023-10-17T07:20:54Z\",\"author\":\"Jenny Wilson\",\"title\":\"\",\"body\":\"Pannband- Sovhörlurar med bluetooth\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"50fefefb-e32b-4701-8eba-e6dc82c2ef5b\",\"rating\":5,\"date\":\"2023-10-16T15:11:56Z\",\"author\":\"Pernilla Hermansson\",\"title\":\"Pannbandslurar\",\"body\":\"Suveräna \\n\\nHade lite svårt att hitta vart de skulle laddas och fick öppna upp lite. Annars är de kanon. Både att lyssna på böcker/musik eller prata i telefon med.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"c70d87bc-e2ca-4cfa-9581-bba0db5df1ed\",\"rating\":4,\"date\":\"2023-10-12T18:38:02Z\",\"author\":\"Åsa Sollenberg\",\"title\":\"Bra ljud,dålig passform..\",\"body\":\"Det var lätt att förstå beskrivningen,ladda samt börja använda sovhörlurarna.\\n\\nBra ljud  o lång batteritid. Tyv är materialet i bandet både li blankt o väl mjukt/ glatt. Det innebär att bandet glider upp över håret samt snurrar \\\"ur läge\\\" snabbt när (försiktigt!)byter sida i sängen. Ett annat material i bandet som sitter åt mer,samt ev ett hakband skulle vara bra.\\n\\nDock värt det låga pris som det kostade mig👍\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"bab191e6-fbd5-40f8-8eba-30499045d79f\",\"rating\":5,\"date\":\"2023-10-04T14:14:56Z\",\"author\":\"Ewa Mithander\",\"title\":\"Bra\",\"body\":\"Jätte bra hörlurar när man inte kan sova på natten.  Rekommenderat till fler.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"6948cf39-c6f5-4d78-a3f1-ceb302cc528c\",\"rating\":3,\"date\":\"2023-07-13T05:39:17Z\",\"author\":\"Annika Thunell\",\"title\":\"Pannband med lurar\",\"body\":\"Mjuk och skön att sova med. Lite varm.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"7bcdf460-99ca-45f9-97f5-cd22a56ffe23\",\"rating\":5,\"date\":\"2023-07-10T16:18:13Z\",\"author\":\"Gunilla Johansson\",\"title\":\"Har fortfarande inte kommit något\",\"body\":\"Har fortfarande inte kommit något\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"ca7ca58f-d754-4497-8033-605ec97c41d5\",\"rating\":5,\"date\":\"2023-06-21T01:34:09Z\",\"author\":\"Roland Arksand\",\"title\":\"\",\"body\":\"Pannband- Sovhörlurar med bluetooth\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"7eb7c6e2-404e-40ba-821d-774820c7f5ef\",\"rating\":4,\"date\":\"2023-06-17T06:11:49Z\",\"author\":\"Emma Frogner\",\"title\":\"\",\"body\":\"Köpte två för ett tag sedan. De såg likadana ut men det nya har sämre tyg.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"003c9658-1597-417a-b517-bc82f4486e9e\",\"rating\":5,\"date\":\"2023-06-09T09:02:20Z\",\"author\":\"Mikael Alavaara\",\"title\":\"\",\"body\":\"Pannband- Sovhörlurar med bluetooth\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"36b373e3-8601-499d-8f1b-38d2c8696c1e\",\"rating\":5,\"date\":\"2023-05-31T20:14:02Z\",\"author\":\"Ulrika Bäckman\",\"title\":\"\",\"body\":\"Pannband- Sovhörlurar med bluetooth\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"a56c0b5a-6fa4-4d3e-a49f-39f5ad2ea193\",\"rating\":5,\"date\":\"2023-05-07T15:46:55Z\",\"author\":\"Åsa Adler\",\"title\":\"Hörlurar\",\"body\":\"Mjuka och sköna bra ljud lätta att ansluta\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"a3d58187-aa87-4cc1-b709-eafa8b7aa9b4\",\"rating\":5,\"date\":\"2023-05-04T18:47:12Z\",\"author\":\"Henrik Olsson\",\"title\":\"\",\"body\":\"Pannband- Sovhörlurar med bluetooth\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"4ab8c69e-78eb-4c68-8472-c9330b7d1134\",\"rating\":5,\"date\":\"2023-04-30T22:10:12Z\",\"author\":\"Camilla ATTERFORS\",\"title\":\"Ej fått\",\"body\":\"Jag har inte fått den\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"d454fe8e-8629-4a6c-a93c-1825a8b65441\",\"rating\":5,\"date\":\"2023-04-24T09:00:07Z\",\"author\":\"Anna Ericson\",\"title\":\"\",\"body\":\"Pannband- Sovhörlurar med bluetooth\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"db5825a0-9456-4627-b461-5ac0c8f473d2\",\"rating\":3,\"date\":\"2023-04-14T04:19:45Z\",\"author\":\"Anders J Jörgensen\",\"title\":\"Öronvärmare\",\"body\":\"Ok ljud men det blev lite för varmt\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"b74408cd-3542-4c98-8cdc-efcad0f7d5b8\",\"rating\":5,\"date\":\"2023-03-06T20:18:49Z\",\"author\":\"Britt Isaksson\",\"title\":\"Hörlurar\",\"body\":\"Skönt pannband med hörlurar, som passar att sova i och ha vid utevistelse.Snabb laddtid.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"fbf417ba-e54a-4d77-b1e7-a27646f20c4f\",\"rating\":5,\"date\":\"2023-02-28T05:40:51Z\",\"author\":\"Britt-Marie Skagerberg\",\"title\":\"Bäst\",\"body\":\"Väldigt noga med att inte ha något som stör på skallen men det här va det bästa. Den känns inte, bra ljud och skön att ha på sig. Man somnar fort.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"9ec354be-3a1a-4047-9f45-db1e2323e53e\",\"rating\":5,\"date\":\"2023-02-25T08:27:55Z\",\"author\":\"Göran Petersson\",\"title\":\"Pannband bluetooth\",\"body\":\"Fungerar Utmärkt.Lång batteritid. Är helnöjd.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"d5204489-8b5f-4dd9-9d07-aa6cd9d33750\",\"rating\":5,\"date\":\"2023-02-12T14:56:07Z\",\"author\":\"Anne-Charlotte Widing\",\"title\":\"\",\"body\":\"Jag har inte ens fått varan\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"69d39c2c-6bb1-429b-8d76-4c1e74d85041\",\"rating\":5,\"date\":\"2023-02-12T11:42:31Z\",\"author\":\"Göran Aronsson\",\"title\":\"Superbra!\",\"body\":\"Uppfyller förväntningarna\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"dbe924fb-a9ff-4445-b4b9-c23b36fd2adc\",\"rating\":5,\"date\":\"2022-12-29T00:06:25Z\",\"author\":\"Eva Skoglund\",\"title\":\"Har inte fått ordern😒\",\"body\":\"Var är min leverans????\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"eb0593f0-b374-401b-9f0e-e5ff1e3652cd\",\"rating\":4,\"date\":\"2022-12-14T18:28:45Z\",\"author\":\"Sjolanta\",\"title\":\"Mina nya sovlurar\",\"body\":\"Bra, sköna. Lätta att ladda och manövrera. De hade fått toppbetyg om det var så att själva öronsnäckorna inte skavde lite och om ljudet inte var så ”diskantigt”.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"},{\"id\":\"65649632-5d25-4c96-a41b-6dffd7c26c13\",\"rating\":5,\"date\":\"2022-12-03T08:53:21Z\",\"author\":\"Peter Fogelberg\",\"title\":\"Julklapp\",\"body\":\"Vet mer om 23 dagar när den är provad\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/pannband-sovhorlurar-med-bluetooth\",\"images\":[],\"reply\":\"\"}]}"),
	somnmask: /* @__PURE__ */ JSON.parse("{\"productId\":6635103813840,\"sourceUrl\":\"https://jonblund.se/products/somnmask\",\"importedAt\":\"2026-09-18\",\"count\":222,\"average\":4.6441441441441444,\"distribution\":{\"1\":3,\"2\":5,\"3\":8,\"4\":36,\"5\":170},\"reviews\":[{\"id\":\"487b6fe6-f6b7-5d0d-88c0-4ae6db4154a6\",\"rating\":5,\"date\":\"2026-06-07T09:29:53Z\",\"author\":\"S.K.L.\",\"title\":\"\",\"body\":\"Blockerar allt ljus! Lång leveranstid och opraktiskt spårningssystem dock.\",\"verified\":true,\"sourceLanguage\":\"en\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"170c15f1-4887-4ede-8e1d-3e10981c75a1\",\"rating\":2,\"date\":\"2026-06-03T09:08:19Z\",\"author\":\"Max Ström\",\"title\":\"Hård\",\"body\":\"Banden skar mot öronen och masken kändes torr och hård.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"e2763d0b-a118-49a9-960f-c71c49c71149\",\"rating\":5,\"date\":\"2026-03-20T08:32:47Z\",\"author\":\"Dan Mahr\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"e1c5dd93-07f3-4221-b86b-ee70221efb4c\",\"rating\":5,\"date\":\"2025-11-30T17:53:55Z\",\"author\":\"Gunilla Skarped\",\"title\":\"\",\"body\":\"Jag är nöjd med ”masken”. Har tvättat i maskin och det gick också bra.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"775a5955-2b86-47fe-baa3-d68aeb4a3e4c\",\"rating\":4,\"date\":\"2025-10-08T04:57:21Z\",\"author\":\"John Jerry Olsson\",\"title\":\"En produkt att bruka även utanför flyplanet\",\"body\":\"Sedan inköp av denna omhändertagande, eleganta produkt i kombination med Noise-Cancelling Sleep Buds med tillhörande avslappnings ljud. Har det blivit en självklar del i min uppsättning av rutiner vid avslappning och läggdags.\\n\\nHelt uppriktigt har jag nog underskattat användningsområdet utanför flygplan / flygplatser och med denna erfarenhet är det en given produkt jag kommer använda mer frekvent även vid power-naps! \\n\\nOm förslag till förbättring är välkommet skulle det vara att plastdetaljer ersätts med bambu, likväl tyget som tillhörande band som omsluter huvudet. I övrigt skulle en förvaringsväska vara en välkommen gest och i Bambu så man lätt kan transportera den. Sedan så tenderar öglorna som fäster bandet med sovmasken att vrida sig alldeles för enkelt och skulle behöva ses över. Efterfrågar så även en produkt presentation som long term review, gärna YouTube för det är en produkt som förtjänar mera rampljus än nu. \\n\\nTack på förhand både för eran evaluering som framtida beslut kring min feedback och all lycka och framgång med produkten som borde säljas på flera platser än nu.\\n\\nTack!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"8706a345-ec2f-4133-8064-002efc303fe7\",\"rating\":5,\"date\":\"2025-06-08T03:49:11Z\",\"author\":\"Anna\",\"title\":\"Bästa\",\"body\":\"Den här sovmasken är den bästa jag provat . I.o.m att den har hålighet för ögonen så känns det inte att man har den på sig, och mörkt blir det 😃👌🏼\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"dd291a03-c5a3-4534-b97d-fffead5742d3\",\"rating\":5,\"date\":\"2025-02-22T07:40:56Z\",\"author\":\"Frida\",\"title\":\"Magi\",\"body\":\"Kan inte sova utan!!!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"dd0101da-0d3a-4c11-abb5-f2b449d77bc5\",\"rating\":5,\"date\":\"2024-12-25T08:57:07Z\",\"author\":\"Björn Löwegren\",\"title\":\"Fullsuccé\",\"body\":\"Skön mask som gör det den ska\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"507233fd-0e23-4385-b653-9378653c6852\",\"rating\":5,\"date\":\"2024-12-12T17:13:12Z\",\"author\":\"Anders Berg\",\"title\":\"\",\"body\":\"Mycket bra 👍👍\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"197c6c9a-736c-4f31-b0ff-8a1a5e6152e8\",\"rating\":4,\"date\":\"2024-10-17T08:06:41Z\",\"author\":\"Nisse Årman\",\"title\":\"\",\"body\":\"Bästa sopmaskiner jag använt\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"0456265b-552f-4658-a754-ac180c52af41\",\"rating\":5,\"date\":\"2024-10-12T07:56:58Z\",\"author\":\"M.L.\",\"title\":\"Sovmask\",\"body\":\"Riktigt bra o h jag har haft många. Ii nte optimala för magsovare dock pga 3d-struktur rapporterar tjejen\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"1a2a5090-7b07-4e40-9c08-8e64e38e047a\",\"rating\":2,\"date\":\"2024-09-07T06:07:55Z\",\"author\":\"Ebba Florin Vadman\",\"title\":\"\",\"body\":\"Tycker den var lite väl hård och går endast att sova på rygg med den\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a6b6d2ad-0870-4eb3-b4cd-06fd1c712a6d\",\"rating\":5,\"date\":\"2024-08-21T10:14:07Z\",\"author\":\"Anna Sönnerberg\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"e59531b4-5251-4be3-acee-f5bfd5e95b18\",\"rating\":4,\"date\":\"2024-08-04T07:31:30Z\",\"author\":\"Robert Barany\",\"title\":\"Nattis natt\",\"body\":\"Funkar bra,\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"5cbb559e-49b6-4465-a551-f1067269e9d2\",\"rating\":5,\"date\":\"2024-08-03T18:46:16Z\",\"author\":\"Andrea Matschoss-Falck\",\"title\":\"Sovmask\",\"body\":\"Snabb leverans, produkten uppfyller det som skrevs i annonsen, är helt nöjd med den. Sovmask er är ju alltid lite störande, men den täcker verkligen helt\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a98b028c-6b14-4587-b283-c1042adaa476\",\"rating\":5,\"date\":\"2024-08-02T14:38:10Z\",\"author\":\"Ewa Lennartsson\",\"title\":\"Ger bättre sömn\",\"body\":\"Den som fick produkten är nöjd. Sover bättre när det börjar ljusna. Behöver inte släcka lampa utomhus längre som gav obehagligt ljudms\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"60ddc561-70ff-4b94-9338-cddb8a90b5a0\",\"rating\":5,\"date\":\"2024-07-27T21:39:51Z\",\"author\":\"Sofie Thulin\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"6f24530a-5ddc-4002-b686-743a25f54b1e\",\"rating\":5,\"date\":\"2024-07-26T07:40:35Z\",\"author\":\"Beatrice Firth\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"ef279679-d57f-49f1-ba8d-c606d8de79af\",\"rating\":5,\"date\":\"2024-07-03T21:25:50Z\",\"author\":\"Inger Astrid Maria Karlsson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"b5289f39-1f69-41ce-83e7-fd8499c2c97f\",\"rating\":5,\"date\":\"2024-07-03T04:58:44Z\",\"author\":\"Ronny Quist\",\"title\":\"\",\"body\":\"Toppen\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"5eff2204-ab79-4000-82f7-c45e94e43c6e\",\"rating\":5,\"date\":\"2024-05-13T20:24:16Z\",\"author\":\"Jan Sundqvist\",\"title\":\"Nu sover jag gott.\",\"body\":\"Bekväm och skön när solen lyser in kl 4 på morgonen!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"ba1aa9bc-2660-46df-b66a-535035e872b9\",\"rating\":5,\"date\":\"2024-04-27T14:50:50Z\",\"author\":\"Charles Davis\",\"title\":\"Superbra\",\"body\":\"Kanonprodukt. Sitter jättebra och mörklägger helt.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"2f3f0c29-6858-46c4-b977-025eac94cbdd\",\"rating\":4,\"date\":\"2024-04-15T00:03:34Z\",\"author\":\"Marie Fondelius\",\"title\":\"Ganska nöjd\",\"body\":\"Själv masken är lite för stor annars är den bra.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"9fafaaf4-1ea7-4800-baa2-24f0b96b9a87\",\"rating\":5,\"date\":\"2024-03-22T14:56:18Z\",\"author\":\"Heli Vänskä\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"39215dce-08d4-439d-b633-570c9ffd4cbe\",\"rating\":5,\"date\":\"2024-01-18T21:37:49Z\",\"author\":\"Malin Storbacka\",\"title\":\"Nöjd\",\"body\":\"Tog ca 2 v , men nöjd med produkten, släpper ej igenom ljus, och blir ej så varm som tidigare sovmasker jag haft!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"0dafb20d-f242-489a-8844-d497a3142fc0\",\"rating\":5,\"date\":\"2024-01-08T14:34:09Z\",\"author\":\"Dairiimaa Tumenbileg\",\"title\":\"Otroligt bra produkt\",\"body\":\"En bra ögonbindel fick jag senast och jag är sååå nöjd och sover som en stock med ögonbindeln. Tack\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"fa4db648-6dad-48ec-9656-da469af81c4d\",\"rating\":5,\"date\":\"2024-01-04T17:23:15Z\",\"author\":\"Cecilia Dismo\",\"title\":\"Sömnmask\",\"body\":\"Oerhörd lång leveranstid! Jag beställde 231216 och idag 240104 kom varorna.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"b358525d-02d5-4196-8f89-3f59fd4449a7\",\"rating\":4,\"date\":\"2023-12-27T14:35:00Z\",\"author\":\"Tommy Gustavsson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"d1f403cb-64f5-4364-995b-9ce2f630720e\",\"rating\":5,\"date\":\"2023-11-23T10:59:24Z\",\"author\":\"Anna Fornell\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"75f00c40-bd66-449d-aab4-01b24d36a731\",\"rating\":5,\"date\":\"2023-11-13T21:46:56Z\",\"author\":\"Bertil Lundberg\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"ddfa3a14-9d83-4213-b125-30cb68fd37df\",\"rating\":5,\"date\":\"2023-11-07T07:36:47Z\",\"author\":\"Helena Livijn\",\"title\":\"\",\"body\":\"Dessa är så så bra.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"502cdb05-ae76-40c2-b0d6-6881a78a3922\",\"rating\":4,\"date\":\"2023-11-05T21:56:45Z\",\"author\":\"kikki arnberg\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"06dd0c15-f2ea-4bd6-9d49-570681b7ea00\",\"rating\":5,\"date\":\"2023-10-23T13:04:42Z\",\"author\":\"Thomas Nilsson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"75075eb0-a7c2-44e1-bf69-15bbe1a59653\",\"rating\":5,\"date\":\"2023-10-16T13:01:03Z\",\"author\":\"Kristina Elofsson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"c74c8c8f-0439-4cbc-a4c4-ad5025387dac\",\"rating\":5,\"date\":\"2023-09-22T21:00:30Z\",\"author\":\"Lennart Arvedson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"f542c9af-c1cd-45eb-8c6d-97f35cb7bb53\",\"rating\":5,\"date\":\"2023-09-22T20:06:42Z\",\"author\":\"Erika Lidén\",\"title\":\"\",\"body\":\"Produkten var bra men illa att den skickades direkt från Kina. Kommer därför inte handla igen. Ha ett lager i Sverige istället och skicka därifrån.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"997c0b43-3e31-4e2b-b76c-d71babd28438\",\"rating\":5,\"date\":\"2023-09-14T11:17:52Z\",\"author\":\"Hanna Sevéus\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"d557cf80-41fe-4717-b1a2-c7693f2cd933\",\"rating\":3,\"date\":\"2023-09-14T08:23:46Z\",\"author\":\"Mats Sundström\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"cb00d6f2-2220-4d2c-b2d8-09abc1d12e80\",\"rating\":5,\"date\":\"2023-07-27T06:54:44Z\",\"author\":\"Kerstin Gebart\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"65e0090a-74d5-4992-8cdd-7fbe8ae13821\",\"rating\":5,\"date\":\"2023-07-21T19:56:00Z\",\"author\":\"Maria Gustafsson\",\"title\":\"Sömnmask\",\"body\":\"Funkar jättebra. Blir inte längre väckt av morgonsolen.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"ef34ed03-b1f5-491a-b3cb-8740b753c9ba\",\"rating\":5,\"date\":\"2023-07-17T10:04:28Z\",\"author\":\"Anneli Hedener\",\"title\":\"mkt bra\",\"body\":\"bästa jag använt\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"8cdd9ab7-5ed6-4b2c-99ba-127136313e81\",\"rating\":5,\"date\":\"2023-07-10T17:19:20Z\",\"author\":\"Sara Haasmark\",\"title\":\"\",\"body\":\"Jag har inte fått beställningen\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"e73ad53c-f85a-4a13-bc23-7ac6081919c5\",\"rating\":5,\"date\":\"2023-07-07T05:48:38Z\",\"author\":\"Rose-Marie Ehn\",\"title\":\"Sovmask\",\"body\":\"Masken sitter bra under hela natten och den slutet helt tätt, det blir nattsvart 😎\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"ca1a1fa4-c6db-45b6-87dd-ed1d320d726a\",\"rating\":5,\"date\":\"2023-06-28T16:12:20Z\",\"author\":\"Tom Eliasson\",\"title\":\"Mer sovtid\",\"body\":\"Sömnen har förlängts på morgonen med minst 2 timmar.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"6993352e-de27-4337-ad5c-47de90297bed\",\"rating\":5,\"date\":\"2023-06-28T10:45:29Z\",\"author\":\"Emelie Karlsson\",\"title\":\"\",\"body\":\"👌\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"46f24e60-1431-404f-b2a2-44e66ffa47c3\",\"rating\":5,\"date\":\"2023-06-23T08:18:25Z\",\"author\":\"Karin Ögren\",\"title\":\"Mycket bra sömnstöd\",\"body\":\"Denna sömnmask är mycket bra med den tredimensionella designen som gör det med bekvämt för ögonen och gör att det inte känns lite tätt runt ögonen. Rekommenderas!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"975cac91-f28e-4955-bbbe-2fd5e4408f36\",\"rating\":5,\"date\":\"2023-06-22T05:32:40Z\",\"author\":\"Johan Särnbratt\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a24e2ceb-9499-415b-ae6b-61d9501e7dc6\",\"rating\":5,\"date\":\"2023-06-14T17:24:59Z\",\"author\":\"Joakim Hedman\",\"title\":\"Jon blund\",\"body\":\"Kanon 👍\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"62fe6390-8a06-42b0-b091-b172068a8206\",\"rating\":5,\"date\":\"2023-05-27T11:42:41Z\",\"author\":\"Christina Eng\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"dc34f807-073f-4202-98dd-993d0e65024f\",\"rating\":4,\"date\":\"2023-05-22T19:16:09Z\",\"author\":\"Lotta Carlsson\",\"title\":\"\",\"body\":\"Något för tjockvadderad för mig som sover på sidan men annars funkar den kanon\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a692af73-a196-47e8-81cc-2467eb4f3a45\",\"rating\":5,\"date\":\"2023-05-22T16:56:27Z\",\"author\":\"Carina Karlsson\",\"title\":\"\",\"body\":\"Helt perfekt håller ljuset helt\\n\\nBorta med den mjuka vaderingen runt.sitter bra.\\n\\nMörkt o bra när ljuset faller på.underbar\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"d5965ecf-f564-4414-9b27-510fadad7fd9\",\"rating\":5,\"date\":\"2023-05-22T10:42:28Z\",\"author\":\"Ulf Lundqvist\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"060f814e-2d2f-44aa-a20e-a96089d11ebf\",\"rating\":5,\"date\":\"2023-04-29T06:30:52Z\",\"author\":\"Eva Färnlöf Orbe\",\"title\":\"Behaglig och ljustät\",\"body\":\"Min man sover bättre nu och gillar verkligen denna sovmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"44d3880c-db4a-45fc-92e5-a8e08724edb4\",\"rating\":5,\"date\":\"2023-04-27T11:58:11Z\",\"author\":\"Johan Rudqvist\",\"title\":\"Mkt bra!!!\",\"body\":\"Bästa masken jag testat\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"47513465-d1b1-4146-90f5-1c7d52865fe8\",\"rating\":5,\"date\":\"2023-04-20T06:39:35Z\",\"author\":\"Emilia Waldenskiöld\",\"title\":\"Bästa sovmasken!\",\"body\":\"Har provat andra och dyrare men denna är bäst. Så skön och inget ljus tittat in. Sitter där den ska.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"47e0fe2a-bcd6-4e3e-bde2-d2549c361f04\",\"rating\":5,\"date\":\"2023-04-06T05:55:06Z\",\"author\":\"Sandra Belacsi\",\"title\":\"Nöjd kund\",\"body\":\"Väldigt nöjd! Även i dagsljus så blir det kolsvart.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"edd401d6-add4-46a4-9622-fc5fa1b6db3d\",\"rating\":5,\"date\":\"2023-03-16T20:13:29Z\",\"author\":\"Jerry Dahlbom\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a66555d5-2b61-415c-975d-4266a99a1c11\",\"rating\":3,\"date\":\"2023-03-09T22:30:35Z\",\"author\":\"Alexandra Agnes Ingeborg Hagström\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"7cdd6fb3-6e44-47f0-84e7-ed40570b460d\",\"rating\":5,\"date\":\"2023-03-03T08:53:20Z\",\"author\":\"Ewa Grafford\",\"title\":\"Underbart!\",\"body\":\"Sover mycket bättre med denna mask. Den är mjuk, sluter tätt och man kan blinka utan att fransarna tar emot.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"4a4d18ef-de16-4c82-b24d-6df7687f7b09\",\"rating\":4,\"date\":\"2023-02-27T11:54:27Z\",\"author\":\"Patric Svanberg\",\"title\":\"Okej sovmask men lång leverans från Kina\",\"body\":\"Bra mask som mörkar omgivningen bra men kunde ha tjockare fyllning för att sitta åt ordentligt skönt och effektivare mot ljus. Resårbandet som får masken att sitta kvar borde ha mjukare kant då den inte är så bekväm.\\n\\nSkulle fått fem stjärnor om detta var ordnat. Skulle gärna betalt en hundralapp extra för dessa egenskaper.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"23bc1097-932b-473a-9e96-56a250549c56\",\"rating\":5,\"date\":\"2023-02-15T19:28:56Z\",\"author\":\"Tobiaz Rosengren scapiro\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"edfe3096-9e40-4377-aad8-089a9363b4cf\",\"rating\":5,\"date\":\"2023-02-14T17:00:16Z\",\"author\":\"Ann Sparrock\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"58a53067-6d00-4349-a0f3-7bd44fdd14ed\",\"rating\":5,\"date\":\"2023-01-22T21:39:02Z\",\"author\":\"Stig Larsson\",\"title\":\"\",\"body\":\"Bra mask släpper inte något ljus\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"7cf2e6c7-af37-4879-aeb7-6739706b76e9\",\"rating\":5,\"date\":\"2023-01-20T05:40:02Z\",\"author\":\"Pernilla\",\"title\":\"\",\"body\":\"Bästa sömnmasken som jag har haft!!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"96452bdf-470f-45cd-b333-7b14d79ccb09\",\"rating\":5,\"date\":\"2023-01-19T04:27:33Z\",\"author\":\"Peter Krook\",\"title\":\"\",\"body\":\"Sover som en gud\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"843a3957-d115-4753-b684-262ad54eb51f\",\"rating\":5,\"date\":\"2023-01-07T04:00:55Z\",\"author\":\"Customer\",\"title\":\"Bästa\",\"body\":\"Köpte 2 för ett par år sen.\\n\\nSkulle ha en i reserv!\\n\\nAnvänder fortfarande den första!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"cf17ddc1-eefc-49bf-9812-d66a27d48bed\",\"rating\":5,\"date\":\"2023-01-05T10:35:13Z\",\"author\":\"Margaretha Lilliesköld\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"b23523f0-cd44-4465-bade-7b0d46096c7b\",\"rating\":4,\"date\":\"2022-12-28T13:43:15Z\",\"author\":\"Börje Lundmark\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"d322911b-f5b5-4d9c-bd9e-9f2726c6649b\",\"rating\":4,\"date\":\"2022-12-25T07:43:00Z\",\"author\":\"Åke Ljunggren\",\"title\":\"Sovmask\",\"body\":\"Masken var bra, men jag uppfattade inte att den skulle komma direkt från Kina onödigt lång transport för en produkt hade inte köpt den om jag förstått det\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"31a13a96-fe31-4ad7-bad7-a2d1bc357ddd\",\"rating\":5,\"date\":\"2022-12-07T16:19:31Z\",\"author\":\"Jessica Persson\",\"title\":\"Good\",\"body\":\"Good\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"417d6f3a-f3bd-4ff0-a8e8-05d1ef1adc9d\",\"rating\":5,\"date\":\"2022-12-01T11:12:11Z\",\"author\":\"Fredrik Ed\",\"title\":\"\",\"body\":\"Skön\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"61e5f531-5e74-4c15-a668-955b9e8f5c94\",\"rating\":5,\"date\":\"2022-11-07T19:40:30Z\",\"author\":\"Sandra Kantosalmi\",\"title\":\"\",\"body\":\"Bästa sovmasken jag haft 👍\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"9f57557c-ee8e-43c6-b3ad-687dc08763c9\",\"rating\":5,\"date\":\"2022-11-07T14:32:09Z\",\"author\":\"Carl-Martin Edén\",\"title\":\"\",\"body\":\"Fantastisk produkt! Förbättrar sömnen hundra procent!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"10c59fdf-758f-4353-884b-edbdbb4930dd\",\"rating\":5,\"date\":\"2022-10-27T04:20:38Z\",\"author\":\"Mats Luphinius\",\"title\":\"Superbra\",\"body\":\"Den är så skön helt mörkt och luftig \\n\\nHar man problem med sömnen så är den här perfekt 🤩\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"d7e14ba5-af1a-438e-a42c-d1ab2d7a0c34\",\"rating\":5,\"date\":\"2022-10-26T21:08:23Z\",\"author\":\"Johan D\",\"title\":\"Härliga.\",\"body\":\"Sköna blir riktigt mörkt,äntligen kan man sova dagtid.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"ad0017f3-3a5e-4f51-a4b7-f2f9e0f62c74\",\"rating\":5,\"date\":\"2022-10-14T10:54:58Z\",\"author\":\"Irina Valenceva\",\"title\":\"Gillar starkt och kan verkligen rekommendera\",\"body\":\"Bra kvalite! Superskönt att sova med. Kolsvart!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"fe4df188-e048-4419-8205-91947099acc0\",\"rating\":4,\"date\":\"2022-09-22T07:56:59Z\",\"author\":\"Mikael Lewerth\",\"title\":\"Stor sömnmask\",\"body\":\"Gör det verkligen mörkt, men pga sin tjocklek inte så bra när man ligger på sidan - lite obekväm.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"30efbfb6-a8f2-4534-b9ab-331fe536ff21\",\"rating\":3,\"date\":\"2022-09-21T17:44:03Z\",\"author\":\"Joakim Sædén\",\"title\":\"Inte min form\",\"body\":\"Fin, mysig och bra i princip, men rundlarna vid ögonen är för breda nedtill. Masken glider lätt upp lite för att hamna bekvämt och då går ögonfransarna mot rundlarna, vilka då tappar sitt syfte. Kan ha med min ansiktsform att göra, men jag blev besviken.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"908d07a9-4221-47f4-b119-2a1461953133\",\"rating\":5,\"date\":\"2022-09-16T13:53:01Z\",\"author\":\"S.J.\",\"title\":\"Toppen!\",\"body\":\"Mjuk och skön,  Släpper inte in ljus alls!  Bästa jag haft!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"77a68696-0564-4b6a-8cb9-7aaaef552b77\",\"rating\":5,\"date\":\"2022-09-04T13:24:10Z\",\"author\":\"Disa Zakariasson Jönsson\",\"title\":\"\",\"body\":\"Toppen!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"7139006b-59dc-40ee-8792-a660f0606629\",\"rating\":5,\"date\":\"2022-09-02T10:52:18Z\",\"author\":\"Hans Lemker\",\"title\":\"\",\"body\":\"Fungerar bra\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"33ddbc3d-4857-452c-b75f-65984ac169b3\",\"rating\":4,\"date\":\"2022-08-24T16:47:39Z\",\"author\":\"Christer Holgersson\",\"title\":\"\",\"body\":\"Helt okej. Lite längre leveranstid än väntat.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"118e2d5b-2fa4-4c73-8f0f-d529af58ebe0\",\"rating\":4,\"date\":\"2022-08-24T12:45:13Z\",\"author\":\"Maria Nilsson Hagberg\",\"title\":\"Bra köp\",\"body\":\"Stänger ute allt ljus men lite varm.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"0ccc8621-3974-46ea-b6b3-bc180d562dfb\",\"rating\":5,\"date\":\"2022-08-21T06:02:58Z\",\"author\":\"Kevin\",\"title\":\"Inget ljus tränger sig igenom!\",\"body\":\"Väldigt sköna och bra passform. Inget ljus tränger sig igenom och bra med det justerbara bandet. Enda negativa är att dom skickas från Kina så leveransen tog ca 16 dagar.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"b4ba3438-bf88-4ac9-8853-3ae61f501852\",\"rating\":5,\"date\":\"2022-08-20T15:15:26Z\",\"author\":\"Hans winblad\",\"title\":\"Nöjd\",\"body\":\"Iite lång leverans, annars nöjd\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"5accdcbf-26c4-4190-b70e-ce1e4108f7e0\",\"rating\":5,\"date\":\"2022-08-19T14:55:47Z\",\"author\":\"Ingela Källström\",\"title\":\"Sömnmask\",\"body\":\"Den är perfekt och klämmer inte någonstans och trycker inte på ögonlocken, mycket bekväm rekommenderar verkligen denna sömnmask.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"96d47914-68bb-44e5-92ba-7876917e0c0a\",\"rating\":5,\"date\":\"2022-08-18T05:55:55Z\",\"author\":\"Ljiljana Ilic\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"ed9061fa-36d8-434c-ba7f-4eb2b208d3bb\",\"rating\":5,\"date\":\"2022-08-15T14:04:16Z\",\"author\":\"Djateu Tarja\",\"title\":\"\",\"body\":\"Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"6ee58138-c077-406e-af49-55ee0265f323\",\"rating\":4,\"date\":\"2022-08-14T15:33:57Z\",\"author\":\"Elin Amanda Johansson\",\"title\":\"Bästa sovmask jag har provat\",\"body\":\"Mycket bra, det blir mörkt. Bandet skaver lite bakom öronen dock, och den trycker lite på min stora näsa. Annars toppen.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"107f2c56-6088-4d88-b924-fe48f5e5e3c8\",\"rating\":5,\"date\":\"2022-08-13T17:57:18Z\",\"author\":\"Yvonne Sjögren\",\"title\":\"\",\"body\":\"Mjuk och behaglig.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"8c08641a-1eca-4844-8c40-81af303234eb\",\"rating\":5,\"date\":\"2022-08-12T17:53:45Z\",\"author\":\"Bo Enquist\",\"title\":\"Sömnproblem\",\"body\":\"Hej! Högsta betyg! Håller vad som lovats, det blir mörkt släpper inte in ngt ljus.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"6c1cdef8-a215-47a7-a0dc-a5c1ffddb936\",\"rating\":5,\"date\":\"2022-08-11T06:27:31Z\",\"author\":\"Carin Wahlberg\",\"title\":\"Ögonmask\",\"body\":\"Toppenbra\\n\\nUppskattar att man kan blinka med masken på\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"602f07b3-103f-4ee0-932c-7025c2576f44\",\"rating\":5,\"date\":\"2022-08-10T08:34:27Z\",\"author\":\"Ylva Hållander\",\"title\":\"Helt underbar!\",\"body\":\"Sitter bra, klämmer inte åt, lossnar inte. Mycket nöjd med prisvärd artikel.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"f51819e4-b313-4e08-8b85-45a10b57e102\",\"rating\":4,\"date\":\"2022-08-09T07:54:37Z\",\"author\":\"Anne-Maria Holma\",\"title\":\"\",\"body\":\"Allt var ok.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"b0d37baa-0e49-4af3-83b5-92473d32eeb1\",\"rating\":5,\"date\":\"2022-08-08T06:16:49Z\",\"author\":\"Catharina\",\"title\":\"\",\"body\":\"Riktigt bra och bekväm sovmask.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"e279e60b-7bca-4e3a-885a-4c87ceabd5ba\",\"rating\":5,\"date\":\"2022-08-05T19:42:28Z\",\"author\":\"Ann-cathrine Hammarin\",\"title\":\"\",\"body\":\"Superbra sömnnask och skön\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"0591da51-59ba-4063-bc5d-f7774bf3b771\",\"rating\":3,\"date\":\"2022-07-27T22:19:45Z\",\"author\":\"Therese Lindenmo\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"6ea35c9a-4016-44d9-98f9-fcc10b0cefc9\",\"rating\":3,\"date\":\"2022-07-26T13:38:25Z\",\"author\":\"Elisabeth Svensson\",\"title\":\"Bra mask i det stora hela men passar inte alla näsor\",\"body\":\"Masken är skön men lite klumpig. Hamnar den rätt släpper den inte igenom ljuset. Men som med många andra produkter verkar den vara av och för män då min näsa är liten och ögonbindeln inte täpper till runt näsan tillräckligt.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"d3b002d4-ba1c-476f-8f58-96d2e00dd920\",\"rating\":5,\"date\":\"2022-07-25T17:54:43Z\",\"author\":\"Nour Eddine El Harrab\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"2de59e43-7978-44a1-829f-70066db58ed8\",\"rating\":5,\"date\":\"2022-07-24T17:29:47Z\",\"author\":\"Mikael solin\",\"title\":\"Mso\",\"body\":\"Funkar bra för oss.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"4a0ebd44-52bc-4053-90e4-8a50c1f96dc1\",\"rating\":5,\"date\":\"2022-07-23T20:20:13Z\",\"author\":\"Susanne Lundell\",\"title\":\"Ögonmask\",\"body\":\"Tack Jon Blund!\\n\\nJag har testat såå många ögonmasker som inte håller vad de lovar, för fem öre.\\n\\nJag har b.la en hjärntumör i skelettet som även sitter bakom höger öga och dessutom trycker ut ögat tre millimeter. Andra masker trycker mot ögat, men inte den här!\\n\\nJag är så glad och tacksam för att jag hittade den här 🙏\\n\\nDen håller vad ni lovar att den ska, till 100%!\\n\\nMvh Susanne\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a0ad159e-5264-4291-a89f-e38ce6815529\",\"rating\":5,\"date\":\"2022-07-21T19:23:56Z\",\"author\":\"Eva Hallor\",\"title\":\"Ögonbindel\",\"body\":\"Världens bästa sovhjälpande ögonbindel. Bra färg och jättemjuk och skön är den. Jag är så nöjd och tacksam att jag hittat Jon Blund.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"11a25236-2ebb-439a-a40f-5ca5d7afcd79\",\"rating\":5,\"date\":\"2022-07-21T10:24:38Z\",\"author\":\"Cherish Reed Alborn\",\"title\":\"Sover som en stock!\",\"body\":\"Bästa sov masken jag någonsin haft! Super bekväm!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"ec85e838-c57c-4ded-960a-00bfa643770a\",\"rating\":5,\"date\":\"2022-07-20T06:58:58Z\",\"author\":\"Emma Jönsson Jönsson\",\"title\":\"\",\"body\":\"Bandet som sitter runt huvudet, skaver lite på öronen, annars supernöjd! Sover jättebra på morgonen numera!👍😊\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"733da594-747a-4b1e-8828-bb525eb3c775\",\"rating\":5,\"date\":\"2022-07-13T11:02:32Z\",\"author\":\"Christina Sedlmayer\",\"title\":\"Sömnmask\",\"body\":\"Toppenbra!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"c1b2f506-561c-4475-b4e4-2a1c10658d21\",\"rating\":5,\"date\":\"2022-07-11T10:18:19Z\",\"author\":\"Mats Larsson\",\"title\":\"\",\"body\":\"Bästa masken\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"d1356856-5f9d-4d1a-b096-e04e1e20744b\",\"rating\":5,\"date\":\"2022-07-10T18:34:17Z\",\"author\":\"Per-Olof Olsson\",\"title\":\"Kanonköp\",\"body\":\"Funkar suveränt, rekommenderas starkt.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"f2427aa8-c7fa-4bf7-996a-6784ecd3dddd\",\"rating\":5,\"date\":\"2022-07-08T09:15:09Z\",\"author\":\"Pontus Ros\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"570b72ed-b667-4bdf-b374-06991a80b685\",\"rating\":2,\"date\":\"2022-07-06T19:45:52Z\",\"author\":\"Gunilla Zetterkvist\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"12b96acc-f416-49d6-b407-b53b31ea64cb\",\"rating\":5,\"date\":\"2022-07-05T22:21:36Z\",\"author\":\"Nicolas Rönnegard\",\"title\":\"Aldrig sovit så bra\",\"body\":\"Otroligt skön sovmask som sätter så skönt! Det blir helt mörkt och inte alls obekväm. Jag gillar verkligen att man kan ställa in hur långt bandet ska vara runt! Leveranstiden tog sig ungefär en vecka men det var det verkligen värt! Rekommenderar verkligen \\n\\n//En riktigt nöjd kund\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"57dd3315-46dc-4a4b-ba8a-1f2e55823f18\",\"rating\":5,\"date\":\"2022-07-04T06:34:12Z\",\"author\":\"Johan Sjövall\",\"title\":\"\",\"body\":\"Mycket bra\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"aaaf7eaf-3e8b-42a3-8b3a-9be79abdf9fa\",\"rating\":5,\"date\":\"2022-07-04T04:35:29Z\",\"author\":\"Mia Melin\",\"title\":\"Sovmask\",\"body\":\"Min man älskar den. Helt tät och väldigt behaglig och skön❣️\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"e67dd141-3a5a-41fc-8611-b18eb87c6825\",\"rating\":5,\"date\":\"2022-07-02T12:25:39Z\",\"author\":\"Carin Bright\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"718fd5af-702d-4d0e-9bc3-7d363ae9af42\",\"rating\":5,\"date\":\"2022-07-02T02:48:02Z\",\"author\":\"Marie Lorentzen Hamberg\",\"title\":\"Mycket nöjd!\",\"body\":\"Masken är perfekt för mig eftersom jag jobbar natt och sover på dagtid! Den sluter helt tätt och är mjuk och bekväm mot ansiktet. Man kan till och med öppna ögonen med masken på 😊!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"cce5691c-d442-4693-ae18-077264931452\",\"rating\":5,\"date\":\"2022-07-01T09:17:32Z\",\"author\":\"Christina Granath\",\"title\":\"Jättebra\",\"body\":\"Det blir otroligt svart inget ljus tränger igenom\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"99736c31-3341-462b-8e31-18553e8511c0\",\"rating\":5,\"date\":\"2022-06-30T21:08:44Z\",\"author\":\"Anna Johansson\",\"title\":\"\",\"body\":\"Total darkness!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"367d4202-6626-4268-af32-dfc7ae829568\",\"rating\":1,\"date\":\"2022-06-29T11:25:42Z\",\"author\":\"Lenita Jakobsson\",\"title\":\"Bara okej\",\"body\":\"Mörklägger jättebra, men tyvärr andas den ingenting så det blir alldeles för varmt. Dessutom är bandet så smart så det skär in och skaver.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"1e458143-ccf8-487a-9d53-ceb17a4a6ea8\",\"rating\":1,\"date\":\"2022-06-25T21:09:42Z\",\"author\":\"Martin Kryger\",\"title\":\"Bra ögonskydd, dåligt band\",\"body\":\"Själva ögonskyddet är helt ok. Gummibandet, däremot är värdelöst. Dels är det för kort, dels skaver både bandet och spännena på öronen. Detta gör skyddet obrukbart.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"e493493a-5158-42c6-9c46-205e2a09150f\",\"rating\":5,\"date\":\"2022-06-24T06:31:00Z\",\"author\":\"Jessica Berghult\",\"title\":\"Fungerar bra!\",\"body\":\"Bra kvalitet i håller ljuset ute.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"3ec8f44f-ab40-428b-9a82-1f089b6f0bc7\",\"rating\":5,\"date\":\"2022-06-22T09:38:22Z\",\"author\":\"Ulrika Aspling\",\"title\":\"Bra produkt!\",\"body\":\"Stänger ute ljus samtidigt som den är bekväm\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a387ded3-0b14-411f-878e-669472b5a666\",\"rating\":3,\"date\":\"2022-06-22T02:41:25Z\",\"author\":\"Ida Olsson\",\"title\":\"Inte helt nöjd\",\"body\":\"Tycker att bandet runt huvudet skaver på toppen av öronen,  annars är det en bra produkt\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"7b0d1a48-aff0-4851-83ac-ba056ccfad96\",\"rating\":5,\"date\":\"2022-06-20T15:47:48Z\",\"author\":\"Elisabet Petersson-Lind\",\"title\":\"Ok\",\"body\":\"Ok! Lite varm bara!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"23e1ff14-d24c-470a-8090-a34293f9c142\",\"rating\":5,\"date\":\"2022-06-19T09:45:29Z\",\"author\":\"Britt Thorstensson\",\"title\":\"Sitter bra\",\"body\":\"Har i nuläget ej provat.Gav bort i present\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"078f5355-d692-4a66-b9a6-cc70d50eb12f\",\"rating\":5,\"date\":\"2022-06-19T06:48:21Z\",\"author\":\"Carina Mattsson\",\"title\":\"Sömnmask\",\"body\":\"Superbra sömnmask. Ska köpa en till.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"db8b4cad-8653-4da7-ab29-2c55ac465cc7\",\"rating\":5,\"date\":\"2022-06-18T17:16:02Z\",\"author\":\"Marie Rosberg\",\"title\":\"Jon Blund\",\"body\":\"Bästa masken jag provat. Sitter på plats hela natten, inget tryck på ögonen då det är utfasat för att kunna titta/blinka. Kan nog inte vara utan dem sommartid när det blir ljust tidigt/Marie\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a8b6cb29-a41f-4d8a-b589-31ae087d7ddf\",\"rating\":5,\"date\":\"2022-06-17T18:49:34Z\",\"author\":\"Klas Sundström\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"6915c6da-7c0e-47da-8fdc-e1b9e02faf92\",\"rating\":5,\"date\":\"2022-06-17T14:55:46Z\",\"author\":\"Kaj Johansson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"718b3b26-19ac-450e-95ca-1c8c2d89074e\",\"rating\":4,\"date\":\"2022-06-17T13:35:44Z\",\"author\":\"Daniel Finnhult\",\"title\":\"Sömnmask\",\"body\":\"Helt mörkt. Bra komfort och inte för varm.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"d007e24b-7744-4db0-aa78-cd86681ca8d2\",\"rating\":5,\"date\":\"2022-06-17T09:50:26Z\",\"author\":\"Gab\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"0b74529e-e226-4f89-a69e-0d9a340ab1f9\",\"rating\":4,\"date\":\"2022-06-11T20:31:31Z\",\"author\":\"Matilda Jonsson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"2bc84923-f62a-4386-8024-d3d6550b0820\",\"rating\":5,\"date\":\"2022-06-08T17:25:04Z\",\"author\":\"Jan-Inge Dahlberg\",\"title\":\"\",\"body\":\"Har fortfarande inte fått varan\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"bf6f1fbd-f0fd-47f8-90a7-9a9ae8aca9ad\",\"rating\":5,\"date\":\"2022-06-08T08:05:16Z\",\"author\":\"Anna\",\"title\":\"Äntligen nattsvart!\",\"body\":\"Äntligen en ögonmask som stänger ute allt ljus. Den sitter på ordentligt och luftspalten framför ögonen är väldigt bekväm.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"d12579d2-c7fd-42b7-9c1e-c5dd90d10eff\",\"rating\":5,\"date\":\"2022-06-05T18:11:07Z\",\"author\":\"Margareta Wall\",\"title\":\"\",\"body\":\"Bra köp\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"3d8a99d1-d5f0-4eeb-b2cc-7318b94a9a67\",\"rating\":5,\"date\":\"2022-06-05T17:22:06Z\",\"author\":\"Bert Pettersson\",\"title\":\"Sömnmask\",\"body\":\"Bra mask som stängee ute ljus.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"0b87b949-7f41-4a7c-99dd-e12d55a42c3b\",\"rating\":5,\"date\":\"2022-05-28T18:16:08Z\",\"author\":\"Eva Wennberg\",\"title\":\"Absolut mörkt!\",\"body\":\"Skön att ha på sig och ger totalt mörker. Det enda negativa var att den luktar lite plastigt men det lär väl gå över.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"9f93190b-ce03-47a4-ab04-f1542c83ee10\",\"rating\":4,\"date\":\"2022-05-28T08:25:57Z\",\"author\":\"Ulf Adolfsson\",\"title\":\"\",\"body\":\"Mycket bra. Lite varm ibland vid lång sovperiod.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"fc5513a4-52e1-4b3e-bd5d-cefbd7bbee62\",\"rating\":4,\"date\":\"2022-05-28T07:13:11Z\",\"author\":\"Marlene Duvhammar Espell\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"f5fa8e59-13ce-4179-b8a2-48422eb18f5e\",\"rating\":5,\"date\":\"2022-05-26T09:56:24Z\",\"author\":\"Axel D'Angelo Gentile\",\"title\":\"Great mask!\",\"body\":\"To try it last night and switched on the light on my bedside table to check whether any light would go through... I woke up this morning and the light was still on, which I had not realised that until I took my mask off. Soft and breathable material, and total blackout. I'm very pleasently surprised.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"80384fa3-5749-48f8-a26b-084130ccece4\",\"rating\":4,\"date\":\"2022-05-23T12:59:14Z\",\"author\":\"Sandra Olsson\",\"title\":\"\",\"body\":\"C\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"cf40b884-7e75-4215-b07a-81d96dec7859\",\"rating\":5,\"date\":\"2022-05-21T16:07:41Z\",\"author\":\"Theresa\",\"title\":\"Tipp tipp topp!!!\",\"body\":\"Superbra!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"21a46248-5872-4b09-9312-b4fb9037e2e2\",\"rating\":5,\"date\":\"2022-05-21T07:33:51Z\",\"author\":\"Birgit Andersson\",\"title\":\"Sovmask\",\"body\":\"Fungerar bra - inga problem hittills.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"1c24ca1c-e2c9-42b9-8636-55145f600663\",\"rating\":5,\"date\":\"2022-05-20T21:43:56Z\",\"author\":\"Linda Chang Andersson\",\"title\":\"Mjukt och behagligt\",\"body\":\"Riktigt bra kvalitet och en av de bästa jag har använt.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"1fd96774-9553-48c7-a8ae-9dac30fa366a\",\"rating\":5,\"date\":\"2022-05-19T19:29:10Z\",\"author\":\"Catrin Granqvist\",\"title\":\"\",\"body\":\"Mycket nöjd\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"000774eb-fbbf-4289-a251-4e7b3e9abcbf\",\"rating\":4,\"date\":\"2022-05-16T18:57:15Z\",\"author\":\"Annacarin Söderfeldt\",\"title\":\"Sovmask\",\"body\":\"Superskön och lätt. Och det blir verkligen mörkt😝\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a0943fe6-6761-4de4-8289-02e2e7aa80aa\",\"rating\":4,\"date\":\"2022-05-16T10:41:13Z\",\"author\":\"Majvor Agvén\",\"title\":\"Jon Blund sovmask\",\"body\":\"Denna mask är toppen 😀\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"01c8e3d5-5ad8-468c-9b48-a73a7012bec7\",\"rating\":5,\"date\":\"2022-05-05T16:37:31Z\",\"author\":\"Ann-Sofi Henriksson\",\"title\":\"Toppen!!\",\"body\":\"Den bästa sömnmask jag testat.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"57bd5313-5eaa-41f5-adb0-669b783361c6\",\"rating\":2,\"date\":\"2022-05-04T10:05:59Z\",\"author\":\"Andre Andersson\",\"title\":\"Nja\",\"body\":\"Memoryskum var det inte, någon billigare mycket enklare innehåll... får märken I ansiktet efter användning.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"0002c8ab-3049-4d5c-bcd4-49bfba5f4c38\",\"rating\":5,\"date\":\"2022-04-29T20:31:00Z\",\"author\":\"Susanne Lundell\",\"title\":\"\",\"body\":\"Superbra produkt\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"4137c00a-703e-4965-9cb7-94b598d4a5bd\",\"rating\":5,\"date\":\"2022-03-29T05:06:39Z\",\"author\":\"Fredrik Marthell\",\"title\":\"Bästa sovmasken\",\"body\":\"Köpte en till min tjej för 6 månader sedan, nu köpte jag 2 till då hon aldrig vill vara utan.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"74789429-2958-4a92-bbac-399a3707ee78\",\"rating\":5,\"date\":\"2022-03-24T10:35:28Z\",\"author\":\"Tomas Ciba\",\"title\":\"Sovmask\",\"body\":\"Bekväm, tät och fungerar bra. Trycker inte på ögonen.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"bf3ebff7-27ac-4bdf-b390-8f108e7c9166\",\"rating\":5,\"date\":\"2022-01-17T13:26:06Z\",\"author\":\"Eivor Hortlund\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"5632c960-7b62-448b-b49d-bded40b8e77d\",\"rating\":5,\"date\":\"2021-11-17T08:05:39Z\",\"author\":\"Inga Nelvig\",\"title\":\"\",\"body\":\"Fungerar bättre än alla andra jag haft eftersom inget tryck känns på ögat. Storleken hindrar ljus att hitta in. Absolut en bra grej!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"4ca2792f-9771-4757-bde4-6f15ce887a30\",\"rating\":4,\"date\":\"2021-10-06T23:08:11Z\",\"author\":\"Peter Juhlin\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a6549037-68a2-4ce6-ab2f-d482249e08d3\",\"rating\":5,\"date\":\"2021-10-04T07:48:15Z\",\"author\":\"Marcus Ehrenhorn\",\"title\":\"Väldigt bra\",\"body\":\"Skriver sällan recensioner, men har varit på jakt efter den bra mask väldigt länge. Har kollat runt i väldigt många prisklasser och i princip inga håller måttet eller är väldigt små och meningslösa, men ändå dyra. Den här masken är skön, släpper inte in något ljus och känns helt enkelt perfekt för min del. Bandet går att ställa in efter ditt huvud. Beställer genast 3 till.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"72b49204-cd45-4456-b022-11aae667f81c\",\"rating\":5,\"date\":\"2021-09-29T17:25:40Z\",\"author\":\"Mitha\",\"title\":\"Bästa Sömnmasken!\",\"body\":\"Denna sömnmask ger 100% mörkläggning och är superskön att ha på sig. Den sitter väldigt bra runt ansiktet och åker inte iväg när jag vänder mig på natten. Rekommenderas starkt! Den bästa sömnmasken som jag har använt.  Tur att jag köpte 2 st på en  gång. Fick sömnmasken väldigt snabbt.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"fef080c7-d5a3-4ff1-a627-e20257214e9b\",\"rating\":5,\"date\":\"2021-09-27T17:13:09Z\",\"author\":\"Britt Eriksson\",\"title\":\"\",\"body\":\"Luktar rökig fick huvudvärk  , annars mycket bra .\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"e0ed2db4-c4d4-4641-894e-599562cafa61\",\"rating\":1,\"date\":\"2021-09-27T10:14:11Z\",\"author\":\"Marie Berglund\",\"title\":\"\",\"body\":\"Har inte fått produkt även\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"feefe6e3-3d9f-4d4e-9b2e-3a5aeda625c3\",\"rating\":5,\"date\":\"2021-09-22T13:44:17Z\",\"author\":\"Gustafsson Nicklas\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"812a2efb-eb44-49f0-a0d0-d4d3e3aba561\",\"rating\":5,\"date\":\"2021-09-18T18:33:32Z\",\"author\":\"Zoltan Simek\",\"title\":\"\",\"body\":\"Bra\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"c50e12f1-14ff-4d50-ac4b-d6df24b762b5\",\"rating\":5,\"date\":\"2021-09-18T08:36:36Z\",\"author\":\"Claus Röyem\",\"title\":\"Mycket bra och prisvärd\",\"body\":\"Sömnmasken stänger effektivt ute allt ljus. Den känns mjuk och skön att ha på sig, sitter på plats hela natten och verkar vara av god kvalitet. Leveransen kom utan problem efter en dryg vecka. Apotekets sömnmask hamnade i soptunnan🙂\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"1f802b2a-9cae-4446-b792-9431e9dd3692\",\"rating\":4,\"date\":\"2021-09-16T09:05:15Z\",\"author\":\"Heidi Stenman\",\"title\":\"Bra\",\"body\":\"Bra sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a50b6e7c-f9ee-4656-982d-a834f20dc78d\",\"rating\":5,\"date\":\"2021-09-15T18:50:36Z\",\"author\":\"Cecilia Mildner\",\"title\":\"Mjuk och skön\",\"body\":\"Den sitter jättebra och släpper inte in ljus tack vare den lilla extra isydda tygstycket vid näsan. Min make tycker att banden bakom skär in i örat, den borde ha varit vadderad.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"9b4c037a-42bc-4287-96f9-6a6db5353ebc\",\"rating\":5,\"date\":\"2021-09-15T18:18:53Z\",\"author\":\"Anna Lavröd\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"18d7e602-18d0-4a97-a116-e9003662c506\",\"rating\":5,\"date\":\"2021-09-15T15:37:08Z\",\"author\":\"Jörgen Berggren\",\"title\":\"Kanon bra\",\"body\":\"Den var jätteskön. När den är utsliten skall jag köpa en ny 👍👍\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"ef8fb51f-45bb-4d16-b443-07b02eabe34d\",\"rating\":5,\"date\":\"2021-09-14T16:07:52Z\",\"author\":\"Anita Palm\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"011e7858-7711-490f-b769-2047db2c6c61\",\"rating\":4,\"date\":\"2021-09-13T18:30:35Z\",\"author\":\"Hans\",\"title\":\"Den bästa jag har provat, men mindre klimtsmart\",\"body\":\"Detta är den bästa sömnmask som jag har provat. Den sluter verkligen helt tätt, och är väldigt bekväm i och med att ögonen inte blir tilltryckta. Kan dock bli en aning varm, och det tjocka materialet gör det mindre bekvämt att sova på sidan.\\n\\nDrar av en stjärna för att den skickas styckevis från Kina. Tack och lov slipper man betala avgift till PostNord, men det är ju inte så klimatsmart att skicka saker en och en.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"0c8c8fac-5f89-4005-8e8c-df2cc0988c90\",\"rating\":5,\"date\":\"2021-09-13T13:07:36Z\",\"author\":\"Teresa Valle\",\"title\":\"Underbar sömn\",\"body\":\"Den bästa jag provat!!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"f2397f61-9a10-4601-bf63-1929906b9829\",\"rating\":4,\"date\":\"2021-09-11T12:27:29Z\",\"author\":\"Conny Corneliusson\",\"title\":\"Bästa mask jag har prövat\",\"body\":\"En bra och skön mask. Den bästa jag har provat. Jag har inte använt den vid så många tillfällen ännu men den känns vara av bra kvalitet. Utmärkt på flyg- och tågresor där mörker är önskvärt eller på hotell där mörkläggningen inte är bra. Leveransen tog för mig en vecka vilket jag tycker är fullt rimligt. Valde \\\"early bird\\\" och hade den hängdes på min dörr en tidig morgon. Jag är nöjd både med produkt och leverans.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"152eea7e-ec0b-40aa-97b2-26395fd598a0\",\"rating\":5,\"date\":\"2021-09-10T15:30:58Z\",\"author\":\"Carolina de la Fé\",\"title\":\"\",\"body\":\"Behaglig, funktionell och stilren\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a1337448-f011-482f-9e94-982e87fba414\",\"rating\":4,\"date\":\"2021-09-09T16:16:04Z\",\"author\":\"Paula Samuelsson\",\"title\":\"Bra reglering\",\"body\":\"Jag gillar verkligen den här masken. Trycker inte på ögonen och har ett bekvämt reglerbart band. Leveransen tog tyvärr lång tid och kundtjänst verkar vara svårt att få tag på. Men produkten är bra!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"ece02174-40c7-4acd-9ac2-80aa3d2e5d66\",\"rating\":5,\"date\":\"2021-09-07T09:04:27Z\",\"author\":\"Markus Nordqvist\",\"title\":\"\",\"body\":\"Snabb leverans. Bra kvalite!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"5c7f20fe-69e7-4d85-b309-14d79ee3240b\",\"rating\":4,\"date\":\"2021-09-05T05:44:22Z\",\"author\":\"Anonym\",\"title\":\"Bra! Men lite bulkig\",\"body\":\"Blockerar 99% av ljuset, mjukt och skönt tyg och nuddar inte ögonen. Funkar med fransförlängning. Problemet för mig som sover på sida/mage är att den är lite bulkig och hamnar på sniskan, då släpps ljus in från sidorna. Men det är lätt justerat. Ljusskyddet över näsan är lite för tjockt för mig och gör det liiiite svårt att andas, men det är inte ett jätteproblem. Överlag mycket nöjd!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"eaecfe69-10d7-49c5-9fa2-5f38bf14b781\",\"rating\":5,\"date\":\"2021-09-05T05:32:54Z\",\"author\":\"Liudmila Dubanos\",\"title\":\"\",\"body\":\"Jag är jätte nöjd!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"437d00e8-4a8e-47ab-a29f-a4c192c084f5\",\"rating\":5,\"date\":\"2021-09-04T21:52:27Z\",\"author\":\"Mia Florén\",\"title\":\"Väldigt bra!\",\"body\":\"Jag älskar den! Jag har sovit så bra sedan jag fick hem den. Det blir helt mörkt. Den sitter mjukt mot ansiktet och är så bekväm. Den luktade konstigt när jag fick den så handtvättade den lite snabbt så gick det bort. Det enda som inte känns najs är att den skickas från andra sidan jorden. Sånt miljöslös man bidrar till!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"7b005760-a6de-41fa-8208-0f0bba74f302\",\"rating\":5,\"date\":\"2021-09-04T17:26:41Z\",\"author\":\"Kerstin Norrman\",\"title\":\"Sömnmask\",\"body\":\"Absolut den bästa mask jag någonsin provat. Inget ljusinsläpp, mjuk mot ansiktet och dessutom inte varm.\\n\\nHar nu beställt ytterligare en att ha i reserv.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"93d24284-01f7-414d-9394-21b6193b85b8\",\"rating\":3,\"date\":\"2021-09-04T09:21:01Z\",\"author\":\"Agneta Glemme\",\"title\":\"God natt\",\"body\":\"Sov gott\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"1b509c72-19e3-4a59-982a-bf17a7363630\",\"rating\":5,\"date\":\"2021-08-29T06:25:30Z\",\"author\":\"Erik K\",\"title\":\"Bästa sömnmasken\",\"body\":\"Jag har testat många sömnmasker, det här är den överlägset bästa: Inga glipor, inget som skaver och mycket bekväm.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"36922266-6f8b-494e-b795-c212fbb8c845\",\"rating\":5,\"date\":\"2021-08-27T12:47:37Z\",\"author\":\"Annelie\",\"title\":\"Sömnmask som utlovats\",\"body\":\"Fick hem den beställda masken efter ca 12 dagar. Den håller hög kvalite. Är nöjd med köpet.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a259f39c-5479-4e7a-86f5-8196971592f3\",\"rating\":5,\"date\":\"2021-08-23T14:22:52Z\",\"author\":\"Karin Nilsson\",\"title\":\"Sömnmask\",\"body\":\"Otroligt skön! Sitter jättebra på.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"360099a2-26f5-43db-94f5-a2a639133623\",\"rating\":5,\"date\":\"2021-08-21T10:20:34Z\",\"author\":\"Eva\",\"title\":\"Sömnmask\",\"body\":\"Jätteskön och det blir helt mörkt, kan verkligen rekommenderas\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"9fd57703-fdad-405d-920b-db773a93e8d2\",\"rating\":4,\"date\":\"2021-08-19T19:49:27Z\",\"author\":\"Jan-Olof Åsen\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"804e839b-c235-462f-913b-cc637c6d5673\",\"rating\":5,\"date\":\"2021-08-19T16:49:05Z\",\"author\":\"Christian Gille\",\"title\":\"Bekväm sömnmask\",\"body\":\"Detta är en av de mest bekväma sömnmaskerna jag har provat hittills.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"49d878e0-9e4c-4b1d-b0da-b556591d9626\",\"rating\":5,\"date\":\"2021-08-19T15:41:35Z\",\"author\":\"Björn Larsson\",\"title\":\"Drömmar\",\"body\":\"Den är super bra!!!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"5910c5cf-2aa5-4c8d-b0e3-44b61422a85f\",\"rating\":4,\"date\":\"2021-08-18T19:16:44Z\",\"author\":\"Claes Larsson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"1234ab56-04f9-42f9-95f9-4d94d5aac333\",\"rating\":3,\"date\":\"2021-08-18T14:22:23Z\",\"author\":\"Lars Wahlin\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"0aee3ff7-53e5-4a51-8740-6a0031809006\",\"rating\":5,\"date\":\"2021-08-18T07:09:36Z\",\"author\":\"Eva Lönn\",\"title\":\"Nattsvart!\",\"body\":\"Täcker allt ljus. Sitter skönt. Helt perfekt. Det tog cirka två veckor till leverans. Skickas inte från Sverige.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"bacf9296-b306-4aa3-a094-23d2cf25e0d9\",\"rating\":5,\"date\":\"2021-08-17T19:04:53Z\",\"author\":\"Magdalena Anderberg\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"405b6662-a6ea-4057-8314-c9cb930317c4\",\"rating\":4,\"date\":\"2021-08-17T13:46:23Z\",\"author\":\"Laila Andersson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"6803b3ca-1083-42f0-a6a2-81a859910178\",\"rating\":5,\"date\":\"2021-08-16T10:42:53Z\",\"author\":\"Elisabet\",\"title\":\"Bästa sömnmasken\",\"body\":\"Jag har provat många sömnmasker, detta är den bästa! Den är mjuk men stadig, stänger ute ljuset bra, bra förlängningsband. Det bästa av allt, kupad över ögonen. Mycket nöjd!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"e2d4574f-cf5c-468f-bca3-e60c5c3bc592\",\"rating\":5,\"date\":\"2021-08-16T09:01:22Z\",\"author\":\"Marre\",\"title\":\"\",\"body\":\"Toppen! Jag kan verkligen rekommendera den här.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"214a0d44-2ae9-4ec2-8876-ac427401c0d6\",\"rating\":5,\"date\":\"2021-08-16T07:59:49Z\",\"author\":\"Charlotte\",\"title\":\"Fantastisk\",\"body\":\"Mjuk och behaglig. Stänger ute ALLT ljus. Framför allt är bandet reglerbart med väl tilltaget mått o sitter inte åt. Passar alltså även oss med lite större huvudmått.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a1854e23-25a1-4343-bf93-d15c1a08b4c5\",\"rating\":4,\"date\":\"2021-08-15T07:08:35Z\",\"author\":\"Jeanette Slotthed\",\"title\":\"\",\"body\":\"Luktar lite konstigt, men annars väldigt bekväm och mörkläggande!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"2d4ad54c-ec40-4ffc-9d12-17d7d065c77d\",\"rating\":4,\"date\":\"2021-08-13T19:17:15Z\",\"author\":\"Danne Asplund\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"57840ad9-dc1f-4fc9-b7a3-933730cadf4b\",\"rating\":5,\"date\":\"2021-08-13T17:49:57Z\",\"author\":\"M.F.\",\"title\":\"Effektiv sömnhjälp!\",\"body\":\"Tog på masken när jag vaknade av morgonsolen kl 05. Somnade om och sov till 09.30, det längsta jag sovit på hela sommaren. Underbart! Blir helt mörkt och den är mjuk och bekväm att ha på sig.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"a35e4cc4-0c7e-4f39-adc3-718b2f6963ec\",\"rating\":5,\"date\":\"2021-08-13T06:04:13Z\",\"author\":\"Anita Ericsson\",\"title\":\"Jon blund\",\"body\":\"Väldigt nöjd med min nya ögonmask👍Otroligt skön och passformen är super. Håller verkligen ljuset borta och jag får sova i ett riktigt mörkt sovrum🙏\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"242f2b8b-ec7d-44d4-b471-8e94ad5604ca\",\"rating\":5,\"date\":\"2021-08-12T19:20:42Z\",\"author\":\"Jennie Lindberg\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"811797e9-3f6f-478c-bfd4-e53744dcf11c\",\"rating\":5,\"date\":\"2021-08-12T16:16:49Z\",\"author\":\"Sandra Juya\",\"title\":\"Värt & Rekommenderar!\",\"body\":\"Super skön materiel, mjukt tyg, skonsam mot huden & låter huden andas. Släpper inte något ljus alls & är helt svårt när på. Precis vad jag har letat efter & priset är perfekt & ska inte kosta mera! Jag rekommenderar denna produkt. Älskar min & så glad jag tog chansen att prova denna produkt.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"2455bbb1-54ae-4f82-af74-660d03b16f57\",\"rating\":5,\"date\":\"2021-08-11T19:53:40Z\",\"author\":\"Lars-Åke Atlesson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"f57ce243-d493-4885-b58f-48fc3cd5dcf5\",\"rating\":4,\"date\":\"2021-08-11T19:17:41Z\",\"author\":\"Maria Willén Larsson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"b1dd7e43-12e3-409c-a704-8db85f38ea6c\",\"rating\":5,\"date\":\"2021-08-11T15:34:02Z\",\"author\":\"Anne-Sophie Malmström\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"6b1e9dd6-edb5-4df8-afe7-3e07067d2f08\",\"rating\":2,\"date\":\"2021-08-11T09:27:11Z\",\"author\":\"Sigfredo Leiva\",\"title\":\"\",\"body\":\"Tåg lång tid.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"7bf333e5-c23e-49e0-ac21-3807692f73c5\",\"rating\":5,\"date\":\"2021-08-05T16:49:30Z\",\"author\":\"Ingrid Alfe\",\"title\":\"Bekväm mask!\",\"body\":\"Väl fungerande och bekväm sömnmask!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"94be934b-b878-47aa-a467-cc24f5a26253\",\"rating\":5,\"date\":\"2021-08-04T08:01:09Z\",\"author\":\"Karin af Klintberg\",\"title\":\"\",\"body\":\"Jättebra!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"52a6aed5-a2e3-4dad-9e13-33a5ab0d77b1\",\"rating\":5,\"date\":\"2021-07-31T11:43:32Z\",\"author\":\"Viviann Göransson\",\"title\":\"Bästa sämnmasken!\",\"body\":\"Jättebra sömnmask som ger totalt mörker och inte trycker mot ögonen.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"150a88e4-8fd4-40e9-85a6-8b5231d017d1\",\"rating\":4,\"date\":\"2021-07-30T09:17:30Z\",\"author\":\"Kent Bengtsson\",\"title\":\"Sovmask\",\"body\":\"Fungerar bra för mej!\\n\\nMin fru tycker hon svettas av den.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"25e908cb-6c9d-4380-b5d2-deb562998119\",\"rating\":5,\"date\":\"2021-07-24T12:46:38Z\",\"author\":\"Dodoli\",\"title\":\"Godnatt\",\"body\":\"Har provat Apotekets sömnmask, men denna är hundra gånger skönare och mer effektivt. Det blir helt mörkt och den är dessutom väldigt skön att ha på sig. Ett måste för oss som har lite svårt att somna\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"872a21ce-3d4b-4c40-946c-6ff8b264b811\",\"rating\":5,\"date\":\"2021-07-21T07:01:52Z\",\"author\":\"Camilla Karlsson\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"3fd47d59-f51b-4bb8-b95d-2f63514bf1d9\",\"rating\":5,\"date\":\"2021-07-07T16:21:11Z\",\"author\":\"Kerstin Clarström\",\"title\":\"\",\"body\":\"Fungerade mycket bra!\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"6e1e4be1-a0ea-4355-9e2d-e9420991d076\",\"rating\":4,\"date\":\"2021-07-05T17:20:54Z\",\"author\":\"Thomas Holm\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"4eb6a29d-3bba-4774-9859-bd0a750dde46\",\"rating\":5,\"date\":\"2021-07-04T16:22:49Z\",\"author\":\"eva engberg\",\"title\":\"Skönaste sovmasken\",\"body\":\"Mjuk, skön och ”tät” sovmask, kan rekommenderas\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"5be32594-cda9-49be-9ece-ecaef4aa6bc9\",\"rating\":5,\"date\":\"2021-07-03T12:36:17Z\",\"author\":\"Ewa Soytemiz\",\"title\":\"\",\"body\":\"Jon Blund™ Sömnmask\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"0c286855-3361-4b1d-b562-0a6ea8e55e6f\",\"rating\":5,\"date\":\"2021-06-29T19:40:07Z\",\"author\":\"Martin Lindbäck\",\"title\":\"Har inte fått produkten\",\"body\":\"Väntar fortfarande på paketet. Går inte att spåra. Svårt att recensera något som de inte levererar. Funderar på att be om pengarna tillbaka.\",\"verified\":true,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"1deaf41c-eb35-4901-b71b-6c649e938992\",\"rating\":5,\"date\":\"2021-05-19T15:58:00Z\",\"author\":\"J Schmitt\",\"title\":\"\",\"body\":\"Fantastiskt bra jämfört med tidigare masker jag använt.\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[],\"reply\":\"\"},{\"id\":\"30fa9c6d-d574-48e3-8815-a3e80f494fc4\",\"rating\":5,\"date\":\"2021-05-18T10:03:00Z\",\"author\":\"Susanna Bartell\",\"title\":\"\",\"body\":\"Jättebra!\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[\"https://ae01.alicdn.com/kf/Ud5412afde4754607aa137666f01e92eam.jpg\",\"https://ae01.alicdn.com/kf/U16480c9b3fd648d3ad082a37b58f7cb4x.jpg\",\"https://ae01.alicdn.com/kf/Ua11f0383b45e420cbd7ca0422bdffefa5.jpg\"],\"reply\":\"\"},{\"id\":\"1153c54b-2a3a-44f5-8da3-06d6bf0c03b5\",\"rating\":5,\"date\":\"2021-05-17T23:16:00Z\",\"author\":\"Kassandra R\",\"title\":\"\",\"body\":\"Bra kvalité, mötte förväntningarna. Hade en konstig lukt men jag kastade den i tvätten sen var det inga problem :)\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[\"https://ae01.alicdn.com/kf/Uc8d0680e2ad849a78ae9d40ebad99214b.jpg\",\"https://ae01.alicdn.com/kf/U7d8420b7b0e645ee9fe3d04456f7e72er.jpg\"],\"reply\":\"\"},{\"id\":\"d531087a-4ae5-4663-91a8-77ecd9a5d827\",\"rating\":5,\"date\":\"2021-05-17T01:21:00Z\",\"author\":\"Alexandra B\",\"title\":\"\",\"body\":\"Mjuk och skön mot ansiktet\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[\"https://ae01.alicdn.com/kf/Ud6c9811225764214bf49607a42de53f1b.jpg\",\"https://ae01.alicdn.com/kf/U0789c893f3ba4bb4bff7ca98931b1edfQ.jpg\",\"https://ae01.alicdn.com/kf/U7fefe911fc534dc19ffcd4372da5e446O.jpg\"],\"reply\":\"\"},{\"id\":\"cf0a5954-9a81-4111-96e0-a33a1adab28c\",\"rating\":5,\"date\":\"2021-05-10T09:50:00Z\",\"author\":\"Danne\",\"title\":\"\",\"body\":\"Funkar skitbra\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[\"https://ae01.alicdn.com/kf/U4ae83026de8c4e92afdc1010a6f002433.jpg\",\"https://ae01.alicdn.com/kf/U26354de370a64f85a56e4fb1091e908dP.jpg\",\"https://ae01.alicdn.com/kf/U3fe5569ea68a40d090f0964c13910603I.jpg\"],\"reply\":\"\"},{\"id\":\"79fc58f1-b968-4e50-a6dd-889ca3f902e3\",\"rating\":5,\"date\":\"2021-05-09T17:46:00Z\",\"author\":\"Agneta Olsson\",\"title\":\"\",\"body\":\"Har stora problem med ljuset i denna årstid då våra persienner inte blockerar ut ljuset bra. Denna gör ett utmärkt jobb.\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[\"https://ae01.alicdn.com/kf/Ub13d37a04ec5464982f68319313e2aacK.jpg\",\"https://ae01.alicdn.com/kf/U87137eb932944f5391ecaf73468b32ac4.jpg\",\"https://ae01.alicdn.com/kf/Ued52bc10ab7f4e5dae86cf2a078932c4r.jpg\"],\"reply\":\"\"},{\"id\":\"7aca1fed-e121-406c-8418-43c173668c56\",\"rating\":5,\"date\":\"2021-05-04T12:30:00Z\",\"author\":\"Carl\",\"title\":\"\",\"body\":\"Mjuk o skön att bära. Särskilt med \\\"groparna\\\" för ögonen\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[\"https://ae01.alicdn.com/kf/U72437161ef834491b8ae890323f31f43q.jpg\",\"https://ae01.alicdn.com/kf/U35f58f54b7104835ac58ab5021fbb3f0w.jpg\",\"https://ae01.alicdn.com/kf/U6c6f008ff2734916bc1c9445dd9a20d0p.jpg\"],\"reply\":\"\"},{\"id\":\"e8fd10a2-1935-4858-8d68-45776549f42b\",\"rating\":5,\"date\":\"2021-04-07T00:07:00Z\",\"author\":\"Alexandria Yassos\",\"title\":\"\",\"body\":\"Hjälper mig oerhört mkt med sömnen, rekommenderas starkt :)\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[\"https://ae01.alicdn.com/kf/U36e0de455eda4992bdf6965f096a0478Q.jpg\"],\"reply\":\"\"},{\"id\":\"d5e3b4a5-e6bf-4a12-82e3-9ce0c81ccc89\",\"rating\":5,\"date\":\"2021-04-06T10:21:00Z\",\"author\":\"Martin Schiller\",\"title\":\"\",\"body\":\"Mycket nöjd\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[\"https://ae01.alicdn.com/kf/Ue2b9dd8d947c4a89af12e2297b95df74o.jpg\"],\"reply\":\"\"},{\"id\":\"b09eccd6-1866-40de-bf5c-3a32ba90e11a\",\"rating\":5,\"date\":\"2021-03-25T08:44:00Z\",\"author\":\"Gabriel R\",\"title\":\"\",\"body\":\"Fungerar som den ska, nöjd\",\"verified\":false,\"sourceLanguage\":\"\",\"productUrl\":\"/products/somnmask\",\"images\":[\"https://ae01.alicdn.com/kf/Uae8f27dc64804f8eba695a1f92413a1dj.jpg\"],\"reply\":\"\"}]}")
}, Ws = Us, Gs = (e) => new Intl.DateTimeFormat("sv-SE", {
	day: "numeric",
	month: "long",
	year: "numeric",
	timeZone: "UTC"
}).format(new Date(e));
function Ks({ rating: e = 5 }) {
	return /* @__PURE__ */ (0, W.jsx)("span", {
		className: "review-stars",
		"aria-label": `${e.toLocaleString("sv-SE", { maximumFractionDigits: 2 })} av 5 stjärnor`,
		children: [
			1,
			2,
			3,
			4,
			5
		].map((t) => /* @__PURE__ */ (0, W.jsxs)("span", {
			className: "review-star",
			children: [/* @__PURE__ */ (0, W.jsx)(fe, { size: 14 }), /* @__PURE__ */ (0, W.jsx)(fe, {
				size: 14,
				fill: "currentColor",
				className: "review-star-fill",
				style: { clipPath: `inset(0 ${100 - Math.max(0, Math.min(1, e - t + 1)) * 100}% 0 0)` }
			})]
		}, t))
	});
}
function qs({ handle: e = "somnmask" }) {
	let t = Ws[e];
	return t?.count ? /* @__PURE__ */ (0, W.jsxs)("a", {
		className: "proof-rating",
		href: "#omdomen",
		children: [
			/* @__PURE__ */ (0, W.jsx)(Ks, { rating: t.average }),
			/* @__PURE__ */ (0, W.jsxs)("strong", { children: [t.average.toLocaleString("sv-SE", { maximumFractionDigits: 2 }), " av 5"] }),
			/* @__PURE__ */ (0, W.jsxs)("span", { children: [t.count, " omdömen"] }),
			/* @__PURE__ */ (0, W.jsx)(M, { size: 15 })
		]
	}) : null;
}
var Js = [
	[
		"4137c00a-703e-4965-9cb7-94b598d4a5bd",
		"Först en. Sedan två till.",
		"ÅTERKÖPET"
	],
	[
		"843a3957-d115-4753-b684-262ad54eb51f",
		"Reservmasken fick vänta.",
		"ÅREN TILLSAMMANS"
	],
	[
		"5eff2204-ab79-4000-82f7-c45e94e43c6e",
		"När solen går upp före dig.",
		"DEN SVENSKA MORGONEN"
	]
];
function Ys() {
	return /* @__PURE__ */ (0, W.jsxs)("section", {
		className: "section customer-stories",
		id: "var-historia",
		children: [
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "section-heading",
				children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("p", {
					className: "eyebrow",
					children: "KUNDRÖSTER SEDAN 2021"
				}), /* @__PURE__ */ (0, W.jsxs)("h2", { children: [
					"En del av era nätter.",
					/* @__PURE__ */ (0, W.jsx)("br", {}),
					/* @__PURE__ */ (0, W.jsx)("em", { children: "År efter år." })
				] })] }), /* @__PURE__ */ (0, W.jsx)("p", {
					className: "story-intro",
					children: "Det finns saker som bara ni kan berätta. Om masken som följer med genom åren. Och den man köper en till av."
				})]
			}),
			/* @__PURE__ */ (0, W.jsx)("div", {
				className: "story-grid",
				children: Js.map(([e, t, n]) => {
					let r = Us.somnmask.reviews.find((t) => t.id === e);
					return /* @__PURE__ */ (0, W.jsxs)("figure", {
						className: "story-card",
						children: [
							/* @__PURE__ */ (0, W.jsx)("p", {
								className: "eyebrow",
								children: n
							}),
							/* @__PURE__ */ (0, W.jsx)("h3", { children: t }),
							/* @__PURE__ */ (0, W.jsx)(Ks, { rating: r.rating }),
							/* @__PURE__ */ (0, W.jsxs)("blockquote", { children: [
								"“",
								r.body,
								"”"
							] }),
							/* @__PURE__ */ (0, W.jsxs)("figcaption", { children: [
								/* @__PURE__ */ (0, W.jsx)("strong", { children: r.author }),
								/* @__PURE__ */ (0, W.jsx)("span", { children: Gs(r.date) }),
								/* @__PURE__ */ (0, W.jsxs)("span", {
									className: "verified-review",
									children: [/* @__PURE__ */ (0, W.jsx)(N, { size: 14 }), " Verifierat köp"]
								})
							] })
						]
					}, e);
				})
			}),
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "story-foot",
				children: [/* @__PURE__ */ (0, W.jsx)("span", { children: "Tre kunders egna erfarenheter av Jon Blund™ Sömnmask." }), /* @__PURE__ */ (0, W.jsxs)("a", {
					className: "text-link",
					href: "#omdomen",
					children: ["Läs alla 222 omdömen ", /* @__PURE__ */ (0, W.jsx)(M, { size: 17 })]
				})]
			})
		]
	});
}
function Xs({ review: e }) {
	let [t, n] = (0, _.useState)(!1), r = e.body.length > 360;
	return /* @__PURE__ */ (0, W.jsxs)("article", {
		className: "archive-review",
		"data-review-id": e.id,
		children: [
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "archive-review-top",
				children: [/* @__PURE__ */ (0, W.jsx)(Ks, { rating: e.rating }), /* @__PURE__ */ (0, W.jsx)("time", {
					dateTime: e.date,
					children: Gs(e.date)
				})]
			}),
			e.title && /* @__PURE__ */ (0, W.jsx)("h3", { children: e.title }),
			/* @__PURE__ */ (0, W.jsx)("p", {
				className: "review-body",
				children: r && !t ? `${e.body.slice(0, 360)}…` : e.body
			}),
			r && /* @__PURE__ */ (0, W.jsx)("button", {
				className: "review-expand",
				"aria-expanded": t,
				onClick: () => n(!t),
				children: t ? "Visa mindre" : "Läs hela omdömet"
			}),
			e.reply && /* @__PURE__ */ (0, W.jsxs)("div", {
				className: "review-reply",
				children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: "Svar från Jonblund" }), /* @__PURE__ */ (0, W.jsx)("p", { children: e.reply })]
			}),
			e.images.length > 0 && /* @__PURE__ */ (0, W.jsx)("a", {
				className: "review-expand",
				href: `${Ws[e.productUrl.split("/").pop()]?.sourceUrl}#judgeme_product_reviews`,
				target: "_blank",
				rel: "noreferrer",
				children: "Bilder finns i originalomdömet ↗"
			}),
			/* @__PURE__ */ (0, W.jsxs)("footer", { children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: e.author }), e.verified && /* @__PURE__ */ (0, W.jsxs)("span", {
				className: "verified-review",
				children: [/* @__PURE__ */ (0, W.jsx)(N, { size: 14 }), " Verifierat köp"]
			})] })
		]
	});
}
function Zs({ handle: e = "somnmask" }) {
	let [t, n] = (0, _.useState)("all"), [r, i] = (0, _.useState)("new"), [a, o] = (0, _.useState)(""), [s, c] = (0, _.useState)(1), l = Ws[e], u = (0, _.useMemo)(() => (l?.reviews ?? []).filter((e) => (t === "all" || e.rating === Number(t)) && `${e.author} ${e.title} ${e.body}`.toLocaleLowerCase("sv").includes(a.trim().toLocaleLowerCase("sv"))).sort((e, t) => r === "old" ? e.date.localeCompare(t.date) : r === "low" ? e.rating - t.rating || t.date.localeCompare(e.date) : r === "high" && t.rating - e.rating || t.date.localeCompare(e.date)), [
		l,
		t,
		r,
		a
	]);
	if (!l?.count) return null;
	let d = Math.max(1, Math.ceil(u.length / 6)), f = (e) => {
		n(e), c(1);
	};
	return /* @__PURE__ */ (0, W.jsxs)("section", {
		className: "section reviews-library",
		id: "omdomen",
		children: [
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "section-heading",
				children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("p", {
					className: "eyebrow",
					children: "HELA BILDEN, MED ERA ORD"
				}), /* @__PURE__ */ (0, W.jsxs)("h2", { children: ["Så tycker ", /* @__PURE__ */ (0, W.jsx)("em", { children: "ni." })] })] }), /* @__PURE__ */ (0, W.jsxs)("p", {
					className: "review-section-intro",
					children: [
						"Alla produktens omdömen. Från fem stjärnor till en.",
						/* @__PURE__ */ (0, W.jsx)("br", {}),
						"Läs, sök och hitta det som är viktigt för dig."
					]
				})]
			}),
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "review-overview",
				children: [/* @__PURE__ */ (0, W.jsxs)("div", {
					className: "review-score",
					children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: l.average.toLocaleString("sv-SE", { maximumFractionDigits: 2 }) }), /* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)(Ks, { rating: l.average }), /* @__PURE__ */ (0, W.jsxs)("p", { children: [
						"av 5 · ",
						l.count,
						" produktomdömen"
					] })] })]
				}), /* @__PURE__ */ (0, W.jsx)("div", {
					className: "rating-bars",
					children: [
						5,
						4,
						3,
						2,
						1
					].map((e) => /* @__PURE__ */ (0, W.jsxs)("button", {
						onClick: () => f(String(e)),
						"aria-label": `Visa ${e}-stjärniga omdömen`,
						"aria-pressed": t === String(e),
						children: [
							/* @__PURE__ */ (0, W.jsxs)("span", { children: [
								e,
								" ",
								/* @__PURE__ */ (0, W.jsx)(fe, {
									size: 12,
									fill: "currentColor"
								})
							] }),
							/* @__PURE__ */ (0, W.jsx)("span", {
								className: "rating-track",
								children: /* @__PURE__ */ (0, W.jsx)("span", { style: { width: `${l.distribution[String(e)] / l.count * 100}%` } })
							}),
							/* @__PURE__ */ (0, W.jsx)("span", { children: l.distribution[String(e)] })
						]
					}, e))
				})]
			}),
			/* @__PURE__ */ (0, W.jsxs)("aside", {
				className: "judge-medals",
				"aria-label": "Jonblunds butiksutmärkelser från Judge.me",
				children: [
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "judge-medals-label",
						children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: "Två guldsigill från Judge.me" }), /* @__PURE__ */ (0, W.jsx)("span", { children: "Tilldelade Jonblund som butik" })]
					}),
					/* @__PURE__ */ (0, W.jsxs)("a", {
						href: "https://judge.me/reviews/stores/jonblund.se",
						target: "_blank",
						rel: "noreferrer",
						className: "judge-medal",
						children: [/* @__PURE__ */ (0, W.jsx)("img", {
							src: "https://public-images.judge.me/judgeme/medals-v2-2025-rebranding/auth/gold.svg",
							width: 84,
							height: 84,
							alt: "Judge.me Gold Authentic Shop",
							loading: "lazy"
						}), /* @__PURE__ */ (0, W.jsxs)("span", { children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: "Gold Authentic Shop" }), /* @__PURE__ */ (0, W.jsx)("small", { children: "Minst 95 % av publicerade omdömen är verifierade." })] })]
					}),
					/* @__PURE__ */ (0, W.jsxs)("a", {
						href: "https://judge.me/reviews/stores/jonblund.se",
						target: "_blank",
						rel: "noreferrer",
						className: "judge-medal",
						children: [/* @__PURE__ */ (0, W.jsx)("img", {
							src: "https://public-images.judge.me/judgeme/medals-v2-2025-rebranding/ver_rev/gold.svg",
							width: 84,
							height: 84,
							alt: "Judge.me Gold Verified Reviews Shop",
							loading: "lazy"
						}), /* @__PURE__ */ (0, W.jsxs)("span", { children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: "Gold Verified Reviews Shop" }), /* @__PURE__ */ (0, W.jsx)("small", { children: "Minst 100 verifierade kundomdömen." })] })]
					})
				]
			}),
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "review-controls",
				children: [
					/* @__PURE__ */ (0, W.jsxs)("label", {
						className: "review-search",
						children: [/* @__PURE__ */ (0, W.jsx)(ue, { size: 18 }), /* @__PURE__ */ (0, W.jsx)("input", {
							"aria-label": "Sök i omdömen",
							value: a,
							placeholder: "Sök efter t.ex. passform, ljus, sidan…",
							onChange: (e) => {
								o(e.target.value), c(1);
							}
						})]
					}),
					/* @__PURE__ */ (0, W.jsxs)(Vs, {
						"aria-label": "Filtrera efter betyg",
						value: t,
						onChange: (e) => f(e.target.value),
						children: [/* @__PURE__ */ (0, W.jsx)(Hs, {
							value: "all",
							children: "Alla betyg"
						}), [
							5,
							4,
							3,
							2,
							1
						].map((e) => /* @__PURE__ */ (0, W.jsxs)(Hs, {
							value: e,
							children: [e, " stjärnor"]
						}, e))]
					}),
					/* @__PURE__ */ (0, W.jsxs)(Vs, {
						"aria-label": "Sortera omdömen",
						value: r,
						onChange: (e) => {
							i(e.target.value), c(1);
						},
						children: [
							/* @__PURE__ */ (0, W.jsx)(Hs, {
								value: "new",
								children: "Nyast först"
							}),
							/* @__PURE__ */ (0, W.jsx)(Hs, {
								value: "old",
								children: "Äldst först"
							}),
							/* @__PURE__ */ (0, W.jsx)(Hs, {
								value: "low",
								children: "Lägst betyg"
							}),
							/* @__PURE__ */ (0, W.jsx)(Hs, {
								value: "high",
								children: "Högst betyg"
							})
						]
					})
				]
			}),
			/* @__PURE__ */ (0, W.jsx)("p", {
				className: "review-results",
				"aria-live": "polite",
				children: u.length ? `Visar ${(s - 1) * 6 + 1}–${Math.min(s * 6, u.length)} av ${u.length} omdömen` : "Inga omdömen matchar din sökning."
			}),
			/* @__PURE__ */ (0, W.jsx)("div", {
				className: "review-archive-grid",
				children: u.slice((s - 1) * 6, s * 6).map((e) => /* @__PURE__ */ (0, W.jsx)(Xs, { review: e }, e.id))
			}),
			d > 1 && /* @__PURE__ */ (0, W.jsxs)("nav", {
				className: "review-pagination",
				"aria-label": "Omdömessidor",
				children: [
					/* @__PURE__ */ (0, W.jsx)("button", {
						disabled: s === 1,
						onClick: () => c(s - 1),
						children: "← Föregående"
					}),
					/* @__PURE__ */ (0, W.jsxs)("span", { children: [
						"Sida ",
						s,
						" av ",
						d
					] }),
					/* @__PURE__ */ (0, W.jsx)("button", {
						disabled: s === d,
						onClick: () => c(s + 1),
						children: "Nästa →"
					})
				]
			}),
			/* @__PURE__ */ (0, W.jsxs)("p", {
				className: "review-note",
				children: [
					"Produktomdömen från Jonblund, hämtade via Judge.me den 18 september 2026. Märkningen ”Verifierat köp” följer originalet.",
					" ",
					/* @__PURE__ */ (0, W.jsx)("a", {
						href: `${l.sourceUrl}#judgeme_product_reviews`,
						target: "_blank",
						rel: "noreferrer",
						children: "Se originalkällan ↗"
					})
				]
			})
		]
	});
}
//#endregion
//#region components/store/night-hero.tsx
var Qs = (e) => globalThis.__JB_ASSETS__?.[e] || "/images/" + e;
function $s() {
	return /* @__PURE__ */ (0, W.jsxs)(W.Fragment, { children: [/* @__PURE__ */ (0, W.jsxs)("a", {
		className: "cta",
		href: "/products/somnmask",
		children: ["Upptäck sömnmasken ", /* @__PURE__ */ (0, W.jsx)("span", {
			"aria-hidden": "true",
			children: "↗"
		})]
	}), /* @__PURE__ */ (0, W.jsx)(qs, {})] });
}
function ec() {
	return /* @__PURE__ */ (0, W.jsxs)("section", {
		className: "jb-night",
		"aria-labelledby": "night-headline",
		children: [/* @__PURE__ */ (0, W.jsxs)("div", {
			className: "stage",
			children: [
				/* @__PURE__ */ (0, W.jsxs)("div", {
					className: "copy",
					children: [
						/* @__PURE__ */ (0, W.jsxs)("p", {
							className: "eyebrow",
							children: [/* @__PURE__ */ (0, W.jsx)("span", {
								className: "swedish-flag",
								"aria-hidden": "true"
							}), "En av Sveriges mest köpta sovmasker"]
						}),
						/* @__PURE__ */ (0, W.jsxs)("h1", {
							id: "night-headline",
							children: [
								"Världen",
								/* @__PURE__ */ (0, W.jsx)("br", {}),
								" kan ",
								/* @__PURE__ */ (0, W.jsx)("em", { children: "vänta." })
							]
						}),
						/* @__PURE__ */ (0, W.jsxs)("p", {
							className: "description",
							children: [
								/* @__PURE__ */ (0, W.jsx)("strong", { children: "För Sveriges ljusa nätter." }),
								/* @__PURE__ */ (0, W.jsx)("br", {}),
								"När solen går upp före dig. Jonblunds 3D-sömnmask stänger ute ljuset och ger plats för ögonen."
							]
						}),
						/* @__PURE__ */ (0, W.jsx)("div", {
							className: "desktop-actions",
							children: /* @__PURE__ */ (0, W.jsx)($s, {})
						})
					]
				}),
				/* @__PURE__ */ (0, W.jsx)("div", {
					className: "visual",
					children: /* @__PURE__ */ (0, W.jsx)("img", {
						src: Qs("hero-night.jpg"),
						width: 1800,
						height: 1200,
						alt: "Jonblunds svarta sömnmask mot en mörkblå bakgrund",
						fetchPriority: "high"
					})
				}),
				/* @__PURE__ */ (0, W.jsxs)("div", {
					className: "annotation",
					children: ["JON BLUND™", /* @__PURE__ */ (0, W.jsx)("b", { children: "3D SÖMNMASK / SVART" })]
				}),
				/* @__PURE__ */ (0, W.jsxs)("div", {
					className: "product-note",
					children: [/* @__PURE__ */ (0, W.jsx)("span", {
						className: "plus",
						"aria-hidden": "true",
						children: "+"
					}), "Formad för mörker. Med plats för ögonen."]
				}),
				/* @__PURE__ */ (0, W.jsx)("div", {
					className: "actions mobile-label",
					children: /* @__PURE__ */ (0, W.jsx)($s, {})
				})
			]
		}), /* @__PURE__ */ (0, W.jsxs)("div", {
			className: "hero-bottom",
			children: [
				/* @__PURE__ */ (0, W.jsxs)("a", {
					className: "fact",
					href: "#omdomen",
					children: [/* @__PURE__ */ (0, W.jsx)("div", {
						className: "num",
						children: Us.somnmask.count
					}), /* @__PURE__ */ (0, W.jsxs)("div", {
						className: "text",
						children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: "Egna kundberättelser." }), "Alla produktomdömen, alla betyg. ↗"]
					})]
				}),
				/* @__PURE__ */ (0, W.jsxs)("div", {
					className: "fact",
					children: [/* @__PURE__ */ (0, W.jsx)("div", {
						className: "num",
						children: "2021"
					}), /* @__PURE__ */ (0, W.jsxs)("div", {
						className: "text",
						children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: "Kundröster sedan 2021." }), "En del av era nätter."]
					})]
				}),
				/* @__PURE__ */ (0, W.jsxs)("div", {
					className: "fact",
					children: [/* @__PURE__ */ (0, W.jsx)("div", {
						className: "num",
						children: "3D"
					}), /* @__PURE__ */ (0, W.jsxs)("div", {
						className: "text",
						children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: "Plats för ögonen." }), "Kupad insida. Mjuk känsla."]
					})]
				})
			]
		})]
	});
}
//#endregion
//#region components/store/mask-comparison.tsx
var tc = [
	{
		label: "Utrymme för ögonen",
		jonblund: "Formade ögonkupor skapar ett utrymme framför ögonlock och fransar.",
		flat: "Platt tyg utan formade ögonkupor ligger närmare ögonen."
	},
	{
		label: "Kontakt med ansiktet",
		jonblund: "Den mjuka dynan ligger runt ögonen. Bandet justerar hur masken sitter.",
		flat: "Tyget ligger över ögonområdet. Hur det känns beror på tyg och band."
	},
	{
		label: "Passform vid näsan",
		jonblund: "En formad näsdel hjälper masken att följa ansiktets konturer.",
		flat: "Passformen följer tygets snitt. Glipor beror på modell och ansiktsform."
	},
	{
		label: "Mot kudden",
		jonblund: "3D-formen bygger på höjden och kan kännas mer mot kudden i vissa sovlägen.",
		flat: "En tunn, platt modell tar mindre plats mellan ansiktet och kudden."
	}
];
function nc({ contoured: e }) {
	return /* @__PURE__ */ (0, W.jsxs)("svg", {
		viewBox: "0 0 160 52",
		fill: "none",
		"aria-hidden": "true",
		className: "mask-profile",
		children: [
			/* @__PURE__ */ (0, W.jsx)("path", {
				d: "M18 40 Q48 32 78 40 Q109 32 142 40",
				stroke: "currentColor",
				strokeOpacity: ".3",
				strokeWidth: "1.5"
			}),
			/* @__PURE__ */ (0, W.jsx)("path", {
				d: e ? "M18 31 L29 31 Q31 9 50 9 L58 9 Q75 9 77 30 L83 30 Q85 9 103 9 L111 9 Q130 9 132 31 L142 31" : "M18 28 Q48 20 78 28 Q109 20 142 28",
				stroke: "currentColor",
				strokeWidth: "4",
				strokeLinecap: "round"
			}),
			e && /* @__PURE__ */ (0, W.jsx)(W.Fragment, { children: /* @__PURE__ */ (0, W.jsx)("path", {
				d: "M52 18 V29 M47 24 L52 29 L57 24 M108 18 V29 M103 24 L108 29 L113 24",
				stroke: "currentColor",
				strokeWidth: "1.3",
				opacity: ".6"
			}) })
		]
	});
}
function rc() {
	return /* @__PURE__ */ (0, W.jsx)("section", {
		className: "mask-comparison",
		id: "jamfor-masker",
		"aria-labelledby": "mask-comparison-title",
		children: /* @__PURE__ */ (0, W.jsxs)("div", {
			className: "mask-comparison-inner",
			children: [/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "mask-comparison-intro",
				children: [
					/* @__PURE__ */ (0, W.jsx)("p", {
						className: "eyebrow",
						children: "PLATT TYG / FORMAD 3D"
					}),
					/* @__PURE__ */ (0, W.jsxs)("h2", {
						id: "mask-comparison-title",
						children: [
							"Skillnaden är",
							/* @__PURE__ */ (0, W.jsx)("br", {}),
							/* @__PURE__ */ (0, W.jsx)("em", { children: "utrymmet." })
						]
					}),
					/* @__PURE__ */ (0, W.jsx)("p", { children: "En sovmask ska stänga ute ljuset. Jonblunds 3D-form skapar samtidigt plats framför ögonen." }),
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "mask-comparison-principle",
						children: [/* @__PURE__ */ (0, W.jsx)("span", { children: "01 — KONSTRUKTIONEN" }), /* @__PURE__ */ (0, W.jsxs)("p", { children: [
							"Urgröpningar framför.",
							/* @__PURE__ */ (0, W.jsx)("br", {}),
							"Mjuk dyna runtom."
						] })]
					})
				]
			}), /* @__PURE__ */ (0, W.jsxs)("div", {
				className: "mask-comparison-content",
				children: [/* @__PURE__ */ (0, W.jsx)("div", {
					className: "mask-comparison-table-wrap",
					children: /* @__PURE__ */ (0, W.jsxs)("table", {
						className: "mask-comparison-table",
						children: [
							/* @__PURE__ */ (0, W.jsx)("caption", {
								className: "sr-only",
								children: "Jonblunds 3D-sömnmask jämförd med en enkel platt tygmask utan formade ögonkupor"
							}),
							/* @__PURE__ */ (0, W.jsxs)("colgroup", { children: [
								/* @__PURE__ */ (0, W.jsx)("col", {}),
								/* @__PURE__ */ (0, W.jsx)("col", { className: "mask-comparison-highlight" }),
								/* @__PURE__ */ (0, W.jsx)("col", {})
							] }),
							/* @__PURE__ */ (0, W.jsx)("thead", { children: /* @__PURE__ */ (0, W.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, W.jsx)("th", {
									scope: "col",
									children: /* @__PURE__ */ (0, W.jsx)("span", {
										className: "mask-comparison-small",
										children: "DETALJEN"
									})
								}),
								/* @__PURE__ */ (0, W.jsxs)("th", {
									scope: "col",
									children: [
										/* @__PURE__ */ (0, W.jsxs)("span", {
											className: "mask-comparison-brand",
											children: ["jonblund", /* @__PURE__ */ (0, W.jsx)("sup", { children: "®" })]
										}),
										/* @__PURE__ */ (0, W.jsx)("span", {
											className: "mask-comparison-type",
											children: "Formad 3D-mask"
										}),
										/* @__PURE__ */ (0, W.jsx)(nc, { contoured: !0 })
									]
								}),
								/* @__PURE__ */ (0, W.jsxs)("th", {
									scope: "col",
									children: [
										/* @__PURE__ */ (0, W.jsx)("span", {
											className: "mask-comparison-other",
											children: "Vanlig sovmask"
										}),
										/* @__PURE__ */ (0, W.jsx)("span", {
											className: "mask-comparison-type",
											children: "Enkel, platt tygmask"
										}),
										/* @__PURE__ */ (0, W.jsx)(nc, { contoured: !1 })
									]
								})
							] }) }),
							/* @__PURE__ */ (0, W.jsx)("tbody", { children: tc.map((e) => /* @__PURE__ */ (0, W.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, W.jsx)("th", {
									scope: "row",
									children: e.label
								}),
								/* @__PURE__ */ (0, W.jsx)("td", { children: e.jonblund }),
								/* @__PURE__ */ (0, W.jsx)("td", { children: e.flat })
							] }, e.label)) })
						]
					})
				}), /* @__PURE__ */ (0, W.jsx)("p", {
					className: "mask-comparison-note",
					children: "Jämförelsen gäller konstruktionen hos en enkel platt tygmask, inte alla andra sovmasker. Illustrationerna är schematiska. Ljustäthet och komfort beror på passform, ansiktsform och sovställning."
				})]
			})]
		})
	});
}
//#endregion
//#region components/ui/dialog.tsx
function ic({ ...e }) {
	return /* @__PURE__ */ (0, W.jsx)(Na, {
		"data-slot": "dialog",
		...e
	});
}
function ac({ ...e }) {
	return /* @__PURE__ */ (0, W.jsx)(ha, {
		"data-slot": "dialog-portal",
		...e
	});
}
function oc({ ...e }) {
	return /* @__PURE__ */ (0, W.jsx)(Xt, {
		"data-slot": "dialog-close",
		...e
	});
}
function sc({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)(mt, {
		"data-slot": "dialog-overlay",
		className: cs("fixed inset-0 isolate z-50 bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0", e),
		...t
	});
}
function cc({ className: e, children: t, showCloseButton: n = !0, ...r }) {
	return /* @__PURE__ */ (0, W.jsxs)(ac, { children: [/* @__PURE__ */ (0, W.jsx)(sc, {}), /* @__PURE__ */ (0, W.jsxs)(fa, {
		"data-slot": "dialog-content",
		className: cs("fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-sm text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", e),
		...r,
		children: [t, n && /* @__PURE__ */ (0, W.jsxs)(Xt, {
			"data-slot": "dialog-close",
			render: /* @__PURE__ */ (0, W.jsx)(ms, {
				variant: "ghost",
				className: "absolute top-2 right-2",
				size: "icon-sm"
			}),
			children: [/* @__PURE__ */ (0, W.jsx)(he, {}), /* @__PURE__ */ (0, W.jsx)("span", {
				className: "sr-only",
				children: "Close"
			})]
		})]
	})] });
}
function lc({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)(Pa, {
		"data-slot": "dialog-title",
		className: cs("font-heading text-base leading-none font-medium", e),
		...t
	});
}
function uc({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)(nn, {
		"data-slot": "dialog-description",
		className: cs("text-sm text-muted-foreground *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground", e),
		...t
	});
}
//#endregion
//#region node_modules/@base-ui/utils/useControlled.mjs
function dc({ controlled: e, default: t, name: n, state: r = "value" }) {
	let { current: i } = _.useRef(e !== void 0), [a, o] = _.useState(t);
	return [i ? e : a, _.useCallback((e) => {
		i || o(e);
	}, [])];
}
//#endregion
//#region node_modules/@base-ui/react/internals/composite/list/CompositeListContext.mjs
var fc = /* @__PURE__ */ _.createContext({
	register: () => {},
	unregister: () => {},
	subscribeMapChange: () => () => {},
	nextIndexRef: { current: 0 }
});
function pc() {
	return _.useContext(fc);
}
//#endregion
//#region node_modules/@base-ui/react/internals/composite/list/CompositeList.mjs
function mc(e) {
	let { children: t, elementsRef: n, labelsRef: r, onMapChange: i } = e, a = B(i), [, o] = _.useState(!1), s = xe(gc).current, c = xe(hc).current, l = _.useRef(0), u = _.useRef(!0), d = _.useRef([]), f = _.useRef(null), p = B(() => {
		u.current || (u.current = !0, o((e) => !e));
	}), m = B((e, t) => {
		c.set(e, t), p();
	}), h = B((e) => {
		c.delete(e), p();
	}), g = B((e) => {
		let t = /* @__PURE__ */ new Map();
		return n.current.length = 0, r && (r.current.length = 0), e.forEach((e) => {
			t.set(e.element, {
				...e.registration.metadata ?? {},
				index: e.index
			}), n.current[e.index] = e.element, r && (r.current[e.index] = e.registration.label === void 0 ? e.registration.textRef?.current?.textContent ?? e.element.textContent : e.registration.label);
		}), l.current = n.current.length, t;
	});
	function v(e) {
		if (f.current?.disconnect(), f.current = null, typeof MutationObserver != "function" || e.length < 2) return;
		let t = new MutationObserver((n) => {
			if (!yc(n)) return;
			let r = null;
			for (let n of e) if (n.isConnected) {
				if (r && bc(r, n) > 0) {
					t.disconnect(), p();
					return;
				}
				r = n;
			}
		});
		f.current = t;
		let n = /* @__PURE__ */ new Set();
		for (let t = 1; t < e.length; t += 1) {
			let r = vc(e[t - 1], e[t]);
			r && n.add(r);
		}
		n.forEach((e) => t.observe(e, { childList: !0 }));
	}
	let y = B(() => {
		let [e, t] = _c(c), n = g(e);
		v(t), d.current = e, u.current = !1, s.forEach((e) => e(n)), a(n);
	});
	V(() => (u.current || g(d.current), () => {
		n.current = [], r && (r.current = []);
	}), [
		n,
		r,
		g
	]), V(() => {
		u.current && y();
	}), V(() => () => {
		f.current?.disconnect(), u.current = !0;
	}, []);
	let b = B((e) => (s.add(e), () => {
		s.delete(e);
	})), x = _.useMemo(() => ({
		register: m,
		unregister: h,
		subscribeMapChange: b,
		nextIndexRef: l
	}), [
		m,
		h,
		b,
		l
	]);
	return /* @__PURE__ */ (0, W.jsx)(fc.Provider, {
		value: x,
		children: t
	});
}
function hc() {
	return /* @__PURE__ */ new Map();
}
function gc() {
	return /* @__PURE__ */ new Set();
}
function _c(e) {
	let t = /* @__PURE__ */ new Set(), n = [], r = [];
	e.forEach((e, i) => {
		if (!i.isConnected) return;
		let a = e.index, o = {
			index: a ?? -1,
			element: i,
			registration: e
		};
		a === null ? r.push(o) : a >= 0 && (t.add(a), n.push(o));
	});
	let i = 0;
	return r.sort((e, t) => bc(e.element, t.element)), r.forEach((e) => {
		for (; t.has(i);) i += 1;
		e.index = i, n.push(e), i += 1;
	}), t.size > 0 && n.sort((e, t) => e.index - t.index), [n, r.map((e) => e.element)];
}
function vc(e, t) {
	let n = e.parentElement;
	for (; n && !n.contains(t);) n = n.parentElement;
	return n;
}
function yc(e) {
	for (let t of e) for (let e = 0; e < t.removedNodes.length; e += 1) if (t.removedNodes[e].isConnected) return !0;
	return !1;
}
function bc(e, t) {
	return e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
}
//#endregion
//#region node_modules/@base-ui/react/accordion/root/AccordionRootContext.mjs
var xc = /* @__PURE__ */ _.createContext(void 0);
function Sc() {
	let e = _.useContext(xc);
	if (e === void 0) throw Error(_e(10));
	return e;
}
//#endregion
//#region node_modules/@base-ui/react/accordion/root/AccordionRoot.mjs
var Cc = { value: () => null }, wc = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { render: n, className: r, disabled: i = !1, hiddenUntilFound: a, keepMounted: o, loopFocus: s, onValueChange: c, multiple: l = !1, orientation: u = "vertical", value: d, defaultValue: f, style: p, ...m } = e, h = _.useMemo(() => {
		if (d === void 0) return f ?? [];
	}, [d, f]), g = _.useRef([]), [v, y] = dc({
		controlled: d,
		default: h,
		name: "Accordion",
		state: "value"
	}), b = B((e, t, n) => {
		if (!l) {
			let t = v[0] === e ? [] : [e];
			if (c?.(t, n), n.isCanceled) return;
			y(t);
		} else if (t) {
			let t = v.slice();
			if (t.push(e), c?.(t, n), n.isCanceled) return;
			y(t);
		} else {
			let t = v.filter((t) => t !== e);
			if (c?.(t, n), n.isCanceled) return;
			y(t);
		}
	}), x = _.useMemo(() => ({
		value: v,
		disabled: i,
		orientation: u
	}), [
		v,
		i,
		u
	]), S = _.useMemo(() => ({
		disabled: i,
		handleValueChange: b,
		hiddenUntilFound: a ?? !1,
		keepMounted: o ?? !1,
		state: x,
		value: v
	}), [
		i,
		b,
		a,
		o,
		x,
		v
	]), C = $e("div", e, {
		state: x,
		ref: t,
		props: m,
		stateAttributesMapping: Cc
	});
	return /* @__PURE__ */ (0, W.jsx)(xc.Provider, {
		value: S,
		children: /* @__PURE__ */ (0, W.jsx)(mc, {
			elementsRef: g,
			children: C
		})
	});
});
//#endregion
//#region node_modules/@base-ui/react/collapsible/root/useCollapsibleRoot.mjs
function Tc(e) {
	let { open: t, defaultOpen: n, onOpenChange: r, disabled: i } = e, [a, o] = dc({
		controlled: t,
		default: n,
		name: "Collapsible",
		state: "open"
	}), { mounted: s, setMounted: c, transitionStatus: l } = Ai(a, !0, !0), u = tn(), [d, f] = _.useState(), p = d === null ? void 0 : d ?? u, m = B((e) => {
		let t = !a, n = Yt(Bt, e.nativeEvent);
		r(t, n), !n.isCanceled && o(t);
	});
	return _.useMemo(() => ({
		defaultPanelId: u,
		disabled: i,
		handleTrigger: m,
		mounted: s,
		open: a,
		panelId: p,
		setMounted: c,
		setOpen: o,
		setPanelIdState: f,
		transitionStatus: l
	}), [
		u,
		i,
		m,
		s,
		a,
		p,
		c,
		o,
		f,
		l
	]);
}
//#endregion
//#region node_modules/@base-ui/react/collapsible/root/CollapsibleRootContext.mjs
var Ec = /* @__PURE__ */ _.createContext(void 0);
function Dc() {
	let e = _.useContext(Ec);
	if (e === void 0) throw Error(_e(15));
	return e;
}
//#endregion
//#region node_modules/@base-ui/react/internals/composite/list/useCompositeListItem.mjs
function Oc(e = {}) {
	let { guess: t, label: n, metadata: r, textRef: i, index: a } = e, { register: o, unregister: s, subscribeMapChange: c, nextIndexRef: l } = pc(), u = _.useRef(-1), [d, f] = _.useState(a == null && t ? () => {
		if (u.current === -1) {
			let e = l.current;
			l.current += 1, u.current = e;
		}
		return u.current;
	} : -1), p = a ?? d, m = _.useRef(null), h = _.useCallback((e) => {
		let t = m.current;
		t && s(t), m.current = e, e && o(e, {
			metadata: r ?? null,
			index: a ?? null,
			label: n,
			textRef: i
		});
	}, [
		a,
		o,
		s,
		r,
		n,
		i
	]);
	return V(() => {
		if (a == null) return c((e) => {
			let t = m.current ? e.get(m.current)?.index : null;
			t != null && f(t);
		});
	}, [a, c]), {
		ref: h,
		index: p
	};
}
//#endregion
//#region node_modules/@base-ui/react/accordion/item/AccordionItemContext.mjs
var kc = /* @__PURE__ */ _.createContext(void 0);
function Ac() {
	let e = _.useContext(kc);
	if (e === void 0) throw Error(_e(9));
	return e;
}
//#endregion
//#region node_modules/@base-ui/react/collapsible/panel/CollapsiblePanelDataAttributes.mjs
var jc = function(e) {
	return e.open = "data-open", e.closed = "data-closed", e[e.startingStyle = at.startingStyle] = "startingStyle", e[e.endingStyle = at.endingStyle] = "endingStyle", e;
}({}), Mc = /* @__PURE__ */ function(e) {
	return e.panelOpen = "data-panel-open", e;
}({}), Nc = { [jc.open]: "" }, Pc = { [jc.closed]: "" }, Fc = { open(e) {
	return e ? { [Mc.panelOpen]: "" } : null;
} }, Ic = { open(e) {
	return e ? Nc : Pc;
} }, Lc = /* @__PURE__ */ function(e) {
	return e.index = "data-index", e.disabled = "data-disabled", e.open = "data-open", e;
}({}), Rc = {
	...Ic,
	index: (e) => ({ [Lc.index]: String(e) }),
	...ct,
	value: () => null
}, zc = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { className: n, disabled: r = !1, onOpenChange: i, render: a, value: o, style: s, ...c } = e, { ref: l, index: u } = Oc(), d = Se(t, l), { disabled: f, handleValueChange: p, state: m, value: h } = Sc(), g = tn(), v = o ?? g, y = r || f, b = h.indexOf(v) !== -1, x = B((e, t) => {
		i?.(e, t), !t.isCanceled && p(v, e, t);
	}), S = Tc({
		open: b,
		onOpenChange: x,
		disabled: y
	}), C = _.useMemo(() => ({
		open: S.open,
		disabled: S.disabled,
		transitionStatus: S.transitionStatus
	}), [
		S.open,
		S.disabled,
		S.transitionStatus
	]), w = _.useMemo(() => ({
		...S,
		onOpenChange: x,
		state: C
	}), [
		S,
		C,
		x
	]), T = _.useMemo(() => ({
		...m,
		hidden: !b && !S.mounted,
		index: u,
		disabled: y,
		open: b
	}), [
		S.mounted,
		y,
		u,
		b,
		m
	]), E = tn(), [D, O] = _.useState(), k = D === null ? void 0 : D ?? E, A = _.useMemo(() => ({
		defaultTriggerId: E,
		open: b,
		state: T,
		setTriggerId: O,
		triggerId: k
	}), [
		E,
		b,
		T,
		O,
		k
	]), j = $e("div", e, {
		state: T,
		ref: d,
		props: c,
		stateAttributesMapping: Rc
	});
	return /* @__PURE__ */ (0, W.jsx)(Ec.Provider, {
		value: w,
		children: /* @__PURE__ */ (0, W.jsx)(kc.Provider, {
			value: A,
			children: j
		})
	});
}), Bc = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { render: n, className: r, style: i, ...a } = e, { state: o } = Ac();
	return $e("h3", e, {
		state: o,
		ref: t,
		props: a,
		stateAttributesMapping: Rc
	});
}), Vc = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { disabled: n, className: r, id: i, render: a, nativeButton: o = !0, style: s, ...c } = e, { panelId: l, open: u, handleTrigger: d, disabled: f } = Dc(), { getButtonProps: p, buttonRef: m } = It({
		disabled: n || f,
		focusableWhenDisabled: !0,
		native: o
	}), { defaultTriggerId: h, state: g, setTriggerId: _ } = Ac(), v = i || void 0, y = v ?? h;
	return V(() => (_((e) => v ?? (e === null ? void 0 : e)), () => {
		_((e) => e === v ? null : e);
	}), [v, _]), $e("button", e, {
		state: g,
		ref: [t, m],
		props: [
			{
				"aria-controls": u ? l : void 0,
				"aria-expanded": u,
				id: y,
				onClick: d
			},
			c,
			p
		],
		stateAttributesMapping: Fc
	});
}), Hc = {
	height: void 0,
	width: void 0
};
function Uc(e) {
	let { externalRef: t, hiddenUntilFound: n, id: r, keepMounted: i, mounted: a, onOpenChange: o, open: s, setMounted: c, setOpen: l, transitionStatus: u } = e, d = _.useRef(null), f = _.useRef(null), [p, m] = _.useState(Hc), h = _.useRef(Hc), g = _.useRef(!1), v = _.useRef(s), y = _.useRef(!1), [b, x] = _.useState(!1), S = _.useRef(null), C = Se(t, d), w = zn(s), T = ji(d), E = !s && !a, D = b ? "idle" : u, O = s && (v.current || y.current), k = !s && a && f.current === "css-animation" && p.height === void 0 && p.width === void 0 ? h.current : p, A = n && E && f.current !== "css-animation", j = B((e, t = !0) => {
		t && (h.current = e), m(e);
	}), M = B(() => {
		S.current?.(), S.current = null;
	}), N = B((e) => {
		M(), S.current = () => {
			S.current = null, e();
		};
	}), ee = B(() => {
		s && a && f.current === "css-animation" && (y.current = !0);
	});
	V(() => {
		!b || u === "starting" || x(!1);
	}, [b, u]), _.useEffect(() => () => {
		ee(), M();
	}, [ee, M]), V(() => {
		let e = d.current;
		if (!e) return;
		!s && S.current && M();
		let t = Gc(e, O);
		if (f.current = t, s && u === "idle" && v.current && t === "css-animation") {
			h.current = Wc(e);
			return;
		}
		if (s && u === "starting") {
			let n = g.current;
			if (g.current = !1, t === "none") {
				j(Wc(e)), x(!0);
				return;
			}
			if (t === "css-transition") {
				let t = Jc(e);
				return j(Wc(e)), n ? (N(qc(e, "transition-duration", "0s")), x(!0), t) : t;
			}
			j(Wc(e));
			let r = qc(e, "animation-name", "none");
			if (!n) {
				r();
				return;
			}
			let i = qc(e, "animation-duration", "0s");
			r(), N(i), x(!0);
			return;
		}
		if (!s && a && (u === "idle" || u === "starting")) {
			if (v.current = !1, y.current = !1, t === "none") {
				j(Hc, !1), c(!1);
				return;
			}
			j(Wc(e));
			return;
		}
		if (u !== "ending") return;
		if (t === "none") {
			c(!1);
			return;
		}
		let n = Wc(e);
		if (!(n.height > 0 || n.width > 0)) {
			c(!1);
			return;
		}
		j(n), t === "css-animation" && qc(e, "animation-name", "none")();
	}, [
		a,
		s,
		M,
		j,
		c,
		N,
		O,
		u
	]), Mi({
		enabled: s && a && D === "idle",
		open: !0,
		ref: d,
		onComplete() {
			s && j(Hc, !1);
		}
	}), _.useEffect(() => {
		if (s || !a || D !== "ending" || !d.current) return;
		let e = new AbortController(), t = -1;
		function n() {
			w.current || (c(!1), j(Hc, !1));
		}
		return t = Un.request(() => {
			T(n, e.signal);
		}), () => {
			Un.cancel(t), e.abort();
		};
	}, [
		w,
		a,
		s,
		D,
		T,
		j,
		c
	]), V(() => {
		let e = d.current;
		!e || !n || !E || e.setAttribute("hidden", "until-found");
	}, [E, n]), _.useEffect(function() {
		let e = d.current;
		if (!e) return;
		function t(e) {
			let t = Yt(zt, e);
			o(!0, t), !t.isCanceled && (g.current = !0, l(!0));
		}
		return Ln(e, "beforematch", t);
	}, [o, l]);
	let te = i || n || a || s;
	return {
		height: k.height,
		props: {
			...A ? { [jc.startingStyle]: "" } : void 0,
			hidden: E,
			id: r
		},
		ref: C,
		shouldPreventOpenAnimation: O,
		shouldRender: te,
		transitionStatus: D,
		width: k.width
	};
}
function Wc(e) {
	return {
		height: e.scrollHeight,
		width: e.scrollWidth
	};
}
function Gc(e, t) {
	let n = _t(e).getComputedStyle(e), r = (n.animationName.split(",").map((e) => e.trim()).some((e) => e !== "" && e !== "none") || t) && Kc(n.animationDuration), i = Kc(n.transitionDuration);
	return r && i || i ? "css-transition" : r ? "css-animation" : "none";
}
function Kc(e) {
	return e.split(",").map((e) => e.trim()).some((e) => e !== "" && Number.parseFloat(e) > 0);
}
function qc(e, t, n) {
	let r = e.style.getPropertyValue(t), i = e.style.getPropertyPriority(t);
	return e.style.setProperty(t, n), () => {
		if (r === "") {
			e.style.removeProperty(t);
			return;
		}
		e.style.setProperty(t, r, i);
	};
}
function Jc(e) {
	let t = {
		"justify-content": e.style.justifyContent,
		"align-items": e.style.alignItems,
		"align-content": e.style.alignContent,
		"justify-items": e.style.justifyItems
	};
	Object.keys(t).forEach((t) => {
		e.style.setProperty(t, "initial", "important");
	});
	function n() {
		Object.entries(t).forEach(([t, n]) => {
			if (n === "") {
				e.style.removeProperty(t);
				return;
			}
			e.style.setProperty(t, n);
		});
	}
	let r = Un.request(n);
	return () => {
		Un.cancel(r), n();
	};
}
//#endregion
//#region node_modules/@base-ui/react/accordion/panel/AccordionPanelCssVars.mjs
var Yc = /* @__PURE__ */ function(e) {
	return e.accordionPanelHeight = "--accordion-panel-height", e.accordionPanelWidth = "--accordion-panel-width", e;
}({}), Xc = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { className: n, hiddenUntilFound: r, keepMounted: i, id: a, render: o, style: s, ...c } = e, { hiddenUntilFound: l, keepMounted: u } = Sc(), { defaultPanelId: d, mounted: f, onOpenChange: p, open: m, setMounted: h, setOpen: g, setPanelIdState: _, transitionStatus: v } = Dc(), y = r ?? l, b = i ?? u, x = a || void 0, S = a ?? d;
	V(() => (_((e) => x ?? (e === null ? void 0 : e)), () => {
		_((e) => e === x ? null : e);
	}), [x, _]);
	let { height: C, props: w, ref: T, shouldPreventOpenAnimation: E, shouldRender: D, transitionStatus: O, width: k } = Uc({
		externalRef: t,
		hiddenUntilFound: y,
		id: S,
		keepMounted: b,
		mounted: f,
		onOpenChange: p,
		open: m,
		setMounted: h,
		setOpen: g,
		transitionStatus: v
	}), { state: A, triggerId: j } = Ac(), M = {
		...A,
		transitionStatus: O
	}, N = Le(s, M), ee = $e("div", {
		...e,
		style: void 0
	}, {
		state: M,
		ref: T,
		props: [
			w,
			{
				"aria-labelledby": j,
				role: "region",
				style: {
					[Yc.accordionPanelHeight]: C === void 0 ? "auto" : `${C}px`,
					[Yc.accordionPanelWidth]: k === void 0 ? "auto" : `${k}px`
				}
			},
			c,
			N ? { style: N } : void 0,
			E ? { style: { animationName: "none" } } : void 0
		],
		stateAttributesMapping: Rc
	});
	return D ? ee : null;
});
//#endregion
//#region components/ui/accordion.tsx
function Zc({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)(wc, {
		"data-slot": "accordion",
		className: cs("flex w-full flex-col", e),
		...t
	});
}
function Qc({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)(zc, {
		"data-slot": "accordion-item",
		className: cs("not-last:border-b", e),
		...t
	});
}
function $c({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ (0, W.jsx)(Bc, {
		className: "flex",
		children: /* @__PURE__ */ (0, W.jsxs)(Vc, {
			"data-slot": "accordion-trigger",
			className: cs("focus-visible:ring-ring/50 focus-visible:border-ring focus-visible:after:border-ring **:data-[slot=accordion-trigger-icon]:text-muted-foreground rounded-lg py-2.5 text-left text-sm font-medium hover:underline focus-visible:ring-3 **:data-[slot=accordion-trigger-icon]:ml-auto **:data-[slot=accordion-trigger-icon]:size-4 group/accordion-trigger relative flex flex-1 items-start justify-between border border-transparent transition-all outline-none aria-disabled:pointer-events-none aria-disabled:opacity-50", e),
			...n,
			children: [
				t,
				/* @__PURE__ */ (0, W.jsx)(P, {
					"data-slot": "accordion-trigger-icon",
					className: "pointer-events-none shrink-0 group-aria-expanded/accordion-trigger:hidden"
				}),
				/* @__PURE__ */ (0, W.jsx)(re, {
					"data-slot": "accordion-trigger-icon",
					className: "pointer-events-none hidden shrink-0 group-aria-expanded/accordion-trigger:inline"
				})
			]
		})
	});
}
function el({ className: e, children: t, ...n }) {
	return /* @__PURE__ */ (0, W.jsx)(Xc, {
		"data-slot": "accordion-content",
		className: "data-open:animate-accordion-down data-closed:animate-accordion-up text-sm overflow-hidden",
		...n,
		children: /* @__PURE__ */ (0, W.jsx)("div", {
			className: cs("pt-0 pb-2.5 h-(--accordion-panel-height) data-ending-style:h-0 data-starting-style:h-0 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4", e),
			children: t
		})
	});
}
//#endregion
//#region components/store/faq.tsx
var tl = [
	["Vad är skillnaden mot en vanlig sovmask?", "Jon Blunds mask har urgröpningar runt ögonen. Det ger plats för ögonrörelser och ögonfransar, samtidigt som den mjuka dynan följer området runt ögonen och näsan."],
	["Hur får jag masken att sitta bra?", "Placera ögonen i urgröpningarna och justera bandet tills masken sluter bekvämt runt ansiktet. Finjustera läget vid näsan om ljus letar sig in. Bandet behöver inte sitta hårt."],
	["Passar den om jag sover på sidan eller magen?", "Komforten beror på ansiktsform, kudde och sovställning. Vissa kunder tycker att vadderingen är för tjock när de sover på sidan eller magen. Andra nämner att bandet kan kännas vid öronen. Justera både bandet och maskens läge utan att spänna hårt. Läs gärna omdömena för fler erfarenheter av passformen."],
	["Kan jag tvätta sömnmasken?", "Ja, masken är tvättbar. Följ skötselråden som följer med din produkt."],
	["Vad kostar frakten och när kommer min order?", "Fraktkostnaden visas i kassan. Se våra leveransvillkor för aktuell information om hantering och leverans."],
	["Kan jag returnera min beställning?", "Se våra returvillkor för ångerrätt och retur. Det utökade 30-dagarsvillkoret på nuvarande butik gäller oanvända produkter, räknat från beställningsdagen. Kontakta oss innan du skickar tillbaka en vara."]
];
function nl() {
	return /* @__PURE__ */ (0, W.jsxs)("section", {
		className: "section faq-section",
		id: "faq",
		children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [
			/* @__PURE__ */ (0, W.jsx)("p", {
				className: "eyebrow",
				children: "LITE MER ATT SOVA PÅ"
			}),
			/* @__PURE__ */ (0, W.jsxs)("h2", { children: [
				"Stora frågor.",
				/* @__PURE__ */ (0, W.jsx)("br", {}),
				/* @__PURE__ */ (0, W.jsx)("em", { children: "Lugna svar." })
			] }),
			/* @__PURE__ */ (0, W.jsxs)("p", { children: [
				"Funderar du på något annat?",
				/* @__PURE__ */ (0, W.jsx)("br", {}),
				"Vi finns här för att hjälpa dig."
			] }),
			/* @__PURE__ */ (0, W.jsxs)("a", {
				className: "text-link",
				href: "/pages/kontakta-oss",
				children: ["Kontakta oss ", /* @__PURE__ */ (0, W.jsx)(M, { size: 18 })]
			})
		] }), /* @__PURE__ */ (0, W.jsx)(Zc, {
			className: "faq-list",
			children: tl.map(([e, t], n) => /* @__PURE__ */ (0, W.jsxs)(Qc, {
				value: String(n),
				children: [/* @__PURE__ */ (0, W.jsxs)($c, { children: [/* @__PURE__ */ (0, W.jsx)("span", { children: e }), /* @__PURE__ */ (0, W.jsx)("span", {
					className: "disclosure-toggle",
					"aria-hidden": "true"
				})] }), /* @__PURE__ */ (0, W.jsxs)(el, { children: [
					/* @__PURE__ */ (0, W.jsx)("p", { children: t }),
					n === 4 && /* @__PURE__ */ (0, W.jsx)("a", {
						href: "/policies/shipping-policy",
						children: "Läs leveransvillkoren"
					}),
					n === 5 && /* @__PURE__ */ (0, W.jsx)("a", {
						href: "/policies/refund-policy",
						children: "Läs returvillkoren"
					})
				] })]
			}, e))
		})]
	});
}
//#endregion
//#region components/store/science.tsx
function rl() {
	return /* @__PURE__ */ (0, W.jsxs)("section", {
		className: "section science-teaser",
		children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [
			/* @__PURE__ */ (0, W.jsxs)("p", {
				className: "eyebrow",
				children: [/* @__PURE__ */ (0, W.jsx)(ee, { size: 15 }), " FORSKNINGSINSPIRERAD SÖMNMILJÖ"]
			}),
			/* @__PURE__ */ (0, W.jsxs)("h2", { children: [
				"Mindre ljus.",
				/* @__PURE__ */ (0, W.jsx)("br", {}),
				/* @__PURE__ */ (0, W.jsx)("em", { children: "En genomtänkt natt." })
			] }),
			/* @__PURE__ */ (0, W.jsx)("p", { children: "Ett mörkt sovrum är ett av 1177:s råd för en bättre sömnmiljö. Men vad säger forskningen om att sova med mask? Vi har läst studierna — och deras begränsningar." }),
			/* @__PURE__ */ (0, W.jsxs)("a", {
				className: "button peach",
				href: "/pages/forskning",
				children: ["Utforska forskningen ", /* @__PURE__ */ (0, W.jsx)(M, { size: 18 })]
			})
		] }), /* @__PURE__ */ (0, W.jsxs)("div", {
			className: "science-note",
			children: [
				/* @__PURE__ */ (0, W.jsx)("span", {
					className: "science-index",
					children: "FORSKNINGSANTECKNING / 01"
				}),
				/* @__PURE__ */ (0, W.jsxs)("h3", { children: [
					"Lovande fynd.",
					/* @__PURE__ */ (0, W.jsx)("br", {}),
					"Intressanta frågor."
				] }),
				/* @__PURE__ */ (0, W.jsx)("p", { children: "En studie från 2023 undersökte sovmasker och prestation nästa dag. Den rapporterade positiva resultat på vissa tester, men ingen förbättring av självskattad sömnkvalitet. En senare omanalys ifrågasatte hur robusta fynden är." }),
				/* @__PURE__ */ (0, W.jsxs)("a", {
					href: "/pages/forskning#studier",
					className: "text-link",
					children: ["Läs studien och omanalysen ", /* @__PURE__ */ (0, W.jsx)(M, { size: 17 })]
				}),
				/* @__PURE__ */ (0, W.jsx)("small", { children: "Forskning om sovmasker generellt. Jonblunds mask har inte testats i de studier vi hänvisar till." })
			]
		})]
	});
}
function il() {
	return /* @__PURE__ */ (0, W.jsxs)("main", {
		id: "main",
		className: "research-page",
		children: [
			/* @__PURE__ */ (0, W.jsxs)("section", {
				className: "section research-hero",
				children: [
					/* @__PURE__ */ (0, W.jsx)("p", {
						className: "eyebrow",
						children: "JONBLUND / FORSKNING & SÖMN"
					}),
					/* @__PURE__ */ (0, W.jsxs)("h1", { children: [
						"Mörkret förtjänar",
						/* @__PURE__ */ (0, W.jsx)("br", {}),
						/* @__PURE__ */ (0, W.jsx)("em", { children: "lite eftertanke." })
					] }),
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "research-lead",
						children: [/* @__PURE__ */ (0, W.jsx)("p", { children: "Vi är nyfikna på vad som gör en sömnmiljö bättre. Här samlar vi utvald forskning om sovmasker och praktiska råd om mörker — med länkar till källorna." }), /* @__PURE__ */ (0, W.jsxs)("p", {
							className: "research-date",
							children: [
								"Genomgång: 18 september 2026",
								/* @__PURE__ */ (0, W.jsx)("br", {}),
								"Urval av källor · Ingen systematisk översikt"
							]
						})]
					}),
					/* @__PURE__ */ (0, W.jsxs)("nav", {
						className: "research-nav",
						"aria-label": "På forskningssidan",
						children: [
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "#studier",
								children: "Studier & resultat"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "#i-praktiken",
								children: "I praktiken"
							}),
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "#var-tolkning",
								children: "Vår tolkning"
							})
						]
					})
				]
			}),
			/* @__PURE__ */ (0, W.jsxs)("section", {
				className: "section research-studies",
				id: "studier",
				children: [
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "section-heading",
						children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("p", {
							className: "eyebrow",
							children: "LÄS BAKOM RUBRIKERNA"
						}), /* @__PURE__ */ (0, W.jsxs)("h2", { children: ["Vad vet vi ", /* @__PURE__ */ (0, W.jsx)("em", { children: "egentligen?" })] })] }), /* @__PURE__ */ (0, W.jsx)("p", { children: "Resultat blir mer användbara när man också vet hur de togs fram." })]
					}),
					/* @__PURE__ */ (0, W.jsxs)("article", {
						className: "study-row",
						children: [/* @__PURE__ */ (0, W.jsxs)("div", {
							className: "study-meta",
							children: [
								/* @__PURE__ */ (0, W.jsx)("span", { children: "01 / EXPERIMENTELL STUDIE" }),
								/* @__PURE__ */ (0, W.jsx)("strong", { children: "SLEEP · 2023" }),
								/* @__PURE__ */ (0, W.jsx)("span", { children: "Greco med flera" }),
								/* @__PURE__ */ (0, W.jsx)("span", { children: "Friska vuxna, 18–35 år" })
							]
						}), /* @__PURE__ */ (0, W.jsxs)("div", { children: [
							/* @__PURE__ */ (0, W.jsx)("h3", { children: "Sovmask och prestation nästa dag" }),
							/* @__PURE__ */ (0, W.jsx)("p", { children: "Två experiment jämförde nätter med sovmask med en kontroll utan ljusblockering. Deltagarna sov hemma under sommaren, med öppna gardiner eller fönsterluckor." }),
							/* @__PURE__ */ (0, W.jsxs)("div", {
								className: "study-findings",
								children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("h4", { children: "Det forskarna såg" }), /* @__PURE__ */ (0, W.jsx)("p", { children: "Bättre resultat på ett test av inlärning av ordpar i båda experimenten. Snabbare reaktioner på ett uppmärksamhetstest i det första." })] }), /* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("h4", { children: "Det studien inte visade" }), /* @__PURE__ */ (0, W.jsx)("p", { children: "Ingen påvisad förbättring av självskattad sömnkvalitet. Mätningen i det andra experimentet visade inte mer djupsömn. Resultaten gäller inte specifikt Jonblunds mask." })] })]
							}),
							/* @__PURE__ */ (0, W.jsxs)("a", {
								className: "text-link",
								href: "https://academic.oup.com/sleep/article/46/3/zsac305/6912219",
								target: "_blank",
								rel: "noreferrer",
								children: ["Läs originalstudien ", /* @__PURE__ */ (0, W.jsx)(M, { size: 17 })]
							}),
							/* @__PURE__ */ (0, W.jsx)("p", {
								className: "study-citation",
								children: "Greco et al. · DOI: 10.1093/sleep/zsac305 · Publicerad online december 2022, tidskriftsnummer mars 2023."
							})
						] })]
					}),
					/* @__PURE__ */ (0, W.jsxs)("article", {
						className: "study-row",
						children: [/* @__PURE__ */ (0, W.jsxs)("div", {
							className: "study-meta",
							children: [
								/* @__PURE__ */ (0, W.jsx)("span", { children: "02 / VETENSKAPLIG DISKUSSION" }),
								/* @__PURE__ */ (0, W.jsx)("strong", { children: "SLEEP · 2023" }),
								/* @__PURE__ */ (0, W.jsx)("span", { children: "Stephen Rhodes" }),
								/* @__PURE__ */ (0, W.jsx)("span", { children: "Omanalys av samma data" })
							]
						}), /* @__PURE__ */ (0, W.jsxs)("div", { children: [
							/* @__PURE__ */ (0, W.jsx)("h3", { children: "En studie är början på ett samtal" }),
							/* @__PURE__ */ (0, W.jsx)("p", { children: "I en publicerad omanalys ifrågasatte Rhodes om resultaten ger tydliga och konsekventa belägg för en meningsfull förbättring av inlärning och uppmärksamhet." }),
							/* @__PURE__ */ (0, W.jsx)("p", { children: "Det är relevant för hur vi beskriver forskningen: fynden är intressanta att följa, men räcker inte för att lova bättre minne eller skarpare fokus av en sovmask." }),
							/* @__PURE__ */ (0, W.jsxs)("a", {
								className: "text-link",
								href: "https://academic.oup.com/sleep/article/46/8/zsad105/7143720",
								target: "_blank",
								rel: "noreferrer",
								children: ["Läs omanalysen ", /* @__PURE__ */ (0, W.jsx)(M, { size: 17 })]
							}),
							/* @__PURE__ */ (0, W.jsx)("p", {
								className: "study-citation",
								children: "Rhodes · DOI: 10.1093/sleep/zsad105 · Publicerad april 2023. Detta är en omanalys, inte ett nytt experiment."
							})
						] })]
					}),
					/* @__PURE__ */ (0, W.jsxs)("article", {
						className: "study-row",
						children: [/* @__PURE__ */ (0, W.jsxs)("div", {
							className: "study-meta",
							children: [
								/* @__PURE__ */ (0, W.jsx)("span", { children: "03 / PRAKTISKA VÅRDRÅD" }),
								/* @__PURE__ */ (0, W.jsx)("strong", { children: "1177" }),
								/* @__PURE__ */ (0, W.jsx)("span", { children: "Sömnsvårigheter hos vuxna" }),
								/* @__PURE__ */ (0, W.jsx)("span", { children: "Råd om sömnmiljön" })
							]
						}), /* @__PURE__ */ (0, W.jsxs)("div", { children: [
							/* @__PURE__ */ (0, W.jsx)("h3", { children: "Ett mörkare sovrum är en bra utgångspunkt" }),
							/* @__PURE__ */ (0, W.jsx)("p", { children: "1177 tar upp mörker, tystnad och en sval sovmiljö. Under ljusa sommarmånader kan en mörk rullgardin hjälpa. En sovmask nämns som ett sätt att skydda ögonen från ljus." }),
							/* @__PURE__ */ (0, W.jsx)("p", { children: "Det här är allmänna råd om sömnmiljö, inte en rekommendation av Jonblund eller en klinisk prövning av vår produkt." }),
							/* @__PURE__ */ (0, W.jsxs)("a", {
								className: "text-link",
								href: "https://www.1177.se/liv--halsa/stresshantering-och-somn/somnsvarigheter/",
								target: "_blank",
								rel: "noreferrer",
								children: ["Läs råden hos 1177 ", /* @__PURE__ */ (0, W.jsx)(M, { size: 17 })]
							})
						] })]
					})
				]
			}),
			/* @__PURE__ */ (0, W.jsxs)("section", {
				className: "section research-practice",
				id: "i-praktiken",
				children: [
					/* @__PURE__ */ (0, W.jsx)("p", {
						className: "eyebrow",
						children: "FRÅN LÄSNING TILL KVÄLLSRUTIN"
					}),
					/* @__PURE__ */ (0, W.jsxs)("h2", { children: ["Börja med ", /* @__PURE__ */ (0, W.jsx)("em", { children: "din sovmiljö." })] }),
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "practice-grid",
						children: [
							/* @__PURE__ */ (0, W.jsxs)("div", { children: [
								/* @__PURE__ */ (0, W.jsx)("span", { children: "01" }),
								/* @__PURE__ */ (0, W.jsx)("h3", { children: "Se över ljuset" }),
								/* @__PURE__ */ (0, W.jsx)("p", { children: "Mörklägg där du sover. En sovmask kan vara ett praktiskt komplement när gardinerna inte räcker eller när du sover borta." })
							] }),
							/* @__PURE__ */ (0, W.jsxs)("div", { children: [
								/* @__PURE__ */ (0, W.jsx)("span", { children: "02" }),
								/* @__PURE__ */ (0, W.jsx)("h3", { children: "Låt komforten avgöra" }),
								/* @__PURE__ */ (0, W.jsx)("p", { children: "Justera masken utan att dra åt hårt. Hur den känns beror på ansiktsform, kudde och sovställning. Läs gärna kundernas erfarenheter av passformen." })
							] }),
							/* @__PURE__ */ (0, W.jsxs)("div", { children: [
								/* @__PURE__ */ (0, W.jsx)("span", { children: "03" }),
								/* @__PURE__ */ (0, W.jsx)("h3", { children: "Se hela rutinen" }),
								/* @__PURE__ */ (0, W.jsx)("p", { children: "Ljus är en del av sömnmiljön. 1177 lyfter också regelbundna tider, dagsljus och nedvarvning. Vid ihållande sömnbesvär finns hjälp att få via vården." })
							] })
						]
					}),
					/* @__PURE__ */ (0, W.jsxs)("a", {
						className: "text-link",
						href: "https://www.1177.se/liv--halsa/stresshantering-och-somn/somnsvarigheter/",
						target: "_blank",
						rel: "noreferrer",
						children: ["Mer om sömnvanor hos 1177 ", /* @__PURE__ */ (0, W.jsx)(M, { size: 17 })]
					})
				]
			}),
			/* @__PURE__ */ (0, W.jsxs)("section", {
				className: "section research-position",
				id: "var-tolkning",
				children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("p", {
					className: "eyebrow",
					children: "VÅR TOLKNING"
				}), /* @__PURE__ */ (0, W.jsxs)("h2", { children: [
					"Forskningsinspirerad.",
					/* @__PURE__ */ (0, W.jsx)("br", {}),
					/* @__PURE__ */ (0, W.jsx)("em", { children: "Öppen med underlaget." })
				] })] }), /* @__PURE__ */ (0, W.jsxs)("div", { children: [
					/* @__PURE__ */ (0, W.jsx)("p", { children: "För oss innebär det att läsa relevanta källor, beskriva vad de faktiskt visar och hålla isär forskning, produktens egenskaper och kundernas egna upplevelser." }),
					/* @__PURE__ */ (0, W.jsx)("p", { children: "Vi har ingen egen klinisk studie av Jonblunds sömnmask att hänvisa till. Därför använder vi inte de här studierna som bevis för att vår mask förbättrar minnet, ökar djupsömnen eller behandlar sömnproblem." }),
					/* @__PURE__ */ (0, W.jsxs)("a", {
						className: "button",
						href: "/products/somnmask",
						children: ["Upptäck sömnmasken ", /* @__PURE__ */ (0, W.jsx)(M, { size: 18 })]
					})
				] })]
			})
		]
	});
}
//#endregion
//#region components/store/product-detail.tsx
var al = (e) => globalThis.__JB_ASSETS__?.[e] || "/images/" + e;
function ol({ product: e, compact: t = !1 }) {
	let n = Ns(), r = n.catalog.find((t) => t.handle === e.handle), [i, a] = (0, _.useState)(null), [o, s] = (0, _.useState)(0), [c, l] = (0, _.useState)(n.offers && e.handle === "somnmask" ? 2 : 1), [u, d] = (0, _.useState)(!1), f = (0, _.useRef)(null), p = r?.variants.find((e) => e.id === i) || r?.variants[0];
	(0, _.useEffect)(() => {
		let t = Number(new URLSearchParams(window.location.search).get("variant"));
		r?.variants.some((e) => e.id === t) && (a(t), e.handle === "nightshift" && s(r.variants.findIndex((e) => e.id === t)));
	}, [e.handle, r?.variants]);
	let m = (t) => s((n) => (n + t + e.images.length) % e.images.length), h = (n, r) => {
		if (a(n), e.handle === "nightshift" && s(r), !t) {
			let e = new URL(window.location.href);
			e.searchParams.set("variant", String(n)), window.history.replaceState(null, "", e);
		}
	}, g = e.images[o], v = [
		oe,
		I,
		me,
		se
	], y = n.status === "live" && p?.available, b = p ? n.offers && e.handle === "somnmask" ? As(p.price, c) : p.price * c : null;
	return /* @__PURE__ */ (0, W.jsxs)(W.Fragment, { children: [
		!t && /* @__PURE__ */ (0, W.jsxs)("div", {
			className: "breadcrumb",
			children: [
				/* @__PURE__ */ (0, W.jsx)("a", {
					href: "/",
					children: "Hem"
				}),
				/* @__PURE__ */ (0, W.jsx)("span", { children: "/" }),
				/* @__PURE__ */ (0, W.jsx)("a", {
					href: "/collections/all",
					children: "Produkter"
				}),
				/* @__PURE__ */ (0, W.jsx)("span", { children: "/" }),
				/* @__PURE__ */ (0, W.jsx)("span", { children: e.title })
			]
		}),
		/* @__PURE__ */ (0, W.jsxs)("section", {
			className: "product-detail section " + (t ? "compact-product" : ""),
			id: "kop",
			children: [/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "gallery",
				children: [/* @__PURE__ */ (0, W.jsxs)("div", {
					className: "gallery-stage",
					"aria-label": "Produktgalleri",
					onTouchStart: (e) => f.current = e.touches[0].clientX,
					onTouchEnd: (e) => {
						if (f.current !== null) {
							let t = e.changedTouches[0].clientX - f.current;
							Math.abs(t) > 40 && m(t < 0 ? 1 : -1), f.current = null;
						}
					},
					children: [
						/* @__PURE__ */ (0, W.jsxs)("span", {
							className: "gallery-counter",
							children: [
								String(o + 1).padStart(2, "0"),
								" /",
								" ",
								String(e.images.length).padStart(2, "0")
							]
						}),
						/* @__PURE__ */ (0, W.jsx)("img", {
							src: g.src,
							alt: g.alt,
							width: g.width,
							height: g.height,
							loading: t ? "lazy" : "eager"
						}),
						/* @__PURE__ */ (0, W.jsx)("button", {
							className: "zoom-button icon-button",
							"aria-label": "Förstora produktbild",
							onClick: () => d(!0),
							children: /* @__PURE__ */ (0, W.jsx)(ie, { size: 19 })
						}),
						/* @__PURE__ */ (0, W.jsxs)("div", {
							className: "gallery-caption",
							children: [/* @__PURE__ */ (0, W.jsx)("span", { children: g.caption }), /* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("button", {
								className: "icon-button",
								onClick: () => m(-1),
								"aria-label": "Föregående produktbild",
								children: /* @__PURE__ */ (0, W.jsx)(F, { size: 20 })
							}), /* @__PURE__ */ (0, W.jsx)("button", {
								className: "icon-button",
								onClick: () => m(1),
								"aria-label": "Nästa produktbild",
								children: /* @__PURE__ */ (0, W.jsx)(ne, { size: 20 })
							})] })]
						})
					]
				}), /* @__PURE__ */ (0, W.jsx)("div", {
					className: "gallery-thumbnails",
					"aria-label": "Välj produktbild",
					children: e.images.map((e, t) => /* @__PURE__ */ (0, W.jsxs)("button", {
						onKeyDown: (e) => {
							e.key === "ArrowRight" && (e.preventDefault(), m(1)), e.key === "ArrowLeft" && (e.preventDefault(), m(-1));
						},
						onClick: () => s(t),
						"aria-pressed": o === t,
						"aria-label": e.label,
						className: o === t ? "selected" : "",
						children: [/* @__PURE__ */ (0, W.jsx)("img", {
							src: e.src,
							alt: "",
							width: 100,
							height: 75,
							loading: "lazy"
						}), /* @__PURE__ */ (0, W.jsx)("span", { children: e.label })]
					}, e.src))
				})]
			}), /* @__PURE__ */ (0, W.jsxs)("div", {
				className: "buy-box",
				id: "valj-kop",
				children: [
					/* @__PURE__ */ (0, W.jsx)("p", {
						className: "eyebrow",
						children: e.kicker
					}),
					t ? /* @__PURE__ */ (0, W.jsx)("h2", { children: e.title }) : /* @__PURE__ */ (0, W.jsx)("h1", { children: e.title }),
					/* @__PURE__ */ (0, W.jsx)("p", {
						className: "product-subtitle",
						children: e.summary
					}),
					/* @__PURE__ */ (0, W.jsx)(qs, { handle: e.handle }),
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "product-price",
						children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: p ? Ds(p.price) : "Pris saknas" }), /* @__PURE__ */ (0, W.jsx)("span", { children: "inkl. moms" })]
					}),
					/* @__PURE__ */ (0, W.jsx)("p", {
						className: "product-description",
						children: e.description
					}),
					/* @__PURE__ */ (0, W.jsx)("ul", {
						className: "product-benefits",
						children: e.benefits.map((t, n) => /* @__PURE__ */ (0, W.jsxs)("li", { children: [/* @__PURE__ */ (0, W.jsx)(e.handle === "somnmask" ? v[n] : te, {
							size: 20,
							strokeWidth: 1.4
						}), t] }, t))
					}),
					r && r.variants.length > 1 && /* @__PURE__ */ (0, W.jsxs)("fieldset", {
						className: "variant-options",
						children: [/* @__PURE__ */ (0, W.jsxs)("legend", { children: ["Linsfärg: ", /* @__PURE__ */ (0, W.jsx)("strong", { children: p?.title })] }), r.variants.map((e, t) => /* @__PURE__ */ (0, W.jsxs)("button", {
							type: "button",
							"aria-pressed": p?.id === e.id,
							onClick: () => h(e.id, t),
							className: p?.id === e.id ? "selected" : "",
							children: [
								/* @__PURE__ */ (0, W.jsx)("span", { className: "swatch swatch-" + t }),
								e.title,
								n.status === "live" && !e.available && /* @__PURE__ */ (0, W.jsx)("small", { children: "Slutsåld" })
							]
						}, e.id))]
					}),
					n.offers && e.handle === "somnmask" && p && /* @__PURE__ */ (0, W.jsxs)("fieldset", {
						className: "mask-packs",
						children: [/* @__PURE__ */ (0, W.jsx)("legend", { children: "Välj antal masker" }), [
							1,
							2,
							3,
							4
						].map((e) => {
							let t = As(p.price, e), n = p.price * e - t;
							return /* @__PURE__ */ (0, W.jsxs)("button", {
								type: "button",
								className: c === e ? "pack selected" : "pack",
								"aria-pressed": c === e,
								onClick: () => l(e),
								children: [
									/* @__PURE__ */ (0, W.jsxs)("span", { children: [/* @__PURE__ */ (0, W.jsxs)("strong", { children: [
										e,
										" ",
										e === 1 ? "mask" : "masker"
									] }), /* @__PURE__ */ (0, W.jsx)("small", { children: e === 1 ? "Till dig" : e === 2 ? "En hemma. En med dig." : e === 3 ? "Till dig och någon du tycker om" : "Fler att dela med" })] }),
									/* @__PURE__ */ (0, W.jsxs)("span", { children: [/* @__PURE__ */ (0, W.jsx)("strong", { children: Ds(t) }), n > 0 && /* @__PURE__ */ (0, W.jsxs)("small", { children: ["Spara ", Ds(n)] })] }),
									e === 2 && /* @__PURE__ */ (0, W.jsx)("span", {
										className: "pack-label",
										children: "Vårt förval"
									})
								]
							}, e);
						})]
					}),
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "purchase-row",
						children: [!(n.offers && e.handle === "somnmask") && /* @__PURE__ */ (0, W.jsxs)("div", {
							className: "quantity",
							children: [
								/* @__PURE__ */ (0, W.jsx)("button", {
									"aria-label": "Minska antal",
									disabled: c === 1,
									onClick: () => l((e) => e - 1),
									children: /* @__PURE__ */ (0, W.jsx)(z, { size: 17 })
								}),
								/* @__PURE__ */ (0, W.jsx)("span", {
									"aria-label": `Antal ${c}`,
									children: c
								}),
								/* @__PURE__ */ (0, W.jsx)("button", {
									"aria-label": "Öka antal",
									disabled: c === 20,
									onClick: () => l((e) => e + 1),
									children: /* @__PURE__ */ (0, W.jsx)(le, { size: 17 })
								})
							]
						}), /* @__PURE__ */ (0, W.jsxs)("button", {
							className: "button add-button",
							disabled: !y || n.checking,
							onClick: () => p && n.add(p.id, c),
							children: [n.status === "loading" ? "Kontrollerar lager…" : n.status === "error" ? "Kunde inte hämta lager" : p?.available ? n.checking ? "Uppdaterar…" : n.offers && e.handle === "somnmask" ? `Lägg ${c} ${c === 1 ? "mask" : "masker"} i varukorgen` : "Lägg i varukorgen" : "Tillfälligt slut", /* @__PURE__ */ (0, W.jsx)(j, { size: 20 })]
						})]
					}),
					n.status === "error" && /* @__PURE__ */ (0, W.jsxs)("p", {
						role: "alert",
						className: "error-text",
						children: [
							"Vi behöver kontrollera pris och lager.",
							" ",
							/* @__PURE__ */ (0, W.jsx)("button", {
								onClick: () => n.refresh(),
								children: "Försök igen"
							})
						]
					}),
					/* @__PURE__ */ (0, W.jsxs)("p", {
						className: "shipping-note",
						children: [
							"Frakt beräknas i kassan.",
							" ",
							/* @__PURE__ */ (0, W.jsx)("a", {
								href: "/policies/shipping-policy",
								children: "Leverans & frakt"
							})
						]
					}),
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "purchase-reassurance",
						children: [/* @__PURE__ */ (0, W.jsxs)("span", { children: [
							/* @__PURE__ */ (0, W.jsx)(te, { size: 15 }),
							" ",
							e.handle === "somnmask" ? "Justerbar passform" : "Betala säkert"
						] }), /* @__PURE__ */ (0, W.jsxs)("span", { children: [/* @__PURE__ */ (0, W.jsx)(te, { size: 15 }), " Betala med Klarna"] })]
					}),
					t ? /* @__PURE__ */ (0, W.jsxs)("a", {
						className: "text-link all-details",
						href: "/products/" + e.handle,
						children: ["Alla detaljer om masken ", /* @__PURE__ */ (0, W.jsx)(M, { size: 18 })]
					}) : /* @__PURE__ */ (0, W.jsx)(Zc, {
						className: "product-accordions",
						children: e.details.map(([e, t], n) => /* @__PURE__ */ (0, W.jsxs)(Qc, {
							value: String(n),
							children: [/* @__PURE__ */ (0, W.jsxs)($c, { children: [/* @__PURE__ */ (0, W.jsx)("span", { children: e }), /* @__PURE__ */ (0, W.jsx)("span", {
								className: "disclosure-toggle",
								"aria-hidden": "true"
							})] }), /* @__PURE__ */ (0, W.jsx)(el, { children: /* @__PURE__ */ (0, W.jsx)("p", { children: t }) })]
						}, e))
					})
				]
			})]
		}),
		/* @__PURE__ */ (0, W.jsx)(ic, {
			open: u,
			onOpenChange: d,
			children: /* @__PURE__ */ (0, W.jsxs)(cc, {
				className: "zoom-dialog",
				showCloseButton: !1,
				children: [
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "drawer-heading",
						children: [/* @__PURE__ */ (0, W.jsx)(lc, { children: g.label }), /* @__PURE__ */ (0, W.jsx)(oc, {
							className: "icon-button",
							"aria-label": "Stäng bildvisning",
							children: /* @__PURE__ */ (0, W.jsx)(he, {})
						})]
					}),
					/* @__PURE__ */ (0, W.jsx)(uc, { children: g.caption }),
					/* @__PURE__ */ (0, W.jsx)("div", {
						className: "zoom-image",
						children: /* @__PURE__ */ (0, W.jsx)("img", {
							src: g.src,
							alt: g.alt,
							width: g.width,
							height: g.height
						})
					}),
					/* @__PURE__ */ (0, W.jsxs)("div", {
						className: "zoom-controls",
						children: [
							/* @__PURE__ */ (0, W.jsx)("button", {
								className: "icon-button",
								onClick: () => m(-1),
								"aria-label": "Föregående förstorad bild",
								children: /* @__PURE__ */ (0, W.jsx)(F, {})
							}),
							/* @__PURE__ */ (0, W.jsxs)("span", { children: [
								o + 1,
								" / ",
								e.images.length
							] }),
							/* @__PURE__ */ (0, W.jsx)("button", {
								className: "icon-button",
								onClick: () => m(1),
								"aria-label": "Nästa förstorad bild",
								children: /* @__PURE__ */ (0, W.jsx)(ne, {})
							})
						]
					})
				]
			})
		}),
		!t && /* @__PURE__ */ (0, W.jsxs)(W.Fragment, { children: [
			e.handle === "somnmask" && /* @__PURE__ */ (0, W.jsxs)(W.Fragment, { children: [
				/* @__PURE__ */ (0, W.jsx)(sl, {}),
				/* @__PURE__ */ (0, W.jsx)(rc, {}),
				/* @__PURE__ */ (0, W.jsx)(rl, {}),
				/* @__PURE__ */ (0, W.jsx)(Ys, {}),
				/* @__PURE__ */ (0, W.jsx)(nl, {})
			] }),
			/* @__PURE__ */ (0, W.jsx)(Zs, { handle: e.handle }),
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "mobile-purchase",
				children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("span", { children: c > 1 ? `${c} × ${e.title}` : e.title }), /* @__PURE__ */ (0, W.jsx)("strong", { children: b === null ? "Pris saknas" : Ds(b) })] }), /* @__PURE__ */ (0, W.jsxs)("a", {
					className: "button",
					href: "#valj-kop",
					children: [p?.available ? "Välj & köp" : "Se alternativ", /* @__PURE__ */ (0, W.jsx)(M, { size: 17 })]
				})]
			})
		] })
	] });
}
function sl() {
	return /* @__PURE__ */ (0, W.jsxs)("section", {
		className: "section mask-details",
		id: "designen",
		children: [/* @__PURE__ */ (0, W.jsxs)("div", {
			className: "section-heading",
			children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("p", {
				className: "eyebrow",
				children: "SKILLNADEN SITTER I FORMEN"
			}), /* @__PURE__ */ (0, W.jsxs)("h2", { children: [
				"Plats för ögonen.",
				/* @__PURE__ */ (0, W.jsx)("br", {}),
				/* @__PURE__ */ (0, W.jsx)("em", { children: "Ro för resten." })
			] })] }), /* @__PURE__ */ (0, W.jsxs)("p", { children: [
				"Allt det viktiga är enkelt.",
				/* @__PURE__ */ (0, W.jsx)("br", {}),
				"Och sitter precis där det behövs."
			] })]
		}), /* @__PURE__ */ (0, W.jsxs)("div", {
			className: "construction",
			children: [/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "construction-image",
				children: [
					/* @__PURE__ */ (0, W.jsx)("img", {
						src: al("somnmask-9.jpg"),
						alt: "Originalfoto av maskens djupa ögonutrymmen",
						width: 1800,
						height: 1200,
						loading: "lazy"
					}),
					/* @__PURE__ */ (0, W.jsx)("span", {
						className: "construction-label label-one",
						children: "01"
					}),
					/* @__PURE__ */ (0, W.jsx)("span", {
						className: "construction-label label-two",
						children: "02"
					}),
					/* @__PURE__ */ (0, W.jsx)("span", {
						className: "construction-label label-three",
						children: "03"
					})
				]
			}), /* @__PURE__ */ (0, W.jsx)("div", {
				className: "construction-copy",
				children: [
					[
						"01",
						"Formad runt ögon och näsa.",
						"Den formade näsbryggan och mjuka dynan hjälper masken att sluta runt ansiktet."
					],
					[
						"02",
						"Låt ögonen vara fria.",
						"Urgröpningarna skapar utrymme framför ögonen och ögonfransarna."
					],
					[
						"03",
						"Hitta din sköna passform.",
						"Ett justerbart band och ett lent tyg gör det enkelt att finjustera känslan."
					]
				].map(([e, t, n]) => /* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("span", { children: e }), /* @__PURE__ */ (0, W.jsxs)("article", { children: [/* @__PURE__ */ (0, W.jsx)("h3", { children: t }), /* @__PURE__ */ (0, W.jsx)("p", { children: n })] })] }, e))
			})]
		})]
	});
}
//#endregion
//#region node_modules/@base-ui/react/tabs/root/TabsRootContext.mjs
var cl = /* @__PURE__ */ _.createContext(void 0);
function ll() {
	let e = _.useContext(cl);
	if (e === void 0) throw Error(_e(64));
	return e;
}
//#endregion
//#region node_modules/@base-ui/react/tabs/root/stateAttributesMapping.mjs
var ul = { tabActivationDirection: (e) => ({ "data-activation-direction": e }) }, dl = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { className: n, defaultValue: r = 0, onValueChange: i, orientation: a = "horizontal", render: o, value: s, style: c, ...l } = e, u = e.defaultValue !== void 0, d = _.useRef([]), [f, p] = _.useState(() => /* @__PURE__ */ new Map()), [m, h] = dc({
		controlled: s,
		default: r,
		name: "Tabs",
		state: "value"
	}), g = s !== void 0, [v, y] = _.useState(() => /* @__PURE__ */ new Map()), b = _.useRef(void 0), x = _.useCallback((e) => fl(v, e), [v]), [S, C] = _.useState(() => ({
		previousValue: m,
		tabActivationDirection: "none"
	})), { previousValue: w, tabActivationDirection: T } = S, E = T, D = !1;
	w !== m && (E = pl(w, m, a, v), D = w != null && m != null && x(m) == null);
	let O = D ? w : m, k = w !== O || T !== E;
	V(() => {
		k && C({
			previousValue: O,
			tabActivationDirection: E
		});
	}, [
		O,
		k,
		E
	]);
	let A = B((e, t) => {
		t.activationDirection = pl(m, e, a, v), i?.(e, t), !t.isCanceled && h(e);
	}), j = B((e, t) => {
		i?.(e, Yt(t, void 0, void 0, { activationDirection: "none" }));
	}), M = B((e, t) => (p((n) => {
		let r = new Map(n);
		return r.set(e, t), r;
	}), () => {
		p((n) => {
			if (n.get(e) !== t) return n;
			let r = new Map(n);
			return r.delete(e), r;
		});
	})), N = _.useCallback((e) => f.get(e), [f]), ee = _.useCallback((e) => {
		for (let t of v.values()) if (e === t.value) return t.id;
	}, [v]), te = _.useMemo(() => ({
		getTabElementBySelectedValue: x,
		getTabIdByPanelValue: ee,
		getTabPanelIdByValue: N,
		onValueChange: A,
		orientation: a,
		registerMountedTabPanel: M,
		setTabMap: y,
		tabActivationDirection: E,
		value: m
	}), [
		x,
		ee,
		N,
		A,
		a,
		M,
		y,
		E,
		m
	]), P = _.useMemo(() => {
		for (let e of v.values()) if (e.value === m) return e;
	}, [v, m]), F = _.useMemo(() => {
		for (let e of v.values()) if (!e.disabled) return e.value;
	}, [v]), ne = _.useRef(!u), re = _.useRef(r), ie = _.useRef(u), I = _.useRef(!1);
	V(() => {
		if (g) return;
		function e(e, t) {
			h(e), C({
				previousValue: e,
				tabActivationDirection: "none"
			}), j(e, t), ne.current = !1;
		}
		if (v.size === 0) {
			I.current && m !== null && !b.current?.isConnected && e(null, Kt);
			return;
		}
		I.current = !0, b.current = v.keys().next().value;
		let t = P?.disabled, n = P == null && m !== null;
		if (!t && m === re.current && (ie.current = !1), ie.current && t && m === re.current) return;
		let r = ne.current;
		if (t || n) {
			let n = F ?? null;
			if (m === n) {
				ne.current = !1;
				return;
			}
			let i = Kt;
			r ? i = qt : t && (i = Gt), e(n, i);
			return;
		}
		r && P != null && (j(m, qt), ne.current = !1);
	}, [
		F,
		g,
		j,
		P,
		h,
		v,
		m
	]);
	let L = $e("div", e, {
		state: {
			orientation: a,
			tabActivationDirection: E
		},
		ref: t,
		props: l,
		stateAttributesMapping: ul
	});
	return /* @__PURE__ */ (0, W.jsx)(cl.Provider, {
		value: te,
		children: /* @__PURE__ */ (0, W.jsx)(mc, {
			elementsRef: d,
			children: L
		})
	});
});
function fl(e, t) {
	for (let [n, r] of e.entries()) if (t === r.value) return n;
	return null;
}
function pl(e, t, n, r) {
	if (e == null || t == null) return "none";
	let [i, a, o] = n === "horizontal" ? [
		"left",
		"left",
		"right"
	] : [
		"top",
		"up",
		"down"
	], s = fl(r, e), c = fl(r, t);
	if (s == null || c == null) return s !== c && (typeof e == "number" || typeof e == "string") && typeof e == typeof t ? t > e ? o : a : "none";
	let l = s.getBoundingClientRect()[i], u = c.getBoundingClientRect()[i];
	return u < l ? a : u > l ? o : "none";
}
//#endregion
//#region node_modules/@base-ui/react/internals/composite/constants.mjs
var ml = "data-composite-item-active";
//#endregion
//#region node_modules/@base-ui/react/internals/composite/item/useCompositeItem.mjs
function hl(e = {}) {
	let { highlightItemOnHover: t, highlightedIndex: n, onHighlightedIndexChange: r } = Nt(), { ref: i, index: a } = Oc(e), o = n === a, s = _.useRef(null), c = Se(i, s);
	return {
		compositeProps: {
			tabIndex: o ? 0 : -1,
			onFocus() {
				r(a);
			},
			onMouseMove() {
				let e = s.current;
				if (!t || !e) return;
				let n = e.hasAttribute("disabled") || e.ariaDisabled === "true";
				!o && !n && e.focus();
			}
		},
		compositeRef: c,
		index: a
	};
}
//#endregion
//#region node_modules/@base-ui/react/tabs/list/TabsListContext.mjs
var gl = /* @__PURE__ */ _.createContext(void 0);
function _l() {
	let e = _.useContext(gl);
	if (e === void 0) throw Error(_e(65));
	return e;
}
//#endregion
//#region node_modules/@base-ui/react/tabs/tab/TabsTab.mjs
var vl = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { className: n, disabled: r = !1, render: i, value: a, id: o, nativeButton: s = !0, style: c, ...l } = e, { value: u, getTabPanelIdByValue: d, onValueChange: f, orientation: p, tabActivationDirection: m } = ll(), { activateOnFocus: h, registerTabResizeObserverElement: g, tabsListElement: v } = _l(), { highlightedIndex: y, onHighlightedIndexChange: b } = Nt(), x = tn(o), { compositeProps: S, compositeRef: C, index: w } = hl({ metadata: _.useMemo(() => ({
		disabled: r,
		id: x,
		value: a
	}), [
		r,
		x,
		a
	]) }), T = a === u, E = _.useRef(!1), D = _.useRef(null), O = B((e) => {
		D.current?.(), D.current = e ? g(e) : null;
	});
	V(() => {
		if (E.current) {
			E.current = !1;
			return;
		}
		if (!(T && w > -1 && y !== w)) return;
		let e = v;
		if (e != null) {
			let t = On(H(e));
			if (t && U(e, t)) return;
		}
		r || b(w);
	}, [
		T,
		w,
		y,
		b,
		r,
		v
	]);
	let { getButtonProps: k, buttonRef: A } = It({
		disabled: r,
		native: s,
		focusableWhenDisabled: !0
	}), j = d(a), M = _.useRef(!1), N = _.useRef(!1);
	function ee(e) {
		f(a, Yt(zt, e.nativeEvent, void 0, { activationDirection: "none" }));
	}
	function te(e) {
		T || r || ee(e);
	}
	function P(e) {
		T || r || h && (!M.current || N.current) && ee(e);
	}
	function F(e) {
		if (T || r) return;
		M.current = !0, N.current = e.button === 0;
		let t = H(e.currentTarget);
		function n() {
			M.current = !1, N.current = !1, t.removeEventListener("pointerup", n), t.removeEventListener("pointercancel", n);
		}
		t.addEventListener("pointerup", n), t.addEventListener("pointercancel", n);
	}
	return $e("button", e, {
		state: {
			disabled: r,
			active: T,
			orientation: p,
			tabActivationDirection: m
		},
		ref: [
			t,
			A,
			C,
			O
		],
		props: [
			S,
			{
				role: "tab",
				"aria-controls": j,
				"aria-selected": T,
				id: x,
				onClick: te,
				onFocus: P,
				onPointerDown: F,
				[ml]: T ? "" : void 0,
				onKeyDownCapture() {
					E.current = !0;
				}
			},
			l,
			k
		],
		stateAttributesMapping: ul
	});
}), yl = {
	...ul,
	...ct
}, bl = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { className: n, value: r, render: i, keepMounted: a = !1, style: o, ...s } = e, { value: c, getTabIdByPanelValue: l, orientation: u, tabActivationDirection: d, registerMountedTabPanel: f } = ll(), p = tn(), { ref: m, index: h } = Oc(), g = r === c, { mounted: v, transitionStatus: y, setMounted: b } = Ai(g), x = !v, S = l(r), C = {
		hidden: x,
		orientation: u,
		tabActivationDirection: d,
		transitionStatus: y
	}, w = _.useRef(null), T = $e("div", e, {
		state: C,
		ref: [
			t,
			m,
			w
		],
		props: [{
			"aria-labelledby": S,
			hidden: x,
			id: p,
			role: "tabpanel",
			tabIndex: g ? 0 : -1,
			inert: pa(!g),
			"data-index": h
		}, s],
		stateAttributesMapping: yl
	});
	return Mi({
		open: g,
		ref: w,
		onComplete() {
			g || b(!1);
		}
	}), V(() => {
		if (!(p == null || x && !a)) return f(r, p);
	}, [
		x,
		a,
		r,
		p,
		f
	]), a || v ? T : null;
});
//#endregion
//#region node_modules/@base-ui/utils/isElementDisabled.mjs
function xl(e) {
	return e == null || e.hasAttribute("disabled") || e.getAttribute("aria-disabled") === "true";
}
//#endregion
//#region node_modules/@base-ui/react/internals/composite/root/useCompositeRoot.mjs
var Sl = [];
function Cl(e) {
	let { loopFocus: t = !0, orientation: n = "both", grid: r, onLoop: i, direction: a, highlightedIndex: o, onHighlightedIndexChange: s, rootRef: c, enableHomeAndEndKeys: l = !1, stopEventPropagation: u, disabledIndices: d, modifierKeys: f = Sl } = e, [p, m] = _.useState(0), h = r != null, g = _.useRef(null), v = Se(g, c), y = _.useRef([]), b = _.useRef(!1), x = o ?? p, S = B((e, t = !1) => {
		if ((s ?? m)(e), t) {
			let t = y.current[e];
			ca(g.current, t, a, n);
		}
	}), C = B((e) => {
		if (e.size === 0 || b.current) return;
		b.current = !0;
		let t = Array.from(e.keys()), r = t.find((e) => e?.hasAttribute("data-composite-item-active")) ?? null, i = r ? e.get(r)?.index ?? -1 : -1;
		if (i !== -1) S(i);
		else if (Qn(t, x, d)) {
			let e = Zn(t, { disabledIndices: d });
			Jn(t, e) || S(e);
		}
		ca(g.current, r, a, n);
	});
	V(() => {
		if (d == null || o != null || !b.current) return;
		let e = y.current;
		if (Qn(e, x, d)) {
			let t = Zn(e, { disabledIndices: d });
			Jn(e, t) || S(t);
		}
	}, [
		d,
		o,
		x,
		y,
		S
	]);
	let w = B((e, t, n) => i ? i(e, t, n, y) : n), T = B((e) => {
		let o = e.key === "Home" || e.key === "End";
		if (!ia.has(e.key) || !l && o || wl(e, f) || !g.current) return;
		let s = a === "rtl", c = s ? na : ra, p = s ? ra : na, m = n === "vertical" ? ta : c, _ = n === "vertical" ? ea : p, v = kn(e.nativeEvent);
		if (v != null && sa(v) && !xl(v)) {
			let t = v.selectionStart, n = v.selectionEnd, r = v.value;
			if (t == null || e.shiftKey || t !== n || e.key !== _ && t < r.length || e.key !== m && t > 0) return;
		}
		let b = x, C = Yn(y, d), T = Xn(y, d);
		r != null && (b = r({
			disabledIndices: d,
			elementsRef: y,
			event: e,
			highlightedIndex: x,
			loopFocus: t,
			maxIndex: T,
			minIndex: C,
			onLoop: w,
			orientation: n,
			rtl: s
		}));
		let E = n !== "vertical" && e.key === c || n !== "horizontal" && e.key === "ArrowDown", D = n !== "vertical" && e.key === p || n !== "horizontal" && e.key === "ArrowUp";
		l && (e.key === "Home" ? b = C : e.key === "End" && (b = T)), b === x && (E || D) && (t && b === T && E ? (b = C, i && (b = i(e, x, b, y))) : t && b === C && D ? (b = T, i && (b = i(e, x, b, y))) : b = Zn(y.current, {
			startingIndex: b,
			decrement: D,
			disabledIndices: d
		})), b !== x && !Jn(y.current, b) && (u && e.stopPropagation(), (h || o || E || D) && e.preventDefault(), S(b, !0), queueMicrotask(() => {
			y.current[b]?.focus();
		}));
	});
	return {
		props: {
			ref: v,
			onFocus(e) {
				let t = g.current, n = kn(e.nativeEvent);
				!t || n == null || !sa(n) || n.setSelectionRange(0, n.value.length);
			},
			onKeyDown: T
		},
		highlightedIndex: x,
		onHighlightedIndexChange: S,
		elementsRef: y,
		onMapChange: C,
		relayKeyboardEvent: T
	};
}
function wl(e, t) {
	for (let n of aa) if (!t.includes(n) && e.getModifierState(n)) return !0;
	return !1;
}
//#endregion
//#region node_modules/@base-ui/react/internals/direction-context/DirectionContext.mjs
var Tl = /* @__PURE__ */ _.createContext(void 0);
function El() {
	return _.useContext(Tl)?.direction ?? "ltr";
}
//#endregion
//#region node_modules/@base-ui/react/internals/composite/root/CompositeRoot.mjs
function Dl(e) {
	let { render: t, className: n, style: r, refs: i = Ne, props: a = Ne, state: o = Pe, stateAttributesMapping: s, highlightedIndex: c, onHighlightedIndexChange: l, orientation: u, grid: d, loopFocus: f, onLoop: p, enableHomeAndEndKeys: m, onMapChange: h, stopEventPropagation: g = !0, rootRef: v, disabledIndices: y, modifierKeys: b, highlightItemOnHover: x = !1, tag: S = "div", ...C } = e, { props: w, highlightedIndex: T, onHighlightedIndexChange: E, elementsRef: D, onMapChange: O, relayKeyboardEvent: k } = Cl({
		grid: d,
		loopFocus: f,
		onLoop: p,
		orientation: u,
		highlightedIndex: c,
		onHighlightedIndexChange: l,
		rootRef: v,
		stopEventPropagation: g,
		enableHomeAndEndKeys: m,
		direction: El(),
		disabledIndices: y,
		modifierKeys: b
	}), A = $e(S, e, {
		state: o,
		ref: i,
		props: [
			w,
			...a,
			C
		],
		stateAttributesMapping: s
	}), j = _.useMemo(() => ({
		highlightedIndex: T,
		onHighlightedIndexChange: E,
		highlightItemOnHover: x,
		relayKeyboardEvent: k
	}), [
		T,
		E,
		x,
		k
	]);
	return /* @__PURE__ */ (0, W.jsx)(Mt.Provider, {
		value: j,
		children: /* @__PURE__ */ (0, W.jsx)(mc, {
			elementsRef: D,
			onMapChange: (e) => {
				h?.(e), O(e);
			},
			children: A
		})
	});
}
//#endregion
//#region node_modules/@base-ui/react/tabs/list/TabsList.mjs
var Ol = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { activateOnFocus: n = !1, className: r, loopFocus: i = !0, render: a, style: o, ...s } = e, { orientation: c, setTabMap: l, tabActivationDirection: u } = ll(), [d, f] = _.useState(0), [p, m] = _.useState(null), h = _.useRef(/* @__PURE__ */ new Set()), g = _.useRef(/* @__PURE__ */ new Set()), v = _.useRef(null);
	V(() => {
		if (typeof ResizeObserver > "u") return;
		let e = new ResizeObserver(() => {
			h.current.forEach((e) => {
				e();
			});
		});
		return v.current = e, p && e.observe(p), g.current.forEach((t) => {
			e.observe(t);
		}), () => {
			e.disconnect(), v.current = null;
		};
	}, [p]);
	let y = B((e) => (h.current.add(e), () => {
		h.current.delete(e);
	})), b = B((e) => (g.current.add(e), v.current?.observe(e), () => {
		g.current.delete(e), v.current?.unobserve(e);
	})), x = {
		orientation: c,
		tabActivationDirection: u
	}, S = {
		"aria-orientation": c === "vertical" ? "vertical" : void 0,
		role: "tablist"
	}, C = _.useMemo(() => ({
		activateOnFocus: n,
		registerIndicatorUpdateListener: y,
		registerTabResizeObserverElement: b,
		tabsListElement: p
	}), [
		n,
		y,
		b,
		p
	]);
	return /* @__PURE__ */ (0, W.jsx)(gl.Provider, {
		value: C,
		children: /* @__PURE__ */ (0, W.jsx)(Dl, {
			render: a,
			className: r,
			style: o,
			state: x,
			refs: [t, m],
			props: [S, s],
			stateAttributesMapping: ul,
			highlightedIndex: d,
			enableHomeAndEndKeys: !0,
			loopFocus: i,
			orientation: c,
			onHighlightedIndexChange: f,
			onMapChange: l,
			disabledIndices: Ne
		})
	});
});
//#endregion
//#region components/ui/tabs.tsx
function kl({ className: e, orientation: t = "horizontal", ...n }) {
	return /* @__PURE__ */ (0, W.jsx)(dl, {
		"data-slot": "tabs",
		"data-orientation": t,
		className: cs("group/tabs flex gap-2 data-horizontal:flex-col", e),
		...n
	});
}
var Al = fs("group/tabs-list inline-flex w-fit items-center justify-center rounded-lg p-[3px] text-muted-foreground group-data-horizontal/tabs:h-8 group-data-vertical/tabs:h-fit group-data-vertical/tabs:flex-col data-[variant=line]:rounded-none", {
	variants: { variant: {
		default: "bg-muted",
		line: "gap-1 bg-transparent"
	} },
	defaultVariants: { variant: "default" }
});
function jl({ className: e, variant: t = "default", ...n }) {
	return /* @__PURE__ */ (0, W.jsx)(Ol, {
		"data-slot": "tabs-list",
		"data-variant": t,
		className: cs(Al({ variant: t }), e),
		...n
	});
}
function Ml({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)(vl, {
		"data-slot": "tabs-trigger",
		className: cs("relative inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-1.5 py-0.5 text-sm font-medium whitespace-nowrap text-foreground/60 transition-all group-data-vertical/tabs:w-full group-data-vertical/tabs:justify-start hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50 has-data-[icon=inline-end]:pr-1 has-data-[icon=inline-start]:pl-1 aria-disabled:pointer-events-none aria-disabled:opacity-50 dark:text-muted-foreground dark:hover:text-foreground group-data-[variant=default]/tabs-list:data-active:shadow-sm group-data-[variant=line]/tabs-list:data-active:shadow-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", "group-data-[variant=line]/tabs-list:bg-transparent group-data-[variant=line]/tabs-list:data-active:bg-transparent dark:group-data-[variant=line]/tabs-list:data-active:border-transparent dark:group-data-[variant=line]/tabs-list:data-active:bg-transparent", "data-active:bg-background data-active:text-foreground dark:data-active:border-input dark:data-active:bg-input/30 dark:data-active:text-foreground", "after:absolute after:bg-foreground after:opacity-0 after:transition-opacity group-data-horizontal/tabs:after:inset-x-0 group-data-horizontal/tabs:after:bottom-[-5px] group-data-horizontal/tabs:after:h-0.5 group-data-vertical/tabs:after:inset-y-0 group-data-vertical/tabs:after:-right-1 group-data-vertical/tabs:after:w-0.5 group-data-[variant=line]/tabs-list:data-active:after:opacity-100", e),
		...t
	});
}
function Nl({ className: e, ...t }) {
	return /* @__PURE__ */ (0, W.jsx)(bl, {
		"data-slot": "tabs-content",
		className: cs("flex-1 text-sm outline-none", e),
		...t
	});
}
//#endregion
//#region components/store/product-card.tsx
function Pl({ product: e }) {
	let t = Ns(), n = t.catalog.find((t) => t.handle === e.handle), r = n?.variants.find((e) => e.available) || n?.variants[0], i = "/products/" + e.handle + (e.handle === "nightshift" && r ? "?variant=" + r.id : ""), a = +(e.handle === "nightshift" && r?.title === "Orange lins");
	return /* @__PURE__ */ (0, W.jsxs)("article", {
		className: "product-card",
		children: [
			/* @__PURE__ */ (0, W.jsxs)("a", {
				href: i,
				className: "product-card-image",
				children: [
					/* @__PURE__ */ (0, W.jsx)("img", {
						src: e.images[a].src,
						alt: e.images[a].alt,
						width: e.images[a].width,
						height: e.images[a].height,
						loading: "lazy"
					}),
					e.handle === "somnmask" && /* @__PURE__ */ (0, W.jsx)("span", {
						className: "tag",
						children: "Din nya kvällsrutin"
					}),
					/* @__PURE__ */ (0, W.jsx)("span", {
						className: "card-arrow",
						children: /* @__PURE__ */ (0, W.jsx)(M, { size: 22 })
					})
				]
			}),
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "card-meta",
				children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("p", {
					className: "card-category",
					children: e.category
				}), /* @__PURE__ */ (0, W.jsx)("h3", { children: /* @__PURE__ */ (0, W.jsx)("a", {
					href: i,
					children: e.title
				}) })] }), /* @__PURE__ */ (0, W.jsx)("span", { children: r ? Ds(r.price) : "Pris saknas" })]
			}),
			/* @__PURE__ */ (0, W.jsx)("p", {
				className: "card-summary",
				children: e.summary
			}),
			t.status === "live" && !n?.variants.some((e) => e.available) && /* @__PURE__ */ (0, W.jsx)("span", {
				className: "small-text",
				children: "Tillfälligt slut"
			})
		]
	});
}
function X({ search: e = !1 }) {
	let [t, n] = (0, _.useState)(""), r = [
		"Alla",
		"Sömnmasker",
		"Öronproppar",
		"Sovhörlurar",
		"Glasögon"
	], i = Ts.filter((e) => (e.title + " " + e.summary + " " + e.category).toLocaleLowerCase("sv").includes(t.toLocaleLowerCase("sv")));
	return /* @__PURE__ */ (0, W.jsxs)("section", {
		className: "section collection",
		children: [
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "collection-intro",
				children: [
					/* @__PURE__ */ (0, W.jsx)("p", {
						className: "eyebrow",
						children: "SMÅ SAKER FÖR DIN KVÄLL"
					}),
					/* @__PURE__ */ (0, W.jsx)("h1", { children: e ? "Hitta ditt lugn." : /* @__PURE__ */ (0, W.jsxs)(W.Fragment, { children: [
						"Din stund.",
						/* @__PURE__ */ (0, W.jsx)("br", {}),
						/* @__PURE__ */ (0, W.jsx)("em", { children: "Dina favoriter." })
					] }) }),
					/* @__PURE__ */ (0, W.jsxs)("p", { children: [
						"Mörker, mjuka material och ljud på dina villkor.",
						/* @__PURE__ */ (0, W.jsx)("br", {}),
						"Hitta det som passar din kvällsrutin."
					] })
				]
			}),
			e && /* @__PURE__ */ (0, W.jsxs)("label", {
				className: "search-box",
				children: [/* @__PURE__ */ (0, W.jsx)(ue, {}), /* @__PURE__ */ (0, W.jsx)("input", {
					type: "search",
					value: t,
					onChange: (e) => n(e.target.value),
					placeholder: "Sök efter sömnmask, öronproppar…",
					"aria-label": "Sök produkter"
				})]
			}),
			/* @__PURE__ */ (0, W.jsxs)(kl, {
				defaultValue: "Alla",
				children: [/* @__PURE__ */ (0, W.jsx)(jl, {
					className: "category-tabs",
					"aria-label": "Produktkategori",
					children: r.map((e) => /* @__PURE__ */ (0, W.jsx)(Ml, {
						value: e,
						children: e
					}, e))
				}), r.map((e) => /* @__PURE__ */ (0, W.jsxs)(Nl, {
					value: e,
					children: [
						/* @__PURE__ */ (0, W.jsxs)("div", {
							className: "collection-count",
							children: [
								i.filter((t) => e === "Alla" || t.category === e).length,
								" ",
								i.filter((t) => e === "Alla" || t.category === e).length === 1 ? "produkt" : "produkter"
							]
						}),
						/* @__PURE__ */ (0, W.jsx)("div", {
							className: "product-grid",
							children: i.filter((t) => e === "Alla" || t.category === e).map((e) => /* @__PURE__ */ (0, W.jsx)(Pl, { product: e }, e.handle))
						}),
						!i.filter((t) => e === "Alla" || t.category === e).length && /* @__PURE__ */ (0, W.jsxs)("div", {
							className: "empty-search",
							children: [
								/* @__PURE__ */ (0, W.jsx)("h2", { children: "Inga träffar ännu." }),
								/* @__PURE__ */ (0, W.jsx)("p", { children: "Prova ett annat sökord eller välj Alla." }),
								/* @__PURE__ */ (0, W.jsx)("button", {
									onClick: () => n(""),
									className: "text-link",
									children: "Rensa sökning"
								})
							]
						})
					]
				}, e))]
			})
		]
	});
}
//#endregion
//#region app/page.tsx
var Fl = (e) => globalThis.__JB_ASSETS__?.[e] || "/images/" + e;
function Z() {
	return /* @__PURE__ */ (0, W.jsxs)("main", {
		id: "main",
		children: [
			/* @__PURE__ */ (0, W.jsx)(ec, {}),
			/* @__PURE__ */ (0, W.jsxs)("div", {
				className: "benefit-ribbon",
				children: [
					/* @__PURE__ */ (0, W.jsxs)("span", { children: [/* @__PURE__ */ (0, W.jsx)(oe, {}), " Omslutande mörker"] }),
					/* @__PURE__ */ (0, W.jsxs)("span", { children: [/* @__PURE__ */ (0, W.jsx)(I, {}), " Utrymme för ögonen"] }),
					/* @__PURE__ */ (0, W.jsxs)("span", { children: [/* @__PURE__ */ (0, W.jsx)(me, {}), " Mjukt material som andas"] }),
					/* @__PURE__ */ (0, W.jsxs)("span", { children: [/* @__PURE__ */ (0, W.jsx)(se, {}), " Enkel att justera"] })
				]
			}),
			/* @__PURE__ */ (0, W.jsx)(ol, {
				product: Ts[0],
				compact: !0
			}),
			/* @__PURE__ */ (0, W.jsx)(Ys, {}),
			/* @__PURE__ */ (0, W.jsx)(sl, {}),
			/* @__PURE__ */ (0, W.jsx)(rl, {}),
			/* @__PURE__ */ (0, W.jsxs)("section", {
				className: "lifestyle-section",
				children: [/* @__PURE__ */ (0, W.jsx)("img", {
					src: Fl("lifestyle-original.jpg"),
					alt: "En kvinna vilar bekvämt i soffan med Jon Blunds sömnmask",
					width: 1440,
					height: 1080,
					loading: "lazy"
				}), /* @__PURE__ */ (0, W.jsxs)("div", {
					className: "lifestyle-copy",
					children: [
						/* @__PURE__ */ (0, W.jsx)("p", {
							className: "eyebrow",
							children: "STUNDEN INNAN ALLT BLIR TYST"
						}),
						/* @__PURE__ */ (0, W.jsxs)("h2", { children: [
							"Inget att hinna.",
							/* @__PURE__ */ (0, W.jsx)("br", {}),
							/* @__PURE__ */ (0, W.jsx)("em", { children: "Bara att landa." })
						] }),
						/* @__PURE__ */ (0, W.jsx)("p", { children: "Lägg undan skärmen. Hitta en skön plats. Justera masken. Ibland får det vara så enkelt." }),
						/* @__PURE__ */ (0, W.jsxs)("a", {
							href: "/products/somnmask",
							className: "text-link",
							children: ["Gör plats för din stund ", /* @__PURE__ */ (0, W.jsx)(M, { size: 20 })]
						})
					]
				})]
			}),
			/* @__PURE__ */ (0, W.jsx)(Zs, {}),
			/* @__PURE__ */ (0, W.jsxs)("section", {
				className: "section more-products",
				children: [/* @__PURE__ */ (0, W.jsxs)("div", {
					className: "section-heading",
					children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("p", {
						className: "eyebrow",
						children: "HITTA DIN KVÄLLSRUTIN"
					}), /* @__PURE__ */ (0, W.jsxs)("h2", { children: ["Lite mer ", /* @__PURE__ */ (0, W.jsx)("em", { children: "lugn." })] })] }), /* @__PURE__ */ (0, W.jsxs)("a", {
						className: "text-link",
						href: "/collections/all",
						children: ["Alla produkter ", /* @__PURE__ */ (0, W.jsx)(M, { size: 19 })]
					})]
				}), /* @__PURE__ */ (0, W.jsx)("div", {
					className: "product-grid three",
					children: Ts.slice(1).map((e) => /* @__PURE__ */ (0, W.jsx)(Pl, { product: e }, e.handle))
				})]
			}),
			/* @__PURE__ */ (0, W.jsx)(nl, {})
		]
	});
}
//#endregion
//#region app/products/[handle]/page.tsx
async function Q({ params: e }) {
	let { handle: t } = await e, n = Os(t);
	return n || b(), /* @__PURE__ */ (0, W.jsxs)("main", {
		id: "main",
		children: [/* @__PURE__ */ (0, W.jsx)(ol, { product: n }), /* @__PURE__ */ (0, W.jsxs)("section", {
			className: "section more-products",
			children: [/* @__PURE__ */ (0, W.jsx)("div", {
				className: "section-heading",
				children: /* @__PURE__ */ (0, W.jsxs)("div", { children: [/* @__PURE__ */ (0, W.jsx)("p", {
					className: "eyebrow",
					children: "GÖR STUNDEN TILL DIN"
				}), /* @__PURE__ */ (0, W.jsxs)("h2", { children: ["Passar din ", /* @__PURE__ */ (0, W.jsx)("em", { children: "kväll." })] })] })
			}), /* @__PURE__ */ (0, W.jsx)("div", {
				className: "product-grid three",
				children: Ts.filter((e) => e.handle !== t).map((e) => /* @__PURE__ */ (0, W.jsx)(Pl, { product: e }, e.handle))
			})]
		})]
	});
}
//#endregion
//#region app/pages/[slug]/page.tsx
var Il = (e) => globalThis.__JB_ASSETS__?.[e] || "/images/" + e;
async function Ll({ params: e }) {
	let { slug: t } = await e;
	if (t === "forskning") return /* @__PURE__ */ (0, W.jsx)(il, {});
	if (t === "vanliga-fragor") return /* @__PURE__ */ (0, W.jsx)("main", {
		id: "main",
		children: /* @__PURE__ */ (0, W.jsx)(nl, {})
	});
	if (t === "kontakta-oss") return /* @__PURE__ */ (0, W.jsxs)("main", {
		id: "main",
		className: "section contact-page",
		children: [/* @__PURE__ */ (0, W.jsxs)("div", { children: [
			/* @__PURE__ */ (0, W.jsx)("p", {
				className: "eyebrow",
				children: "VI FINNS HÄR"
			}),
			/* @__PURE__ */ (0, W.jsxs)("h1", { children: [
				"En fråga?",
				/* @__PURE__ */ (0, W.jsx)("br", {}),
				/* @__PURE__ */ (0, W.jsx)("em", { children: "Vi hjälper dig." })
			] }),
			/* @__PURE__ */ (0, W.jsx)("p", { children: "Undrar du över en produkt, din beställning eller en retur? Hör av dig och berätta hur vi kan hjälpa till." }),
			/* @__PURE__ */ (0, W.jsxs)("a", {
				className: "contact-link",
				href: "mailto:info@jonblund.se",
				children: [
					/* @__PURE__ */ (0, W.jsx)(R, { size: 21 }),
					"info@jonblund.se",
					/* @__PURE__ */ (0, W.jsx)(M, { size: 21 })
				]
			}),
			/* @__PURE__ */ (0, W.jsxs)("a", {
				className: "contact-link",
				href: "tel:+46700780002",
				children: [
					/* @__PURE__ */ (0, W.jsx)(ce, { size: 21 }),
					"0700 78 00 02",
					/* @__PURE__ */ (0, W.jsx)(M, { size: 21 })
				]
			}),
			/* @__PURE__ */ (0, W.jsx)("p", {
				className: "small-text",
				children: "Ange gärna ditt ordernummer om frågan gäller en beställning."
			})
		] }), /* @__PURE__ */ (0, W.jsxs)("div", {
			className: "contact-panel",
			children: [
				/* @__PURE__ */ (0, W.jsx)("span", {
					className: "contact-moon",
					children: "☾"
				}),
				/* @__PURE__ */ (0, W.jsxs)("h2", { children: [
					"Ofta finns svaret",
					/* @__PURE__ */ (0, W.jsx)("br", {}),
					/* @__PURE__ */ (0, W.jsx)("em", { children: "precis här." })
				] }),
				/* @__PURE__ */ (0, W.jsxs)("a", {
					href: "/pages/vanliga-fragor",
					children: ["Vanliga frågor ", /* @__PURE__ */ (0, W.jsx)(M, {})]
				}),
				/* @__PURE__ */ (0, W.jsxs)("a", {
					href: "/policies/shipping-policy",
					children: ["Leverans & frakt ", /* @__PURE__ */ (0, W.jsx)(M, {})]
				}),
				/* @__PURE__ */ (0, W.jsxs)("a", {
					href: "/policies/refund-policy",
					children: ["Retur & ångerrätt ", /* @__PURE__ */ (0, W.jsx)(M, {})]
				})
			]
		})]
	});
	if (t === "om-oss") return /* @__PURE__ */ (0, W.jsxs)("main", {
		id: "main",
		children: [
			/* @__PURE__ */ (0, W.jsxs)("section", {
				className: "section about-hero",
				children: [
					/* @__PURE__ */ (0, W.jsx)("p", {
						className: "eyebrow",
						children: "HEJ, VI ÄR JONBLUND."
					}),
					/* @__PURE__ */ (0, W.jsxs)("h1", { children: [
						"För stunden",
						/* @__PURE__ */ (0, W.jsx)("br", {}),
						/* @__PURE__ */ (0, W.jsx)("em", { children: "som bara är din." })
					] }),
					/* @__PURE__ */ (0, W.jsx)("p", { children: "Vardagen kan vara full av ljud, ljus och saker som behöver bli gjorda. Vi tycker att det ska vara enkelt att skapa en lugnare stund mitt i allt." })
				]
			}),
			/* @__PURE__ */ (0, W.jsx)(Ys, {}),
			/* @__PURE__ */ (0, W.jsxs)("section", {
				className: "section about-body",
				children: [/* @__PURE__ */ (0, W.jsx)("img", {
					src: Il("lifestyle-original.jpg"),
					width: 1440,
					height: 1080,
					alt: "En lugn stund med Jon Blunds sömnmask"
				}), /* @__PURE__ */ (0, W.jsxs)("div", { children: [
					/* @__PURE__ */ (0, W.jsx)("p", {
						className: "eyebrow",
						children: "SMÅ SAKER. DIN RUTIN."
					}),
					/* @__PURE__ */ (0, W.jsxs)("h2", { children: [
						"Börja med",
						/* @__PURE__ */ (0, W.jsx)("br", {}),
						/* @__PURE__ */ (0, W.jsx)("em", { children: "lite mörker." })
					] }),
					/* @__PURE__ */ (0, W.jsx)("p", { children: "Jonblund samlar produkter för kvällens små ritualer. En sömnmask som stänger ute ljuset, öronproppar som dämpar omgivningen eller en ljudbok i ett mjukt pannband." }),
					/* @__PURE__ */ (0, W.jsx)("p", { children: "Välj det som känns rätt för dig. Du bestämmer hur din stund ser ut." }),
					/* @__PURE__ */ (0, W.jsxs)("a", {
						className: "text-link",
						href: "/collections/all",
						children: ["Utforska produkterna ", /* @__PURE__ */ (0, W.jsx)(M, { size: 19 })]
					})
				] })]
			}),
			/* @__PURE__ */ (0, W.jsx)(Zs, {})
		]
	});
	b();
}
//#endregion
//#region app/collections/[[...slug]]/page.tsx
function Rl() {
	return /* @__PURE__ */ (0, W.jsx)("main", {
		id: "main",
		children: /* @__PURE__ */ (0, W.jsx)(X, {})
	});
}
//#endregion
//#region app/search/page.tsx
function zl() {
	return /* @__PURE__ */ (0, W.jsx)("main", {
		id: "main",
		children: /* @__PURE__ */ (0, W.jsx)(X, { search: !0 })
	});
}
//#endregion
//#region app/cart/page.tsx
function Bl() {
	return /* @__PURE__ */ (0, W.jsxs)("main", {
		id: "main",
		className: "section cart-page",
		children: [
			/* @__PURE__ */ (0, W.jsx)("p", {
				className: "eyebrow",
				children: "SNART DIN STUND"
			}),
			/* @__PURE__ */ (0, W.jsx)("h1", { children: "Din varukorg." }),
			/* @__PURE__ */ (0, W.jsx)(Ls, {})
		]
	});
}
//#endregion
//#region app/not-found.tsx
function Vl() {
	return /* @__PURE__ */ (0, W.jsxs)("main", {
		id: "main",
		className: "section not-found",
		children: [
			/* @__PURE__ */ (0, W.jsx)("p", {
				className: "eyebrow",
				children: "404 — HÄR VAR DET MÖRKT"
			}),
			/* @__PURE__ */ (0, W.jsxs)("h1", { children: [
				"Vi hittar inte sidan.",
				/* @__PURE__ */ (0, W.jsx)("br", {}),
				/* @__PURE__ */ (0, W.jsx)("em", { children: "Men lugnet finns kvar." })
			] }),
			/* @__PURE__ */ (0, W.jsxs)("a", {
				className: "button",
				href: "/",
				children: ["Till startsidan ", /* @__PURE__ */ (0, W.jsx)(M, { size: 19 })]
			})
		]
	});
}
//#endregion
//#region shopify-integration/app.tsx
async function Hl(e) {
	let t;
	return t = e === "/" ? /* @__PURE__ */ (0, W.jsx)(Z, {}) : e.startsWith("/products/") ? await Q({ params: Promise.resolve({ handle: e.split("/")[2] }) }) : e.startsWith("/pages/") ? await Ll({ params: Promise.resolve({ slug: e.split("/")[2] }) }) : e.startsWith("/collections") ? /* @__PURE__ */ (0, W.jsx)(Rl, {}) : e === "/search" ? /* @__PURE__ */ (0, W.jsx)(zl, {}) : e === "/cart" ? /* @__PURE__ */ (0, W.jsx)(Bl, {}) : /* @__PURE__ */ (0, W.jsx)(Vl, {}), /* @__PURE__ */ (0, W.jsxs)(Fs, { children: [
		/* @__PURE__ */ (0, W.jsx)(zs, {}),
		t,
		/* @__PURE__ */ (0, W.jsx)(Bs, {})
	] });
}
//#endregion
//#region shopify-integration/client.tsx
var Ul = document.getElementById("jonblund-root");
Ul && Hl(window.location.pathname).then((e) => (0, v.hydrateRoot)(Ul, e)).catch(() => {
	Ul.innerHTML = "<main style=\"padding:40px\"><h1>Sidan kunde inte laddas</h1><a href=\"/\">Till startsidan</a></main>";
});
//#endregion
